// This is a generated file

import type { EmojiItem } from './emoji.js'

export const emojis: EmojiItem[] = [
  {
    emoji: '🇦',
    name: 'regional_indicator_a',
    shortcodes: ['regional_indicator_a'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇧',
    name: 'regional_indicator_b',
    shortcodes: ['regional_indicator_b'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇨',
    name: 'regional_indicator_c',
    shortcodes: ['regional_indicator_c'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇩',
    name: 'regional_indicator_d',
    shortcodes: ['regional_indicator_d'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇪',
    name: 'regional_indicator_e',
    shortcodes: ['regional_indicator_e'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇫',
    name: 'regional_indicator_f',
    shortcodes: ['regional_indicator_f'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇬',
    name: 'regional_indicator_g',
    shortcodes: ['regional_indicator_g'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇭',
    name: 'regional_indicator_h',
    shortcodes: ['regional_indicator_h'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇮',
    name: 'regional_indicator_i',
    shortcodes: ['regional_indicator_i'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇯',
    name: 'regional_indicator_j',
    shortcodes: ['regional_indicator_j'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇰',
    name: 'regional_indicator_k',
    shortcodes: ['regional_indicator_k'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇱',
    name: 'regional_indicator_l',
    shortcodes: ['regional_indicator_l'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇲',
    name: 'regional_indicator_m',
    shortcodes: ['regional_indicator_m'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇳',
    name: 'regional_indicator_n',
    shortcodes: ['regional_indicator_n'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇴',
    name: 'regional_indicator_o',
    shortcodes: ['regional_indicator_o'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇵',
    name: 'regional_indicator_p',
    shortcodes: ['regional_indicator_p'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇶',
    name: 'regional_indicator_q',
    shortcodes: ['regional_indicator_q'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇷',
    name: 'regional_indicator_r',
    shortcodes: ['regional_indicator_r'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇸',
    name: 'regional_indicator_s',
    shortcodes: ['regional_indicator_s'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇹',
    name: 'regional_indicator_t',
    shortcodes: ['regional_indicator_t'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇺',
    name: 'regional_indicator_u',
    shortcodes: ['regional_indicator_u'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇻',
    name: 'regional_indicator_v',
    shortcodes: ['regional_indicator_v'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇼',
    name: 'regional_indicator_w',
    shortcodes: ['regional_indicator_w'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇽',
    name: 'regional_indicator_x',
    shortcodes: ['regional_indicator_x'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇾',
    name: 'regional_indicator_y',
    shortcodes: ['regional_indicator_y'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '🇿',
    name: 'regional_indicator_z',
    shortcodes: ['regional_indicator_z'],
    tags: [],
    group: '',
    emoticons: [],
    version: 0,
  },
  {
    emoji: '😀',
    name: 'grinning',
    shortcodes: ['grinning', 'grinning_face'],
    tags: [
      'cheerful',
      'cheery',
      'face',
      'grin',
      'grinning',
      'happy',
      'laugh',
      'nice',
      'smile',
      'smiling',
      'teeth',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png',
  },
  {
    emoji: '😃',
    name: 'smiley',
    shortcodes: ['grinning_face_with_big_eyes', 'smiley'],
    tags: [
      'awesome',
      'big',
      'eyes',
      'face',
      'grin',
      'grinning',
      'happy',
      'mouth',
      'open',
      'smile',
      'smiling',
      'teeth',
      'yay',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f603.png',
  },
  {
    emoji: '😄',
    name: 'smile',
    shortcodes: ['grinning_face_with_closed_eyes', 'smile'],
    tags: [
      'eye',
      'eyes',
      'face',
      'grin',
      'grinning',
      'happy',
      'laugh',
      'lol',
      'mouth',
      'open',
      'smile',
      'smiling',
    ],
    group: '',
    emoticons: [':D'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f604.png',
  },
  {
    emoji: '😁',
    name: 'grin',
    shortcodes: ['beaming_face', 'grin'],
    tags: [
      'beaming',
      'eye',
      'eyes',
      'face',
      'grin',
      'grinning',
      'happy',
      'nice',
      'smile',
      'smiling',
      'teeth',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f601.png',
  },
  {
    emoji: '😆',
    name: 'laughing',
    shortcodes: ['laughing', 'lol', 'satisfied', 'squinting_face'],
    tags: [
      'closed',
      'eyes',
      'face',
      'grinning',
      'haha',
      'hahaha',
      'happy',
      'laugh',
      'lol',
      'mouth',
      'open',
      'rofl',
      'smile',
      'smiling',
      'squinting',
    ],
    group: '',
    emoticons: ['xD', 'XD'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f606.png',
  },
  {
    emoji: '😅',
    name: 'sweat_smile',
    shortcodes: ['grinning_face_with_sweat', 'sweat_smile'],
    tags: [
      'cold',
      'dejected',
      'excited',
      'face',
      'grinning',
      'mouth',
      'nervous',
      'open',
      'smile',
      'smiling',
      'stress',
      'stressed',
      'sweat',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f605.png',
  },
  {
    emoji: '🤣',
    name: 'rofl',
    shortcodes: ['rofl'],
    tags: [
      'crying',
      'face',
      'floor',
      'funny',
      'haha',
      'happy',
      'hehe',
      'hilarious',
      'joy',
      'laugh',
      'lmao',
      'lol',
      'rofl',
      'roflmao',
      'rolling',
      'tear',
    ],
    group: '',
    emoticons: [":'D"],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f923.png',
  },
  {
    emoji: '😂',
    name: 'joy',
    shortcodes: ['joy', 'lmao', 'tears_of_joy'],
    tags: [
      'crying',
      'face',
      'feels',
      'funny',
      'haha',
      'happy',
      'hehe',
      'hilarious',
      'joy',
      'laugh',
      'lmao',
      'lol',
      'rofl',
      'roflmao',
      'tear',
    ],
    group: '',
    emoticons: [":')"],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f602.png',
  },
  {
    emoji: '🙂',
    name: 'slightly_smiling_face',
    shortcodes: ['slightly_smiling_face'],
    tags: ['face', 'happy', 'slightly', 'smile', 'smiling'],
    group: '',
    emoticons: [':)'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f642.png',
  },
  {
    emoji: '🙃',
    name: 'upside_down_face',
    shortcodes: ['upside_down_face'],
    tags: ['face', 'hehe', 'smile', 'upside-down'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f643.png',
  },
  {
    emoji: '🫠',
    name: 'melting_face',
    shortcodes: ['melt', 'melting_face'],
    tags: [
      'disappear',
      'dissolve',
      'embarrassed',
      'face',
      'haha',
      'heat',
      'hot',
      'liquid',
      'lol',
      'melt',
      'melting',
      'sarcasm',
      'sarcastic',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae0.png',
  },
  {
    emoji: '😉',
    name: 'wink',
    shortcodes: ['wink', 'winking_face'],
    tags: ['face', 'flirt', 'heartbreaker', 'sexy', 'slide', 'tease', 'wink', 'winking', 'winks'],
    group: '',
    emoticons: [';)'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f609.png',
  },
  {
    emoji: '😊',
    name: 'blush',
    shortcodes: ['blush', 'smiling_face_with_closed_eyes'],
    tags: ['blush', 'eye', 'eyes', 'face', 'glad', 'satisfied', 'smile', 'smiling'],
    group: '',
    emoticons: [':>'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60a.png',
  },
  {
    emoji: '😇',
    name: 'innocent',
    shortcodes: ['halo', 'innocent'],
    tags: [
      'angel',
      'angelic',
      'angels',
      'blessed',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'halo',
      'happy',
      'innocent',
      'peaceful',
      'smile',
      'smiling',
      'spirit',
      'tale',
    ],
    group: '',
    emoticons: ['o:)', 'O:)'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f607.png',
  },
  {
    emoji: '🥰',
    name: 'smiling_face_with_three_hearts',
    shortcodes: ['smiling_face_with_3_hearts'],
    tags: [
      '3',
      'adore',
      'crush',
      'face',
      'heart',
      'hearts',
      'ily',
      'love',
      'romance',
      'smile',
      'smiling',
      'you',
    ],
    group: '',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f970.png',
  },
  {
    emoji: '😍',
    name: 'heart_eyes',
    shortcodes: ['heart_eyes', 'smiling_face_with_heart_eyes'],
    tags: [
      '143',
      'bae',
      'eye',
      'face',
      'feels',
      'heart-eyes',
      'hearts',
      'ily',
      'kisses',
      'love',
      'romance',
      'romantic',
      'smile',
      'xoxo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60d.png',
  },
  {
    emoji: '🤩',
    name: 'star_struck',
    shortcodes: ['star_struck'],
    tags: ['excited', 'eyes', 'face', 'grinning', 'smile', 'star', 'starry-eyed', 'wow'],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f929.png',
  },
  {
    emoji: '😘',
    name: 'kissing_heart',
    shortcodes: ['blowing_a_kiss', 'kissing_heart'],
    tags: [
      'adorbs',
      'bae',
      'blowing',
      'face',
      'flirt',
      'heart',
      'ily',
      'kiss',
      'love',
      'lover',
      'miss',
      'muah',
      'romantic',
      'smooch',
      'xoxo',
      'you',
    ],
    group: '',
    emoticons: [':x', ':X'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f618.png',
  },
  {
    emoji: '😗',
    name: 'kissing',
    shortcodes: ['kissing', 'kissing_face'],
    tags: [
      '143',
      'date',
      'dating',
      'face',
      'flirt',
      'ily',
      'kiss',
      'love',
      'smooch',
      'smooches',
      'xoxo',
      'you',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f617.png',
  },
  {
    emoji: '☺',
    name: 'relaxed',
    shortcodes: ['relaxed', 'smiling_face'],
    tags: ['face', 'happy', 'outlined', 'relaxed', 'smile', 'smiling'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/263a-fe0f.png',
  },
  {
    emoji: '😚',
    name: 'kissing_closed_eyes',
    shortcodes: ['kissing_closed_eyes', 'kissing_face_with_closed_eyes'],
    tags: [
      '143',
      'bae',
      'blush',
      'closed',
      'date',
      'dating',
      'eye',
      'eyes',
      'face',
      'flirt',
      'ily',
      'kisses',
      'kissing',
      'smooches',
      'xoxo',
    ],
    group: '',
    emoticons: [':*'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61a.png',
  },
  {
    emoji: '😙',
    name: 'kissing_smiling_eyes',
    shortcodes: ['kissing_face_with_smiling_eyes', 'kissing_smiling_eyes'],
    tags: [
      '143',
      'closed',
      'date',
      'dating',
      'eye',
      'eyes',
      'face',
      'flirt',
      'ily',
      'kiss',
      'kisses',
      'kissing',
      'love',
      'night',
      'smile',
      'smiling',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f619.png',
  },
  {
    emoji: '🥲',
    name: 'smiling_face_with_tear',
    shortcodes: ['smiling_face_with_tear'],
    tags: [
      'face',
      'glad',
      'grateful',
      'happy',
      'joy',
      'pain',
      'proud',
      'relieved',
      'smile',
      'smiley',
      'smiling',
      'tear',
      'touched',
    ],
    group: '',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f972.png',
  },
  {
    emoji: '😋',
    name: 'yum',
    shortcodes: ['savoring_food', 'yum'],
    tags: [
      'delicious',
      'eat',
      'face',
      'food',
      'full',
      'hungry',
      'savor',
      'smile',
      'smiling',
      'tasty',
      'um',
      'yum',
      'yummy',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60b.png',
  },
  {
    emoji: '😛',
    name: 'stuck_out_tongue',
    shortcodes: ['face_with_tongue', 'stuck_out_tongue'],
    tags: ['awesome', 'cool', 'face', 'nice', 'party', 'stuck-out', 'sweet', 'tongue'],
    group: '',
    emoticons: [':p', ':P'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61b.png',
  },
  {
    emoji: '😜',
    name: 'stuck_out_tongue_winking_eye',
    shortcodes: ['stuck_out_tongue_winking_eye'],
    tags: [
      'crazy',
      'epic',
      'eye',
      'face',
      'funny',
      'joke',
      'loopy',
      'nutty',
      'party',
      'stuck-out',
      'tongue',
      'wacky',
      'weirdo',
      'wink',
      'winking',
      'yolo',
    ],
    group: '',
    emoticons: [';p', ';P'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61c.png',
  },
  {
    emoji: '🤪',
    name: 'zany_face',
    shortcodes: ['zany', 'zany_face'],
    tags: ['crazy', 'eye', 'eyes', 'face', 'goofy', 'large', 'small', 'zany'],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92a.png',
  },
  {
    emoji: '😝',
    name: 'stuck_out_tongue_closed_eyes',
    shortcodes: ['stuck_out_tongue_closed_eyes'],
    tags: [
      'closed',
      'eye',
      'eyes',
      'face',
      'gross',
      'horrible',
      'omg',
      'squinting',
      'stuck-out',
      'taste',
      'tongue',
      'whatever',
      'yolo',
    ],
    group: '',
    emoticons: ['xp', 'xP', 'XP'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61d.png',
  },
  {
    emoji: '🤑',
    name: 'money_mouth_face',
    shortcodes: ['money_mouth_face'],
    tags: ['face', 'money', 'money-mouth', 'mouth', 'paid'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f911.png',
  },
  {
    emoji: '🤗',
    name: 'hugs',
    shortcodes: ['hug', 'hugging', 'hugging_face'],
    tags: ['face', 'hands', 'hug', 'hugging', 'open', 'smiling'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f917.png',
  },
  {
    emoji: '🤭',
    name: 'hand_over_mouth',
    shortcodes: ['face_with_hand_over_mouth', 'hand_over_mouth'],
    tags: [
      'face',
      'giggle',
      'giggling',
      'hand',
      'mouth',
      'oops',
      'realization',
      'secret',
      'shock',
      'sudden',
      'surprise',
      'whoops',
    ],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92d.png',
  },
  {
    emoji: '🫢',
    name: 'face_with_open_eyes_and_hand_over_mouth',
    shortcodes: ['face_with_open_eyes_hand_over_mouth', 'gasp'],
    tags: [
      'amazement',
      'awe',
      'disbelief',
      'embarrass',
      'eyes',
      'face',
      'gasp',
      'hand',
      'mouth',
      'omg',
      'open',
      'over',
      'quiet',
      'scared',
      'shock',
      'surprise',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae2.png',
  },
  {
    emoji: '🫣',
    name: 'face_with_peeking_eye',
    shortcodes: ['face_with_peeking_eye', 'peek'],
    tags: [
      'captivated',
      'embarrass',
      'eye',
      'face',
      'hide',
      'hiding',
      'peek',
      'peeking',
      'peep',
      'scared',
      'shy',
      'stare',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae3.png',
  },
  {
    emoji: '🤫',
    name: 'shushing_face',
    shortcodes: ['shush', 'shushing_face'],
    tags: ['face', 'quiet', 'shh', 'shush', 'shushing'],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92b.png',
  },
  {
    emoji: '🤔',
    name: 'thinking',
    shortcodes: ['thinking', 'thinking_face', 'wtf'],
    tags: ['chin', 'consider', 'face', 'hmm', 'ponder', 'pondering', 'thinking', 'wondering'],
    group: '',
    emoticons: [':l', ':L'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f914.png',
  },
  {
    emoji: '🫡',
    name: 'saluting_face',
    shortcodes: ['salute', 'saluting_face'],
    tags: [
      'face',
      'good',
      'luck',
      'ma’am',
      'ok',
      'respect',
      'salute',
      'saluting',
      'sir',
      'troops',
      'yes',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae1.png',
  },
  {
    emoji: '🤐',
    name: 'zipper_mouth_face',
    shortcodes: ['zipper_mouth', 'zipper_mouth_face'],
    tags: ['face', 'keep', 'mouth', 'quiet', 'secret', 'shut', 'zip', 'zipper', 'zipper-mouth'],
    group: '',
    emoticons: [':z', ':Z'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f910.png',
  },
  {
    emoji: '🤨',
    name: 'raised_eyebrow',
    shortcodes: ['face_with_raised_eyebrow', 'raised_eyebrow'],
    tags: [
      'disapproval',
      'disbelief',
      'distrust',
      'emoji',
      'eyebrow',
      'face',
      'hmm',
      'mild',
      'raised',
      'skeptic',
      'skeptical',
      'skepticism',
      'surprise',
      'what',
    ],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f928.png',
  },
  {
    emoji: '😐',
    name: 'neutral_face',
    shortcodes: ['neutral', 'neutral_face'],
    tags: [
      'awkward',
      'blank',
      'deadpan',
      'expressionless',
      'face',
      'fine',
      'jealous',
      'meh',
      'neutral',
      'oh',
      'shade',
      'straight',
      'unamused',
      'unhappy',
      'unimpressed',
      'whatever',
    ],
    group: '',
    emoticons: [':|'],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f610.png',
  },
  {
    emoji: '😑',
    name: 'expressionless',
    shortcodes: ['expressionless', 'expressionless_face'],
    tags: [
      'awkward',
      'dead',
      'expressionless',
      'face',
      'fine',
      'inexpressive',
      'jealous',
      'meh',
      'not',
      'oh',
      'omg',
      'straight',
      'uh',
      'unhappy',
      'unimpressed',
      'whatever',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f611.png',
  },
  {
    emoji: '😶',
    name: 'no_mouth',
    shortcodes: ['no_mouth'],
    tags: [
      'awkward',
      'blank',
      'expressionless',
      'face',
      'mouth',
      'mouthless',
      'mute',
      'quiet',
      'secret',
      'silence',
      'silent',
      'speechless',
    ],
    group: '',
    emoticons: [':#'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f636.png',
  },
  {
    emoji: '🫥',
    name: 'dotted_line_face',
    shortcodes: ['dotted_line_face'],
    tags: [
      'depressed',
      'disappear',
      'dotted',
      'face',
      'hidden',
      'hide',
      'introvert',
      'invisible',
      'line',
      'meh',
      'whatever',
      'wtv',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae5.png',
  },
  {
    emoji: '😶‍🌫',
    name: 'face_in_clouds',
    shortcodes: ['in_clouds'],
    tags: ['absentminded', 'clouds', 'face', 'fog', 'head'],
    group: '',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f636-200d-1f32b-fe0f.png',
  },
  {
    emoji: '😏',
    name: 'smirk',
    shortcodes: ['smirk', 'smirking', 'smirking_face'],
    tags: [
      'boss',
      'dapper',
      'face',
      'flirt',
      'homie',
      'kidding',
      'leer',
      'shade',
      'slick',
      'sly',
      'smirk',
      'smug',
      'snicker',
      'suave',
      'suspicious',
      'swag',
    ],
    group: '',
    emoticons: [':j'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60f.png',
  },
  {
    emoji: '😒',
    name: 'unamused',
    shortcodes: ['unamused', 'unamused_face'],
    tags: [
      '...',
      'bored',
      'face',
      'fine',
      'jealous',
      'jel',
      'jelly',
      'pissed',
      'smh',
      'ugh',
      'uhh',
      'unamused',
      'unhappy',
      'weird',
      'whatever',
    ],
    group: '',
    emoticons: [':?'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f612.png',
  },
  {
    emoji: '🙄',
    name: 'roll_eyes',
    shortcodes: ['rolling_eyes'],
    tags: ['eyeroll', 'eyes', 'face', 'rolling', 'shade', 'ugh', 'whatever'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f644.png',
  },
  {
    emoji: '😬',
    name: 'grimacing',
    shortcodes: ['grimacing', 'grimacing_face'],
    tags: [
      'awk',
      'awkward',
      'dentist',
      'face',
      'grimace',
      'grimacing',
      'grinning',
      'smile',
      'smiling',
    ],
    group: '',
    emoticons: ['8D'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62c.png',
  },
  {
    emoji: '😮‍💨',
    name: 'face_exhaling',
    shortcodes: ['exhale', 'exhaling'],
    tags: [
      'blow',
      'blowing',
      'exhale',
      'exhaling',
      'exhausted',
      'face',
      'gasp',
      'groan',
      'relief',
      'sigh',
      'smiley',
      'smoke',
      'whisper',
      'whistle',
    ],
    group: '',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62e-200d-1f4a8.png',
  },
  {
    emoji: '🤥',
    name: 'lying_face',
    shortcodes: ['lying', 'lying_face'],
    tags: ['face', 'liar', 'lie', 'lying', 'pinocchio'],
    group: '',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f925.png',
  },
  {
    emoji: '🫨',
    name: 'shaking_face',
    shortcodes: ['shaking', 'shaking_face'],
    tags: [
      'crazy',
      'daze',
      'earthquake',
      'face',
      'omg',
      'panic',
      'shaking',
      'shock',
      'surprise',
      'vibrate',
      'whoa',
      'wow',
    ],
    group: '',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae8.png',
  },
  {
    emoji: '🙂‍↔',
    name: 'head_shaking_horizontally',
    shortcodes: ['head_shaking_horizontally'],
    tags: ['head', 'horizontally', 'no', 'shake', 'shaking'],
    group: '',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f642-200d-2194-fe0f.png',
  },
  {
    emoji: '🙂‍↕',
    name: 'head_shaking_vertically',
    shortcodes: ['head_shaking_vertically'],
    tags: ['head', 'nod', 'shaking', 'vertically', 'yes'],
    group: '',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f642-200d-2195-fe0f.png',
  },
  {
    emoji: '😌',
    name: 'relieved',
    shortcodes: ['relieved', 'relieved_face'],
    tags: ['calm', 'face', 'peace', 'relief', 'relieved', 'zen'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60c.png',
  },
  {
    emoji: '😔',
    name: 'pensive',
    shortcodes: ['pensive', 'pensive_face'],
    tags: [
      'awful',
      'bored',
      'dejected',
      'died',
      'disappointed',
      'face',
      'losing',
      'lost',
      'pensive',
      'sad',
      'sucks',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f614.png',
  },
  {
    emoji: '😪',
    name: 'sleepy',
    shortcodes: ['sleepy', 'sleepy_face'],
    tags: ['crying', 'face', 'good', 'night', 'sad', 'sleep', 'sleeping', 'sleepy', 'tired'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62a.png',
  },
  {
    emoji: '🤤',
    name: 'drooling_face',
    shortcodes: ['drooling', 'drooling_face'],
    tags: ['drooling', 'face'],
    group: '',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f924.png',
  },
  {
    emoji: '😴',
    name: 'sleeping',
    shortcodes: ['sleeping', 'sleeping_face'],
    tags: [
      'bed',
      'bedtime',
      'face',
      'good',
      'goodnight',
      'nap',
      'night',
      'sleep',
      'sleeping',
      'tired',
      'whatever',
      'yawn',
      'zzz',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f634.png',
  },
  {
    emoji: '🫩',
    name: 'face_with_eye_bags',
    shortcodes: ['face_with_eye_bags'],
    tags: [
      'bags',
      'bored',
      'exhausted',
      'eyes',
      'face',
      'fatigued',
      'late',
      'sleepy',
      'tired',
      'weary',
    ],
    group: '',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae9.png',
  },
  {
    emoji: '😷',
    name: 'mask',
    shortcodes: ['mask', 'medical_mask'],
    tags: [
      'cold',
      'dentist',
      'dermatologist',
      'doctor',
      'dr',
      'face',
      'germs',
      'mask',
      'medical',
      'medicine',
      'sick',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f637.png',
  },
  {
    emoji: '🤒',
    name: 'face_with_thermometer',
    shortcodes: ['face_with_thermometer'],
    tags: ['face', 'ill', 'sick', 'thermometer'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f912.png',
  },
  {
    emoji: '🤕',
    name: 'face_with_head_bandage',
    shortcodes: ['face_with_head_bandage'],
    tags: ['bandage', 'face', 'head-bandage', 'hurt', 'injury', 'ouch'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f915.png',
  },
  {
    emoji: '🤢',
    name: 'nauseated_face',
    shortcodes: ['nauseated', 'nauseated_face'],
    tags: ['face', 'gross', 'nasty', 'nauseated', 'sick', 'vomit'],
    group: '',
    emoticons: ['%('],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f922.png',
  },
  {
    emoji: '🤮',
    name: 'vomiting_face',
    shortcodes: ['face_vomiting', 'vomiting'],
    tags: [
      'barf',
      'ew',
      'face',
      'gross',
      'puke',
      'sick',
      'spew',
      'throw',
      'up',
      'vomit',
      'vomiting',
    ],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92e.png',
  },
  {
    emoji: '🤧',
    name: 'sneezing_face',
    shortcodes: ['sneezing', 'sneezing_face'],
    tags: ['face', 'fever', 'flu', 'gesundheit', 'sick', 'sneeze', 'sneezing'],
    group: '',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f927.png',
  },
  {
    emoji: '🥵',
    name: 'hot_face',
    shortcodes: ['hot', 'hot_face'],
    tags: [
      'dying',
      'face',
      'feverish',
      'heat',
      'hot',
      'panting',
      'red-faced',
      'stroke',
      'sweating',
      'tongue',
    ],
    group: '',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f975.png',
  },
  {
    emoji: '🥶',
    name: 'cold_face',
    shortcodes: ['cold', 'cold_face'],
    tags: [
      'blue',
      'blue-faced',
      'cold',
      'face',
      'freezing',
      'frostbite',
      'icicles',
      'subzero',
      'teeth',
    ],
    group: '',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f976.png',
  },
  {
    emoji: '🥴',
    name: 'woozy_face',
    shortcodes: ['woozy', 'woozy_face'],
    tags: [
      'dizzy',
      'drunk',
      'eyes',
      'face',
      'intoxicated',
      'mouth',
      'tipsy',
      'uneven',
      'wavy',
      'woozy',
    ],
    group: '',
    emoticons: [':&'],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f974.png',
  },
  {
    emoji: '😵',
    name: 'dizzy_face',
    shortcodes: ['dizzy_face', 'knocked_out'],
    tags: [
      'crossed-out',
      'dead',
      'dizzy',
      'eyes',
      'face',
      'feels',
      'knocked',
      'out',
      'sick',
      'tired',
    ],
    group: '',
    emoticons: ['xo', 'XO'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f635.png',
  },
  {
    emoji: '😵‍💫',
    name: 'face_with_spiral_eyes',
    shortcodes: ['dizzy_eyes'],
    tags: [
      'confused',
      'dizzy',
      'eyes',
      'face',
      'hypnotized',
      'omg',
      'smiley',
      'spiral',
      'trouble',
      'whoa',
      'woah',
      'woozy',
    ],
    group: '',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f635-200d-1f4ab.png',
  },
  {
    emoji: '🤯',
    name: 'exploding_head',
    shortcodes: ['exploding_head'],
    tags: ['blown', 'explode', 'exploding', 'head', 'mind', 'mindblown', 'no', 'shocked', 'way'],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92f.png',
  },
  {
    emoji: '🤠',
    name: 'cowboy_hat_face',
    shortcodes: ['cowboy', 'cowboy_face'],
    tags: ['cowboy', 'cowgirl', 'face', 'hat'],
    group: '',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f920.png',
  },
  {
    emoji: '🥳',
    name: 'partying_face',
    shortcodes: ['hooray', 'partying', 'partying_face'],
    tags: [
      'bday',
      'birthday',
      'celebrate',
      'celebration',
      'excited',
      'face',
      'happy',
      'hat',
      'hooray',
      'horn',
      'party',
      'partying',
    ],
    group: '',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f973.png',
  },
  {
    emoji: '🥸',
    name: 'disguised_face',
    shortcodes: ['disguised', 'disguised_face'],
    tags: [
      'disguise',
      'eyebrow',
      'face',
      'glasses',
      'incognito',
      'moustache',
      'mustache',
      'nose',
      'person',
      'spy',
      'tache',
      'tash',
    ],
    group: '',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f978.png',
  },
  {
    emoji: '😎',
    name: 'sunglasses',
    shortcodes: ['smiling_face_with_sunglasses', 'sunglasses_cool', 'too_cool'],
    tags: [
      'awesome',
      'beach',
      'bright',
      'bro',
      'chilling',
      'cool',
      'face',
      'rad',
      'relaxed',
      'shades',
      'slay',
      'smile',
      'style',
      'sunglasses',
      'swag',
      'win',
    ],
    group: '',
    emoticons: ['8)'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f60e.png',
  },
  {
    emoji: '🤓',
    name: 'nerd_face',
    shortcodes: ['nerd', 'nerd_face'],
    tags: [
      'brainy',
      'clever',
      'expert',
      'face',
      'geek',
      'gifted',
      'glasses',
      'intelligent',
      'nerd',
      'smart',
    ],
    group: '',
    emoticons: [':B'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f913.png',
  },
  {
    emoji: '🧐',
    name: 'monocle_face',
    shortcodes: ['face_with_monocle'],
    tags: ['classy', 'face', 'fancy', 'monocle', 'rich', 'stuffy', 'wealthy'],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d0.png',
  },
  {
    emoji: '😕',
    name: 'confused',
    shortcodes: ['confused', 'confused_face'],
    tags: [
      'befuddled',
      'confused',
      'confusing',
      'dunno',
      'face',
      'frown',
      'hm',
      'meh',
      'not',
      'sad',
      'sorry',
      'sure',
    ],
    group: '',
    emoticons: [':/'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f615.png',
  },
  {
    emoji: '🫤',
    name: 'face_with_diagonal_mouth',
    shortcodes: ['face_with_diagonal_mouth'],
    tags: [
      'confused',
      'confusion',
      'diagonal',
      'disappointed',
      'doubt',
      'doubtful',
      'face',
      'frustrated',
      'frustration',
      'meh',
      'mouth',
      'skeptical',
      'unsure',
      'whatever',
      'wtv',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae4.png',
  },
  {
    emoji: '😟',
    name: 'worried',
    shortcodes: ['worried', 'worried_face'],
    tags: [
      'anxious',
      'butterflies',
      'face',
      'nerves',
      'nervous',
      'sad',
      'stress',
      'stressed',
      'surprised',
      'worried',
      'worry',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61f.png',
  },
  {
    emoji: '🙁',
    name: 'slightly_frowning_face',
    shortcodes: ['slightly_frowning_face'],
    tags: ['face', 'frown', 'frowning', 'sad', 'slightly'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f641.png',
  },
  {
    emoji: '☹',
    name: 'frowning_face',
    shortcodes: ['white_frowning_face'],
    tags: ['face', 'frown', 'frowning', 'sad'],
    group: '',
    emoticons: [':('],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2639-fe0f.png',
  },
  {
    emoji: '😮',
    name: 'open_mouth',
    shortcodes: ['face_with_open_mouth', 'open_mouth'],
    tags: [
      'believe',
      'face',
      'forgot',
      'mouth',
      'omg',
      'open',
      'shocked',
      'surprised',
      'sympathy',
      'unbelievable',
      'unreal',
      'whoa',
      'wow',
      'you',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62e.png',
  },
  {
    emoji: '😯',
    name: 'hushed',
    shortcodes: ['hushed', 'hushed_face'],
    tags: ['epic', 'face', 'hushed', 'omg', 'stunned', 'surprised', 'whoa', 'woah'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62f.png',
  },
  {
    emoji: '😲',
    name: 'astonished',
    shortcodes: ['astonished', 'astonished_face'],
    tags: ['astonished', 'cost', 'face', 'no', 'omg', 'shocked', 'totally', 'way'],
    group: '',
    emoticons: [':o', ':O'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f632.png',
  },
  {
    emoji: '😳',
    name: 'flushed',
    shortcodes: ['flushed', 'flushed_face'],
    tags: [
      'amazed',
      'awkward',
      'crazy',
      'dazed',
      'dead',
      'disbelief',
      'embarrassed',
      'face',
      'flushed',
      'geez',
      'heat',
      'hot',
      'impressed',
      'jeez',
      'what',
      'wow',
    ],
    group: '',
    emoticons: [':$'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f633.png',
  },
  {
    emoji: '🫪',
    name: 'distorted_face',
    shortcodes: ['distorted_face'],
    tags: ['anxiety', 'bloated', 'panic', 'shocked', 'surprised', 'vulnerable'],
    group: '',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '🥺',
    name: 'pleading_face',
    shortcodes: ['pleading', 'pleading_face'],
    tags: [
      'begging',
      'big',
      'eyes',
      'face',
      'mercy',
      'not',
      'pleading',
      'please',
      'pretty',
      'puppy',
      'sad',
      'why',
    ],
    group: '',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97a.png',
  },
  {
    emoji: '🥹',
    name: 'face_holding_back_tears',
    shortcodes: ['face_holding_back_tears', 'watery_eyes'],
    tags: [
      'admiration',
      'aww',
      'back',
      'cry',
      'embarrassed',
      'face',
      'feelings',
      'grateful',
      'gratitude',
      'holding',
      'joy',
      'please',
      'proud',
      'resist',
      'sad',
      'tears',
    ],
    group: '',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f979.png',
  },
  {
    emoji: '😦',
    name: 'frowning',
    shortcodes: ['frowning', 'frowning_face'],
    tags: [
      'caught',
      'face',
      'frown',
      'frowning',
      'guard',
      'mouth',
      'open',
      'scared',
      'scary',
      'surprise',
      'what',
      'wow',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f626.png',
  },
  {
    emoji: '😧',
    name: 'anguished',
    shortcodes: ['anguished', 'anguished_face'],
    tags: [
      'anguished',
      'face',
      'forgot',
      'scared',
      'scary',
      'stressed',
      'surprise',
      'unhappy',
      'what',
      'wow',
    ],
    group: '',
    emoticons: [':s', ':S'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f627.png',
  },
  {
    emoji: '😨',
    name: 'fearful',
    shortcodes: ['fearful', 'fearful_face'],
    tags: ['afraid', 'anxious', 'blame', 'face', 'fear', 'fearful', 'scared', 'worried'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f628.png',
  },
  {
    emoji: '😰',
    name: 'cold_sweat',
    shortcodes: ['anxious', 'anxious_face', 'cold_sweat'],
    tags: [
      'anxious',
      'blue',
      'cold',
      'eek',
      'face',
      'mouth',
      'nervous',
      'open',
      'rushed',
      'scared',
      'sweat',
      'yikes',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f630.png',
  },
  {
    emoji: '😥',
    name: 'disappointed_relieved',
    shortcodes: ['disappointed_relieved', 'sad_relieved_face'],
    tags: [
      'anxious',
      'call',
      'close',
      'complicated',
      'disappointed',
      'face',
      'not',
      'relieved',
      'sad',
      'sweat',
      'time',
      'whew',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f625.png',
  },
  {
    emoji: '😢',
    name: 'cry',
    shortcodes: ['cry', 'crying_face'],
    tags: ['awful', 'cry', 'crying', 'face', 'feels', 'miss', 'sad', 'tear', 'triste', 'unhappy'],
    group: '',
    emoticons: [":'("],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f622.png',
  },
  {
    emoji: '😭',
    name: 'sob',
    shortcodes: ['loudly_crying_face', 'sob'],
    tags: ['bawling', 'cry', 'crying', 'face', 'loudly', 'sad', 'sob', 'tear', 'tears', 'unhappy'],
    group: '',
    emoticons: [":'o"],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62d.png',
  },
  {
    emoji: '😱',
    name: 'scream',
    shortcodes: ['scream', 'screaming_in_fear'],
    tags: [
      'epic',
      'face',
      'fear',
      'fearful',
      'munch',
      'scared',
      'scream',
      'screamer',
      'screaming',
      'shocked',
      'surprised',
      'woah',
    ],
    group: '',
    emoticons: ['Dx'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f631.png',
  },
  {
    emoji: '😖',
    name: 'confounded',
    shortcodes: ['confounded', 'confounded_face'],
    tags: [
      'annoyed',
      'confounded',
      'confused',
      'cringe',
      'distraught',
      'face',
      'feels',
      'frustrated',
      'mad',
      'sad',
    ],
    group: '',
    emoticons: ['x(', 'X('],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f616.png',
  },
  {
    emoji: '😣',
    name: 'persevere',
    shortcodes: ['persevere', 'persevering_face'],
    tags: ['concentrate', 'concentration', 'face', 'focus', 'headache', 'persevere', 'persevering'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f623.png',
  },
  {
    emoji: '😞',
    name: 'disappointed',
    shortcodes: ['disappointed', 'disappointed_face'],
    tags: [
      'awful',
      'blame',
      'dejected',
      'disappointed',
      'face',
      'fail',
      'losing',
      'sad',
      'unhappy',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f61e.png',
  },
  {
    emoji: '😓',
    name: 'sweat',
    shortcodes: ['downcast_face', 'sweat'],
    tags: [
      'close',
      'cold',
      'downcast',
      'face',
      'feels',
      'headache',
      'nervous',
      'sad',
      'scared',
      'sweat',
      'yikes',
    ],
    group: '',
    emoticons: [':<'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f613.png',
  },
  {
    emoji: '😩',
    name: 'weary',
    shortcodes: ['weary', 'weary_face'],
    tags: [
      'crying',
      'face',
      'fail',
      'feels',
      'hungry',
      'mad',
      'nooo',
      'sad',
      'sleepy',
      'tired',
      'unhappy',
      'weary',
    ],
    group: '',
    emoticons: ['D:'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f629.png',
  },
  {
    emoji: '😫',
    name: 'tired_face',
    shortcodes: ['tired', 'tired_face'],
    tags: ['cost', 'face', 'feels', 'nap', 'sad', 'sneeze', 'tired'],
    group: '',
    emoticons: [':c', ':C'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f62b.png',
  },
  {
    emoji: '🥱',
    name: 'yawning_face',
    shortcodes: ['yawn', 'yawning', 'yawning_face'],
    tags: [
      'bedtime',
      'bored',
      'face',
      'goodnight',
      'nap',
      'night',
      'sleep',
      'sleepy',
      'tired',
      'whatever',
      'yawn',
      'yawning',
      'zzz',
    ],
    group: '',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f971.png',
  },
  {
    emoji: '😤',
    name: 'triumph',
    shortcodes: ['nose_steam', 'triumph'],
    tags: [
      'anger',
      'angry',
      'face',
      'feels',
      'fume',
      'fuming',
      'furious',
      'fury',
      'mad',
      'nose',
      'steam',
      'triumph',
      'unhappy',
      'won',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f624.png',
  },
  {
    emoji: '😡',
    name: 'pout',
    shortcodes: ['pout', 'pouting_face', 'rage'],
    tags: [
      'anger',
      'angry',
      'enraged',
      'face',
      'feels',
      'mad',
      'maddening',
      'pouting',
      'rage',
      'red',
      'shade',
      'unhappy',
      'upset',
    ],
    group: '',
    emoticons: ['>:/'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f621.png',
  },
  {
    emoji: '😠',
    name: 'angry',
    shortcodes: ['angry', 'angry_face'],
    tags: [
      'anger',
      'angry',
      'blame',
      'face',
      'feels',
      'frustrated',
      'mad',
      'maddening',
      'rage',
      'shade',
      'unhappy',
      'upset',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f620.png',
  },
  {
    emoji: '🤬',
    name: 'cursing_face',
    shortcodes: ['censored', 'face_with_symbols_on_mouth'],
    tags: ['censor', 'cursing', 'cussing', 'face', 'mad', 'mouth', 'pissed', 'swearing', 'symbols'],
    group: '',
    emoticons: [':@'],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f92c.png',
  },
  {
    emoji: '😈',
    name: 'smiling_imp',
    shortcodes: ['smiling_imp'],
    tags: [
      'demon',
      'devil',
      'evil',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'horns',
      'purple',
      'shade',
      'smile',
      'smiling',
      'tale',
    ],
    group: '',
    emoticons: ['>:)'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f608.png',
  },
  {
    emoji: '👿',
    name: 'imp',
    shortcodes: ['angry_imp', 'imp'],
    tags: [
      'angry',
      'demon',
      'devil',
      'evil',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'horns',
      'imp',
      'mischievous',
      'purple',
      'shade',
      'tale',
    ],
    group: '',
    emoticons: ['>:('],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47f.png',
  },
  {
    emoji: '💀',
    name: 'skull',
    shortcodes: ['skull'],
    tags: [
      'body',
      'dead',
      'death',
      'face',
      'fairy',
      'fairytale',
      'i’m',
      'lmao',
      'monster',
      'tale',
      'yolo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f480.png',
  },
  {
    emoji: '☠',
    name: 'skull_and_crossbones',
    shortcodes: ['skull_and_crossbones'],
    tags: ['bone', 'crossbones', 'dead', 'death', 'face', 'monster', 'skull'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2620-fe0f.png',
  },
  {
    emoji: '💩',
    name: 'hankey',
    shortcodes: ['poop', 'shit'],
    tags: [
      'bs',
      'comic',
      'doo',
      'dung',
      'face',
      'fml',
      'monster',
      'pile',
      'poo',
      'poop',
      'smelly',
      'smh',
      'stink',
      'stinks',
      'stinky',
      'turd',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a9.png',
  },
  {
    emoji: '🤡',
    name: 'clown_face',
    shortcodes: ['clown', 'clown_face'],
    tags: ['clown', 'face'],
    group: '',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f921.png',
  },
  {
    emoji: '👹',
    name: 'japanese_ogre',
    shortcodes: ['japanese_ogre', 'ogre'],
    tags: [
      'creature',
      'devil',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'mask',
      'monster',
      'scary',
      'tale',
    ],
    group: '',
    emoticons: ['>0)'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f479.png',
  },
  {
    emoji: '👺',
    name: 'japanese_goblin',
    shortcodes: ['goblin', 'japanese_goblin'],
    tags: [
      'angry',
      'creature',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'mask',
      'mean',
      'monster',
      'tale',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47a.png',
  },
  {
    emoji: '👻',
    name: 'ghost',
    shortcodes: ['ghost'],
    tags: [
      'boo',
      'creature',
      'excited',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'halloween',
      'haunting',
      'monster',
      'scary',
      'silly',
      'tale',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47b.png',
  },
  {
    emoji: '👽',
    name: 'alien',
    shortcodes: ['alien'],
    tags: [
      'creature',
      'extraterrestrial',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'monster',
      'space',
      'tale',
      'ufo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47d.png',
  },
  {
    emoji: '👾',
    name: 'space_invader',
    shortcodes: ['alien_monster', 'space_invader'],
    tags: [
      'alien',
      'creature',
      'extraterrestrial',
      'face',
      'fairy',
      'fairytale',
      'fantasy',
      'game',
      'gamer',
      'games',
      'monster',
      'pixelated',
      'space',
      'tale',
      'ufo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47e.png',
  },
  {
    emoji: '🤖',
    name: 'robot',
    shortcodes: ['robot', 'robot_face'],
    tags: ['face', 'monster'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f916.png',
  },
  {
    emoji: '😺',
    name: 'smiley_cat',
    shortcodes: ['grinning_cat', 'smiley_cat'],
    tags: ['animal', 'cat', 'face', 'grinning', 'mouth', 'open', 'smile', 'smiling'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63a.png',
  },
  {
    emoji: '😸',
    name: 'smile_cat',
    shortcodes: ['grinning_cat_with_closed_eyes', 'smile_cat'],
    tags: ['animal', 'cat', 'eye', 'eyes', 'face', 'grin', 'grinning', 'smile', 'smiling'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f638.png',
  },
  {
    emoji: '😹',
    name: 'joy_cat',
    shortcodes: ['joy_cat', 'tears_of_joy_cat'],
    tags: ['animal', 'cat', 'face', 'joy', 'laugh', 'laughing', 'lol', 'tear', 'tears'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f639.png',
  },
  {
    emoji: '😻',
    name: 'heart_eyes_cat',
    shortcodes: ['heart_eyes_cat', 'smiling_cat_with_heart_eyes'],
    tags: ['animal', 'cat', 'eye', 'face', 'heart', 'heart-eyes', 'love', 'smile', 'smiling'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63b.png',
  },
  {
    emoji: '😼',
    name: 'smirk_cat',
    shortcodes: ['smirk_cat', 'wry_smile_cat'],
    tags: ['animal', 'cat', 'face', 'ironic', 'smile', 'wry'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63c.png',
  },
  {
    emoji: '😽',
    name: 'kissing_cat',
    shortcodes: ['kissing_cat'],
    tags: ['animal', 'cat', 'closed', 'eye', 'eyes', 'face', 'kiss', 'kissing'],
    group: '',
    emoticons: [':3'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63d.png',
  },
  {
    emoji: '🙀',
    name: 'scream_cat',
    shortcodes: ['scream_cat', 'weary_cat'],
    tags: ['animal', 'cat', 'face', 'oh', 'surprised', 'weary'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f640.png',
  },
  {
    emoji: '😿',
    name: 'crying_cat_face',
    shortcodes: ['crying_cat'],
    tags: ['animal', 'cat', 'cry', 'crying', 'face', 'sad', 'tear'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63f.png',
  },
  {
    emoji: '😾',
    name: 'pouting_cat',
    shortcodes: ['pouting_cat'],
    tags: ['animal', 'cat', 'face', 'pouting'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63e.png',
  },
  {
    emoji: '🙈',
    name: 'see_no_evil',
    shortcodes: ['see_no_evil'],
    tags: [
      'embarrassed',
      'evil',
      'face',
      'forbidden',
      'forgot',
      'gesture',
      'hide',
      'monkey',
      'no',
      'omg',
      'prohibited',
      'scared',
      'secret',
      'smh',
      'watch',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f648.png',
  },
  {
    emoji: '🙉',
    name: 'hear_no_evil',
    shortcodes: ['hear_no_evil'],
    tags: [
      'animal',
      'ears',
      'evil',
      'face',
      'forbidden',
      'gesture',
      'hear',
      'listen',
      'monkey',
      'no',
      'not',
      'prohibited',
      'secret',
      'shh',
      'tmi',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f649.png',
  },
  {
    emoji: '🙊',
    name: 'speak_no_evil',
    shortcodes: ['speak_no_evil'],
    tags: [
      'animal',
      'evil',
      'face',
      'forbidden',
      'gesture',
      'monkey',
      'no',
      'not',
      'oops',
      'prohibited',
      'quiet',
      'secret',
      'speak',
      'stealth',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64a.png',
  },
  {
    emoji: '💌',
    name: 'love_letter',
    shortcodes: ['love_letter'],
    tags: ['heart', 'letter', 'love', 'mail', 'romance', 'valentine'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48c.png',
  },
  {
    emoji: '💘',
    name: 'cupid',
    shortcodes: ['cupid', 'heart_with_arrow'],
    tags: [
      '143',
      'adorbs',
      'arrow',
      'cupid',
      'date',
      'emotion',
      'heart',
      'ily',
      'love',
      'romance',
      'valentine',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f498.png',
  },
  {
    emoji: '💝',
    name: 'gift_heart',
    shortcodes: ['gift_heart', 'heart_with_ribbon'],
    tags: [
      '143',
      'anniversary',
      'emotion',
      'heart',
      'ily',
      'kisses',
      'ribbon',
      'valentine',
      'xoxo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49d.png',
  },
  {
    emoji: '💖',
    name: 'sparkling_heart',
    shortcodes: ['sparkling_heart'],
    tags: [
      '143',
      'emotion',
      'excited',
      'good',
      'heart',
      'ily',
      'kisses',
      'morning',
      'night',
      'sparkle',
      'sparkling',
      'xoxo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f496.png',
  },
  {
    emoji: '💗',
    name: 'heartpulse',
    shortcodes: ['growing_heart', 'heartpulse'],
    tags: [
      '143',
      'emotion',
      'excited',
      'growing',
      'heart',
      'heartpulse',
      'ily',
      'kisses',
      'muah',
      'nervous',
      'pulse',
      'xoxo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f497.png',
  },
  {
    emoji: '💓',
    name: 'heartbeat',
    shortcodes: ['beating_heart', 'heartbeat'],
    tags: [
      '143',
      'beating',
      'cardio',
      'emotion',
      'heart',
      'heartbeat',
      'ily',
      'love',
      'pulsating',
      'pulse',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f493.png',
  },
  {
    emoji: '💞',
    name: 'revolving_hearts',
    shortcodes: ['revolving_hearts'],
    tags: ['143', 'adorbs', 'anniversary', 'emotion', 'heart', 'hearts', 'revolving'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49e.png',
  },
  {
    emoji: '💕',
    name: 'two_hearts',
    shortcodes: ['two_hearts'],
    tags: [
      '143',
      'anniversary',
      'date',
      'dating',
      'emotion',
      'heart',
      'hearts',
      'ily',
      'kisses',
      'love',
      'loving',
      'two',
      'xoxo',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f495.png',
  },
  {
    emoji: '💟',
    name: 'heart_decoration',
    shortcodes: ['heart_decoration'],
    tags: ['143', 'decoration', 'emotion', 'heart', 'hearth', 'purple', 'white'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49f.png',
  },
  {
    emoji: '❣',
    name: 'heavy_heart_exclamation',
    shortcodes: ['heart_exclamation'],
    tags: ['exclamation', 'heart', 'heavy', 'mark', 'punctuation'],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2763-fe0f.png',
  },
  {
    emoji: '💔',
    name: 'broken_heart',
    shortcodes: ['broken_heart'],
    tags: ['break', 'broken', 'crushed', 'emotion', 'heart', 'heartbroken', 'lonely', 'sad'],
    group: '',
    emoticons: ['</3'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f494.png',
  },
  {
    emoji: '❤‍🔥',
    name: 'heart_on_fire',
    shortcodes: ['heart_on_fire'],
    tags: ['burn', 'fire', 'heart', 'love', 'lust', 'sacred'],
    group: '',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2764-fe0f-200d-1f525.png',
  },
  {
    emoji: '❤‍🩹',
    name: 'mending_heart',
    shortcodes: ['mending_heart'],
    tags: ['healthier', 'heart', 'improving', 'mending', 'recovering', 'recuperating', 'well'],
    group: '',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2764-fe0f-200d-1fa79.png',
  },
  {
    emoji: '❤',
    name: 'heart',
    shortcodes: ['heart', 'red_heart'],
    tags: ['emotion', 'heart', 'love', 'red'],
    group: '',
    emoticons: ['<3'],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2764-fe0f.png',
  },
  {
    emoji: '🩷',
    name: 'pink_heart',
    shortcodes: ['pink_heart'],
    tags: [
      '143',
      'adorable',
      'cute',
      'emotion',
      'heart',
      'ily',
      'like',
      'love',
      'pink',
      'special',
      'sweet',
    ],
    group: '',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa77.png',
  },
  {
    emoji: '🧡',
    name: 'orange_heart',
    shortcodes: ['orange_heart'],
    tags: ['143', 'heart', 'orange'],
    group: '',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e1.png',
  },
  {
    emoji: '💛',
    name: 'yellow_heart',
    shortcodes: ['yellow_heart'],
    tags: ['143', 'cardiac', 'emotion', 'heart', 'ily', 'love', 'yellow'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49b.png',
  },
  {
    emoji: '💚',
    name: 'green_heart',
    shortcodes: ['green_heart'],
    tags: ['143', 'emotion', 'green', 'heart', 'ily', 'love', 'romantic'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49a.png',
  },
  {
    emoji: '💙',
    name: 'blue_heart',
    shortcodes: ['blue_heart'],
    tags: ['143', 'blue', 'emotion', 'heart', 'ily', 'love', 'romance'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f499.png',
  },
  {
    emoji: '🩵',
    name: 'light_blue_heart',
    shortcodes: ['light_blue_heart'],
    tags: [
      '143',
      'blue',
      'cute',
      'cyan',
      'emotion',
      'heart',
      'ily',
      'light',
      'like',
      'love',
      'sky',
      'special',
      'teal',
    ],
    group: '',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa75.png',
  },
  {
    emoji: '💜',
    name: 'purple_heart',
    shortcodes: ['purple_heart'],
    tags: ['143', 'bestest', 'emotion', 'heart', 'ily', 'love', 'purple'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f49c.png',
  },
  {
    emoji: '🤎',
    name: 'brown_heart',
    shortcodes: ['brown_heart'],
    tags: ['143', 'brown', 'heart'],
    group: '',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90e.png',
  },
  {
    emoji: '🖤',
    name: 'black_heart',
    shortcodes: ['black_heart'],
    tags: ['black', 'evil', 'heart', 'wicked'],
    group: '',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5a4.png',
  },
  {
    emoji: '🩶',
    name: 'grey_heart',
    shortcodes: ['gray_heart', 'grey_heart'],
    tags: ['143', 'emotion', 'gray', 'grey', 'heart', 'ily', 'love', 'silver', 'slate', 'special'],
    group: '',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa76.png',
  },
  {
    emoji: '🤍',
    name: 'white_heart',
    shortcodes: ['white_heart'],
    tags: ['143', 'heart', 'white'],
    group: '',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90d.png',
  },
  {
    emoji: '💋',
    name: 'kiss',
    shortcodes: ['kiss'],
    tags: ['dating', 'emotion', 'heart', 'kiss', 'kissing', 'lips', 'mark', 'romance', 'sexy'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48b.png',
  },
  {
    emoji: '💯',
    name: '100',
    shortcodes: ['100'],
    tags: [
      '100',
      'a+',
      'agree',
      'clearly',
      'definitely',
      'faithful',
      'fleek',
      'full',
      'hundred',
      'keep',
      'perfect',
      'point',
      'score',
      'true',
      'truth',
      'yup',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4af.png',
  },
  {
    emoji: '💢',
    name: 'anger',
    shortcodes: ['anger'],
    tags: ['anger', 'angry', 'comic', 'mad', 'symbol', 'upset'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a2.png',
  },
  {
    emoji: '🫯',
    name: 'fight_cloud',
    shortcodes: ['fight_cloud'],
    tags: ['argument', 'brawl', 'debate', 'disagreement', 'fight', 'ruckus', 'wrestle'],
    group: '',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '💥',
    name: 'boom',
    shortcodes: ['boom', 'collision'],
    tags: ['bomb', 'boom', 'collide', 'comic', 'explode'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a5.png',
  },
  {
    emoji: '💫',
    name: 'dizzy',
    shortcodes: ['dizzy'],
    tags: ['comic', 'shining', 'shooting', 'star', 'stars'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ab.png',
  },
  {
    emoji: '💦',
    name: 'sweat_drops',
    shortcodes: ['sweat_drops'],
    tags: [
      'comic',
      'drip',
      'droplet',
      'droplets',
      'drops',
      'splashing',
      'squirt',
      'sweat',
      'water',
      'wet',
      'work',
      'workout',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a6.png',
  },
  {
    emoji: '💨',
    name: 'dash',
    shortcodes: ['dash', 'dashing_away'],
    tags: [
      'away',
      'cloud',
      'comic',
      'dash',
      'dashing',
      'fart',
      'fast',
      'go',
      'gone',
      'gotta',
      'running',
      'smoke',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a8.png',
  },
  {
    emoji: '🕳',
    name: 'hole',
    shortcodes: ['hole'],
    tags: ['hole'],
    group: '',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f573-fe0f.png',
  },
  {
    emoji: '💬',
    name: 'speech_balloon',
    shortcodes: ['speech_balloon'],
    tags: [
      'balloon',
      'bubble',
      'comic',
      'dialog',
      'message',
      'sms',
      'speech',
      'talk',
      'text',
      'typing',
    ],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ac.png',
  },
  {
    emoji: '👁‍🗨️',
    name: 'eye_speech_bubble',
    shortcodes: ['eye_in_speech_bubble'],
    tags: ['balloon', 'bubble', 'eye', 'speech', 'witness'],
    group: '',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f441-fe0f-200d-1f5e8-fe0f.png',
  },
  {
    emoji: '🗨',
    name: 'left_speech_bubble',
    shortcodes: ['left_speech_bubble'],
    tags: ['balloon', 'bubble', 'dialog', 'left', 'speech'],
    group: '',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5e8-fe0f.png',
  },
  {
    emoji: '🗯',
    name: 'right_anger_bubble',
    shortcodes: ['right_anger_bubble'],
    tags: ['anger', 'angry', 'balloon', 'bubble', 'mad', 'right'],
    group: '',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5ef-fe0f.png',
  },
  {
    emoji: '💭',
    name: 'thought_balloon',
    shortcodes: ['thought_balloon'],
    tags: [
      'balloon',
      'bubble',
      'cartoon',
      'cloud',
      'comic',
      'daydream',
      'decisions',
      'dream',
      'idea',
      'invent',
      'invention',
      'realize',
      'think',
      'thoughts',
      'wonder',
    ],
    group: '',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ad.png',
  },
  {
    emoji: '💤',
    name: 'zzz',
    shortcodes: ['zzz'],
    tags: ['comic', 'good', 'goodnight', 'night', 'sleep', 'sleeping', 'sleepy', 'tired', 'zzz'],
    group: '',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a4.png',
  },
  {
    emoji: '👋',
    name: 'wave',
    shortcodes: ['wave', 'waving_hand'],
    tags: [
      'bye',
      'cya',
      'g2g',
      'greetings',
      'gtg',
      'hand',
      'hello',
      'hey',
      'hi',
      'later',
      'outtie',
      'ttfn',
      'ttyl',
      'wave',
      'yo',
      'you',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44b.png',
  },
  {
    emoji: '🤚',
    name: 'raised_back_of_hand',
    shortcodes: ['raised_back_of_hand'],
    tags: ['back', 'backhand', 'hand', 'raised'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91a.png',
  },
  {
    emoji: '🖐',
    name: 'raised_hand_with_fingers_splayed',
    shortcodes: ['raised_hand_with_fingers_splayed'],
    tags: ['finger', 'fingers', 'hand', 'raised', 'splayed', 'stop'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f590-fe0f.png',
  },
  {
    emoji: '✋',
    name: 'hand',
    shortcodes: ['high_five', 'raised_hand'],
    tags: ['5', 'five', 'hand', 'high', 'raised', 'stop'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270b.png',
  },
  {
    emoji: '🖖',
    name: 'vulcan_salute',
    shortcodes: ['vulcan'],
    tags: ['finger', 'hand', 'hands', 'salute', 'vulcan'],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f596.png',
  },
  {
    emoji: '🫱',
    name: 'rightwards_hand',
    shortcodes: ['rightwards_hand'],
    tags: ['hand', 'handshake', 'hold', 'reach', 'right', 'rightward', 'rightwards', 'shake'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf1.png',
  },
  {
    emoji: '🫲',
    name: 'leftwards_hand',
    shortcodes: ['leftwards_hand'],
    tags: ['hand', 'handshake', 'hold', 'left', 'leftward', 'leftwards', 'reach', 'shake'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf2.png',
  },
  {
    emoji: '🫳',
    name: 'palm_down_hand',
    shortcodes: ['palm_down'],
    tags: ['dismiss', 'down', 'drop', 'dropped', 'hand', 'palm', 'pick', 'shoo', 'up'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf3.png',
  },
  {
    emoji: '🫴',
    name: 'palm_up_hand',
    shortcodes: ['palm_up'],
    tags: [
      'beckon',
      'catch',
      'come',
      'hand',
      'hold',
      'know',
      'lift',
      'me',
      'offer',
      'palm',
      'tell',
    ],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf4.png',
  },
  {
    emoji: '🫷',
    name: 'leftwards_pushing_hand',
    shortcodes: ['leftwards_pushing_hand'],
    tags: [
      'block',
      'five',
      'halt',
      'hand',
      'high',
      'hold',
      'leftward',
      'leftwards',
      'pause',
      'push',
      'pushing',
      'refuse',
      'slap',
      'stop',
      'wait',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf7.png',
  },
  {
    emoji: '🫸',
    name: 'rightwards_pushing_hand',
    shortcodes: ['rightwards_pushing_hand'],
    tags: [
      'block',
      'five',
      'halt',
      'hand',
      'high',
      'hold',
      'pause',
      'push',
      'pushing',
      'refuse',
      'rightward',
      'rightwards',
      'slap',
      'stop',
      'wait',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf8.png',
  },
  {
    emoji: '👌',
    name: 'ok_hand',
    shortcodes: ['ok_hand'],
    tags: [
      'awesome',
      'bet',
      'dope',
      'fleek',
      'fosho',
      'got',
      'gotcha',
      'hand',
      'legit',
      'ok',
      'okay',
      'pinch',
      'rad',
      'sure',
      'sweet',
      'three',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44c.png',
  },
  {
    emoji: '🤌',
    name: 'pinched_fingers',
    shortcodes: ['pinch', 'pinched_fingers'],
    tags: [
      'fingers',
      'gesture',
      'hand',
      'hold',
      'huh',
      'interrogation',
      'patience',
      'pinched',
      'relax',
      'sarcastic',
      'ugh',
      'what',
      'zip',
    ],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90c.png',
  },
  {
    emoji: '🤏',
    name: 'pinching_hand',
    shortcodes: ['pinching_hand'],
    tags: ['amount', 'bit', 'fingers', 'hand', 'little', 'pinching', 'small', 'sort'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f90f.png',
  },
  {
    emoji: '✌',
    name: 'v',
    shortcodes: ['v', 'victory'],
    tags: ['hand', 'peace', 'v', 'victory'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270c-fe0f.png',
  },
  {
    emoji: '🤞',
    name: 'crossed_fingers',
    shortcodes: ['fingers_crossed'],
    tags: ['cross', 'crossed', 'finger', 'fingers', 'hand', 'luck'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91e.png',
  },
  {
    emoji: '🫰',
    name: 'hand_with_index_finger_and_thumb_crossed',
    shortcodes: ['hand_with_index_finger_and_thumb_crossed'],
    tags: [
      '<3',
      'crossed',
      'expensive',
      'finger',
      'hand',
      'heart',
      'index',
      'love',
      'money',
      'snap',
      'thumb',
    ],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf0.png',
  },
  {
    emoji: '🤟',
    name: 'love_you_gesture',
    shortcodes: ['love_you_gesture'],
    tags: ['fingers', 'gesture', 'hand', 'ily', 'love', 'love-you', 'three', 'you'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91f.png',
  },
  {
    emoji: '🤘',
    name: 'metal',
    shortcodes: ['metal', 'sign_of_the_horns'],
    tags: ['finger', 'hand', 'horns', 'rock-on', 'sign'],
    group: 'people & body',
    emoticons: ['\\m/', '\\M/'],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f918.png',
  },
  {
    emoji: '🤙',
    name: 'call_me_hand',
    shortcodes: ['call_me_hand'],
    tags: ['call', 'hand', 'hang', 'loose', 'me', 'shaka'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f919.png',
  },
  {
    emoji: '👈',
    name: 'point_left',
    shortcodes: ['point_left'],
    tags: ['backhand', 'finger', 'hand', 'index', 'left', 'point', 'pointing'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f448.png',
  },
  {
    emoji: '👉',
    name: 'point_right',
    shortcodes: ['point_right'],
    tags: ['backhand', 'finger', 'hand', 'index', 'point', 'pointing', 'right'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f449.png',
  },
  {
    emoji: '👆',
    name: 'point_up_2',
    shortcodes: ['point_up'],
    tags: ['backhand', 'finger', 'hand', 'index', 'point', 'pointing', 'up'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f446.png',
  },
  {
    emoji: '🖕',
    name: 'fu',
    shortcodes: ['middle_finger'],
    tags: ['finger', 'hand', 'middle'],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f595.png',
  },
  {
    emoji: '👇',
    name: 'point_down',
    shortcodes: ['point_down'],
    tags: ['backhand', 'down', 'finger', 'hand', 'index', 'point', 'pointing'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f447.png',
  },
  {
    emoji: '☝',
    name: 'point_up',
    shortcodes: ['point_up_2'],
    tags: ['finger', 'hand', 'index', 'point', 'pointing', 'this', 'up'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/261d-fe0f.png',
  },
  {
    emoji: '🫵',
    name: 'index_pointing_at_the_viewer',
    shortcodes: ['point_forward'],
    tags: ['at', 'finger', 'hand', 'index', 'pointing', 'poke', 'viewer', 'you'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf5.png',
  },
  {
    emoji: '👍',
    name: '+1',
    shortcodes: ['+1', 'thumbsup', 'yes'],
    tags: ['+1', 'good', 'hand', 'like', 'thumb', 'up', 'yes'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44d.png',
  },
  {
    emoji: '👎',
    name: '-1',
    shortcodes: ['-1', 'no', 'thumbsdown'],
    tags: ['-1', 'bad', 'dislike', 'down', 'good', 'hand', 'no', 'nope', 'thumb', 'thumbs'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44e.png',
  },
  {
    emoji: '✊',
    name: 'fist',
    shortcodes: ['fist'],
    tags: ['clenched', 'fist', 'hand', 'punch', 'raised', 'solidarity'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270a.png',
  },
  {
    emoji: '👊',
    name: 'facepunch',
    shortcodes: ['punch'],
    tags: [
      'absolutely',
      'agree',
      'boom',
      'bro',
      'bruh',
      'bump',
      'clenched',
      'correct',
      'fist',
      'hand',
      'knuckle',
      'oncoming',
      'pound',
      'punch',
      'rock',
      'ttyl',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44a.png',
  },
  {
    emoji: '🤛',
    name: 'fist_left',
    shortcodes: ['left_facing_fist'],
    tags: ['fist', 'left-facing', 'leftwards'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91b.png',
  },
  {
    emoji: '🤜',
    name: 'fist_right',
    shortcodes: ['right_facing_fist'],
    tags: ['fist', 'right-facing', 'rightwards'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91c.png',
  },
  {
    emoji: '👏',
    name: 'clap',
    shortcodes: ['clap', 'clapping_hands'],
    tags: [
      'applause',
      'approval',
      'awesome',
      'clap',
      'congrats',
      'congratulations',
      'excited',
      'good',
      'great',
      'hand',
      'homie',
      'job',
      'nice',
      'prayed',
      'well',
      'yay',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f44f.png',
  },
  {
    emoji: '🙌',
    name: 'raised_hands',
    shortcodes: ['raised_hands'],
    tags: ['celebration', 'gesture', 'hand', 'hands', 'hooray', 'praise', 'raised', 'raising'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64c.png',
  },
  {
    emoji: '🫶',
    name: 'heart_hands',
    shortcodes: ['heart_hands'],
    tags: ['<3', 'hands', 'heart', 'love', 'you'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faf6.png',
  },
  {
    emoji: '👐',
    name: 'open_hands',
    shortcodes: ['open_hands'],
    tags: ['hand', 'hands', 'hug', 'jazz', 'open', 'swerve'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f450.png',
  },
  {
    emoji: '🤲',
    name: 'palms_up_together',
    shortcodes: ['palms_up_together'],
    tags: ['cupped', 'dua', 'hands', 'palms', 'pray', 'prayer', 'together', 'up', 'wish'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f932.png',
  },
  {
    emoji: '🤝',
    name: 'handshake',
    shortcodes: ['handshake'],
    tags: ['agreement', 'deal', 'hand', 'meeting', 'shake'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f91d.png',
  },
  {
    emoji: '🙏',
    name: 'pray',
    shortcodes: ['folded_hands', 'pray'],
    tags: [
      'appreciate',
      'ask',
      'beg',
      'blessed',
      'bow',
      'cmon',
      'five',
      'folded',
      'gesture',
      'hand',
      'high',
      'please',
      'pray',
      'thanks',
      'thx',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64f.png',
  },
  {
    emoji: '✍',
    name: 'writing_hand',
    shortcodes: ['writing_hand'],
    tags: ['hand', 'write', 'writing'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270d-fe0f.png',
  },
  {
    emoji: '💅',
    name: 'nail_care',
    shortcodes: ['nail_care', 'nail_polish'],
    tags: [
      'bored',
      'care',
      'cosmetics',
      'done',
      'makeup',
      'manicure',
      'nail',
      'polish',
      'whatever',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f485.png',
  },
  {
    emoji: '🤳',
    name: 'selfie',
    shortcodes: ['selfie'],
    tags: ['camera', 'phone'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f933.png',
  },
  {
    emoji: '💪',
    name: 'muscle',
    shortcodes: ['muscle', 'right_bicep'],
    tags: [
      'arm',
      'beast',
      'bench',
      'biceps',
      'bodybuilder',
      'bro',
      'curls',
      'flex',
      'gains',
      'gym',
      'jacked',
      'muscle',
      'press',
      'ripped',
      'strong',
      'weightlift',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4aa.png',
  },
  {
    emoji: '🦾',
    name: 'mechanical_arm',
    shortcodes: ['mechanical_arm'],
    tags: ['accessibility', 'arm', 'mechanical', 'prosthetic'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9be.png',
  },
  {
    emoji: '🦿',
    name: 'mechanical_leg',
    shortcodes: ['mechanical_leg'],
    tags: ['accessibility', 'leg', 'mechanical', 'prosthetic'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bf.png',
  },
  {
    emoji: '🦵',
    name: 'leg',
    shortcodes: ['leg'],
    tags: ['bent', 'foot', 'kick', 'knee', 'limb'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b5.png',
  },
  {
    emoji: '🦶',
    name: 'foot',
    shortcodes: ['foot'],
    tags: ['ankle', 'feet', 'kick', 'stomp'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b6.png',
  },
  {
    emoji: '👂',
    name: 'ear',
    shortcodes: ['ear'],
    tags: ['body', 'ears', 'hear', 'hearing', 'listen', 'listening', 'sound'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f442.png',
  },
  {
    emoji: '🦻',
    name: 'ear_with_hearing_aid',
    shortcodes: ['ear_with_hearing_aid', 'hearing_aid'],
    tags: ['accessibility', 'aid', 'ear', 'hard', 'hearing'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bb.png',
  },
  {
    emoji: '👃',
    name: 'nose',
    shortcodes: ['nose'],
    tags: ['body', 'noses', 'nosey', 'odor', 'smell', 'smells'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f443.png',
  },
  {
    emoji: '🧠',
    name: 'brain',
    shortcodes: ['brain'],
    tags: ['intelligent', 'smart'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e0.png',
  },
  {
    emoji: '🫀',
    name: 'anatomical_heart',
    shortcodes: ['anatomical_heart'],
    tags: [
      'anatomical',
      'beat',
      'cardiology',
      'heart',
      'heartbeat',
      'organ',
      'pulse',
      'real',
      'red',
    ],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac0.png',
  },
  {
    emoji: '🫁',
    name: 'lungs',
    shortcodes: ['lungs'],
    tags: ['breath', 'breathe', 'exhalation', 'inhalation', 'lung', 'organ', 'respiration'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac1.png',
  },
  {
    emoji: '🦷',
    name: 'tooth',
    shortcodes: ['tooth'],
    tags: ['dentist', 'pearly', 'teeth', 'white'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b7.png',
  },
  {
    emoji: '🦴',
    name: 'bone',
    shortcodes: ['bone'],
    tags: ['bones', 'dog', 'skeleton', 'wishbone'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b4.png',
  },
  {
    emoji: '👀',
    name: 'eyes',
    shortcodes: ['eyes'],
    tags: ['body', 'eye', 'face', 'googly', 'look', 'looking', 'omg', 'peep', 'see', 'seeing'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f440.png',
  },
  {
    emoji: '👁',
    name: 'eye',
    shortcodes: ['eye'],
    tags: ['1', 'body', 'one'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f441-fe0f.png',
  },
  {
    emoji: '👅',
    name: 'tongue',
    shortcodes: ['tongue'],
    tags: ['body', 'lick', 'slurp'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f445.png',
  },
  {
    emoji: '👄',
    name: 'lips',
    shortcodes: ['lips', 'mouth'],
    tags: ['beauty', 'body', 'kiss', 'kissing', 'lips', 'lipstick'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f444.png',
  },
  {
    emoji: '🫦',
    name: 'biting_lip',
    shortcodes: ['biting_lip'],
    tags: [
      'anxious',
      'bite',
      'biting',
      'fear',
      'flirt',
      'flirting',
      'kiss',
      'lip',
      'lipstick',
      'nervous',
      'sexy',
      'uncomfortable',
      'worried',
      'worry',
    ],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae6.png',
  },
  {
    emoji: '👶',
    name: 'baby',
    shortcodes: ['baby'],
    tags: ['babies', 'children', 'goo', 'infant', 'newborn', 'pregnant', 'young'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f476.png',
  },
  {
    emoji: '🧒',
    name: 'child',
    shortcodes: ['child'],
    tags: ['bright-eyed', 'grandchild', 'kid', 'young', 'younger'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d2.png',
  },
  {
    emoji: '👦',
    name: 'boy',
    shortcodes: ['boy'],
    tags: ['bright-eyed', 'child', 'grandson', 'kid', 'son', 'young', 'younger'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f466.png',
  },
  {
    emoji: '👧',
    name: 'girl',
    shortcodes: ['girl'],
    tags: [
      'bright-eyed',
      'child',
      'daughter',
      'granddaughter',
      'kid',
      'virgo',
      'young',
      'younger',
      'zodiac',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f467.png',
  },
  {
    emoji: '🧑',
    name: 'adult',
    shortcodes: ['adult'],
    tags: ['adult'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1.png',
  },
  {
    emoji: '👱',
    name: 'blond_haired_person',
    shortcodes: ['blond_haired'],
    tags: ['blond', 'blond-haired', 'human', 'person'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f471.png',
  },
  {
    emoji: '👨',
    name: 'man',
    shortcodes: ['man'],
    tags: ['adult', 'bro'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468.png',
  },
  {
    emoji: '🧔',
    name: 'bearded_person',
    shortcodes: ['person_bearded'],
    tags: ['beard', 'bearded', 'person', 'whiskers'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d4.png',
  },
  {
    emoji: '🧔‍♂',
    name: 'man_beard',
    shortcodes: ['man_bearded'],
    tags: ['beard', 'bearded', 'man', 'whiskers'],
    group: 'people & body',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d4-200d-2642-fe0f.png',
  },
  {
    emoji: '🧔‍♀',
    name: 'woman_beard',
    shortcodes: ['woman_bearded'],
    tags: ['beard', 'bearded', 'whiskers', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 13.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d4-200d-2640-fe0f.png',
  },
  {
    emoji: '👨‍🦰',
    name: 'red_haired_man',
    shortcodes: ['man_red_haired'],
    tags: ['adult', 'bro', 'man', 'red hair'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b0.png',
  },
  {
    emoji: '👨‍🦱',
    name: 'curly_haired_man',
    shortcodes: ['man_curly_haired'],
    tags: ['adult', 'bro', 'curly hair', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b1.png',
  },
  {
    emoji: '👨‍🦳',
    name: 'white_haired_man',
    shortcodes: ['man_white_haired'],
    tags: ['adult', 'bro', 'man', 'white hair'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b3.png',
  },
  {
    emoji: '👨‍🦲',
    name: 'bald_man',
    shortcodes: ['man_bald'],
    tags: ['adult', 'bald', 'bro', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9b2.png',
  },
  {
    emoji: '👩',
    name: 'woman',
    shortcodes: ['woman'],
    tags: ['adult', 'lady'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469.png',
  },
  {
    emoji: '👩‍🦰',
    name: 'red_haired_woman',
    shortcodes: ['woman_red_haired'],
    tags: ['adult', 'lady', 'red hair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b0.png',
  },
  {
    emoji: '🧑‍🦰',
    name: 'person_red_hair',
    shortcodes: ['red_haired'],
    tags: ['adult', 'person', 'red hair'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b0.png',
  },
  {
    emoji: '👩‍🦱',
    name: 'curly_haired_woman',
    shortcodes: ['woman_curly_haired'],
    tags: ['adult', 'curly hair', 'lady', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b1.png',
  },
  {
    emoji: '🧑‍🦱',
    name: 'person_curly_hair',
    shortcodes: ['curly_haired'],
    tags: ['adult', 'curly hair', 'person'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b1.png',
  },
  {
    emoji: '👩‍🦳',
    name: 'white_haired_woman',
    shortcodes: ['woman_white_haired'],
    tags: ['adult', 'lady', 'white hair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b3.png',
  },
  {
    emoji: '🧑‍🦳',
    name: 'person_white_hair',
    shortcodes: ['white_haired'],
    tags: ['adult', 'person', 'white hair'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b3.png',
  },
  {
    emoji: '👩‍🦲',
    name: 'bald_woman',
    shortcodes: ['woman_bald'],
    tags: ['adult', 'bald', 'lady', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b2.png',
  },
  {
    emoji: '🧑‍🦲',
    name: 'person_bald',
    shortcodes: ['bald'],
    tags: ['adult', 'bald', 'person'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9b2.png',
  },
  {
    emoji: '👱‍♀',
    name: 'blond_haired_woman',
    shortcodes: ['woman_blond_haired'],
    tags: ['blond', 'blond-haired', 'blonde', 'hair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f471-200d-2640-fe0f.png',
  },
  {
    emoji: '👱‍♂',
    name: 'blond_haired_man',
    shortcodes: ['man_blond_haired'],
    tags: ['blond', 'blond-haired', 'hair', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f471-200d-2642-fe0f.png',
  },
  {
    emoji: '🧓',
    name: 'older_adult',
    shortcodes: ['older_adult'],
    tags: ['adult', 'elderly', 'grandparent', 'old', 'person', 'wise'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d3.png',
  },
  {
    emoji: '👴',
    name: 'older_man',
    shortcodes: ['older_man'],
    tags: ['adult', 'bald', 'elderly', 'gramps', 'grandfather', 'grandpa', 'man', 'old', 'wise'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f474.png',
  },
  {
    emoji: '👵',
    name: 'older_woman',
    shortcodes: ['older_woman'],
    tags: ['adult', 'elderly', 'grandma', 'grandmother', 'granny', 'lady', 'old', 'wise', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f475.png',
  },
  {
    emoji: '🙍',
    name: 'frowning_person',
    shortcodes: ['person_frowning'],
    tags: [
      'annoyed',
      'disappointed',
      'disgruntled',
      'disturbed',
      'frown',
      'frowning',
      'frustrated',
      'gesture',
      'irritated',
      'person',
      'upset',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64d.png',
  },
  {
    emoji: '🙍‍♂',
    name: 'frowning_man',
    shortcodes: ['man_frowning'],
    tags: [
      'annoyed',
      'disappointed',
      'disgruntled',
      'disturbed',
      'frown',
      'frowning',
      'frustrated',
      'gesture',
      'irritated',
      'man',
      'upset',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64d-200d-2642-fe0f.png',
  },
  {
    emoji: '🙍‍♀',
    name: 'frowning_woman',
    shortcodes: ['woman_frowning'],
    tags: [
      'annoyed',
      'disappointed',
      'disgruntled',
      'disturbed',
      'frown',
      'frowning',
      'frustrated',
      'gesture',
      'irritated',
      'upset',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64d-200d-2640-fe0f.png',
  },
  {
    emoji: '🙎',
    name: 'pouting_face',
    shortcodes: ['person_pouting', 'pouting'],
    tags: [
      'disappointed',
      'downtrodden',
      'frown',
      'grimace',
      'person',
      'pouting',
      'scowl',
      'sulk',
      'upset',
      'whine',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64e.png',
  },
  {
    emoji: '🙎‍♂',
    name: 'pouting_man',
    shortcodes: ['man_pouting'],
    tags: [
      'disappointed',
      'downtrodden',
      'frown',
      'grimace',
      'man',
      'pouting',
      'scowl',
      'sulk',
      'upset',
      'whine',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64e-200d-2642-fe0f.png',
  },
  {
    emoji: '🙎‍♀',
    name: 'pouting_woman',
    shortcodes: ['woman_pouting'],
    tags: [
      'disappointed',
      'downtrodden',
      'frown',
      'grimace',
      'pouting',
      'scowl',
      'sulk',
      'upset',
      'whine',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64e-200d-2640-fe0f.png',
  },
  {
    emoji: '🙅',
    name: 'no_good',
    shortcodes: ['no_good', 'person_gesturing_no'],
    tags: ['forbidden', 'gesture', 'hand', 'no', 'not', 'person', 'prohibit'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f645.png',
  },
  {
    emoji: '🙅‍♂',
    name: 'ng_man',
    shortcodes: ['man_gesturing_no'],
    tags: ['forbidden', 'gesture', 'hand', 'man', 'no', 'not', 'prohibit'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f645-200d-2642-fe0f.png',
  },
  {
    emoji: '🙅‍♀',
    name: 'ng_woman',
    shortcodes: ['woman_gesturing_no'],
    tags: ['forbidden', 'gesture', 'hand', 'no', 'not', 'prohibit', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f645-200d-2640-fe0f.png',
  },
  {
    emoji: '🙆',
    name: 'ok_person',
    shortcodes: ['all_good', 'person_gesturing_ok'],
    tags: ['exercise', 'gesture', 'gesturing', 'hand', 'ok', 'omg', 'person'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f646.png',
  },
  {
    emoji: '🙆‍♂',
    name: 'ok_man',
    shortcodes: ['man_gesturing_ok'],
    tags: ['exercise', 'gesture', 'gesturing', 'hand', 'man', 'ok', 'omg'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f646-200d-2642-fe0f.png',
  },
  {
    emoji: '🙆‍♀',
    name: 'ok_woman',
    shortcodes: ['woman_gesturing_ok'],
    tags: ['exercise', 'gesture', 'gesturing', 'hand', 'ok', 'omg', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f646-200d-2640-fe0f.png',
  },
  {
    emoji: '💁',
    name: 'information_desk_person',
    shortcodes: ['person_tipping_hand'],
    tags: [
      'fetch',
      'flick',
      'flip',
      'gossip',
      'hand',
      'person',
      'sarcasm',
      'sarcastic',
      'sassy',
      'seriously',
      'tipping',
      'whatever',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f481.png',
  },
  {
    emoji: '💁‍♂',
    name: 'sassy_man',
    shortcodes: ['man_tipping_hand'],
    tags: [
      'fetch',
      'flick',
      'flip',
      'gossip',
      'hand',
      'man',
      'sarcasm',
      'sarcastic',
      'sassy',
      'seriously',
      'tipping',
      'whatever',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f481-200d-2642-fe0f.png',
  },
  {
    emoji: '💁‍♀',
    name: 'sassy_woman',
    shortcodes: ['woman_tipping_hand'],
    tags: [
      'fetch',
      'flick',
      'flip',
      'gossip',
      'hand',
      'sarcasm',
      'sarcastic',
      'sassy',
      'seriously',
      'tipping',
      'whatever',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f481-200d-2640-fe0f.png',
  },
  {
    emoji: '🙋',
    name: 'raising_hand',
    shortcodes: ['person_raising_hand'],
    tags: [
      'gesture',
      'hand',
      'here',
      'know',
      'me',
      'person',
      'pick',
      'question',
      'raise',
      'raising',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64b.png',
  },
  {
    emoji: '🙋‍♂',
    name: 'raising_hand_man',
    shortcodes: ['man_raising_hand'],
    tags: ['gesture', 'hand', 'here', 'know', 'man', 'me', 'pick', 'question', 'raise', 'raising'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64b-200d-2642-fe0f.png',
  },
  {
    emoji: '🙋‍♀',
    name: 'raising_hand_woman',
    shortcodes: ['woman_raising_hand'],
    tags: [
      'gesture',
      'hand',
      'here',
      'know',
      'me',
      'pick',
      'question',
      'raise',
      'raising',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f64b-200d-2640-fe0f.png',
  },
  {
    emoji: '🧏',
    name: 'deaf_person',
    shortcodes: ['deaf_person'],
    tags: ['accessibility', 'deaf', 'ear', 'gesture', 'hear', 'person'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cf.png',
  },
  {
    emoji: '🧏‍♂',
    name: 'deaf_man',
    shortcodes: ['deaf_man'],
    tags: ['accessibility', 'deaf', 'ear', 'gesture', 'hear', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cf-200d-2642-fe0f.png',
  },
  {
    emoji: '🧏‍♀',
    name: 'deaf_woman',
    shortcodes: ['deaf_woman'],
    tags: ['accessibility', 'deaf', 'ear', 'gesture', 'hear', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cf-200d-2640-fe0f.png',
  },
  {
    emoji: '🙇',
    name: 'bow',
    shortcodes: ['bow', 'person_bowing'],
    tags: [
      'apology',
      'ask',
      'beg',
      'bow',
      'bowing',
      'favor',
      'forgive',
      'gesture',
      'meditate',
      'meditation',
      'person',
      'pity',
      'regret',
      'sorry',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f647.png',
  },
  {
    emoji: '🙇‍♂',
    name: 'bowing_man',
    shortcodes: ['man_bowing'],
    tags: [
      'apology',
      'ask',
      'beg',
      'bow',
      'bowing',
      'favor',
      'forgive',
      'gesture',
      'man',
      'meditate',
      'meditation',
      'pity',
      'regret',
      'sorry',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f647-200d-2642-fe0f.png',
  },
  {
    emoji: '🙇‍♀',
    name: 'bowing_woman',
    shortcodes: ['woman_bowing'],
    tags: [
      'apology',
      'ask',
      'beg',
      'bow',
      'bowing',
      'favor',
      'forgive',
      'gesture',
      'meditate',
      'meditation',
      'pity',
      'regret',
      'sorry',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f647-200d-2640-fe0f.png',
  },
  {
    emoji: '🤦',
    name: 'facepalm',
    shortcodes: ['facepalm', 'person_facepalming'],
    tags: [
      'again',
      'bewilder',
      'disbelief',
      'exasperation',
      'facepalm',
      'no',
      'not',
      'oh',
      'omg',
      'person',
      'shock',
      'smh',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f926.png',
  },
  {
    emoji: '🤦‍♂',
    name: 'man_facepalming',
    shortcodes: ['man_facepalming'],
    tags: [
      'again',
      'bewilder',
      'disbelief',
      'exasperation',
      'facepalm',
      'man',
      'no',
      'not',
      'oh',
      'omg',
      'shock',
      'smh',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f926-200d-2642-fe0f.png',
  },
  {
    emoji: '🤦‍♀',
    name: 'woman_facepalming',
    shortcodes: ['woman_facepalming'],
    tags: [
      'again',
      'bewilder',
      'disbelief',
      'exasperation',
      'facepalm',
      'no',
      'not',
      'oh',
      'omg',
      'shock',
      'smh',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f926-200d-2640-fe0f.png',
  },
  {
    emoji: '🤷',
    name: 'shrug',
    shortcodes: ['person_shrugging', 'shrug'],
    tags: [
      'doubt',
      'dunno',
      'guess',
      'idk',
      'ignorance',
      'indifference',
      'knows',
      'maybe',
      'person',
      'shrug',
      'shrugging',
      'whatever',
      'who',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f937.png',
  },
  {
    emoji: '🤷‍♂',
    name: 'man_shrugging',
    shortcodes: ['man_shrugging'],
    tags: [
      'doubt',
      'dunno',
      'guess',
      'idk',
      'ignorance',
      'indifference',
      'knows',
      'man',
      'maybe',
      'shrug',
      'shrugging',
      'whatever',
      'who',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f937-200d-2642-fe0f.png',
  },
  {
    emoji: '🤷‍♀',
    name: 'woman_shrugging',
    shortcodes: ['woman_shrugging'],
    tags: [
      'doubt',
      'dunno',
      'guess',
      'idk',
      'ignorance',
      'indifference',
      'knows',
      'maybe',
      'shrug',
      'shrugging',
      'whatever',
      'who',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f937-200d-2640-fe0f.png',
  },
  {
    emoji: '🧑‍⚕',
    name: 'health_worker',
    shortcodes: ['health_worker'],
    tags: ['doctor', 'health', 'healthcare', 'nurse', 'therapist', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-2695-fe0f.png',
  },
  {
    emoji: '👨‍⚕',
    name: 'man_health_worker',
    shortcodes: ['man_health_worker'],
    tags: ['doctor', 'health', 'healthcare', 'man', 'nurse', 'therapist', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2695-fe0f.png',
  },
  {
    emoji: '👩‍⚕',
    name: 'woman_health_worker',
    shortcodes: ['woman_health_worker'],
    tags: ['doctor', 'health', 'healthcare', 'nurse', 'therapist', 'woman', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2695-fe0f.png',
  },
  {
    emoji: '🧑‍🎓',
    name: 'student',
    shortcodes: ['student'],
    tags: ['graduate'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f393.png',
  },
  {
    emoji: '👨‍🎓',
    name: 'man_student',
    shortcodes: ['man_student'],
    tags: ['graduate', 'man', 'student'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f393.png',
  },
  {
    emoji: '👩‍🎓',
    name: 'woman_student',
    shortcodes: ['woman_student'],
    tags: ['graduate', 'student', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f393.png',
  },
  {
    emoji: '🧑‍🏫',
    name: 'teacher',
    shortcodes: ['teacher'],
    tags: ['instructor', 'lecturer', 'professor'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3eb.png',
  },
  {
    emoji: '👨‍🏫',
    name: 'man_teacher',
    shortcodes: ['man_teacher'],
    tags: ['instructor', 'lecturer', 'man', 'professor', 'teacher'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3eb.png',
  },
  {
    emoji: '👩‍🏫',
    name: 'woman_teacher',
    shortcodes: ['woman_teacher'],
    tags: ['instructor', 'lecturer', 'professor', 'teacher', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3eb.png',
  },
  {
    emoji: '🧑‍⚖',
    name: 'judge',
    shortcodes: ['judge'],
    tags: ['justice', 'law', 'scales'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-2696-fe0f.png',
  },
  {
    emoji: '👨‍⚖',
    name: 'man_judge',
    shortcodes: ['man_judge'],
    tags: ['judge', 'justice', 'law', 'man', 'scales'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2696-fe0f.png',
  },
  {
    emoji: '👩‍⚖',
    name: 'woman_judge',
    shortcodes: ['woman_judge'],
    tags: ['judge', 'justice', 'law', 'scales', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2696-fe0f.png',
  },
  {
    emoji: '🧑‍🌾',
    name: 'farmer',
    shortcodes: ['farmer'],
    tags: ['gardener', 'rancher'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f33e.png',
  },
  {
    emoji: '👨‍🌾',
    name: 'man_farmer',
    shortcodes: ['man_farmer'],
    tags: ['farmer', 'gardener', 'man', 'rancher'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f33e.png',
  },
  {
    emoji: '👩‍🌾',
    name: 'woman_farmer',
    shortcodes: ['woman_farmer'],
    tags: ['farmer', 'gardener', 'rancher', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f33e.png',
  },
  {
    emoji: '🧑‍🍳',
    name: 'cook',
    shortcodes: ['cook'],
    tags: ['chef'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f373.png',
  },
  {
    emoji: '👨‍🍳',
    name: 'man_cook',
    shortcodes: ['man_cook'],
    tags: ['chef', 'cook', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f373.png',
  },
  {
    emoji: '👩‍🍳',
    name: 'woman_cook',
    shortcodes: ['woman_cook'],
    tags: ['chef', 'cook', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f373.png',
  },
  {
    emoji: '🧑‍🔧',
    name: 'mechanic',
    shortcodes: ['mechanic'],
    tags: ['electrician', 'plumber', 'tradesperson'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f527.png',
  },
  {
    emoji: '👨‍🔧',
    name: 'man_mechanic',
    shortcodes: ['man_mechanic'],
    tags: ['electrician', 'man', 'mechanic', 'plumber', 'tradesperson'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f527.png',
  },
  {
    emoji: '👩‍🔧',
    name: 'woman_mechanic',
    shortcodes: ['woman_mechanic'],
    tags: ['electrician', 'mechanic', 'plumber', 'tradesperson', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f527.png',
  },
  {
    emoji: '🧑‍🏭',
    name: 'factory_worker',
    shortcodes: ['factory_worker'],
    tags: ['assembly', 'factory', 'industrial', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3ed.png',
  },
  {
    emoji: '👨‍🏭',
    name: 'man_factory_worker',
    shortcodes: ['man_factory_worker'],
    tags: ['assembly', 'factory', 'industrial', 'man', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3ed.png',
  },
  {
    emoji: '👩‍🏭',
    name: 'woman_factory_worker',
    shortcodes: ['woman_factory_worker'],
    tags: ['assembly', 'factory', 'industrial', 'woman', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3ed.png',
  },
  {
    emoji: '🧑‍💼',
    name: 'office_worker',
    shortcodes: ['office_worker'],
    tags: ['architect', 'business', 'manager', 'office', 'white-collar', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f4bc.png',
  },
  {
    emoji: '👨‍💼',
    name: 'man_office_worker',
    shortcodes: ['man_office_worker'],
    tags: ['architect', 'business', 'man', 'manager', 'office', 'white-collar', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f4bc.png',
  },
  {
    emoji: '👩‍💼',
    name: 'woman_office_worker',
    shortcodes: ['woman_office_worker'],
    tags: ['architect', 'business', 'manager', 'office', 'white-collar', 'woman', 'worker'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f4bc.png',
  },
  {
    emoji: '🧑‍🔬',
    name: 'scientist',
    shortcodes: ['scientist'],
    tags: ['biologist', 'chemist', 'engineer', 'mathematician', 'physicist'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f52c.png',
  },
  {
    emoji: '👨‍🔬',
    name: 'man_scientist',
    shortcodes: ['man_scientist'],
    tags: ['biologist', 'chemist', 'engineer', 'man', 'mathematician', 'physicist', 'scientist'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f52c.png',
  },
  {
    emoji: '👩‍🔬',
    name: 'woman_scientist',
    shortcodes: ['woman_scientist'],
    tags: ['biologist', 'chemist', 'engineer', 'mathematician', 'physicist', 'scientist', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f52c.png',
  },
  {
    emoji: '🧑‍💻',
    name: 'technologist',
    shortcodes: ['technologist'],
    tags: ['coder', 'computer', 'developer', 'inventor', 'software'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f4bb.png',
  },
  {
    emoji: '👨‍💻',
    name: 'man_technologist',
    shortcodes: ['man_technologist'],
    tags: ['coder', 'computer', 'developer', 'inventor', 'man', 'software', 'technologist'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f4bb.png',
  },
  {
    emoji: '👩‍💻',
    name: 'woman_technologist',
    shortcodes: ['woman_technologist'],
    tags: ['coder', 'computer', 'developer', 'inventor', 'software', 'technologist', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f4bb.png',
  },
  {
    emoji: '🧑‍🎤',
    name: 'singer',
    shortcodes: ['singer'],
    tags: ['actor', 'entertainer', 'rock', 'rockstar', 'star'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3a4.png',
  },
  {
    emoji: '👨‍🎤',
    name: 'man_singer',
    shortcodes: ['man_singer'],
    tags: ['actor', 'entertainer', 'man', 'rock', 'rockstar', 'singer', 'star'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3a4.png',
  },
  {
    emoji: '👩‍🎤',
    name: 'woman_singer',
    shortcodes: ['woman_singer'],
    tags: ['actor', 'entertainer', 'rock', 'rockstar', 'singer', 'star', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3a4.png',
  },
  {
    emoji: '🧑‍🎨',
    name: 'artist',
    shortcodes: ['artist'],
    tags: ['palette'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f3a8.png',
  },
  {
    emoji: '👨‍🎨',
    name: 'man_artist',
    shortcodes: ['man_artist'],
    tags: ['artist', 'man', 'palette'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f3a8.png',
  },
  {
    emoji: '👩‍🎨',
    name: 'woman_artist',
    shortcodes: ['woman_artist'],
    tags: ['artist', 'palette', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f3a8.png',
  },
  {
    emoji: '🧑‍✈',
    name: 'pilot',
    shortcodes: ['pilot'],
    tags: ['plane'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-2708-fe0f.png',
  },
  {
    emoji: '👨‍✈',
    name: 'man_pilot',
    shortcodes: ['man_pilot'],
    tags: ['man', 'pilot', 'plane'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2708-fe0f.png',
  },
  {
    emoji: '👩‍✈',
    name: 'woman_pilot',
    shortcodes: ['woman_pilot'],
    tags: ['pilot', 'plane', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2708-fe0f.png',
  },
  {
    emoji: '🧑‍🚀',
    name: 'astronaut',
    shortcodes: ['astronaut'],
    tags: ['rocket', 'space'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f680.png',
  },
  {
    emoji: '👨‍🚀',
    name: 'man_astronaut',
    shortcodes: ['man_astronaut'],
    tags: ['astronaut', 'man', 'rocket', 'space'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f680.png',
  },
  {
    emoji: '👩‍🚀',
    name: 'woman_astronaut',
    shortcodes: ['woman_astronaut'],
    tags: ['astronaut', 'rocket', 'space', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f680.png',
  },
  {
    emoji: '🧑‍🚒',
    name: 'firefighter',
    shortcodes: ['firefighter'],
    tags: ['fire', 'firetruck'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f692.png',
  },
  {
    emoji: '👨‍🚒',
    name: 'man_firefighter',
    shortcodes: ['man_firefighter'],
    tags: ['fire', 'firefighter', 'firetruck', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f692.png',
  },
  {
    emoji: '👩‍🚒',
    name: 'woman_firefighter',
    shortcodes: ['woman_firefighter'],
    tags: ['fire', 'firefighter', 'firetruck', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f692.png',
  },
  {
    emoji: '👮',
    name: 'cop',
    shortcodes: ['cop', 'police_officer'],
    tags: [
      'apprehend',
      'arrest',
      'citation',
      'cop',
      'law',
      'officer',
      'over',
      'police',
      'pulled',
      'undercover',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46e.png',
  },
  {
    emoji: '👮‍♂',
    name: 'policeman',
    shortcodes: ['man_police_officer'],
    tags: [
      'apprehend',
      'arrest',
      'citation',
      'cop',
      'law',
      'man',
      'officer',
      'over',
      'police',
      'pulled',
      'undercover',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46e-200d-2642-fe0f.png',
  },
  {
    emoji: '👮‍♀',
    name: 'policewoman',
    shortcodes: ['woman_police_officer'],
    tags: [
      'apprehend',
      'arrest',
      'citation',
      'cop',
      'law',
      'officer',
      'over',
      'police',
      'pulled',
      'undercover',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46e-200d-2640-fe0f.png',
  },
  {
    emoji: '🕵',
    name: 'detective',
    shortcodes: ['detective'],
    tags: ['sleuth', 'spy'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f575-fe0f.png',
  },
  {
    emoji: '🕵‍♂️',
    name: 'male_detective',
    shortcodes: ['man_detective'],
    tags: ['detective', 'man', 'sleuth', 'spy'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f575-fe0f-200d-2642-fe0f.png',
  },
  {
    emoji: '🕵‍♀️',
    name: 'female_detective',
    shortcodes: ['woman_detective'],
    tags: ['detective', 'sleuth', 'spy', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f575-fe0f-200d-2640-fe0f.png',
  },
  {
    emoji: '💂',
    name: 'guard',
    shortcodes: ['guard'],
    tags: ['buckingham', 'helmet', 'london', 'palace'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f482.png',
  },
  {
    emoji: '💂‍♂',
    name: 'guardsman',
    shortcodes: ['man_guard'],
    tags: ['buckingham', 'guard', 'helmet', 'london', 'man', 'palace'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f482-200d-2642-fe0f.png',
  },
  {
    emoji: '💂‍♀',
    name: 'guardswoman',
    shortcodes: ['woman_guard'],
    tags: ['buckingham', 'guard', 'helmet', 'london', 'palace', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f482-200d-2640-fe0f.png',
  },
  {
    emoji: '🥷',
    name: 'ninja',
    shortcodes: ['ninja'],
    tags: [
      'assassin',
      'fight',
      'fighter',
      'hidden',
      'person',
      'secret',
      'skills',
      'sly',
      'soldier',
      'stealth',
      'war',
    ],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f977.png',
  },
  {
    emoji: '👷',
    name: 'construction_worker',
    shortcodes: ['construction_worker'],
    tags: [
      'build',
      'construction',
      'fix',
      'hardhat',
      'hat',
      'man',
      'person',
      'rebuild',
      'remodel',
      'repair',
      'work',
      'worker',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f477.png',
  },
  {
    emoji: '👷‍♂',
    name: 'construction_worker_man',
    shortcodes: ['man_construction_worker'],
    tags: [
      'build',
      'construction',
      'fix',
      'hardhat',
      'hat',
      'man',
      'rebuild',
      'remodel',
      'repair',
      'work',
      'worker',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f477-200d-2642-fe0f.png',
  },
  {
    emoji: '👷‍♀',
    name: 'construction_worker_woman',
    shortcodes: ['woman_construction_worker'],
    tags: [
      'build',
      'construction',
      'fix',
      'hardhat',
      'hat',
      'man',
      'rebuild',
      'remodel',
      'repair',
      'woman',
      'work',
      'worker',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f477-200d-2640-fe0f.png',
  },
  {
    emoji: '🫅',
    name: 'person_with_crown',
    shortcodes: ['person_with_crown', 'royalty'],
    tags: ['crown', 'monarch', 'noble', 'person', 'regal', 'royal', 'royalty'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac5.png',
  },
  {
    emoji: '🤴',
    name: 'prince',
    shortcodes: ['prince'],
    tags: ['crown', 'fairy', 'fairytale', 'fantasy', 'king', 'royal', 'royalty', 'tale'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f934.png',
  },
  {
    emoji: '👸',
    name: 'princess',
    shortcodes: ['princess'],
    tags: ['crown', 'fairy', 'fairytale', 'fantasy', 'queen', 'royal', 'royalty', 'tale'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f478.png',
  },
  {
    emoji: '👳',
    name: 'person_with_turban',
    shortcodes: ['person_wearing_turban'],
    tags: ['person', 'turban', 'wearing'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f473.png',
  },
  {
    emoji: '👳‍♂',
    name: 'man_with_turban',
    shortcodes: ['man_wearing_turban'],
    tags: ['man', 'turban', 'wearing'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f473-200d-2642-fe0f.png',
  },
  {
    emoji: '👳‍♀',
    name: 'woman_with_turban',
    shortcodes: ['woman_wearing_turban'],
    tags: ['turban', 'wearing', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f473-200d-2640-fe0f.png',
  },
  {
    emoji: '👲',
    name: 'man_with_gua_pi_mao',
    shortcodes: ['person_with_skullcap'],
    tags: ['cap', 'chinese', 'gua', 'guapi', 'hat', 'mao', 'person', 'pi', 'skullcap'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f472.png',
  },
  {
    emoji: '🧕',
    name: 'woman_with_headscarf',
    shortcodes: ['woman_with_headscarf'],
    tags: ['bandana', 'head', 'headscarf', 'hijab', 'kerchief', 'mantilla', 'tichel', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d5.png',
  },
  {
    emoji: '🤵',
    name: 'person_in_tuxedo',
    shortcodes: ['person_in_tuxedo'],
    tags: ['formal', 'person', 'tuxedo', 'wedding'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f935.png',
  },
  {
    emoji: '🤵‍♂',
    name: 'man_in_tuxedo',
    shortcodes: ['man_in_tuxedo'],
    tags: ['formal', 'groom', 'man', 'tuxedo', 'wedding'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f935-200d-2642-fe0f.png',
  },
  {
    emoji: '🤵‍♀',
    name: 'woman_in_tuxedo',
    shortcodes: ['woman_in_tuxedo'],
    tags: ['formal', 'tuxedo', 'wedding', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f935-200d-2640-fe0f.png',
  },
  {
    emoji: '👰',
    name: 'person_with_veil',
    shortcodes: ['person_with_veil'],
    tags: ['person', 'veil', 'wedding'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f470.png',
  },
  {
    emoji: '👰‍♂',
    name: 'man_with_veil',
    shortcodes: ['man_with_veil'],
    tags: ['man', 'veil', 'wedding'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f470-200d-2642-fe0f.png',
  },
  {
    emoji: '👰‍♀',
    name: 'bride_with_veil',
    shortcodes: ['woman_with_veil'],
    tags: ['bride', 'veil', 'wedding', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f470-200d-2640-fe0f.png',
  },
  {
    emoji: '🤰',
    name: 'pregnant_woman',
    shortcodes: ['pregnant_woman'],
    tags: ['pregnant', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f930.png',
  },
  {
    emoji: '🫃',
    name: 'pregnant_man',
    shortcodes: ['pregnant_man'],
    tags: ['belly', 'bloated', 'full', 'man', 'overeat', 'pregnant'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac3.png',
  },
  {
    emoji: '🫄',
    name: 'pregnant_person',
    shortcodes: ['pregnant_person'],
    tags: ['belly', 'bloated', 'full', 'overeat', 'person', 'pregnant', 'stuffed'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac4.png',
  },
  {
    emoji: '🤱',
    name: 'breast_feeding',
    shortcodes: ['breast_feeding'],
    tags: ['baby', 'breast', 'feeding', 'mom', 'mother', 'nursing', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f931.png',
  },
  {
    emoji: '👩‍🍼',
    name: 'woman_feeding_baby',
    shortcodes: ['woman_feeding_baby'],
    tags: ['baby', 'feed', 'feeding', 'mom', 'mother', 'nanny', 'newborn', 'nursing', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f37c.png',
  },
  {
    emoji: '👨‍🍼',
    name: 'man_feeding_baby',
    shortcodes: ['man_feeding_baby'],
    tags: ['baby', 'dad', 'father', 'feed', 'feeding', 'man', 'nanny', 'newborn', 'nursing'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f37c.png',
  },
  {
    emoji: '🧑‍🍼',
    name: 'person_feeding_baby',
    shortcodes: ['person_feeding_baby'],
    tags: ['baby', 'feed', 'feeding', 'nanny', 'newborn', 'nursing', 'parent'],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f37c.png',
  },
  {
    emoji: '👼',
    name: 'angel',
    shortcodes: ['angel'],
    tags: ['angel', 'baby', 'church', 'face', 'fairy', 'fairytale', 'fantasy', 'tale'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47c.png',
  },
  {
    emoji: '🎅',
    name: 'santa',
    shortcodes: ['santa'],
    tags: [
      'celebration',
      'christmas',
      'claus',
      'fairy',
      'fantasy',
      'father',
      'holiday',
      'merry',
      'santa',
      'tale',
      'xmas',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f385.png',
  },
  {
    emoji: '🤶',
    name: 'mrs_claus',
    shortcodes: ['mrs_claus'],
    tags: [
      'celebration',
      'christmas',
      'claus',
      'fairy',
      'fantasy',
      'holiday',
      'merry',
      'mother',
      'mrs',
      'santa',
      'tale',
      'xmas',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f936.png',
  },
  {
    emoji: '🧑‍🎄',
    name: 'mx_claus',
    shortcodes: ['mx_claus'],
    tags: [
      'celebration',
      'christmas',
      'claus',
      'fairy',
      'fantasy',
      'holiday',
      'merry',
      'mx',
      'santa',
      'tale',
      'xmas',
    ],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f384.png',
  },
  {
    emoji: '🦸',
    name: 'superhero',
    shortcodes: ['superhero'],
    tags: ['good', 'hero', 'superpower'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b8.png',
  },
  {
    emoji: '🦸‍♂',
    name: 'superhero_man',
    shortcodes: ['man_superhero'],
    tags: ['good', 'hero', 'man', 'superhero', 'superpower'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b8-200d-2642-fe0f.png',
  },
  {
    emoji: '🦸‍♀',
    name: 'superhero_woman',
    shortcodes: ['woman_superhero'],
    tags: ['good', 'hero', 'heroine', 'superhero', 'superpower', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b8-200d-2640-fe0f.png',
  },
  {
    emoji: '🦹',
    name: 'supervillain',
    shortcodes: ['supervillain'],
    tags: ['bad', 'criminal', 'evil', 'superpower', 'villain'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9.png',
  },
  {
    emoji: '🦹‍♂',
    name: 'supervillain_man',
    shortcodes: ['man_supervillain'],
    tags: ['bad', 'criminal', 'evil', 'man', 'superpower', 'supervillain', 'villain'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9-200d-2642-fe0f.png',
  },
  {
    emoji: '🦹‍♀',
    name: 'supervillain_woman',
    shortcodes: ['woman_supervillain'],
    tags: ['bad', 'criminal', 'evil', 'superpower', 'supervillain', 'villain', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9-200d-2640-fe0f.png',
  },
  {
    emoji: '🧙',
    name: 'mage',
    shortcodes: ['mage'],
    tags: [
      'fantasy',
      'magic',
      'play',
      'sorcerer',
      'sorceress',
      'sorcery',
      'spell',
      'summon',
      'witch',
      'wizard',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d9.png',
  },
  {
    emoji: '🧙‍♂',
    name: 'mage_man',
    shortcodes: ['man_mage'],
    tags: [
      'fantasy',
      'mage',
      'magic',
      'man',
      'play',
      'sorcerer',
      'sorceress',
      'sorcery',
      'spell',
      'summon',
      'witch',
      'wizard',
    ],
    group: 'people & body',
    emoticons: [':{>'],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d9-200d-2642-fe0f.png',
  },
  {
    emoji: '🧙‍♀',
    name: 'mage_woman',
    shortcodes: ['woman_mage'],
    tags: [
      'fantasy',
      'mage',
      'magic',
      'play',
      'sorcerer',
      'sorceress',
      'sorcery',
      'spell',
      'summon',
      'witch',
      'wizard',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d9-200d-2640-fe0f.png',
  },
  {
    emoji: '🧚',
    name: 'fairy',
    shortcodes: ['fairy'],
    tags: ['fairytale', 'fantasy', 'myth', 'person', 'pixie', 'tale', 'wings'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9da.png',
  },
  {
    emoji: '🧚‍♂',
    name: 'fairy_man',
    shortcodes: ['man_fairy'],
    tags: [
      'fairy',
      'fairytale',
      'fantasy',
      'man',
      'myth',
      'oberon',
      'person',
      'pixie',
      'puck',
      'tale',
      'wings',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9da-200d-2642-fe0f.png',
  },
  {
    emoji: '🧚‍♀',
    name: 'fairy_woman',
    shortcodes: ['woman_fairy'],
    tags: [
      'fairy',
      'fairytale',
      'fantasy',
      'myth',
      'person',
      'pixie',
      'tale',
      'titania',
      'wings',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9da-200d-2640-fe0f.png',
  },
  {
    emoji: '🧛',
    name: 'vampire',
    shortcodes: ['vampire'],
    tags: ['blood', 'dracula', 'fangs', 'halloween', 'scary', 'supernatural', 'teeth', 'undead'],
    group: 'people & body',
    emoticons: [':E'],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9db.png',
  },
  {
    emoji: '🧛‍♂',
    name: 'vampire_man',
    shortcodes: ['man_vampire'],
    tags: [
      'blood',
      'fangs',
      'halloween',
      'man',
      'scary',
      'supernatural',
      'teeth',
      'undead',
      'vampire',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9db-200d-2642-fe0f.png',
  },
  {
    emoji: '🧛‍♀',
    name: 'vampire_woman',
    shortcodes: ['woman_vampire'],
    tags: [
      'blood',
      'fangs',
      'halloween',
      'scary',
      'supernatural',
      'teeth',
      'undead',
      'vampire',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9db-200d-2640-fe0f.png',
  },
  {
    emoji: '🧜',
    name: 'merperson',
    shortcodes: ['merperson'],
    tags: ['creature', 'fairytale', 'folklore', 'ocean', 'sea', 'siren', 'trident'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc.png',
  },
  {
    emoji: '🧜‍♂',
    name: 'merman',
    shortcodes: ['merman'],
    tags: [
      'creature',
      'fairytale',
      'folklore',
      'neptune',
      'ocean',
      'poseidon',
      'sea',
      'siren',
      'trident',
      'triton',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc-200d-2642-fe0f.png',
  },
  {
    emoji: '🧜‍♀',
    name: 'mermaid',
    shortcodes: ['mermaid'],
    tags: ['creature', 'fairytale', 'folklore', 'merwoman', 'ocean', 'sea', 'siren', 'trident'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc-200d-2640-fe0f.png',
  },
  {
    emoji: '🧝',
    name: 'elf',
    shortcodes: ['elf'],
    tags: ['elves', 'enchantment', 'fantasy', 'folklore', 'magic', 'magical', 'myth'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dd.png',
  },
  {
    emoji: '🧝‍♂',
    name: 'elf_man',
    shortcodes: ['man_elf'],
    tags: ['elf', 'elves', 'enchantment', 'fantasy', 'folklore', 'magic', 'magical', 'man', 'myth'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dd-200d-2642-fe0f.png',
  },
  {
    emoji: '🧝‍♀',
    name: 'elf_woman',
    shortcodes: ['woman_elf'],
    tags: [
      'elf',
      'elves',
      'enchantment',
      'fantasy',
      'folklore',
      'magic',
      'magical',
      'myth',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dd-200d-2640-fe0f.png',
  },
  {
    emoji: '🧞',
    name: 'genie',
    shortcodes: ['genie'],
    tags: ['djinn', 'fantasy', 'jinn', 'lamp', 'myth', 'rub', 'wishes'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9de.png',
  },
  {
    emoji: '🧞‍♂',
    name: 'genie_man',
    shortcodes: ['man_genie'],
    tags: ['djinn', 'fantasy', 'genie', 'jinn', 'lamp', 'man', 'myth', 'rub', 'wishes'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9de-200d-2642-fe0f.png',
  },
  {
    emoji: '🧞‍♀',
    name: 'genie_woman',
    shortcodes: ['woman_genie'],
    tags: ['djinn', 'fantasy', 'genie', 'jinn', 'lamp', 'myth', 'rub', 'wishes', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9de-200d-2640-fe0f.png',
  },
  {
    emoji: '🧟',
    name: 'zombie',
    shortcodes: ['zombie'],
    tags: ['apocalypse', 'dead', 'halloween', 'horror', 'scary', 'undead', 'walking'],
    group: 'people & body',
    emoticons: ['8#'],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df.png',
  },
  {
    emoji: '🧟‍♂',
    name: 'zombie_man',
    shortcodes: ['man_zombie'],
    tags: [
      'apocalypse',
      'dead',
      'halloween',
      'horror',
      'man',
      'scary',
      'undead',
      'walking',
      'zombie',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df-200d-2642-fe0f.png',
  },
  {
    emoji: '🧟‍♀',
    name: 'zombie_woman',
    shortcodes: ['woman_zombie'],
    tags: [
      'apocalypse',
      'dead',
      'halloween',
      'horror',
      'scary',
      'undead',
      'walking',
      'woman',
      'zombie',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df-200d-2640-fe0f.png',
  },
  {
    emoji: '🧌',
    name: 'troll',
    shortcodes: ['troll'],
    tags: ['fairy', 'fantasy', 'monster', 'tale', 'trolling'],
    group: 'people & body',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cc.png',
  },
  {
    emoji: '🫈',
    name: 'hairy_creature',
    shortcodes: ['hairy_creature'],
    tags: ['bigfoot', 'cryptid', 'forest', 'giant', 'hairy', 'sasquatch', 'woodwose', 'yeti'],
    group: 'people & body',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '💆',
    name: 'massage',
    shortcodes: ['massage', 'person_getting_massage'],
    tags: [
      'face',
      'getting',
      'headache',
      'massage',
      'person',
      'relax',
      'relaxing',
      'salon',
      'soothe',
      'spa',
      'tension',
      'therapy',
      'treatment',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f486.png',
  },
  {
    emoji: '💆‍♂',
    name: 'massage_man',
    shortcodes: ['man_getting_massage'],
    tags: [
      'face',
      'getting',
      'headache',
      'man',
      'massage',
      'relax',
      'relaxing',
      'salon',
      'soothe',
      'spa',
      'tension',
      'therapy',
      'treatment',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f486-200d-2642-fe0f.png',
  },
  {
    emoji: '💆‍♀',
    name: 'massage_woman',
    shortcodes: ['woman_getting_massage'],
    tags: [
      'face',
      'getting',
      'headache',
      'massage',
      'relax',
      'relaxing',
      'salon',
      'soothe',
      'spa',
      'tension',
      'therapy',
      'treatment',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f486-200d-2640-fe0f.png',
  },
  {
    emoji: '💇',
    name: 'haircut',
    shortcodes: ['haircut', 'person_getting_haircut'],
    tags: [
      'barber',
      'beauty',
      'chop',
      'cosmetology',
      'cut',
      'groom',
      'hair',
      'haircut',
      'parlor',
      'person',
      'shears',
      'style',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f487.png',
  },
  {
    emoji: '💇‍♂',
    name: 'haircut_man',
    shortcodes: ['man_getting_haircut'],
    tags: [
      'barber',
      'beauty',
      'chop',
      'cosmetology',
      'cut',
      'groom',
      'hair',
      'haircut',
      'man',
      'parlor',
      'person',
      'shears',
      'style',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f487-200d-2642-fe0f.png',
  },
  {
    emoji: '💇‍♀',
    name: 'haircut_woman',
    shortcodes: ['woman_getting_haircut'],
    tags: [
      'barber',
      'beauty',
      'chop',
      'cosmetology',
      'cut',
      'groom',
      'hair',
      'haircut',
      'parlor',
      'person',
      'shears',
      'style',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f487-200d-2640-fe0f.png',
  },
  {
    emoji: '🚶',
    name: 'walking',
    shortcodes: ['person_walking', 'walking'],
    tags: [
      'amble',
      'gait',
      'hike',
      'man',
      'pace',
      'pedestrian',
      'person',
      'stride',
      'stroll',
      'walk',
      'walking',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6.png',
  },
  {
    emoji: '🚶‍♂',
    name: 'walking_man',
    shortcodes: ['man_walking'],
    tags: [
      'amble',
      'gait',
      'hike',
      'man',
      'pace',
      'pedestrian',
      'stride',
      'stroll',
      'walk',
      'walking',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-2642-fe0f.png',
  },
  {
    emoji: '🚶‍♀',
    name: 'walking_woman',
    shortcodes: ['woman_walking'],
    tags: [
      'amble',
      'gait',
      'hike',
      'man',
      'pace',
      'pedestrian',
      'stride',
      'stroll',
      'walk',
      'walking',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-2640-fe0f.png',
  },
  {
    emoji: '🚶‍➡',
    name: 'person_walking_right',
    shortcodes: ['person_walking_right'],
    tags: [
      'amble',
      'facing',
      'gait',
      'hike',
      'man',
      'pace',
      'pedestrian',
      'person',
      'right',
      'stride',
      'stroll',
      'walk',
      'walking',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-27a1-fe0f.png',
  },
  {
    emoji: '🚶‍♀‍➡️',
    name: 'woman_walking_right',
    shortcodes: ['woman_walking_right'],
    tags: [
      'amble',
      'facing',
      'gait',
      'hike',
      'man',
      'pace',
      'pedestrian',
      'right',
      'stride',
      'stroll',
      'walk',
      'walking',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-2640-fe0f-200d-27a1-fe0f.png',
  },
  {
    emoji: '🚶‍♂‍➡️',
    name: 'man_walking_right',
    shortcodes: ['man_walking_right'],
    tags: [
      'amble',
      'facing',
      'gait',
      'hike',
      'man',
      'pace',
      'pedestrian',
      'right',
      'stride',
      'stroll',
      'walk',
      'walking',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b6-200d-2642-fe0f-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧍',
    name: 'standing_person',
    shortcodes: ['person_standing', 'standing'],
    tags: ['person', 'stand', 'standing'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cd.png',
  },
  {
    emoji: '🧍‍♂',
    name: 'standing_man',
    shortcodes: ['man_standing'],
    tags: ['man', 'stand', 'standing'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cd-200d-2642-fe0f.png',
  },
  {
    emoji: '🧍‍♀',
    name: 'standing_woman',
    shortcodes: ['woman_standing'],
    tags: ['stand', 'standing', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cd-200d-2640-fe0f.png',
  },
  {
    emoji: '🧎',
    name: 'kneeling_person',
    shortcodes: ['kneeling', 'person_kneeling'],
    tags: ['kneel', 'kneeling', 'knees', 'person'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce.png',
  },
  {
    emoji: '🧎‍♂',
    name: 'kneeling_man',
    shortcodes: ['man_kneeling'],
    tags: ['kneel', 'kneeling', 'knees', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-2642-fe0f.png',
  },
  {
    emoji: '🧎‍♀',
    name: 'kneeling_woman',
    shortcodes: ['woman_kneeling'],
    tags: ['kneel', 'kneeling', 'knees', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-2640-fe0f.png',
  },
  {
    emoji: '🧎‍➡',
    name: 'person_kneeling_right',
    shortcodes: ['person_kneeling_right'],
    tags: ['facing', 'kneel', 'kneeling', 'knees', 'person', 'right'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧎‍♀‍➡️',
    name: 'woman_kneeling_right',
    shortcodes: ['woman_kneeling_right'],
    tags: ['facing', 'kneel', 'kneeling', 'knees', 'right', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-2640-fe0f-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧎‍♂‍➡️',
    name: 'man_kneeling_right',
    shortcodes: ['man_kneeling_right'],
    tags: ['facing', 'kneel', 'kneeling', 'knees', 'man', 'right'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ce-200d-2642-fe0f-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧑‍🦯',
    name: 'person_with_probing_cane',
    shortcodes: ['person_with_probing_cane', 'person_with_white_cane'],
    tags: ['accessibility', 'blind', 'cane', 'person', 'probing', 'white'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9af.png',
  },
  {
    emoji: '🧑‍🦯‍➡',
    name: 'person_with_white_cane_right',
    shortcodes: ['person_with_white_cane_right'],
    tags: ['accessibility', 'blind', 'cane', 'facing', 'person', 'probing', 'right', 'white'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9af-200d-27a1-fe0f.png',
  },
  {
    emoji: '👨‍🦯',
    name: 'man_with_probing_cane',
    shortcodes: ['man_with_probing_cane', 'man_with_white_cane'],
    tags: ['accessibility', 'blind', 'cane', 'man', 'probing', 'white'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9af.png',
  },
  {
    emoji: '👨‍🦯‍➡',
    name: 'man_with_white_cane_right',
    shortcodes: ['man_with_white_cane_right'],
    tags: ['accessibility', 'blind', 'cane', 'facing', 'man', 'probing', 'right', 'white'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9af-200d-27a1-fe0f.png',
  },
  {
    emoji: '👩‍🦯',
    name: 'woman_with_probing_cane',
    shortcodes: ['woman_with_probing_cane', 'woman_with_white_cane'],
    tags: ['accessibility', 'blind', 'cane', 'probing', 'white', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9af.png',
  },
  {
    emoji: '👩‍🦯‍➡',
    name: 'woman_with_white_cane_right',
    shortcodes: ['woman_with_white_cane_right'],
    tags: ['accessibility', 'blind', 'cane', 'facing', 'probing', 'right', 'white', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9af-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧑‍🦼',
    name: 'person_in_motorized_wheelchair',
    shortcodes: ['person_in_motorized_wheelchair'],
    tags: ['accessibility', 'motorized', 'person', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9bc.png',
  },
  {
    emoji: '🧑‍🦼‍➡',
    name: 'person_in_motorized_wheelchair_right',
    shortcodes: ['person_in_motorized_wheelchair_right'],
    tags: ['accessibility', 'facing', 'motorized', 'person', 'right', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9bc-200d-27a1-fe0f.png',
  },
  {
    emoji: '👨‍🦼',
    name: 'man_in_motorized_wheelchair',
    shortcodes: ['man_in_motorized_wheelchair'],
    tags: ['accessibility', 'man', 'motorized', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9bc.png',
  },
  {
    emoji: '👨‍🦼‍➡',
    name: 'man_in_motorized_wheelchair_right',
    shortcodes: ['man_in_motorized_wheelchair_right'],
    tags: ['accessibility', 'facing', 'man', 'motorized', 'right', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9bc-200d-27a1-fe0f.png',
  },
  {
    emoji: '👩‍🦼',
    name: 'woman_in_motorized_wheelchair',
    shortcodes: ['woman_in_motorized_wheelchair'],
    tags: ['accessibility', 'motorized', 'wheelchair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9bc.png',
  },
  {
    emoji: '👩‍🦼‍➡',
    name: 'woman_in_motorized_wheelchair_right',
    shortcodes: ['woman_in_motorized_wheelchair_right'],
    tags: ['accessibility', 'facing', 'motorized', 'right', 'wheelchair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9bc-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧑‍🦽',
    name: 'person_in_manual_wheelchair',
    shortcodes: ['person_in_manual_wheelchair'],
    tags: ['accessibility', 'manual', 'person', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 12.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9bd.png',
  },
  {
    emoji: '🧑‍🦽‍➡',
    name: 'person_in_manual_wheelchair_right',
    shortcodes: ['person_in_manual_wheelchair_right'],
    tags: ['accessibility', 'facing', 'manual', 'person', 'right', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9bd-200d-27a1-fe0f.png',
  },
  {
    emoji: '👨‍🦽',
    name: 'man_in_manual_wheelchair',
    shortcodes: ['man_in_manual_wheelchair'],
    tags: ['accessibility', 'man', 'manual', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9bd.png',
  },
  {
    emoji: '👨‍🦽‍➡',
    name: 'man_in_manual_wheelchair_right',
    shortcodes: ['man_in_manual_wheelchair_right'],
    tags: ['accessibility', 'facing', 'man', 'manual', 'right', 'wheelchair'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f9bd-200d-27a1-fe0f.png',
  },
  {
    emoji: '👩‍🦽',
    name: 'woman_in_manual_wheelchair',
    shortcodes: ['woman_in_manual_wheelchair'],
    tags: ['accessibility', 'manual', 'wheelchair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9bd.png',
  },
  {
    emoji: '👩‍🦽‍➡',
    name: 'woman_in_manual_wheelchair_right',
    shortcodes: ['woman_in_manual_wheelchair_right'],
    tags: ['accessibility', 'facing', 'manual', 'right', 'wheelchair', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9bd-200d-27a1-fe0f.png',
  },
  {
    emoji: '🏃',
    name: 'runner',
    shortcodes: ['person_running', 'running'],
    tags: [
      'fast',
      'hurry',
      'marathon',
      'move',
      'person',
      'quick',
      'race',
      'racing',
      'run',
      'rush',
      'speed',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3.png',
  },
  {
    emoji: '🏃‍♂',
    name: 'running_man',
    shortcodes: ['man_running'],
    tags: [
      'fast',
      'hurry',
      'man',
      'marathon',
      'move',
      'quick',
      'race',
      'racing',
      'run',
      'rush',
      'speed',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-2642-fe0f.png',
  },
  {
    emoji: '🏃‍♀',
    name: 'running_woman',
    shortcodes: ['woman_running'],
    tags: [
      'fast',
      'hurry',
      'marathon',
      'move',
      'quick',
      'race',
      'racing',
      'run',
      'rush',
      'speed',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-2640-fe0f.png',
  },
  {
    emoji: '🏃‍➡',
    name: 'person_running_right',
    shortcodes: ['person_running_right'],
    tags: [
      'facing',
      'fast',
      'hurry',
      'marathon',
      'move',
      'person',
      'quick',
      'race',
      'racing',
      'right',
      'run',
      'rush',
      'speed',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-27a1-fe0f.png',
  },
  {
    emoji: '🏃‍♀‍➡️',
    name: 'woman_running_right',
    shortcodes: ['woman_running_right'],
    tags: [
      'facing',
      'fast',
      'hurry',
      'marathon',
      'move',
      'quick',
      'race',
      'racing',
      'right',
      'run',
      'rush',
      'speed',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-2640-fe0f-200d-27a1-fe0f.png',
  },
  {
    emoji: '🏃‍♂‍➡️',
    name: 'man_running_right',
    shortcodes: ['man_running_right'],
    tags: [
      'facing',
      'fast',
      'hurry',
      'man',
      'marathon',
      'move',
      'quick',
      'race',
      'racing',
      'right',
      'run',
      'rush',
      'speed',
    ],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c3-200d-2642-fe0f-200d-27a1-fe0f.png',
  },
  {
    emoji: '🧑‍🩰',
    name: 'ballet_dancer',
    shortcodes: ['ballet_dancer'],
    tags: ['ballet', 'dancer'],
    group: 'people & body',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '💃',
    name: 'dancer',
    shortcodes: ['dancer', 'woman_dancing'],
    tags: [
      'dance',
      'dancer',
      'dancing',
      'elegant',
      'festive',
      'flair',
      'flamenco',
      'groove',
      'let’s',
      'salsa',
      'tango',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f483.png',
  },
  {
    emoji: '🕺',
    name: 'man_dancing',
    shortcodes: ['man_dancing'],
    tags: [
      'dance',
      'dancer',
      'dancing',
      'elegant',
      'festive',
      'flair',
      'flamenco',
      'groove',
      'let’s',
      'man',
      'salsa',
      'tango',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f57a.png',
  },
  {
    emoji: '🕴',
    name: 'business_suit_levitating',
    shortcodes: ['levitate', 'levitating', 'person_in_suit_levitating'],
    tags: ['business', 'levitating', 'person', 'suit'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f574-fe0f.png',
  },
  {
    emoji: '👯',
    name: 'dancers',
    shortcodes: ['dancers', 'people_with_bunny_ears_partying'],
    tags: [
      'bestie',
      'bff',
      'bunny',
      'counterpart',
      'dancer',
      'double',
      'ear',
      'identical',
      'pair',
      'party',
      'partying',
      'people',
      'soulmate',
      'twin',
      'twinsies',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46f.png',
  },
  {
    emoji: '👯‍♂',
    name: 'dancing_men',
    shortcodes: ['men_with_bunny_ears_partying'],
    tags: [
      'bestie',
      'bff',
      'bunny',
      'counterpart',
      'dancer',
      'double',
      'ear',
      'identical',
      'men',
      'pair',
      'party',
      'partying',
      'people',
      'soulmate',
      'twin',
      'twinsies',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46f-200d-2642-fe0f.png',
  },
  {
    emoji: '👯‍♀',
    name: 'dancing_women',
    shortcodes: ['women_with_bunny_ears_partying'],
    tags: [
      'bestie',
      'bff',
      'bunny',
      'counterpart',
      'dancer',
      'double',
      'ear',
      'identical',
      'pair',
      'party',
      'partying',
      'people',
      'soulmate',
      'twin',
      'twinsies',
      'women',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46f-200d-2640-fe0f.png',
  },
  {
    emoji: '🧖',
    name: 'sauna_person',
    shortcodes: ['person_in_steamy_room'],
    tags: [
      'day',
      'luxurious',
      'pamper',
      'person',
      'relax',
      'room',
      'sauna',
      'spa',
      'steam',
      'steambath',
      'unwind',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d6.png',
  },
  {
    emoji: '🧖‍♂',
    name: 'sauna_man',
    shortcodes: ['man_in_steamy_room'],
    tags: [
      'day',
      'luxurious',
      'man',
      'pamper',
      'relax',
      'room',
      'sauna',
      'spa',
      'steam',
      'steambath',
      'unwind',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d6-200d-2642-fe0f.png',
  },
  {
    emoji: '🧖‍♀',
    name: 'sauna_woman',
    shortcodes: ['woman_in_steamy_room'],
    tags: [
      'day',
      'luxurious',
      'pamper',
      'relax',
      'room',
      'sauna',
      'spa',
      'steam',
      'steambath',
      'unwind',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d6-200d-2640-fe0f.png',
  },
  {
    emoji: '🧗',
    name: 'climbing',
    shortcodes: ['climbing', 'person_climbing'],
    tags: ['climb', 'climber', 'climbing', 'mountain', 'person', 'rock', 'scale', 'up'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d7.png',
  },
  {
    emoji: '🧗‍♂',
    name: 'climbing_man',
    shortcodes: ['man_climbing'],
    tags: ['climb', 'climber', 'climbing', 'man', 'mountain', 'rock', 'scale', 'up'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d7-200d-2642-fe0f.png',
  },
  {
    emoji: '🧗‍♀',
    name: 'climbing_woman',
    shortcodes: ['woman_climbing'],
    tags: ['climb', 'climber', 'climbing', 'mountain', 'rock', 'scale', 'up', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d7-200d-2640-fe0f.png',
  },
  {
    emoji: '🤺',
    name: 'person_fencing',
    shortcodes: ['fencer', 'fencing', 'person_fencing'],
    tags: ['fencer', 'fencing', 'person', 'sword'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93a.png',
  },
  {
    emoji: '🏇',
    name: 'horse_racing',
    shortcodes: ['horse_racing'],
    tags: ['horse', 'jockey', 'racehorse', 'racing', 'riding', 'sport'],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c7.png',
  },
  {
    emoji: '⛷',
    name: 'skier',
    shortcodes: ['person_skiing', 'skier', 'skiing'],
    tags: ['ski', 'snow'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f7-fe0f.png',
  },
  {
    emoji: '🏂',
    name: 'snowboarder',
    shortcodes: ['person_snowboarding', 'snowboarder', 'snowboarding'],
    tags: ['ski', 'snow', 'snowboard', 'sport'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c2.png',
  },
  {
    emoji: '🏌',
    name: 'golfing',
    shortcodes: ['golfer', 'golfing', 'person_golfing'],
    tags: [
      'ball',
      'birdie',
      'caddy',
      'driving',
      'golf',
      'golfing',
      'green',
      'person',
      'pga',
      'putt',
      'range',
      'tee',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cc-fe0f.png',
  },
  {
    emoji: '🏌‍♂️',
    name: 'golfing_man',
    shortcodes: ['man_golfing'],
    tags: [
      'ball',
      'birdie',
      'caddy',
      'driving',
      'golf',
      'golfing',
      'green',
      'man',
      'pga',
      'putt',
      'range',
      'tee',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cc-fe0f-200d-2642-fe0f.png',
  },
  {
    emoji: '🏌‍♀️',
    name: 'golfing_woman',
    shortcodes: ['woman_golfing'],
    tags: [
      'ball',
      'birdie',
      'caddy',
      'driving',
      'golf',
      'golfing',
      'green',
      'pga',
      'putt',
      'range',
      'tee',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cc-fe0f-200d-2640-fe0f.png',
  },
  {
    emoji: '🏄',
    name: 'surfer',
    shortcodes: ['person_surfing', 'surfer', 'surfing'],
    tags: ['beach', 'ocean', 'person', 'sport', 'surf', 'surfer', 'surfing', 'swell', 'waves'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c4.png',
  },
  {
    emoji: '🏄‍♂',
    name: 'surfing_man',
    shortcodes: ['man_surfing'],
    tags: ['beach', 'man', 'ocean', 'sport', 'surf', 'surfer', 'surfing', 'swell', 'waves'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c4-200d-2642-fe0f.png',
  },
  {
    emoji: '🏄‍♀',
    name: 'surfing_woman',
    shortcodes: ['woman_surfing'],
    tags: ['beach', 'ocean', 'person', 'sport', 'surf', 'surfer', 'surfing', 'swell', 'waves'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c4-200d-2640-fe0f.png',
  },
  {
    emoji: '🚣',
    name: 'rowboat',
    shortcodes: ['person_rowing_boat', 'rowboat'],
    tags: [
      'boat',
      'canoe',
      'cruise',
      'fishing',
      'lake',
      'oar',
      'paddle',
      'person',
      'raft',
      'river',
      'row',
      'rowboat',
      'rowing',
    ],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a3.png',
  },
  {
    emoji: '🚣‍♂',
    name: 'rowing_man',
    shortcodes: ['man_rowing_boat'],
    tags: [
      'boat',
      'canoe',
      'cruise',
      'fishing',
      'lake',
      'man',
      'oar',
      'paddle',
      'raft',
      'river',
      'row',
      'rowboat',
      'rowing',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a3-200d-2642-fe0f.png',
  },
  {
    emoji: '🚣‍♀',
    name: 'rowing_woman',
    shortcodes: ['woman_rowing_boat'],
    tags: [
      'boat',
      'canoe',
      'cruise',
      'fishing',
      'lake',
      'oar',
      'paddle',
      'raft',
      'river',
      'row',
      'rowboat',
      'rowing',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a3-200d-2640-fe0f.png',
  },
  {
    emoji: '🏊',
    name: 'swimmer',
    shortcodes: ['person_swimming', 'swimmer', 'swimming'],
    tags: ['freestyle', 'person', 'sport', 'swim', 'swimmer', 'swimming', 'triathlon'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ca.png',
  },
  {
    emoji: '🏊‍♂',
    name: 'swimming_man',
    shortcodes: ['man_swimming'],
    tags: ['freestyle', 'man', 'sport', 'swim', 'swimmer', 'swimming', 'triathlon'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ca-200d-2642-fe0f.png',
  },
  {
    emoji: '🏊‍♀',
    name: 'swimming_woman',
    shortcodes: ['woman_swimming'],
    tags: ['freestyle', 'man', 'sport', 'swim', 'swimmer', 'swimming', 'triathlon'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ca-200d-2640-fe0f.png',
  },
  {
    emoji: '⛹',
    name: 'bouncing_ball_person',
    shortcodes: ['person_bouncing_ball'],
    tags: [
      'athletic',
      'ball',
      'basketball',
      'bouncing',
      'championship',
      'dribble',
      'net',
      'person',
      'player',
      'throw',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f9-fe0f.png',
  },
  {
    emoji: '⛹‍♂️',
    name: 'basketball_man',
    shortcodes: ['man_bouncing_ball'],
    tags: [
      'athletic',
      'ball',
      'basketball',
      'bouncing',
      'championship',
      'dribble',
      'man',
      'net',
      'player',
      'throw',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f9-fe0f-200d-2642-fe0f.png',
  },
  {
    emoji: '⛹‍♀️',
    name: 'basketball_woman',
    shortcodes: ['woman_bouncing_ball'],
    tags: [
      'athletic',
      'ball',
      'basketball',
      'bouncing',
      'championship',
      'dribble',
      'net',
      'player',
      'throw',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f9-fe0f-200d-2640-fe0f.png',
  },
  {
    emoji: '🏋',
    name: 'weight_lifting',
    shortcodes: ['person_lifting_weights', 'weight_lifter', 'weight_lifting'],
    tags: [
      'barbell',
      'bodybuilder',
      'deadlift',
      'lifter',
      'lifting',
      'person',
      'powerlifting',
      'weight',
      'weightlifter',
      'weights',
      'workout',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cb-fe0f.png',
  },
  {
    emoji: '🏋‍♂️',
    name: 'weight_lifting_man',
    shortcodes: ['man_lifting_weights'],
    tags: [
      'barbell',
      'bodybuilder',
      'deadlift',
      'lifter',
      'lifting',
      'man',
      'powerlifting',
      'weight',
      'weightlifter',
      'weights',
      'workout',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cb-fe0f-200d-2642-fe0f.png',
  },
  {
    emoji: '🏋‍♀️',
    name: 'weight_lifting_woman',
    shortcodes: ['woman_lifting_weights'],
    tags: [
      'barbell',
      'bodybuilder',
      'deadlift',
      'lifter',
      'lifting',
      'powerlifting',
      'weight',
      'weightlifter',
      'weights',
      'woman',
      'workout',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cb-fe0f-200d-2640-fe0f.png',
  },
  {
    emoji: '🚴',
    name: 'bicyclist',
    shortcodes: ['bicyclist', 'biking', 'person_biking'],
    tags: [
      'bicycle',
      'bicyclist',
      'bike',
      'biking',
      'cycle',
      'cyclist',
      'person',
      'riding',
      'sport',
    ],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b4.png',
  },
  {
    emoji: '🚴‍♂',
    name: 'biking_man',
    shortcodes: ['man_biking'],
    tags: ['bicycle', 'bicyclist', 'bike', 'biking', 'cycle', 'cyclist', 'man', 'riding', 'sport'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b4-200d-2642-fe0f.png',
  },
  {
    emoji: '🚴‍♀',
    name: 'biking_woman',
    shortcodes: ['woman_biking'],
    tags: [
      'bicycle',
      'bicyclist',
      'bike',
      'biking',
      'cycle',
      'cyclist',
      'riding',
      'sport',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b4-200d-2640-fe0f.png',
  },
  {
    emoji: '🚵',
    name: 'mountain_bicyclist',
    shortcodes: ['mountain_bicyclist', 'mountain_biking', 'person_mountain_biking'],
    tags: [
      'bicycle',
      'bicyclist',
      'bike',
      'biking',
      'cycle',
      'cyclist',
      'mountain',
      'person',
      'riding',
      'sport',
    ],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b5.png',
  },
  {
    emoji: '🚵‍♂',
    name: 'mountain_biking_man',
    shortcodes: ['man_mountain_biking'],
    tags: [
      'bicycle',
      'bicyclist',
      'bike',
      'biking',
      'cycle',
      'cyclist',
      'man',
      'mountain',
      'riding',
      'sport',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b5-200d-2642-fe0f.png',
  },
  {
    emoji: '🚵‍♀',
    name: 'mountain_biking_woman',
    shortcodes: ['woman_mountain_biking'],
    tags: [
      'bicycle',
      'bicyclist',
      'bike',
      'biking',
      'cycle',
      'cyclist',
      'mountain',
      'riding',
      'sport',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b5-200d-2640-fe0f.png',
  },
  {
    emoji: '🤸',
    name: 'cartwheeling',
    shortcodes: ['cartwheeling', 'person_cartwheel'],
    tags: [
      'active',
      'cartwheel',
      'cartwheeling',
      'excited',
      'flip',
      'gymnastics',
      'happy',
      'person',
      'somersault',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f938.png',
  },
  {
    emoji: '🤸‍♂',
    name: 'man_cartwheeling',
    shortcodes: ['man_cartwheeling'],
    tags: [
      'active',
      'cartwheel',
      'cartwheeling',
      'excited',
      'flip',
      'gymnastics',
      'happy',
      'man',
      'somersault',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f938-200d-2642-fe0f.png',
  },
  {
    emoji: '🤸‍♀',
    name: 'woman_cartwheeling',
    shortcodes: ['woman_cartwheeling'],
    tags: [
      'active',
      'cartwheel',
      'cartwheeling',
      'excited',
      'flip',
      'gymnastics',
      'happy',
      'somersault',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f938-200d-2640-fe0f.png',
  },
  {
    emoji: '🤼',
    name: 'wrestling',
    shortcodes: ['people_wrestling', 'wrestlers', 'wrestling'],
    tags: ['combat', 'duel', 'grapple', 'people', 'ring', 'tournament', 'wrestle', 'wrestling'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93c.png',
  },
  {
    emoji: '🤼‍♂',
    name: 'men_wrestling',
    shortcodes: ['men_wrestling'],
    tags: ['combat', 'duel', 'grapple', 'men', 'ring', 'tournament', 'wrestle', 'wrestling'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93c-200d-2642-fe0f.png',
  },
  {
    emoji: '🤼‍♀',
    name: 'women_wrestling',
    shortcodes: ['women_wrestling'],
    tags: ['combat', 'duel', 'grapple', 'ring', 'tournament', 'women', 'wrestle', 'wrestling'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93c-200d-2640-fe0f.png',
  },
  {
    emoji: '🤽',
    name: 'water_polo',
    shortcodes: ['person_playing_water_polo', 'water_polo'],
    tags: ['person', 'playing', 'polo', 'sport', 'swimming', 'water', 'waterpolo'],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93d.png',
  },
  {
    emoji: '🤽‍♂',
    name: 'man_playing_water_polo',
    shortcodes: ['man_playing_water_polo'],
    tags: ['man', 'playing', 'polo', 'sport', 'swimming', 'water', 'waterpolo'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93d-200d-2642-fe0f.png',
  },
  {
    emoji: '🤽‍♀',
    name: 'woman_playing_water_polo',
    shortcodes: ['woman_playing_water_polo'],
    tags: ['playing', 'polo', 'sport', 'swimming', 'water', 'waterpolo', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93d-200d-2640-fe0f.png',
  },
  {
    emoji: '🤾',
    name: 'handball_person',
    shortcodes: ['handball', 'person_playing_handball'],
    tags: [
      'athletics',
      'ball',
      'catch',
      'chuck',
      'handball',
      'hurl',
      'lob',
      'person',
      'pitch',
      'playing',
      'sport',
      'throw',
      'toss',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93e.png',
  },
  {
    emoji: '🤾‍♂',
    name: 'man_playing_handball',
    shortcodes: ['man_playing_handball'],
    tags: [
      'athletics',
      'ball',
      'catch',
      'chuck',
      'handball',
      'hurl',
      'lob',
      'man',
      'pitch',
      'playing',
      'sport',
      'throw',
      'toss',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93e-200d-2642-fe0f.png',
  },
  {
    emoji: '🤾‍♀',
    name: 'woman_playing_handball',
    shortcodes: ['woman_playing_handball'],
    tags: [
      'athletics',
      'ball',
      'catch',
      'chuck',
      'handball',
      'hurl',
      'lob',
      'pitch',
      'playing',
      'sport',
      'throw',
      'toss',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93e-200d-2640-fe0f.png',
  },
  {
    emoji: '🤹',
    name: 'juggling_person',
    shortcodes: ['juggler', 'juggling', 'person_juggling'],
    tags: [
      'act',
      'balance',
      'balancing',
      'handle',
      'juggle',
      'juggling',
      'manage',
      'multitask',
      'person',
      'skill',
    ],
    group: 'people & body',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f939.png',
  },
  {
    emoji: '🤹‍♂',
    name: 'man_juggling',
    shortcodes: ['man_juggling'],
    tags: [
      'act',
      'balance',
      'balancing',
      'handle',
      'juggle',
      'juggling',
      'man',
      'manage',
      'multitask',
      'skill',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f939-200d-2642-fe0f.png',
  },
  {
    emoji: '🤹‍♀',
    name: 'woman_juggling',
    shortcodes: ['woman_juggling'],
    tags: [
      'act',
      'balance',
      'balancing',
      'handle',
      'juggle',
      'juggling',
      'manage',
      'multitask',
      'skill',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f939-200d-2640-fe0f.png',
  },
  {
    emoji: '🧘',
    name: 'lotus_position',
    shortcodes: ['person_in_lotus_position'],
    tags: [
      'cross',
      'legged',
      'legs',
      'lotus',
      'meditation',
      'peace',
      'person',
      'position',
      'relax',
      'serenity',
      'yoga',
      'yogi',
      'zen',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d8.png',
  },
  {
    emoji: '🧘‍♂',
    name: 'lotus_position_man',
    shortcodes: ['man_in_lotus_position'],
    tags: [
      'cross',
      'legged',
      'legs',
      'lotus',
      'man',
      'meditation',
      'peace',
      'position',
      'relax',
      'serenity',
      'yoga',
      'yogi',
      'zen',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d8-200d-2642-fe0f.png',
  },
  {
    emoji: '🧘‍♀',
    name: 'lotus_position_woman',
    shortcodes: ['woman_in_lotus_position'],
    tags: [
      'cross',
      'legged',
      'legs',
      'lotus',
      'meditation',
      'peace',
      'position',
      'relax',
      'serenity',
      'woman',
      'yoga',
      'yogi',
      'zen',
    ],
    group: 'people & body',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d8-200d-2640-fe0f.png',
  },
  {
    emoji: '🛀',
    name: 'bath',
    shortcodes: ['bath', 'person_taking_bath'],
    tags: ['bath', 'bathtub', 'person', 'taking', 'tub'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c0.png',
  },
  {
    emoji: '🛌',
    name: 'sleeping_bed',
    shortcodes: ['person_in_bed', 'sleeping_accommodation'],
    tags: [
      'bed',
      'bedtime',
      'good',
      'goodnight',
      'hotel',
      'nap',
      'night',
      'person',
      'sleep',
      'tired',
      'zzz',
    ],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cc.png',
  },
  {
    emoji: '🧑‍🤝‍🧑',
    name: 'people_holding_hands',
    shortcodes: ['people_holding_hands'],
    tags: [
      'bae',
      'bestie',
      'bff',
      'couple',
      'dating',
      'flirt',
      'friends',
      'hand',
      'hold',
      'people',
      'twins',
    ],
    group: 'people & body',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f91d-200d-1f9d1.png',
  },
  {
    emoji: '👭',
    name: 'two_women_holding_hands',
    shortcodes: ['two_women_holding_hands'],
    tags: [
      'bae',
      'bestie',
      'bff',
      'couple',
      'dating',
      'flirt',
      'friends',
      'girls',
      'hand',
      'hold',
      'sisters',
      'twins',
      'women',
    ],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46d.png',
  },
  {
    emoji: '👫',
    name: 'couple',
    shortcodes: ['couple'],
    tags: [
      'bae',
      'bestie',
      'bff',
      'couple',
      'dating',
      'flirt',
      'friends',
      'hand',
      'hold',
      'man',
      'twins',
      'woman',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46b.png',
  },
  {
    emoji: '👬',
    name: 'two_men_holding_hands',
    shortcodes: ['two_men_holding_hands'],
    tags: [
      'bae',
      'bestie',
      'bff',
      'boys',
      'brothers',
      'couple',
      'dating',
      'flirt',
      'friends',
      'hand',
      'hold',
      'men',
      'twins',
    ],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46c.png',
  },
  {
    emoji: '💏',
    name: 'couplekiss',
    shortcodes: ['couple_kiss', 'couplekiss'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'date',
      'dating',
      'heart',
      'love',
      'mwah',
      'person',
      'romance',
      'together',
      'xoxo',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48f.png',
  },
  {
    emoji: '👩‍❤‍💋‍👨',
    name: 'couplekiss_man_woman',
    shortcodes: ['kiss_mw', 'kiss_wm'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'date',
      'dating',
      'heart',
      'kiss',
      'love',
      'man',
      'mwah',
      'person',
      'romance',
      'together',
      'woman',
      'xoxo',
    ],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f48b-200d-1f468.png',
  },
  {
    emoji: '👨‍❤‍💋‍👨',
    name: 'couplekiss_man_man',
    shortcodes: ['kiss_mm'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'date',
      'dating',
      'heart',
      'kiss',
      'love',
      'man',
      'mwah',
      'person',
      'romance',
      'together',
      'xoxo',
    ],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2764-fe0f-200d-1f48b-200d-1f468.png',
  },
  {
    emoji: '👩‍❤‍💋‍👩',
    name: 'couplekiss_woman_woman',
    shortcodes: ['kiss_ww'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'date',
      'dating',
      'heart',
      'kiss',
      'love',
      'mwah',
      'person',
      'romance',
      'together',
      'woman',
      'xoxo',
    ],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f48b-200d-1f469.png',
  },
  {
    emoji: '💑',
    name: 'couple_with_heart',
    shortcodes: ['couple_with_heart'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'dating',
      'heart',
      'kiss',
      'love',
      'person',
      'relationship',
      'romance',
      'together',
      'you',
    ],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f491.png',
  },
  {
    emoji: '👩‍❤‍👨',
    name: 'couple_with_heart_woman_man',
    shortcodes: ['couple_with_heart_mw', 'couple_with_heart_wm'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'dating',
      'heart',
      'kiss',
      'love',
      'man',
      'person',
      'relationship',
      'romance',
      'together',
      'woman',
      'you',
    ],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f468.png',
  },
  {
    emoji: '👨‍❤‍👨',
    name: 'couple_with_heart_man_man',
    shortcodes: ['couple_with_heart_mm'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'dating',
      'heart',
      'kiss',
      'love',
      'man',
      'person',
      'relationship',
      'romance',
      'together',
      'you',
    ],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-2764-fe0f-200d-1f468.png',
  },
  {
    emoji: '👩‍❤‍👩',
    name: 'couple_with_heart_woman_woman',
    shortcodes: ['couple_with_heart_ww'],
    tags: [
      'anniversary',
      'babe',
      'bae',
      'couple',
      'dating',
      'heart',
      'kiss',
      'love',
      'person',
      'relationship',
      'romance',
      'together',
      'woman',
      'you',
    ],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-2764-fe0f-200d-1f469.png',
  },
  {
    emoji: '👨‍👩‍👦',
    name: 'family_man_woman_boy',
    shortcodes: ['family_mwb'],
    tags: ['boy', 'child', 'family', 'man', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f466.png',
  },
  {
    emoji: '👨‍👩‍👧',
    name: 'family_man_woman_girl',
    shortcodes: ['family_mwg'],
    tags: ['child', 'family', 'girl', 'man', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f467.png',
  },
  {
    emoji: '👨‍👩‍👧‍👦',
    name: 'family_man_woman_girl_boy',
    shortcodes: ['family_mwgb'],
    tags: ['boy', 'child', 'family', 'girl', 'man', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f467-200d-1f466.png',
  },
  {
    emoji: '👨‍👩‍👦‍👦',
    name: 'family_man_woman_boy_boy',
    shortcodes: ['family_mwbb'],
    tags: ['boy', 'child', 'family', 'man', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f466-200d-1f466.png',
  },
  {
    emoji: '👨‍👩‍👧‍👧',
    name: 'family_man_woman_girl_girl',
    shortcodes: ['family_mwgg'],
    tags: ['child', 'family', 'girl', 'man', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f469-200d-1f467-200d-1f467.png',
  },
  {
    emoji: '👨‍👨‍👦',
    name: 'family_man_man_boy',
    shortcodes: ['family_mmb'],
    tags: ['boy', 'child', 'family', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f466.png',
  },
  {
    emoji: '👨‍👨‍👧',
    name: 'family_man_man_girl',
    shortcodes: ['family_mmg'],
    tags: ['child', 'family', 'girl', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f467.png',
  },
  {
    emoji: '👨‍👨‍👧‍👦',
    name: 'family_man_man_girl_boy',
    shortcodes: ['family_mmgb'],
    tags: ['boy', 'child', 'family', 'girl', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f467-200d-1f466.png',
  },
  {
    emoji: '👨‍👨‍👦‍👦',
    name: 'family_man_man_boy_boy',
    shortcodes: ['family_mmbb'],
    tags: ['boy', 'child', 'family', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f466-200d-1f466.png',
  },
  {
    emoji: '👨‍👨‍👧‍👧',
    name: 'family_man_man_girl_girl',
    shortcodes: ['family_mmgg'],
    tags: ['child', 'family', 'girl', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f468-200d-1f467-200d-1f467.png',
  },
  {
    emoji: '👩‍👩‍👦',
    name: 'family_woman_woman_boy',
    shortcodes: ['family_wwb'],
    tags: ['boy', 'child', 'family', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f466.png',
  },
  {
    emoji: '👩‍👩‍👧',
    name: 'family_woman_woman_girl',
    shortcodes: ['family_wwg'],
    tags: ['child', 'family', 'girl', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f467.png',
  },
  {
    emoji: '👩‍👩‍👧‍👦',
    name: 'family_woman_woman_girl_boy',
    shortcodes: ['family_wwgb'],
    tags: ['boy', 'child', 'family', 'girl', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f467-200d-1f466.png',
  },
  {
    emoji: '👩‍👩‍👦‍👦',
    name: 'family_woman_woman_boy_boy',
    shortcodes: ['family_wwbb'],
    tags: ['boy', 'child', 'family', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f466-200d-1f466.png',
  },
  {
    emoji: '👩‍👩‍👧‍👧',
    name: 'family_woman_woman_girl_girl',
    shortcodes: ['family_wwgg'],
    tags: ['child', 'family', 'girl', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f469-200d-1f467-200d-1f467.png',
  },
  {
    emoji: '👨‍👦',
    name: 'family_man_boy',
    shortcodes: ['family_mb'],
    tags: ['boy', 'child', 'family', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f466.png',
  },
  {
    emoji: '👨‍👦‍👦',
    name: 'family_man_boy_boy',
    shortcodes: ['family_mbb'],
    tags: ['boy', 'child', 'family', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f466-200d-1f466.png',
  },
  {
    emoji: '👨‍👧',
    name: 'family_man_girl',
    shortcodes: ['family_mg'],
    tags: ['child', 'family', 'girl', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f467.png',
  },
  {
    emoji: '👨‍👧‍👦',
    name: 'family_man_girl_boy',
    shortcodes: ['family_mgb'],
    tags: ['boy', 'child', 'family', 'girl', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f467-200d-1f466.png',
  },
  {
    emoji: '👨‍👧‍👧',
    name: 'family_man_girl_girl',
    shortcodes: ['family_mgg'],
    tags: ['child', 'family', 'girl', 'man'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f468-200d-1f467-200d-1f467.png',
  },
  {
    emoji: '👩‍👦',
    name: 'family_woman_boy',
    shortcodes: ['family_wb'],
    tags: ['boy', 'child', 'family', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f466.png',
  },
  {
    emoji: '👩‍👦‍👦',
    name: 'family_woman_boy_boy',
    shortcodes: ['family_wbb'],
    tags: ['boy', 'child', 'family', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f466-200d-1f466.png',
  },
  {
    emoji: '👩‍👧',
    name: 'family_woman_girl',
    shortcodes: ['family_wg'],
    tags: ['child', 'family', 'girl', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f467.png',
  },
  {
    emoji: '👩‍👧‍👦',
    name: 'family_woman_girl_boy',
    shortcodes: ['family_wgb'],
    tags: ['boy', 'child', 'family', 'girl', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f467-200d-1f466.png',
  },
  {
    emoji: '👩‍👧‍👧',
    name: 'family_woman_girl_girl',
    shortcodes: ['family_wgg'],
    tags: ['child', 'family', 'girl', 'woman'],
    group: 'people & body',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f467-200d-1f467.png',
  },
  {
    emoji: '🗣',
    name: 'speaking_head',
    shortcodes: ['speaking_head'],
    tags: ['face', 'head', 'silhouette', 'speak', 'speaking'],
    group: 'people & body',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5e3-fe0f.png',
  },
  {
    emoji: '👤',
    name: 'bust_in_silhouette',
    shortcodes: ['bust_in_silhouette'],
    tags: ['bust', 'mysterious', 'shadow', 'silhouette'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f464.png',
  },
  {
    emoji: '👥',
    name: 'busts_in_silhouette',
    shortcodes: ['busts_in_silhouette'],
    tags: ['bff', 'bust', 'busts', 'everyone', 'friend', 'friends', 'people', 'silhouette'],
    group: 'people & body',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f465.png',
  },
  {
    emoji: '🫂',
    name: 'people_hugging',
    shortcodes: ['people_hugging'],
    tags: [
      'comfort',
      'embrace',
      'farewell',
      'friendship',
      'goodbye',
      'hello',
      'hug',
      'hugging',
      'love',
      'people',
      'thanks',
    ],
    group: 'people & body',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac2.png',
  },
  {
    emoji: '👪',
    name: 'family',
    shortcodes: ['family'],
    tags: ['child'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f46a.png',
  },
  {
    emoji: '🧑‍🧑‍🧒',
    name: 'family_aac',
    shortcodes: ['family_aac'],
    tags: ['adult', 'child', 'family'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9d1-200d-1f9d2.png',
  },
  {
    emoji: '🧑‍🧑‍🧒‍🧒',
    name: 'family_aacc',
    shortcodes: ['family_aacc'],
    tags: ['adult', 'child', 'family'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2.png',
  },
  {
    emoji: '🧑‍🧒',
    name: 'family_aa',
    shortcodes: ['family_aa', 'family_ac'],
    tags: ['adult', 'child', 'family'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9d2.png',
  },
  {
    emoji: '🧑‍🧒‍🧒',
    name: 'family_acc',
    shortcodes: ['family_acc'],
    tags: ['adult', 'child', 'family'],
    group: 'people & body',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9d1-200d-1f9d2-200d-1f9d2.png',
  },
  {
    emoji: '👣',
    name: 'footprints',
    shortcodes: ['footprints'],
    tags: ['barefoot', 'clothing', 'footprint', 'omw', 'print', 'walk'],
    group: 'people & body',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f463.png',
  },
  {
    emoji: '🫆',
    name: 'fingerprint',
    shortcodes: ['fingerprint'],
    tags: [
      'clue',
      'crime',
      'detective',
      'forensics',
      'identity',
      'mystery',
      'print',
      'safety',
      'trace',
    ],
    group: 'people & body',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fac6.png',
  },
  {
    emoji: '🏻',
    name: 'tone1',
    shortcodes: ['tone1', 'tone_light'],
    tags: ['1–2', 'light', 'skin', 'tone', 'type'],
    group: 'components',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fb.png',
  },
  {
    emoji: '🏼',
    name: 'tone2',
    shortcodes: ['tone2', 'tone_medium_light'],
    tags: ['3', 'medium-light', 'skin', 'tone', 'type'],
    group: 'components',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fc.png',
  },
  {
    emoji: '🏽',
    name: 'tone3',
    shortcodes: ['tone3', 'tone_medium'],
    tags: ['4', 'medium', 'skin', 'tone', 'type'],
    group: 'components',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fd.png',
  },
  {
    emoji: '🏾',
    name: 'tone4',
    shortcodes: ['tone4', 'tone_medium_dark'],
    tags: ['5', 'medium-dark', 'skin', 'tone', 'type'],
    group: 'components',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fe.png',
  },
  {
    emoji: '🏿',
    name: 'tone5',
    shortcodes: ['tone5', 'tone_dark'],
    tags: ['6', 'dark', 'skin', 'tone', 'type'],
    group: 'components',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ff.png',
  },
  {
    emoji: '🦰',
    name: 'red_hair',
    shortcodes: ['red_hair'],
    tags: ['ginger', 'hair', 'red', 'redhead'],
    group: 'components',
    emoticons: [],
    version: 11,
  },
  {
    emoji: '🦱',
    name: 'curly_hair',
    shortcodes: ['curly_hair'],
    tags: ['afro', 'curly', 'hair', 'ringlets'],
    group: 'components',
    emoticons: [],
    version: 11,
  },
  {
    emoji: '🦳',
    name: 'white_hair',
    shortcodes: ['white_hair'],
    tags: ['gray', 'hair', 'old', 'white'],
    group: 'components',
    emoticons: [],
    version: 11,
  },
  {
    emoji: '🦲',
    name: 'no_hair',
    shortcodes: ['no_hair'],
    tags: ['chemotherapy', 'hair', 'hairless', 'no', 'shaven'],
    group: 'components',
    emoticons: [],
    version: 11,
  },
  {
    emoji: '🐵',
    name: 'monkey_face',
    shortcodes: ['monkey_face'],
    tags: ['animal', 'banana', 'face', 'monkey'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f435.png',
  },
  {
    emoji: '🐒',
    name: 'monkey',
    shortcodes: ['monkey'],
    tags: ['animal', 'banana'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f412.png',
  },
  {
    emoji: '🦍',
    name: 'gorilla',
    shortcodes: ['gorilla'],
    tags: ['animal'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98d.png',
  },
  {
    emoji: '🦧',
    name: 'orangutan',
    shortcodes: ['orangutan'],
    tags: ['animal', 'ape', 'monkey'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a7.png',
  },
  {
    emoji: '🐶',
    name: 'dog',
    shortcodes: ['dog_face'],
    tags: ['adorbs', 'animal', 'dog', 'face', 'pet', 'puppies', 'puppy'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f436.png',
  },
  {
    emoji: '🐕',
    name: 'dog2',
    shortcodes: ['dog'],
    tags: ['animal', 'animals', 'dogs', 'pet'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f415.png',
  },
  {
    emoji: '🦮',
    name: 'guide_dog',
    shortcodes: ['guide_dog'],
    tags: ['accessibility', 'animal', 'blind', 'dog', 'guide'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ae.png',
  },
  {
    emoji: '🐕‍🦺',
    name: 'service_dog',
    shortcodes: ['service_dog'],
    tags: ['accessibility', 'animal', 'assistance', 'dog', 'service'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f415-200d-1f9ba.png',
  },
  {
    emoji: '🐩',
    name: 'poodle',
    shortcodes: ['poodle'],
    tags: ['animal', 'dog', 'fluffy'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f429.png',
  },
  {
    emoji: '🐺',
    name: 'wolf',
    shortcodes: ['wolf', 'wolf_face'],
    tags: ['animal', 'face'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43a.png',
  },
  {
    emoji: '🦊',
    name: 'fox_face',
    shortcodes: ['fox', 'fox_face'],
    tags: ['animal', 'face'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98a.png',
  },
  {
    emoji: '🦝',
    name: 'raccoon',
    shortcodes: ['raccoon'],
    tags: ['animal', 'curious', 'sly'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99d.png',
  },
  {
    emoji: '🐱',
    name: 'cat',
    shortcodes: ['cat_face'],
    tags: ['animal', 'cat', 'face', 'kitten', 'kitty', 'pet'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f431.png',
  },
  {
    emoji: '🐈',
    name: 'cat2',
    shortcodes: ['cat'],
    tags: ['animal', 'animals', 'cats', 'kitten', 'pet'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f408.png',
  },
  {
    emoji: '🐈‍⬛',
    name: 'black_cat',
    shortcodes: ['black_cat'],
    tags: ['animal', 'black', 'cat', 'feline', 'halloween', 'meow', 'unlucky'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f408-200d-2b1b.png',
  },
  {
    emoji: '🦁',
    name: 'lion',
    shortcodes: ['lion', 'lion_face'],
    tags: [
      'alpha',
      'animal',
      'face',
      'leo',
      'mane',
      'order',
      'rawr',
      'roar',
      'safari',
      'strong',
      'zodiac',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f981.png',
  },
  {
    emoji: '🐯',
    name: 'tiger',
    shortcodes: ['tiger_face'],
    tags: ['animal', 'big', 'cat', 'face', 'predator', 'tiger'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42f.png',
  },
  {
    emoji: '🐅',
    name: 'tiger2',
    shortcodes: ['tiger'],
    tags: ['animal', 'big', 'cat', 'predator', 'zoo'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f405.png',
  },
  {
    emoji: '🐆',
    name: 'leopard',
    shortcodes: ['leopard'],
    tags: ['animal', 'big', 'cat', 'predator', 'zoo'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f406.png',
  },
  {
    emoji: '🐴',
    name: 'horse',
    shortcodes: ['horse_face'],
    tags: ['animal', 'dressage', 'equine', 'face', 'farm', 'horse', 'horses'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f434.png',
  },
  {
    emoji: '🫎',
    name: 'moose',
    shortcodes: ['moose'],
    tags: ['alces', 'animal', 'antlers', 'elk', 'mammal'],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1face.png',
  },
  {
    emoji: '🫏',
    name: 'donkey',
    shortcodes: ['donkey'],
    tags: ['animal', 'ass', 'burro', 'hinny', 'mammal', 'mule', 'stubborn'],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1facf.png',
  },
  {
    emoji: '🐎',
    name: 'racehorse',
    shortcodes: ['horse', 'racehorse'],
    tags: ['animal', 'equestrian', 'farm', 'racehorse', 'racing'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40e.png',
  },
  {
    emoji: '🦄',
    name: 'unicorn',
    shortcodes: ['unicorn', 'unicorn_face'],
    tags: ['face'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f984.png',
  },
  {
    emoji: '🦓',
    name: 'zebra',
    shortcodes: ['zebra'],
    tags: ['animal', 'stripe'],
    group: 'animals & nature',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f993.png',
  },
  {
    emoji: '🦌',
    name: 'deer',
    shortcodes: ['deer'],
    tags: ['animal'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98c.png',
  },
  {
    emoji: '🦬',
    name: 'bison',
    shortcodes: ['bison'],
    tags: ['animal', 'buffalo', 'herd', 'wisent'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ac.png',
  },
  {
    emoji: '🐮',
    name: 'cow',
    shortcodes: ['cow_face'],
    tags: ['animal', 'cow', 'face', 'farm', 'milk', 'moo'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42e.png',
  },
  {
    emoji: '🐂',
    name: 'ox',
    shortcodes: ['ox'],
    tags: ['animal', 'animals', 'bull', 'farm', 'taurus', 'zodiac'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f402.png',
  },
  {
    emoji: '🐃',
    name: 'water_buffalo',
    shortcodes: ['water_buffalo'],
    tags: ['animal', 'buffalo', 'water', 'zoo'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f403.png',
  },
  {
    emoji: '🐄',
    name: 'cow2',
    shortcodes: ['cow'],
    tags: ['animal', 'animals', 'farm', 'milk', 'moo'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f404.png',
  },
  {
    emoji: '🐷',
    name: 'pig',
    shortcodes: ['pig_face'],
    tags: ['animal', 'bacon', 'face', 'farm', 'pig', 'pork'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f437.png',
  },
  {
    emoji: '🐖',
    name: 'pig2',
    shortcodes: ['pig'],
    tags: ['animal', 'bacon', 'farm', 'pork', 'sow'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f416.png',
  },
  {
    emoji: '🐗',
    name: 'boar',
    shortcodes: ['boar'],
    tags: ['animal', 'pig'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f417.png',
  },
  {
    emoji: '🐽',
    name: 'pig_nose',
    shortcodes: ['pig_nose'],
    tags: ['animal', 'face', 'farm', 'nose', 'pig', 'smell', 'snout'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43d.png',
  },
  {
    emoji: '🐏',
    name: 'ram',
    shortcodes: ['ram'],
    tags: ['animal', 'aries', 'horns', 'male', 'sheep', 'zodiac', 'zoo'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40f.png',
  },
  {
    emoji: '🐑',
    name: 'sheep',
    shortcodes: ['ewe', 'sheep'],
    tags: ['animal', 'baa', 'farm', 'female', 'fluffy', 'lamb', 'sheep', 'wool'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f411.png',
  },
  {
    emoji: '🐐',
    name: 'goat',
    shortcodes: ['goat'],
    tags: ['animal', 'capricorn', 'farm', 'milk', 'zodiac'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f410.png',
  },
  {
    emoji: '🐪',
    name: 'dromedary_camel',
    shortcodes: ['dromedary_camel'],
    tags: ['animal', 'desert', 'dromedary', 'hump', 'one'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42a.png',
  },
  {
    emoji: '🐫',
    name: 'camel',
    shortcodes: ['camel'],
    tags: ['animal', 'bactrian', 'camel', 'desert', 'hump', 'two', 'two-hump'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42b.png',
  },
  {
    emoji: '🦙',
    name: 'llama',
    shortcodes: ['llama'],
    tags: ['alpaca', 'animal', 'guanaco', 'vicuña', 'wool'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f999.png',
  },
  {
    emoji: '🦒',
    name: 'giraffe',
    shortcodes: ['giraffe'],
    tags: ['animal', 'spots'],
    group: 'animals & nature',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f992.png',
  },
  {
    emoji: '🐘',
    name: 'elephant',
    shortcodes: ['elephant'],
    tags: ['animal'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f418.png',
  },
  {
    emoji: '🦣',
    name: 'mammoth',
    shortcodes: ['mammoth'],
    tags: ['animal', 'extinction', 'large', 'tusk', 'wooly'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a3.png',
  },
  {
    emoji: '🦏',
    name: 'rhinoceros',
    shortcodes: ['rhino', 'rhinoceros'],
    tags: ['animal'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98f.png',
  },
  {
    emoji: '🦛',
    name: 'hippopotamus',
    shortcodes: ['hippo'],
    tags: ['animal', 'hippo'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99b.png',
  },
  {
    emoji: '🐭',
    name: 'mouse',
    shortcodes: ['mouse_face'],
    tags: ['animal', 'face', 'mouse'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42d.png',
  },
  {
    emoji: '🐁',
    name: 'mouse2',
    shortcodes: ['mouse'],
    tags: ['animal', 'animals'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f401.png',
  },
  {
    emoji: '🐀',
    name: 'rat',
    shortcodes: ['rat'],
    tags: ['animal'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f400.png',
  },
  {
    emoji: '🐹',
    name: 'hamster',
    shortcodes: ['hamster', 'hamster_face'],
    tags: ['animal', 'face', 'pet'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f439.png',
  },
  {
    emoji: '🐰',
    name: 'rabbit',
    shortcodes: ['rabbit_face'],
    tags: ['animal', 'bunny', 'face', 'pet', 'rabbit'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f430.png',
  },
  {
    emoji: '🐇',
    name: 'rabbit2',
    shortcodes: ['rabbit'],
    tags: ['animal', 'bunny', 'pet'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f407.png',
  },
  {
    emoji: '🐿',
    name: 'chipmunk',
    shortcodes: ['chipmunk'],
    tags: ['animal', 'squirrel'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43f-fe0f.png',
  },
  {
    emoji: '🦫',
    name: 'beaver',
    shortcodes: ['beaver'],
    tags: ['animal', 'dam', 'teeth'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ab.png',
  },
  {
    emoji: '🦔',
    name: 'hedgehog',
    shortcodes: ['hedgehog'],
    tags: ['animal', 'spiny'],
    group: 'animals & nature',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f994.png',
  },
  {
    emoji: '🦇',
    name: 'bat',
    shortcodes: ['bat'],
    tags: ['animal', 'vampire'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f987.png',
  },
  {
    emoji: '🐻',
    name: 'bear',
    shortcodes: ['bear', 'bear_face'],
    tags: ['animal', 'face', 'grizzly', 'growl', 'honey'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43b.png',
  },
  {
    emoji: '🐻‍❄',
    name: 'polar_bear',
    shortcodes: ['polar_bear', 'polar_bear_face'],
    tags: ['animal', 'arctic', 'bear', 'polar', 'white'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43b-200d-2744-fe0f.png',
  },
  {
    emoji: '🐨',
    name: 'koala',
    shortcodes: ['koala', 'koala_face'],
    tags: ['animal', 'australia', 'bear', 'down', 'face', 'marsupial', 'under'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f428.png',
  },
  {
    emoji: '🐼',
    name: 'panda_face',
    shortcodes: ['panda', 'panda_face'],
    tags: ['animal', 'bamboo', 'face'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43c.png',
  },
  {
    emoji: '🦥',
    name: 'sloth',
    shortcodes: ['sloth'],
    tags: ['lazy', 'slow'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a5.png',
  },
  {
    emoji: '🦦',
    name: 'otter',
    shortcodes: ['otter'],
    tags: ['animal', 'fishing', 'playful'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a6.png',
  },
  {
    emoji: '🦨',
    name: 'skunk',
    shortcodes: ['skunk'],
    tags: ['animal', 'stink'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a8.png',
  },
  {
    emoji: '🦘',
    name: 'kangaroo',
    shortcodes: ['kangaroo'],
    tags: ['animal', 'joey', 'jump', 'marsupial'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f998.png',
  },
  {
    emoji: '🦡',
    name: 'badger',
    shortcodes: ['badger'],
    tags: ['animal', 'honey', 'pester'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a1.png',
  },
  {
    emoji: '🐾',
    name: 'feet',
    shortcodes: ['paw_prints'],
    tags: ['feet', 'paw', 'paws', 'print', 'prints'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f43e.png',
  },
  {
    emoji: '🦃',
    name: 'turkey',
    shortcodes: ['turkey'],
    tags: ['bird', 'gobble', 'thanksgiving'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f983.png',
  },
  {
    emoji: '🐔',
    name: 'chicken',
    shortcodes: ['chicken', 'chicken_face'],
    tags: ['animal', 'bird', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f414.png',
  },
  {
    emoji: '🐓',
    name: 'rooster',
    shortcodes: ['rooster'],
    tags: ['animal', 'bird', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f413.png',
  },
  {
    emoji: '🐣',
    name: 'hatching_chick',
    shortcodes: ['hatching_chick'],
    tags: ['animal', 'baby', 'bird', 'chick', 'egg', 'hatching'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f423.png',
  },
  {
    emoji: '🐤',
    name: 'baby_chick',
    shortcodes: ['baby_chick'],
    tags: ['animal', 'baby', 'bird', 'chick', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f424.png',
  },
  {
    emoji: '🐥',
    name: 'hatched_chick',
    shortcodes: ['hatched_chick'],
    tags: ['animal', 'baby', 'bird', 'chick', 'front-facing', 'newborn', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f425.png',
  },
  {
    emoji: '🐦',
    name: 'bird',
    shortcodes: ['bird', 'bird_face'],
    tags: ['animal', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f426.png',
  },
  {
    emoji: '🐧',
    name: 'penguin',
    shortcodes: ['penguin', 'penguin_face'],
    tags: ['animal', 'antarctica', 'bird', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f427.png',
  },
  {
    emoji: '🕊',
    name: 'dove',
    shortcodes: ['dove'],
    tags: ['bird', 'fly', 'ornithology', 'peace'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54a-fe0f.png',
  },
  {
    emoji: '🦅',
    name: 'eagle',
    shortcodes: ['eagle'],
    tags: ['animal', 'bird', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f985.png',
  },
  {
    emoji: '🦆',
    name: 'duck',
    shortcodes: ['duck'],
    tags: ['animal', 'bird', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f986.png',
  },
  {
    emoji: '🦢',
    name: 'swan',
    shortcodes: ['swan'],
    tags: ['animal', 'bird', 'cygnet', 'duckling', 'ornithology', 'ugly'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a2.png',
  },
  {
    emoji: '🦉',
    name: 'owl',
    shortcodes: ['owl'],
    tags: ['animal', 'bird', 'ornithology', 'wise'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f989.png',
  },
  {
    emoji: '🦤',
    name: 'dodo',
    shortcodes: ['dodo'],
    tags: ['animal', 'bird', 'extinction', 'large', 'ornithology'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a4.png',
  },
  {
    emoji: '🪶',
    name: 'feather',
    shortcodes: ['feather'],
    tags: ['bird', 'flight', 'light', 'plumage'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab6.png',
  },
  {
    emoji: '🦩',
    name: 'flamingo',
    shortcodes: ['flamingo'],
    tags: ['animal', 'bird', 'flamboyant', 'ornithology', 'tropical'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a9.png',
  },
  {
    emoji: '🦚',
    name: 'peacock',
    shortcodes: ['peacock'],
    tags: [
      'animal',
      'bird',
      'colorful',
      'ornithology',
      'ostentatious',
      'peahen',
      'pretty',
      'proud',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99a.png',
  },
  {
    emoji: '🦜',
    name: 'parrot',
    shortcodes: ['parrot'],
    tags: ['animal', 'bird', 'ornithology', 'pirate', 'talk'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99c.png',
  },
  {
    emoji: '🪽',
    name: 'wing',
    shortcodes: ['wing'],
    tags: [
      'angelic',
      'ascend',
      'aviation',
      'bird',
      'fly',
      'flying',
      'heavenly',
      'mythology',
      'soar',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fabd.png',
  },
  {
    emoji: '🐦‍⬛',
    name: 'black_bird',
    shortcodes: ['black_bird'],
    tags: [
      'animal',
      'beak',
      'bird',
      'black',
      'caw',
      'corvid',
      'crow',
      'ornithology',
      'raven',
      'rook',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f426-200d-2b1b.png',
  },
  {
    emoji: '🪿',
    name: 'goose',
    shortcodes: ['goose'],
    tags: [
      'animal',
      'bird',
      'duck',
      'flock',
      'fowl',
      'gaggle',
      'gander',
      'geese',
      'honk',
      'ornithology',
      'silly',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fabf.png',
  },
  {
    emoji: '🐦‍🔥',
    name: 'phoenix',
    shortcodes: ['phoenix'],
    tags: [
      'ascend',
      'ascension',
      'emerge',
      'fantasy',
      'firebird',
      'glory',
      'immortal',
      'rebirth',
      'reincarnation',
      'reinvent',
      'renewal',
      'revival',
      'revive',
      'rise',
      'transform',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f426-200d-1f525.png',
  },
  {
    emoji: '🐸',
    name: 'frog',
    shortcodes: ['frog', 'frog_face'],
    tags: ['animal', 'face'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f438.png',
  },
  {
    emoji: '🐊',
    name: 'crocodile',
    shortcodes: ['crocodile'],
    tags: ['animal', 'zoo'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40a.png',
  },
  {
    emoji: '🐢',
    name: 'turtle',
    shortcodes: ['turtle'],
    tags: ['animal', 'terrapin', 'tortoise'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f422.png',
  },
  {
    emoji: '🦎',
    name: 'lizard',
    shortcodes: ['lizard'],
    tags: ['animal', 'reptile'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98e.png',
  },
  {
    emoji: '🐍',
    name: 'snake',
    shortcodes: ['snake'],
    tags: ['animal', 'bearer', 'ophiuchus', 'serpent', 'zodiac'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40d.png',
  },
  {
    emoji: '🐲',
    name: 'dragon_face',
    shortcodes: ['dragon_face'],
    tags: ['animal', 'dragon', 'face', 'fairy', 'fairytale', 'tale'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f432.png',
  },
  {
    emoji: '🐉',
    name: 'dragon',
    shortcodes: ['dragon'],
    tags: ['animal', 'fairy', 'fairytale', 'knights', 'tale'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f409.png',
  },
  {
    emoji: '🦕',
    name: 'sauropod',
    shortcodes: ['sauropod'],
    tags: ['brachiosaurus', 'brontosaurus', 'dinosaur', 'diplodocus'],
    group: 'animals & nature',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f995.png',
  },
  {
    emoji: '🦖',
    name: 't-rex',
    shortcodes: ['t-rex', 'trex'],
    tags: ['dinosaur', 'rex', 't', 't-rex', 'tyrannosaurus'],
    group: 'animals & nature',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f996.png',
  },
  {
    emoji: '🐳',
    name: 'whale',
    shortcodes: ['spouting_whale'],
    tags: ['animal', 'beach', 'face', 'ocean', 'spouting', 'whale'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f433.png',
  },
  {
    emoji: '🐋',
    name: 'whale2',
    shortcodes: ['whale'],
    tags: ['animal', 'beach', 'ocean'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40b.png',
  },
  {
    emoji: '🐬',
    name: 'dolphin',
    shortcodes: ['dolphin'],
    tags: ['animal', 'beach', 'flipper', 'ocean'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f42c.png',
  },
  {
    emoji: '🫍',
    name: 'orca',
    shortcodes: ['orca'],
    tags: ['marine', 'ocean', 'whale'],
    group: 'animals & nature',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '🦭',
    name: 'seal',
    shortcodes: ['seal'],
    tags: ['animal', 'lion', 'ocean', 'sea'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ad.png',
  },
  {
    emoji: '🐟',
    name: 'fish',
    shortcodes: ['fish'],
    tags: ['animal', 'dinner', 'fishes', 'fishing', 'pisces', 'zodiac'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41f.png',
  },
  {
    emoji: '🐠',
    name: 'tropical_fish',
    shortcodes: ['tropical_fish'],
    tags: ['animal', 'fish', 'fishes', 'tropical'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f420.png',
  },
  {
    emoji: '🐡',
    name: 'blowfish',
    shortcodes: ['blowfish'],
    tags: ['animal', 'fish'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f421.png',
  },
  {
    emoji: '🦈',
    name: 'shark',
    shortcodes: ['shark'],
    tags: ['animal', 'fish'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f988.png',
  },
  {
    emoji: '🐙',
    name: 'octopus',
    shortcodes: ['octopus'],
    tags: ['animal', 'creature', 'ocean'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f419.png',
  },
  {
    emoji: '🐚',
    name: 'shell',
    shortcodes: ['shell'],
    tags: ['animal', 'beach', 'conch', 'sea', 'shell', 'spiral'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41a.png',
  },
  {
    emoji: '🪸',
    name: 'coral',
    shortcodes: ['coral'],
    tags: ['change', 'climate', 'ocean', 'reef', 'sea'],
    group: 'animals & nature',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab8.png',
  },
  {
    emoji: '🪼',
    name: 'jellyfish',
    shortcodes: ['jellyfish'],
    tags: [
      'animal',
      'aquarium',
      'burn',
      'invertebrate',
      'jelly',
      'life',
      'marine',
      'ocean',
      'ouch',
      'plankton',
      'sea',
      'sting',
      'stinger',
      'tentacles',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fabc.png',
  },
  {
    emoji: '🦀',
    name: 'crab',
    shortcodes: ['crab'],
    tags: ['cancer', 'zodiac'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f980.png',
  },
  {
    emoji: '🦞',
    name: 'lobster',
    shortcodes: ['lobster'],
    tags: ['animal', 'bisque', 'claws', 'seafood'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99e.png',
  },
  {
    emoji: '🦐',
    name: 'shrimp',
    shortcodes: ['shrimp'],
    tags: ['food', 'shellfish', 'small'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f990.png',
  },
  {
    emoji: '🦑',
    name: 'squid',
    shortcodes: ['squid'],
    tags: ['animal', 'food', 'mollusk'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f991.png',
  },
  {
    emoji: '🦪',
    name: 'oyster',
    shortcodes: ['oyster'],
    tags: ['diving', 'pearl'],
    group: 'animals & nature',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9aa.png',
  },
  {
    emoji: '🐌',
    name: 'snail',
    shortcodes: ['snail'],
    tags: ['animal', 'escargot', 'garden', 'nature', 'slug'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f40c.png',
  },
  {
    emoji: '🦋',
    name: 'butterfly',
    shortcodes: ['butterfly'],
    tags: ['insect', 'pretty'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f98b.png',
  },
  {
    emoji: '🐛',
    name: 'bug',
    shortcodes: ['bug'],
    tags: ['animal', 'garden', 'insect'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41b.png',
  },
  {
    emoji: '🐜',
    name: 'ant',
    shortcodes: ['ant'],
    tags: ['animal', 'garden', 'insect'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41c.png',
  },
  {
    emoji: '🐝',
    name: 'bee',
    shortcodes: ['bee'],
    tags: ['animal', 'bee', 'bumblebee', 'honey', 'insect', 'nature', 'spring'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41d.png',
  },
  {
    emoji: '🪲',
    name: 'beetle',
    shortcodes: ['beetle'],
    tags: ['animal', 'bug', 'insect'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab2.png',
  },
  {
    emoji: '🐞',
    name: 'lady_beetle',
    shortcodes: ['lady_beetle'],
    tags: ['animal', 'beetle', 'garden', 'insect', 'lady', 'ladybird', 'ladybug', 'nature'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f41e.png',
  },
  {
    emoji: '🦗',
    name: 'cricket',
    shortcodes: ['cricket'],
    tags: ['animal', 'bug', 'grasshopper', 'insect', 'orthoptera'],
    group: 'animals & nature',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f997.png',
  },
  {
    emoji: '🪳',
    name: 'cockroach',
    shortcodes: ['cockroach'],
    tags: ['animal', 'insect', 'pest', 'roach'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab3.png',
  },
  {
    emoji: '🕷',
    name: 'spider',
    shortcodes: ['spider'],
    tags: ['animal', 'insect'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f577-fe0f.png',
  },
  {
    emoji: '🕸',
    name: 'spider_web',
    shortcodes: ['spider_web'],
    tags: ['spider', 'web'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f578-fe0f.png',
  },
  {
    emoji: '🦂',
    name: 'scorpion',
    shortcodes: ['scorpion'],
    tags: ['scorpio', 'scorpius', 'zodiac'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f982.png',
  },
  {
    emoji: '🦟',
    name: 'mosquito',
    shortcodes: ['mosquito'],
    tags: ['bite', 'disease', 'fever', 'insect', 'malaria', 'pest', 'virus'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f99f.png',
  },
  {
    emoji: '🪰',
    name: 'fly',
    shortcodes: ['fly'],
    tags: ['animal', 'disease', 'insect', 'maggot', 'pest', 'rotting'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab0.png',
  },
  {
    emoji: '🪱',
    name: 'worm',
    shortcodes: ['worm'],
    tags: ['animal', 'annelid', 'earthworm', 'parasite'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab1.png',
  },
  {
    emoji: '🦠',
    name: 'microbe',
    shortcodes: ['microbe'],
    tags: ['amoeba', 'bacteria', 'science', 'virus'],
    group: 'animals & nature',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9a0.png',
  },
  {
    emoji: '💐',
    name: 'bouquet',
    shortcodes: ['bouquet'],
    tags: ['anniversary', 'birthday', 'date', 'flower', 'love', 'plant', 'romance'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f490.png',
  },
  {
    emoji: '🌸',
    name: 'cherry_blossom',
    shortcodes: ['cherry_blossom'],
    tags: ['blossom', 'cherry', 'flower', 'plant', 'spring', 'springtime'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f338.png',
  },
  {
    emoji: '💮',
    name: 'white_flower',
    shortcodes: ['white_flower'],
    tags: ['flower', 'white'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ae.png',
  },
  {
    emoji: '🪷',
    name: 'lotus',
    shortcodes: ['lotus'],
    tags: ['beauty', 'buddhism', 'calm', 'flower', 'hinduism', 'peace', 'purity', 'serenity'],
    group: 'animals & nature',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab7.png',
  },
  {
    emoji: '🏵',
    name: 'rosette',
    shortcodes: ['rosette'],
    tags: ['plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f5-fe0f.png',
  },
  {
    emoji: '🌹',
    name: 'rose',
    shortcodes: ['rose'],
    tags: ['beauty', 'elegant', 'flower', 'love', 'plant', 'red', 'valentine'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f339.png',
  },
  {
    emoji: '🥀',
    name: 'wilted_flower',
    shortcodes: ['wilted_flower'],
    tags: ['dying', 'flower', 'wilted'],
    group: 'animals & nature',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f940.png',
  },
  {
    emoji: '🌺',
    name: 'hibiscus',
    shortcodes: ['hibiscus'],
    tags: ['flower', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33a.png',
  },
  {
    emoji: '🌻',
    name: 'sunflower',
    shortcodes: ['sunflower'],
    tags: ['flower', 'outdoors', 'plant', 'sun'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33b.png',
  },
  {
    emoji: '🌼',
    name: 'blossom',
    shortcodes: ['blossom'],
    tags: ['buttercup', 'dandelion', 'flower', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33c.png',
  },
  {
    emoji: '🌷',
    name: 'tulip',
    shortcodes: ['tulip'],
    tags: ['blossom', 'flower', 'growth', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f337.png',
  },
  {
    emoji: '🪻',
    name: 'hyacinth',
    shortcodes: ['hyacinth'],
    tags: [
      'bloom',
      'bluebonnet',
      'flower',
      'indigo',
      'lavender',
      'lilac',
      'lupine',
      'plant',
      'purple',
      'shrub',
      'snapdragon',
      'spring',
      'violet',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fabb.png',
  },
  {
    emoji: '🌱',
    name: 'seedling',
    shortcodes: ['seedling'],
    tags: ['plant', 'sapling', 'sprout', 'young'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f331.png',
  },
  {
    emoji: '🪴',
    name: 'potted_plant',
    shortcodes: ['potted_plant'],
    tags: ['decor', 'grow', 'house', 'nurturing', 'plant', 'pot', 'potted'],
    group: 'animals & nature',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab4.png',
  },
  {
    emoji: '🌲',
    name: 'evergreen_tree',
    shortcodes: ['evergreen_tree'],
    tags: ['christmas', 'evergreen', 'forest', 'pine', 'tree'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f332.png',
  },
  {
    emoji: '🌳',
    name: 'deciduous_tree',
    shortcodes: ['deciduous_tree'],
    tags: ['deciduous', 'forest', 'green', 'habitat', 'shedding', 'tree'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f333.png',
  },
  {
    emoji: '🌴',
    name: 'palm_tree',
    shortcodes: ['palm_tree'],
    tags: ['beach', 'palm', 'plant', 'tree', 'tropical'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f334.png',
  },
  {
    emoji: '🌵',
    name: 'cactus',
    shortcodes: ['cactus'],
    tags: ['desert', 'drought', 'nature', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f335.png',
  },
  {
    emoji: '🌾',
    name: 'ear_of_rice',
    shortcodes: ['ear_of_rice', 'sheaf_of_rice'],
    tags: ['ear', 'grain', 'grains', 'plant', 'rice', 'sheaf'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33e.png',
  },
  {
    emoji: '🌿',
    name: 'herb',
    shortcodes: ['herb'],
    tags: ['leaf', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33f.png',
  },
  {
    emoji: '☘',
    name: 'shamrock',
    shortcodes: ['shamrock'],
    tags: ['irish', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2618-fe0f.png',
  },
  {
    emoji: '🍀',
    name: 'four_leaf_clover',
    shortcodes: ['four_leaf_clover'],
    tags: ['4', 'clover', 'four', 'four-leaf', 'irish', 'leaf', 'lucky', 'plant'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f340.png',
  },
  {
    emoji: '🍁',
    name: 'maple_leaf',
    shortcodes: ['maple_leaf'],
    tags: ['falling', 'leaf', 'maple'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f341.png',
  },
  {
    emoji: '🍂',
    name: 'fallen_leaf',
    shortcodes: ['fallen_leaf'],
    tags: ['autumn', 'fall', 'fallen', 'falling', 'leaf'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f342.png',
  },
  {
    emoji: '🍃',
    name: 'leaves',
    shortcodes: ['leaves'],
    tags: ['blow', 'flutter', 'fluttering', 'leaf', 'wind'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f343.png',
  },
  {
    emoji: '🪹',
    name: 'empty_nest',
    shortcodes: ['empty_nest', 'nest'],
    tags: ['branch', 'empty', 'home', 'nest', 'nesting'],
    group: 'animals & nature',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab9.png',
  },
  {
    emoji: '🪺',
    name: 'nest_with_eggs',
    shortcodes: ['nest_with_eggs'],
    tags: ['bird', 'branch', 'egg', 'eggs', 'nest', 'nesting'],
    group: 'animals & nature',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faba.png',
  },
  {
    emoji: '🍄',
    name: 'mushroom',
    shortcodes: ['mushroom'],
    tags: ['fungus', 'toadstool'],
    group: 'animals & nature',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f344.png',
  },
  {
    emoji: '🪾',
    name: 'leafless_tree',
    shortcodes: ['leafless_tree'],
    tags: [
      'bare',
      'barren',
      'branches',
      'dead',
      'drought',
      'leafless',
      'tree',
      'trunk',
      'winter',
      'wood',
    ],
    group: 'animals & nature',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fabe.png',
  },
  {
    emoji: '🍇',
    name: 'grapes',
    shortcodes: ['grapes'],
    tags: ['dionysus', 'fruit', 'grape'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f347.png',
  },
  {
    emoji: '🍈',
    name: 'melon',
    shortcodes: ['melon'],
    tags: ['cantaloupe', 'fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f348.png',
  },
  {
    emoji: '🍉',
    name: 'watermelon',
    shortcodes: ['watermelon'],
    tags: ['fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f349.png',
  },
  {
    emoji: '🍊',
    name: 'mandarin',
    shortcodes: ['orange', 'tangerine'],
    tags: ['c', 'citrus', 'fruit', 'nectarine', 'orange', 'vitamin'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34a.png',
  },
  {
    emoji: '🍋',
    name: 'lemon',
    shortcodes: ['lemon'],
    tags: ['citrus', 'fruit', 'sour'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34b.png',
  },
  {
    emoji: '🍋‍🟩',
    name: 'lime',
    shortcodes: ['lime'],
    tags: [
      'acidity',
      'citrus',
      'cocktail',
      'fruit',
      'garnish',
      'key',
      'margarita',
      'mojito',
      'refreshing',
      'salsa',
      'sour',
      'tangy',
      'tequila',
      'tropical',
      'zest',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34b-200d-1f7e9.png',
  },
  {
    emoji: '🍌',
    name: 'banana',
    shortcodes: ['banana'],
    tags: ['fruit', 'potassium'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34c.png',
  },
  {
    emoji: '🍍',
    name: 'pineapple',
    shortcodes: ['pineapple'],
    tags: ['colada', 'fruit', 'pina', 'tropical'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34d.png',
  },
  {
    emoji: '🥭',
    name: 'mango',
    shortcodes: ['mango'],
    tags: ['food', 'fruit', 'tropical'],
    group: 'food & drink',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96d.png',
  },
  {
    emoji: '🍎',
    name: 'apple',
    shortcodes: ['apple', 'red_apple'],
    tags: ['apple', 'diet', 'food', 'fruit', 'health', 'red', 'ripe'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34e.png',
  },
  {
    emoji: '🍏',
    name: 'green_apple',
    shortcodes: ['green_apple'],
    tags: ['apple', 'fruit', 'green'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f34f.png',
  },
  {
    emoji: '🍐',
    name: 'pear',
    shortcodes: ['pear'],
    tags: ['fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f350.png',
  },
  {
    emoji: '🍑',
    name: 'peach',
    shortcodes: ['peach'],
    tags: ['fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f351.png',
  },
  {
    emoji: '🍒',
    name: 'cherries',
    shortcodes: ['cherries'],
    tags: ['berries', 'cherry', 'fruit', 'red'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f352.png',
  },
  {
    emoji: '🍓',
    name: 'strawberry',
    shortcodes: ['strawberry'],
    tags: ['berry', 'fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f353.png',
  },
  {
    emoji: '🫐',
    name: 'blueberries',
    shortcodes: ['blueberries'],
    tags: ['berries', 'berry', 'bilberry', 'blue', 'blueberry', 'food', 'fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad0.png',
  },
  {
    emoji: '🥝',
    name: 'kiwi_fruit',
    shortcodes: ['kiwi'],
    tags: ['food', 'fruit', 'kiwi'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95d.png',
  },
  {
    emoji: '🍅',
    name: 'tomato',
    shortcodes: ['tomato'],
    tags: ['food', 'fruit', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f345.png',
  },
  {
    emoji: '🫒',
    name: 'olive',
    shortcodes: ['olive'],
    tags: ['food'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad2.png',
  },
  {
    emoji: '🥥',
    name: 'coconut',
    shortcodes: ['coconut'],
    tags: ['colada', 'palm', 'piña'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f965.png',
  },
  {
    emoji: '🥑',
    name: 'avocado',
    shortcodes: ['avocado'],
    tags: ['food', 'fruit'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f951.png',
  },
  {
    emoji: '🍆',
    name: 'eggplant',
    shortcodes: ['eggplant'],
    tags: ['aubergine', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f346.png',
  },
  {
    emoji: '🥔',
    name: 'potato',
    shortcodes: ['potato'],
    tags: ['food', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f954.png',
  },
  {
    emoji: '🥕',
    name: 'carrot',
    shortcodes: ['carrot'],
    tags: ['food', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f955.png',
  },
  {
    emoji: '🌽',
    name: 'corn',
    shortcodes: ['corn', 'ear_of_corn'],
    tags: ['corn', 'crops', 'ear', 'farm', 'maize', 'maze'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f33d.png',
  },
  {
    emoji: '🌶',
    name: 'hot_pepper',
    shortcodes: ['hot_pepper'],
    tags: ['hot', 'pepper'],
    group: 'food & drink',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f336-fe0f.png',
  },
  {
    emoji: '🫑',
    name: 'bell_pepper',
    shortcodes: ['bell_pepper'],
    tags: ['bell', 'capsicum', 'food', 'pepper', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad1.png',
  },
  {
    emoji: '🥒',
    name: 'cucumber',
    shortcodes: ['cucumber'],
    tags: ['food', 'pickle', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f952.png',
  },
  {
    emoji: '🥬',
    name: 'leafy_green',
    shortcodes: ['leafy_green'],
    tags: ['bok', 'burgers', 'cabbage', 'choy', 'green', 'kale', 'leafy', 'lettuce', 'salad'],
    group: 'food & drink',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96c.png',
  },
  {
    emoji: '🥦',
    name: 'broccoli',
    shortcodes: ['broccoli'],
    tags: ['cabbage', 'wild'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f966.png',
  },
  {
    emoji: '🧄',
    name: 'garlic',
    shortcodes: ['garlic'],
    tags: ['flavoring'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c4.png',
  },
  {
    emoji: '🧅',
    name: 'onion',
    shortcodes: ['onion'],
    tags: ['flavoring'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c5.png',
  },
  {
    emoji: '🥜',
    name: 'peanuts',
    shortcodes: ['peanuts'],
    tags: ['food', 'nut', 'peanut', 'vegetable'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95c.png',
  },
  {
    emoji: '🫘',
    name: 'beans',
    shortcodes: ['beans'],
    tags: ['food', 'kidney', 'legume', 'small'],
    group: 'food & drink',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad8.png',
  },
  {
    emoji: '🌰',
    name: 'chestnut',
    shortcodes: ['chestnut'],
    tags: ['almond', 'plant'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f330.png',
  },
  {
    emoji: '🫚',
    name: 'ginger_root',
    shortcodes: ['ginger'],
    tags: ['beer', 'ginger', 'health', 'herb', 'natural', 'root', 'spice'],
    group: 'food & drink',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fada.png',
  },
  {
    emoji: '🫛',
    name: 'pea_pod',
    shortcodes: ['pea'],
    tags: [
      'beans',
      'beanstalk',
      'edamame',
      'legume',
      'pea',
      'pod',
      'soybean',
      'vegetable',
      'veggie',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fadb.png',
  },
  {
    emoji: '🍄‍🟫',
    name: 'brown_mushroom',
    shortcodes: ['brown_mushroom'],
    tags: [
      'food',
      'fungi',
      'fungus',
      'mushroom',
      'nature',
      'pizza',
      'portobello',
      'shiitake',
      'shroom',
      'spore',
      'sprout',
      'toppings',
      'truffle',
      'vegetable',
      'vegetarian',
      'veggie',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f344-200d-1f7eb.png',
  },
  {
    emoji: '🫜',
    name: 'root_vegetable',
    shortcodes: ['root_vegetable'],
    tags: [
      'beet',
      'food',
      'garden',
      'radish',
      'root',
      'salad',
      'turnip',
      'vegetable',
      'vegetarian',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fadc.png',
  },
  {
    emoji: '🍞',
    name: 'bread',
    shortcodes: ['bread'],
    tags: ['carbs', 'food', 'grain', 'loaf', 'restaurant', 'toast', 'wheat'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35e.png',
  },
  {
    emoji: '🥐',
    name: 'croissant',
    shortcodes: ['croissant'],
    tags: ['bread', 'breakfast', 'crescent', 'food', 'french', 'roll'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f950.png',
  },
  {
    emoji: '🥖',
    name: 'baguette_bread',
    shortcodes: ['baguette_bread'],
    tags: ['baguette', 'bread', 'food', 'french'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f956.png',
  },
  {
    emoji: '🫓',
    name: 'flatbread',
    shortcodes: ['flatbread'],
    tags: ['arepa', 'bread', 'food', 'gordita', 'lavash', 'naan', 'pita'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad3.png',
  },
  {
    emoji: '🥨',
    name: 'pretzel',
    shortcodes: ['pretzel'],
    tags: ['convoluted', 'twisted'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f968.png',
  },
  {
    emoji: '🥯',
    name: 'bagel',
    shortcodes: ['bagel'],
    tags: ['bakery', 'bread', 'breakfast', 'schmear'],
    group: 'food & drink',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96f.png',
  },
  {
    emoji: '🥞',
    name: 'pancakes',
    shortcodes: ['pancakes'],
    tags: ['breakfast', 'crêpe', 'food', 'hotcake', 'pancake'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95e.png',
  },
  {
    emoji: '🧇',
    name: 'waffle',
    shortcodes: ['waffle'],
    tags: ['breakfast', 'indecisive', 'iron'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c7.png',
  },
  {
    emoji: '🧀',
    name: 'cheese',
    shortcodes: ['cheese'],
    tags: ['cheese', 'wedge'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c0.png',
  },
  {
    emoji: '🍖',
    name: 'meat_on_bone',
    shortcodes: ['meat_on_bone'],
    tags: ['bone', 'meat'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f356.png',
  },
  {
    emoji: '🍗',
    name: 'poultry_leg',
    shortcodes: ['poultry_leg'],
    tags: ['bone', 'chicken', 'drumstick', 'hungry', 'leg', 'poultry', 'turkey'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f357.png',
  },
  {
    emoji: '🥩',
    name: 'cut_of_meat',
    shortcodes: ['cut_of_meat'],
    tags: ['chop', 'cut', 'lambchop', 'meat', 'porkchop', 'red', 'steak'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f969.png',
  },
  {
    emoji: '🥓',
    name: 'bacon',
    shortcodes: ['bacon'],
    tags: ['breakfast', 'food', 'meat'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f953.png',
  },
  {
    emoji: '🍔',
    name: 'hamburger',
    shortcodes: ['hamburger'],
    tags: ['burger', 'eat', 'fast', 'food', 'hungry'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f354.png',
  },
  {
    emoji: '🍟',
    name: 'fries',
    shortcodes: ['french_fries', 'fries'],
    tags: ['fast', 'food', 'french', 'fries'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35f.png',
  },
  {
    emoji: '🍕',
    name: 'pizza',
    shortcodes: ['pizza'],
    tags: ['cheese', 'food', 'hungry', 'pepperoni', 'slice'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f355.png',
  },
  {
    emoji: '🌭',
    name: 'hotdog',
    shortcodes: ['hotdog'],
    tags: ['dog', 'frankfurter', 'hot', 'hotdog', 'sausage'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32d.png',
  },
  {
    emoji: '🥪',
    name: 'sandwich',
    shortcodes: ['sandwich'],
    tags: ['bread'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96a.png',
  },
  {
    emoji: '🌮',
    name: 'taco',
    shortcodes: ['taco'],
    tags: ['mexican'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32e.png',
  },
  {
    emoji: '🌯',
    name: 'burrito',
    shortcodes: ['burrito'],
    tags: ['mexican', 'wrap'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32f.png',
  },
  {
    emoji: '🫔',
    name: 'tamale',
    shortcodes: ['tamale'],
    tags: ['food', 'mexican', 'pamonha', 'wrapped'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad4.png',
  },
  {
    emoji: '🥙',
    name: 'stuffed_flatbread',
    shortcodes: ['stuffed_flatbread'],
    tags: ['falafel', 'flatbread', 'food', 'gyro', 'kebab', 'stuffed'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f959.png',
  },
  {
    emoji: '🧆',
    name: 'falafel',
    shortcodes: ['falafel'],
    tags: ['chickpea', 'meatball'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c6.png',
  },
  {
    emoji: '🥚',
    name: 'egg',
    shortcodes: ['egg'],
    tags: ['breakfast', 'food'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95a.png',
  },
  {
    emoji: '🍳',
    name: 'fried_egg',
    shortcodes: ['cooking', 'fried_egg'],
    tags: [
      'breakfast',
      'easy',
      'egg',
      'fry',
      'frying',
      'over',
      'pan',
      'restaurant',
      'side',
      'sunny',
      'up',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f373.png',
  },
  {
    emoji: '🥘',
    name: 'shallow_pan_of_food',
    shortcodes: ['shallow_pan_of_food'],
    tags: ['casserole', 'food', 'paella', 'pan', 'shallow'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f958.png',
  },
  {
    emoji: '🍲',
    name: 'stew',
    shortcodes: ['pot_of_food', 'stew'],
    tags: ['food', 'pot', 'soup', 'stew'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f372.png',
  },
  {
    emoji: '🫕',
    name: 'fondue',
    shortcodes: ['fondue'],
    tags: ['cheese', 'chocolate', 'food', 'melted', 'pot', 'ski'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad5.png',
  },
  {
    emoji: '🥣',
    name: 'bowl_with_spoon',
    shortcodes: ['bowl_with_spoon'],
    tags: ['bowl', 'breakfast', 'cereal', 'congee', 'oatmeal', 'porridge', 'spoon'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f963.png',
  },
  {
    emoji: '🥗',
    name: 'green_salad',
    shortcodes: ['green_salad', 'salad'],
    tags: ['food', 'green', 'salad'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f957.png',
  },
  {
    emoji: '🍿',
    name: 'popcorn',
    shortcodes: ['popcorn'],
    tags: ['corn', 'movie', 'pop'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37f.png',
  },
  {
    emoji: '🧈',
    name: 'butter',
    shortcodes: ['butter'],
    tags: ['dairy'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c8.png',
  },
  {
    emoji: '🧂',
    name: 'salt',
    shortcodes: ['salt'],
    tags: ['condiment', 'flavor', 'mad', 'salty', 'shaker', 'taste', 'upset'],
    group: 'food & drink',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c2.png',
  },
  {
    emoji: '🥫',
    name: 'canned_food',
    shortcodes: ['canned_food'],
    tags: ['can', 'canned', 'food'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96b.png',
  },
  {
    emoji: '🍱',
    name: 'bento',
    shortcodes: ['bento', 'bento_box'],
    tags: ['bento', 'box', 'food'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f371.png',
  },
  {
    emoji: '🍘',
    name: 'rice_cracker',
    shortcodes: ['rice_cracker'],
    tags: ['cracker', 'food', 'rice'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f358.png',
  },
  {
    emoji: '🍙',
    name: 'rice_ball',
    shortcodes: ['rice_ball'],
    tags: ['ball', 'food', 'japanese', 'rice'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f359.png',
  },
  {
    emoji: '🍚',
    name: 'rice',
    shortcodes: ['cooked_rice', 'rice'],
    tags: ['cooked', 'food', 'rice'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35a.png',
  },
  {
    emoji: '🍛',
    name: 'curry',
    shortcodes: ['curry', 'curry_rice'],
    tags: ['curry', 'food', 'rice'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35b.png',
  },
  {
    emoji: '🍜',
    name: 'ramen',
    shortcodes: ['ramen', 'steaming_bowl'],
    tags: ['bowl', 'chopsticks', 'food', 'noodle', 'pho', 'ramen', 'soup', 'steaming'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35c.png',
  },
  {
    emoji: '🍝',
    name: 'spaghetti',
    shortcodes: ['spaghetti'],
    tags: ['food', 'meatballs', 'pasta', 'restaurant'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f35d.png',
  },
  {
    emoji: '🍠',
    name: 'sweet_potato',
    shortcodes: ['sweet_potato'],
    tags: ['food', 'potato', 'roasted', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f360.png',
  },
  {
    emoji: '🍢',
    name: 'oden',
    shortcodes: ['oden'],
    tags: ['food', 'kebab', 'restaurant', 'seafood', 'skewer', 'stick'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f362.png',
  },
  {
    emoji: '🍣',
    name: 'sushi',
    shortcodes: ['sushi'],
    tags: ['food'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f363.png',
  },
  {
    emoji: '🍤',
    name: 'fried_shrimp',
    shortcodes: ['fried_shrimp'],
    tags: ['fried', 'prawn', 'shrimp', 'tempura'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f364.png',
  },
  {
    emoji: '🍥',
    name: 'fish_cake',
    shortcodes: ['fish_cake'],
    tags: ['cake', 'fish', 'food', 'pastry', 'restaurant', 'swirl'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f365.png',
  },
  {
    emoji: '🥮',
    name: 'moon_cake',
    shortcodes: ['moon_cake'],
    tags: ['autumn', 'cake', 'festival', 'moon', 'yuèbǐng'],
    group: 'food & drink',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f96e.png',
  },
  {
    emoji: '🍡',
    name: 'dango',
    shortcodes: ['dango'],
    tags: ['dessert', 'japanese', 'skewer', 'stick', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f361.png',
  },
  {
    emoji: '🥟',
    name: 'dumpling',
    shortcodes: ['dumpling'],
    tags: ['empanada', 'gyōza', 'jiaozi', 'pierogi', 'potsticker'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95f.png',
  },
  {
    emoji: '🥠',
    name: 'fortune_cookie',
    shortcodes: ['fortune_cookie'],
    tags: ['cookie', 'fortune', 'prophecy'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f960.png',
  },
  {
    emoji: '🥡',
    name: 'takeout_box',
    shortcodes: ['takeout_box'],
    tags: ['box', 'chopsticks', 'delivery', 'food', 'oyster', 'pail', 'takeout'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f961.png',
  },
  {
    emoji: '🍦',
    name: 'icecream',
    shortcodes: ['icecream', 'soft_serve'],
    tags: ['cream', 'dessert', 'food', 'ice', 'icecream', 'restaurant', 'serve', 'soft', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f366.png',
  },
  {
    emoji: '🍧',
    name: 'shaved_ice',
    shortcodes: ['shaved_ice'],
    tags: ['dessert', 'ice', 'restaurant', 'shaved', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f367.png',
  },
  {
    emoji: '🍨',
    name: 'ice_cream',
    shortcodes: ['ice_cream'],
    tags: ['cream', 'dessert', 'food', 'ice', 'restaurant', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f368.png',
  },
  {
    emoji: '🍩',
    name: 'doughnut',
    shortcodes: ['doughnut'],
    tags: ['breakfast', 'dessert', 'donut', 'food', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f369.png',
  },
  {
    emoji: '🍪',
    name: 'cookie',
    shortcodes: ['cookie'],
    tags: ['chip', 'chocolate', 'dessert', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36a.png',
  },
  {
    emoji: '🎂',
    name: 'birthday',
    shortcodes: ['birthday', 'birthday_cake'],
    tags: ['bday', 'birthday', 'cake', 'celebration', 'dessert', 'happy', 'pastry', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f382.png',
  },
  {
    emoji: '🍰',
    name: 'cake',
    shortcodes: ['cake', 'shortcake'],
    tags: ['cake', 'dessert', 'pastry', 'slice', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f370.png',
  },
  {
    emoji: '🧁',
    name: 'cupcake',
    shortcodes: ['cupcake'],
    tags: ['bakery', 'dessert', 'sprinkles', 'sugar', 'sweet', 'treat'],
    group: 'food & drink',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c1.png',
  },
  {
    emoji: '🥧',
    name: 'pie',
    shortcodes: ['pie'],
    tags: ['apple', 'filling', 'fruit', 'meat', 'pastry', 'pumpkin', 'slice'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f967.png',
  },
  {
    emoji: '🍫',
    name: 'chocolate_bar',
    shortcodes: ['chocolate_bar'],
    tags: ['bar', 'candy', 'chocolate', 'dessert', 'halloween', 'sweet', 'tooth'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36b.png',
  },
  {
    emoji: '🍬',
    name: 'candy',
    shortcodes: ['candy'],
    tags: ['cavities', 'dessert', 'halloween', 'restaurant', 'sweet', 'tooth', 'wrapper'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36c.png',
  },
  {
    emoji: '🍭',
    name: 'lollipop',
    shortcodes: ['lollipop'],
    tags: ['candy', 'dessert', 'food', 'restaurant', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36d.png',
  },
  {
    emoji: '🍮',
    name: 'custard',
    shortcodes: ['custard'],
    tags: ['dessert', 'pudding', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36e.png',
  },
  {
    emoji: '🍯',
    name: 'honey_pot',
    shortcodes: ['honey_pot'],
    tags: ['barrel', 'bear', 'food', 'honey', 'honeypot', 'jar', 'pot', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f36f.png',
  },
  {
    emoji: '🍼',
    name: 'baby_bottle',
    shortcodes: ['baby_bottle'],
    tags: ['babies', 'baby', 'birth', 'born', 'bottle', 'drink', 'infant', 'milk', 'newborn'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37c.png',
  },
  {
    emoji: '🥛',
    name: 'milk_glass',
    shortcodes: ['glass_of_milk', 'milk'],
    tags: ['drink', 'glass', 'milk'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f95b.png',
  },
  {
    emoji: '☕',
    name: 'coffee',
    shortcodes: ['coffee'],
    tags: [
      'beverage',
      'cafe',
      'caffeine',
      'chai',
      'coffee',
      'drink',
      'hot',
      'morning',
      'steaming',
      'tea',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2615.png',
  },
  {
    emoji: '🫖',
    name: 'teapot',
    shortcodes: ['teapot'],
    tags: ['brew', 'drink', 'food', 'pot', 'tea'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad6.png',
  },
  {
    emoji: '🍵',
    name: 'tea',
    shortcodes: ['tea'],
    tags: ['beverage', 'cup', 'drink', 'handle', 'oolong', 'tea', 'teacup'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f375.png',
  },
  {
    emoji: '🍶',
    name: 'sake',
    shortcodes: ['sake'],
    tags: ['bar', 'beverage', 'bottle', 'cup', 'drink', 'restaurant'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f376.png',
  },
  {
    emoji: '🍾',
    name: 'champagne',
    shortcodes: ['champagne'],
    tags: ['bar', 'bottle', 'cork', 'drink', 'popping'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37e.png',
  },
  {
    emoji: '🍷',
    name: 'wine_glass',
    shortcodes: ['wine_glass'],
    tags: [
      'alcohol',
      'bar',
      'beverage',
      'booze',
      'club',
      'drink',
      'drinking',
      'drinks',
      'glass',
      'restaurant',
      'wine',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f377.png',
  },
  {
    emoji: '🍸',
    name: 'cocktail',
    shortcodes: ['cocktail'],
    tags: [
      'alcohol',
      'bar',
      'booze',
      'club',
      'cocktail',
      'drink',
      'drinking',
      'drinks',
      'glass',
      'mad',
      'martini',
      'men',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f378.png',
  },
  {
    emoji: '🍹',
    name: 'tropical_drink',
    shortcodes: ['tropical_drink'],
    tags: [
      'alcohol',
      'bar',
      'booze',
      'club',
      'cocktail',
      'drink',
      'drinking',
      'drinks',
      'drunk',
      'mai',
      'party',
      'tai',
      'tropical',
      'tropics',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f379.png',
  },
  {
    emoji: '🍺',
    name: 'beer',
    shortcodes: ['beer'],
    tags: [
      'alcohol',
      'ale',
      'bar',
      'beer',
      'booze',
      'drink',
      'drinking',
      'drinks',
      'mug',
      'octoberfest',
      'oktoberfest',
      'pint',
      'stein',
      'summer',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37a.png',
  },
  {
    emoji: '🍻',
    name: 'beers',
    shortcodes: ['beers'],
    tags: [
      'alcohol',
      'bar',
      'beer',
      'booze',
      'bottoms',
      'cheers',
      'clink',
      'clinking',
      'drinking',
      'drinks',
      'mugs',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37b.png',
  },
  {
    emoji: '🥂',
    name: 'clinking_glasses',
    shortcodes: ['clinking_glasses'],
    tags: ['celebrate', 'clink', 'clinking', 'drink', 'glass', 'glasses'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f942.png',
  },
  {
    emoji: '🥃',
    name: 'tumbler_glass',
    shortcodes: ['tumbler_glass', 'whisky'],
    tags: ['glass', 'liquor', 'scotch', 'shot', 'tumbler', 'whiskey', 'whisky'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f943.png',
  },
  {
    emoji: '🫗',
    name: 'pouring_liquid',
    shortcodes: ['pour', 'pouring_liquid'],
    tags: [
      'accident',
      'drink',
      'empty',
      'glass',
      'liquid',
      'oops',
      'pour',
      'pouring',
      'spill',
      'water',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad7.png',
  },
  {
    emoji: '🥤',
    name: 'cup_with_straw',
    shortcodes: ['cup_with_straw'],
    tags: ['cup', 'drink', 'juice', 'malt', 'soda', 'soft', 'straw', 'water'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f964.png',
  },
  {
    emoji: '🧋',
    name: 'bubble_tea',
    shortcodes: ['boba_drink', 'bubble_tea'],
    tags: ['boba', 'bubble', 'food', 'milk', 'pearl', 'tea'],
    group: 'food & drink',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9cb.png',
  },
  {
    emoji: '🧃',
    name: 'beverage_box',
    shortcodes: ['beverage_box', 'juice_box'],
    tags: ['beverage', 'box', 'juice', 'straw', 'sweet'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c3.png',
  },
  {
    emoji: '🧉',
    name: 'mate',
    shortcodes: ['mate'],
    tags: ['drink'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9c9.png',
  },
  {
    emoji: '🧊',
    name: 'ice_cube',
    shortcodes: ['ice', 'ice_cube'],
    tags: ['cold', 'cube', 'iceberg'],
    group: 'food & drink',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ca.png',
  },
  {
    emoji: '🥢',
    name: 'chopsticks',
    shortcodes: ['chopsticks'],
    tags: ['hashi', 'jeotgarak', 'kuaizi'],
    group: 'food & drink',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f962.png',
  },
  {
    emoji: '🍽',
    name: 'plate_with_cutlery',
    shortcodes: ['fork_knife_plate'],
    tags: ['cooking', 'dinner', 'eat', 'fork', 'knife', 'plate'],
    group: 'food & drink',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f37d-fe0f.png',
  },
  {
    emoji: '🍴',
    name: 'fork_and_knife',
    shortcodes: ['fork_and_knife'],
    tags: [
      'breakfast',
      'breaky',
      'cooking',
      'cutlery',
      'delicious',
      'dinner',
      'eat',
      'feed',
      'food',
      'fork',
      'hungry',
      'knife',
      'lunch',
      'restaurant',
      'yum',
      'yummy',
    ],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f374.png',
  },
  {
    emoji: '🥄',
    name: 'spoon',
    shortcodes: ['spoon'],
    tags: ['eat', 'tableware'],
    group: 'food & drink',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f944.png',
  },
  {
    emoji: '🔪',
    name: 'hocho',
    shortcodes: ['knife'],
    tags: ['chef', 'cooking', 'hocho', 'kitchen', 'knife', 'tool', 'weapon'],
    group: 'food & drink',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52a.png',
  },
  {
    emoji: '🫙',
    name: 'jar',
    shortcodes: ['jar'],
    tags: ['condiment', 'container', 'empty', 'nothing', 'sauce', 'store'],
    group: 'food & drink',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fad9.png',
  },
  {
    emoji: '🏺',
    name: 'amphora',
    shortcodes: ['amphora'],
    tags: ['aquarius', 'cooking', 'drink', 'jug', 'tool', 'weapon', 'zodiac'],
    group: 'food & drink',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3fa.png',
  },
  {
    emoji: '🌍',
    name: 'earth_africa',
    shortcodes: ['earth_africa', 'earth_europe'],
    tags: ['africa', 'earth', 'europe', 'europe-africa', 'globe', 'showing', 'world'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30d.png',
  },
  {
    emoji: '🌎',
    name: 'earth_americas',
    shortcodes: ['earth_americas'],
    tags: ['americas', 'earth', 'globe', 'showing', 'world'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30e.png',
  },
  {
    emoji: '🌏',
    name: 'earth_asia',
    shortcodes: ['earth_asia'],
    tags: ['asia', 'asia-australia', 'australia', 'earth', 'globe', 'showing', 'world'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30f.png',
  },
  {
    emoji: '🌐',
    name: 'globe_with_meridians',
    shortcodes: ['globe_with_meridians'],
    tags: ['earth', 'globe', 'internet', 'meridians', 'web', 'world', 'worldwide'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f310.png',
  },
  {
    emoji: '🗺',
    name: 'world_map',
    shortcodes: ['world_map'],
    tags: ['map', 'world'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fa-fe0f.png',
  },
  {
    emoji: '🗾',
    name: 'japan',
    shortcodes: ['japan_map'],
    tags: ['japan', 'map'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fe.png',
  },
  {
    emoji: '🧭',
    name: 'compass',
    shortcodes: ['compass'],
    tags: ['direction', 'magnetic', 'navigation', 'orienteering'],
    group: 'travel & places',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ed.png',
  },
  {
    emoji: '🏔',
    name: 'mountain_snow',
    shortcodes: ['mountain_snow'],
    tags: ['cold', 'mountain', 'snow', 'snow-capped'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d4-fe0f.png',
  },
  {
    emoji: '⛰',
    name: 'mountain',
    shortcodes: ['mountain'],
    tags: ['mountain'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f0-fe0f.png',
  },
  {
    emoji: '🛘',
    name: 'landslide',
    shortcodes: ['landslide'],
    tags: ['avalanche', 'danger', 'disaster', 'earthquake', 'mountain', 'mudslide', 'rocks'],
    group: 'travel & places',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '🌋',
    name: 'volcano',
    shortcodes: ['volcano'],
    tags: ['eruption', 'mountain', 'nature'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30b.png',
  },
  {
    emoji: '🗻',
    name: 'mount_fuji',
    shortcodes: ['mount_fuji'],
    tags: ['fuji', 'mount', 'mountain', 'nature'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fb.png',
  },
  {
    emoji: '🏕',
    name: 'camping',
    shortcodes: ['camping'],
    tags: ['camping'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d5-fe0f.png',
  },
  {
    emoji: '🏖',
    name: 'beach_umbrella',
    shortcodes: ['beach', 'beach_with_umbrella'],
    tags: ['beach', 'umbrella'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d6-fe0f.png',
  },
  {
    emoji: '🏜',
    name: 'desert',
    shortcodes: ['desert'],
    tags: ['desert'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3dc-fe0f.png',
  },
  {
    emoji: '🏝',
    name: 'desert_island',
    shortcodes: ['desert_island', 'island'],
    tags: ['desert', 'island'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3dd-fe0f.png',
  },
  {
    emoji: '🏞',
    name: 'national_park',
    shortcodes: ['national_park'],
    tags: ['national', 'park'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3de-fe0f.png',
  },
  {
    emoji: '🏟',
    name: 'stadium',
    shortcodes: ['stadium'],
    tags: ['stadium'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3df-fe0f.png',
  },
  {
    emoji: '🏛',
    name: 'classical_building',
    shortcodes: ['classical_building'],
    tags: ['building', 'classical'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3db-fe0f.png',
  },
  {
    emoji: '🏗',
    name: 'building_construction',
    shortcodes: ['building_construction', 'construction_site'],
    tags: ['building', 'construction', 'crane'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d7-fe0f.png',
  },
  {
    emoji: '🧱',
    name: 'bricks',
    shortcodes: ['bricks'],
    tags: ['bricks', 'clay', 'mortar', 'wall'],
    group: 'travel & places',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f1.png',
  },
  {
    emoji: '🪨',
    name: 'rock',
    shortcodes: ['rock'],
    tags: ['boulder', 'heavy', 'solid', 'stone', 'tough'],
    group: 'travel & places',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa8.png',
  },
  {
    emoji: '🪵',
    name: 'wood',
    shortcodes: ['wood'],
    tags: ['log', 'lumber', 'timber'],
    group: 'travel & places',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fab5.png',
  },
  {
    emoji: '🛖',
    name: 'hut',
    shortcodes: ['hut'],
    tags: ['home', 'house', 'roundhouse', 'shelter', 'yurt'],
    group: 'travel & places',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d6.png',
  },
  {
    emoji: '🏘',
    name: 'houses',
    shortcodes: ['homes', 'houses'],
    tags: ['house'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d8-fe0f.png',
  },
  {
    emoji: '🏚',
    name: 'derelict_house',
    shortcodes: ['derelict_house', 'house_abandoned'],
    tags: ['derelict', 'home', 'house'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3da-fe0f.png',
  },
  {
    emoji: '🏠',
    name: 'house',
    shortcodes: ['house'],
    tags: [
      'building',
      'country',
      'heart',
      'home',
      'ranch',
      'settle',
      'simple',
      'suburban',
      'suburbia',
      'where',
    ],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e0.png',
  },
  {
    emoji: '🏡',
    name: 'house_with_garden',
    shortcodes: ['house_with_garden'],
    tags: [
      'building',
      'country',
      'garden',
      'heart',
      'home',
      'house',
      'ranch',
      'settle',
      'simple',
      'suburban',
      'suburbia',
      'where',
    ],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e1.png',
  },
  {
    emoji: '🏢',
    name: 'office',
    shortcodes: ['office'],
    tags: ['building', 'city', 'cubical', 'job', 'office'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e2.png',
  },
  {
    emoji: '🏣',
    name: 'post_office',
    shortcodes: ['post_office'],
    tags: ['building', 'japanese', 'office', 'post'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e3.png',
  },
  {
    emoji: '🏤',
    name: 'european_post_office',
    shortcodes: ['european_post_office'],
    tags: ['building', 'european', 'office', 'post'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e4.png',
  },
  {
    emoji: '🏥',
    name: 'hospital',
    shortcodes: ['hospital'],
    tags: ['building', 'doctor', 'medicine'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e5.png',
  },
  {
    emoji: '🏦',
    name: 'bank',
    shortcodes: ['bank'],
    tags: ['building'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e6.png',
  },
  {
    emoji: '🏨',
    name: 'hotel',
    shortcodes: ['hotel'],
    tags: ['building'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e8.png',
  },
  {
    emoji: '🏩',
    name: 'love_hotel',
    shortcodes: ['love_hotel'],
    tags: ['building', 'hotel', 'love'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e9.png',
  },
  {
    emoji: '🏪',
    name: 'convenience_store',
    shortcodes: ['convenience_store'],
    tags: ['24', 'building', 'convenience', 'hours', 'store'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ea.png',
  },
  {
    emoji: '🏫',
    name: 'school',
    shortcodes: ['school'],
    tags: ['building'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3eb.png',
  },
  {
    emoji: '🏬',
    name: 'department_store',
    shortcodes: ['department_store'],
    tags: ['building', 'department', 'store'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ec.png',
  },
  {
    emoji: '🏭',
    name: 'factory',
    shortcodes: ['factory'],
    tags: ['building'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ed.png',
  },
  {
    emoji: '🏯',
    name: 'japanese_castle',
    shortcodes: ['japanese_castle'],
    tags: ['building', 'castle', 'japanese'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ef.png',
  },
  {
    emoji: '🏰',
    name: 'european_castle',
    shortcodes: ['castle', 'european_castle'],
    tags: ['building', 'european'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f0.png',
  },
  {
    emoji: '💒',
    name: 'wedding',
    shortcodes: ['wedding'],
    tags: ['chapel', 'hitched', 'nuptials', 'romance'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f492.png',
  },
  {
    emoji: '🗼',
    name: 'tokyo_tower',
    shortcodes: ['tokyo_tower'],
    tags: ['tokyo', 'tower'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fc.png',
  },
  {
    emoji: '🗽',
    name: 'statue_of_liberty',
    shortcodes: ['statue_of_liberty'],
    tags: ['liberty', 'new', 'ny', 'nyc', 'statue', 'york'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5fd.png',
  },
  {
    emoji: '⛪',
    name: 'church',
    shortcodes: ['church'],
    tags: ['bless', 'chapel', 'christian', 'cross', 'religion'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26ea.png',
  },
  {
    emoji: '🕌',
    name: 'mosque',
    shortcodes: ['mosque'],
    tags: ['islam', 'masjid', 'muslim', 'religion'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54c.png',
  },
  {
    emoji: '🛕',
    name: 'hindu_temple',
    shortcodes: ['hindu_temple'],
    tags: ['hindu', 'temple'],
    group: 'travel & places',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d5.png',
  },
  {
    emoji: '🕍',
    name: 'synagogue',
    shortcodes: ['synagogue'],
    tags: ['jew', 'jewish', 'judaism', 'religion', 'temple'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54d.png',
  },
  {
    emoji: '⛩',
    name: 'shinto_shrine',
    shortcodes: ['shinto_shrine'],
    tags: ['religion', 'shinto', 'shrine'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26e9-fe0f.png',
  },
  {
    emoji: '🕋',
    name: 'kaaba',
    shortcodes: ['kaaba'],
    tags: ['hajj', 'islam', 'muslim', 'religion', 'umrah'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54b.png',
  },
  {
    emoji: '⛲',
    name: 'fountain',
    shortcodes: ['fountain'],
    tags: ['fountain'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f2.png',
  },
  {
    emoji: '⛺',
    name: 'tent',
    shortcodes: ['tent'],
    tags: ['camping'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26fa.png',
  },
  {
    emoji: '🌁',
    name: 'foggy',
    shortcodes: ['foggy'],
    tags: ['fog'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f301.png',
  },
  {
    emoji: '🌃',
    name: 'night_with_stars',
    shortcodes: ['night_with_stars'],
    tags: ['night', 'star', 'stars'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f303.png',
  },
  {
    emoji: '🏙',
    name: 'cityscape',
    shortcodes: ['cityscape'],
    tags: ['city'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d9-fe0f.png',
  },
  {
    emoji: '🌄',
    name: 'sunrise_over_mountains',
    shortcodes: ['sunrise_over_mountains'],
    tags: ['morning', 'mountains', 'over', 'sun', 'sunrise'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f304.png',
  },
  {
    emoji: '🌅',
    name: 'sunrise',
    shortcodes: ['sunrise'],
    tags: ['morning', 'nature', 'sun'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f305.png',
  },
  {
    emoji: '🌆',
    name: 'city_sunset',
    shortcodes: ['city_dusk'],
    tags: ['at', 'building', 'city', 'cityscape', 'dusk', 'evening', 'landscape', 'sun', 'sunset'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f306.png',
  },
  {
    emoji: '🌇',
    name: 'city_sunrise',
    shortcodes: ['city_sunrise', 'city_sunset'],
    tags: ['building', 'dusk', 'sun'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f307.png',
  },
  {
    emoji: '🌉',
    name: 'bridge_at_night',
    shortcodes: ['bridge_at_night'],
    tags: ['at', 'bridge', 'night'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f309.png',
  },
  {
    emoji: '♨',
    name: 'hotsprings',
    shortcodes: ['hotsprings'],
    tags: ['hot', 'hotsprings', 'springs', 'steaming'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2668-fe0f.png',
  },
  {
    emoji: '🎠',
    name: 'carousel_horse',
    shortcodes: ['carousel_horse'],
    tags: ['carousel', 'entertainment', 'horse'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a0.png',
  },
  {
    emoji: '🛝',
    name: 'playground_slide',
    shortcodes: ['playground_slide', 'slide'],
    tags: ['amusement', 'park', 'play', 'playground', 'playing', 'slide', 'sliding', 'theme'],
    group: 'travel & places',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6dd.png',
  },
  {
    emoji: '🎡',
    name: 'ferris_wheel',
    shortcodes: ['ferris_wheel'],
    tags: ['amusement', 'ferris', 'park', 'theme', 'wheel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a1.png',
  },
  {
    emoji: '🎢',
    name: 'roller_coaster',
    shortcodes: ['roller_coaster'],
    tags: ['amusement', 'coaster', 'park', 'roller', 'theme'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a2.png',
  },
  {
    emoji: '💈',
    name: 'barber',
    shortcodes: ['barber', 'barber_pole'],
    tags: ['barber', 'cut', 'fresh', 'haircut', 'pole', 'shave'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f488.png',
  },
  {
    emoji: '🎪',
    name: 'circus_tent',
    shortcodes: ['circus_tent'],
    tags: ['circus', 'tent'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3aa.png',
  },
  {
    emoji: '🚂',
    name: 'steam_locomotive',
    shortcodes: ['steam_locomotive'],
    tags: ['caboose', 'engine', 'railway', 'steam', 'train', 'trains', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f682.png',
  },
  {
    emoji: '🚃',
    name: 'railway_car',
    shortcodes: ['railway_car'],
    tags: ['car', 'electric', 'railway', 'train', 'tram', 'travel', 'trolleybus'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f683.png',
  },
  {
    emoji: '🚄',
    name: 'bullettrain_side',
    shortcodes: ['bullettrain_side'],
    tags: ['high-speed', 'railway', 'shinkansen', 'speed', 'train'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f684.png',
  },
  {
    emoji: '🚅',
    name: 'bullettrain_front',
    shortcodes: ['bullettrain_front'],
    tags: ['bullet', 'high-speed', 'nose', 'railway', 'shinkansen', 'speed', 'train', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f685.png',
  },
  {
    emoji: '🚆',
    name: 'train2',
    shortcodes: ['train'],
    tags: ['arrived', 'choo', 'railway'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f686.png',
  },
  {
    emoji: '🚇',
    name: 'metro',
    shortcodes: ['metro'],
    tags: ['subway', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f687.png',
  },
  {
    emoji: '🚈',
    name: 'light_rail',
    shortcodes: ['light_rail'],
    tags: ['arrived', 'light', 'monorail', 'rail', 'railway'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f688.png',
  },
  {
    emoji: '🚉',
    name: 'station',
    shortcodes: ['station'],
    tags: ['railway', 'train'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f689.png',
  },
  {
    emoji: '🚊',
    name: 'tram',
    shortcodes: ['tram'],
    tags: ['trolleybus'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68a.png',
  },
  {
    emoji: '🚝',
    name: 'monorail',
    shortcodes: ['monorail'],
    tags: ['vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69d.png',
  },
  {
    emoji: '🚞',
    name: 'mountain_railway',
    shortcodes: ['mountain_railway'],
    tags: ['car', 'mountain', 'railway', 'trip'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69e.png',
  },
  {
    emoji: '🚋',
    name: 'train',
    shortcodes: ['tram_car'],
    tags: ['bus', 'car', 'tram', 'trolley', 'trolleybus'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68b.png',
  },
  {
    emoji: '🚌',
    name: 'bus',
    shortcodes: ['bus'],
    tags: ['school', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68c.png',
  },
  {
    emoji: '🚍',
    name: 'oncoming_bus',
    shortcodes: ['oncoming_bus'],
    tags: ['bus', 'cars', 'oncoming'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68d.png',
  },
  {
    emoji: '🚎',
    name: 'trolleybus',
    shortcodes: ['trolleybus'],
    tags: ['bus', 'tram', 'trolley'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68e.png',
  },
  {
    emoji: '🚐',
    name: 'minibus',
    shortcodes: ['minibus'],
    tags: ['bus', 'drive', 'van', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f690.png',
  },
  {
    emoji: '🚑',
    name: 'ambulance',
    shortcodes: ['ambulance'],
    tags: ['emergency', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f691.png',
  },
  {
    emoji: '🚒',
    name: 'fire_engine',
    shortcodes: ['fire_engine'],
    tags: ['engine', 'fire', 'truck'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f692.png',
  },
  {
    emoji: '🚓',
    name: 'police_car',
    shortcodes: ['police_car'],
    tags: ['5–0', 'car', 'cops', 'patrol', 'police'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f693.png',
  },
  {
    emoji: '🚔',
    name: 'oncoming_police_car',
    shortcodes: ['oncoming_police_car'],
    tags: ['car', 'oncoming', 'police'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f694.png',
  },
  {
    emoji: '🚕',
    name: 'taxi',
    shortcodes: ['taxi'],
    tags: ['cab', 'cabbie', 'car', 'drive', 'vehicle', 'yellow'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f695.png',
  },
  {
    emoji: '🚖',
    name: 'oncoming_taxi',
    shortcodes: ['oncoming_taxi'],
    tags: ['cab', 'cabbie', 'cars', 'drove', 'hail', 'oncoming', 'taxi', 'yellow'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f696.png',
  },
  {
    emoji: '🚗',
    name: 'car',
    shortcodes: ['car', 'red_car'],
    tags: ['car', 'driving', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f697.png',
  },
  {
    emoji: '🚘',
    name: 'oncoming_automobile',
    shortcodes: ['oncoming_automobile'],
    tags: ['automobile', 'car', 'cars', 'drove', 'oncoming', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f698.png',
  },
  {
    emoji: '🚙',
    name: 'blue_car',
    shortcodes: ['blue_car', 'suv'],
    tags: ['car', 'drive', 'recreational', 'sport', 'sportutility', 'utility', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f699.png',
  },
  {
    emoji: '🛻',
    name: 'pickup_truck',
    shortcodes: ['pickup_truck'],
    tags: ['automobile', 'car', 'flatbed', 'pick-up', 'pickup', 'transportation', 'truck'],
    group: 'travel & places',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6fb.png',
  },
  {
    emoji: '🚚',
    name: 'truck',
    shortcodes: ['delivery_truck', 'truck'],
    tags: ['car', 'delivery', 'drive', 'truck', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69a.png',
  },
  {
    emoji: '🚛',
    name: 'articulated_lorry',
    shortcodes: ['articulated_lorry'],
    tags: ['articulated', 'car', 'drive', 'lorry', 'move', 'semi', 'truck', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69b.png',
  },
  {
    emoji: '🚜',
    name: 'tractor',
    shortcodes: ['tractor'],
    tags: ['vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69c.png',
  },
  {
    emoji: '🏎',
    name: 'racing_car',
    shortcodes: ['racing_car'],
    tags: ['car', 'racing', 'zoom'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ce-fe0f.png',
  },
  {
    emoji: '🏍',
    name: 'motorcycle',
    shortcodes: ['motorcycle'],
    tags: ['racing'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cd-fe0f.png',
  },
  {
    emoji: '🛵',
    name: 'motor_scooter',
    shortcodes: ['motor_scooter'],
    tags: ['motor', 'scooter'],
    group: 'travel & places',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f5.png',
  },
  {
    emoji: '🦽',
    name: 'manual_wheelchair',
    shortcodes: ['manual_wheelchair'],
    tags: ['accessibility', 'manual', 'wheelchair'],
    group: 'travel & places',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bd.png',
  },
  {
    emoji: '🦼',
    name: 'motorized_wheelchair',
    shortcodes: ['motorized_wheelchair'],
    tags: ['accessibility', 'motorized', 'wheelchair'],
    group: 'travel & places',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9bc.png',
  },
  {
    emoji: '🛺',
    name: 'auto_rickshaw',
    shortcodes: ['auto_rickshaw'],
    tags: ['auto', 'rickshaw', 'tuk'],
    group: 'travel & places',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6fa.png',
  },
  {
    emoji: '🚲',
    name: 'bike',
    shortcodes: ['bicycle', 'bike'],
    tags: ['bike', 'class', 'cycle', 'cycling', 'cyclist', 'gang', 'ride', 'spin', 'spinning'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b2.png',
  },
  {
    emoji: '🛴',
    name: 'kick_scooter',
    shortcodes: ['scooter'],
    tags: ['kick', 'scooter'],
    group: 'travel & places',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f4.png',
  },
  {
    emoji: '🛹',
    name: 'skateboard',
    shortcodes: ['skateboard'],
    tags: ['board', 'skate', 'skater', 'wheels'],
    group: 'travel & places',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f9.png',
  },
  {
    emoji: '🛼',
    name: 'roller_skate',
    shortcodes: ['roller_skate'],
    tags: ['blades', 'roller', 'skate', 'skates', 'sport'],
    group: 'travel & places',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6fc.png',
  },
  {
    emoji: '🚏',
    name: 'busstop',
    shortcodes: ['busstop'],
    tags: ['bus', 'busstop', 'stop'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f68f.png',
  },
  {
    emoji: '🛣',
    name: 'motorway',
    shortcodes: ['motorway'],
    tags: ['highway', 'road'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e3-fe0f.png',
  },
  {
    emoji: '🛤',
    name: 'railway_track',
    shortcodes: ['railway_track'],
    tags: ['railway', 'track', 'train'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e4-fe0f.png',
  },
  {
    emoji: '🛢',
    name: 'oil_drum',
    shortcodes: ['oil_drum'],
    tags: ['drum', 'oil'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e2-fe0f.png',
  },
  {
    emoji: '⛽',
    name: 'fuelpump',
    shortcodes: ['fuelpump'],
    tags: ['diesel', 'fuel', 'fuelpump', 'gas', 'gasoline', 'pump', 'station'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26fd.png',
  },
  {
    emoji: '🛞',
    name: 'wheel',
    shortcodes: ['wheel'],
    tags: ['car', 'circle', 'tire', 'turn', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6de.png',
  },
  {
    emoji: '🚨',
    name: 'rotating_light',
    shortcodes: ['rotating_light'],
    tags: ['alarm', 'alert', 'beacon', 'car', 'emergency', 'light', 'police', 'revolving', 'siren'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a8.png',
  },
  {
    emoji: '🚥',
    name: 'traffic_light',
    shortcodes: ['traffic_light'],
    tags: ['horizontal', 'intersection', 'light', 'signal', 'stop', 'stoplight', 'traffic'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a5.png',
  },
  {
    emoji: '🚦',
    name: 'vertical_traffic_light',
    shortcodes: ['vertical_traffic_light'],
    tags: ['drove', 'intersection', 'light', 'signal', 'stop', 'stoplight', 'traffic', 'vertical'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a6.png',
  },
  {
    emoji: '🛑',
    name: 'stop_sign',
    shortcodes: ['octagonal_sign', 'stop_sign'],
    tags: ['octagonal', 'sign', 'stop'],
    group: 'travel & places',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d1.png',
  },
  {
    emoji: '🚧',
    name: 'construction',
    shortcodes: ['construction'],
    tags: ['barrier'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a7.png',
  },
  {
    emoji: '⚓',
    name: 'anchor',
    shortcodes: ['anchor'],
    tags: ['ship', 'tool'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2693.png',
  },
  {
    emoji: '🛟',
    name: 'ring_buoy',
    shortcodes: ['lifebuoy', 'ring_buoy'],
    tags: [
      'buoy',
      'float',
      'life',
      'lifesaver',
      'preserver',
      'rescue',
      'ring',
      'safety',
      'save',
      'saver',
      'swim',
    ],
    group: 'travel & places',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6df.png',
  },
  {
    emoji: '⛵',
    name: 'boat',
    shortcodes: ['sailboat'],
    tags: ['boat', 'resort', 'sailing', 'sea', 'yacht'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f5.png',
  },
  {
    emoji: '🛶',
    name: 'canoe',
    shortcodes: ['canoe'],
    tags: ['boat'],
    group: 'travel & places',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f6.png',
  },
  {
    emoji: '🚤',
    name: 'speedboat',
    shortcodes: ['speedboat'],
    tags: ['billionaire', 'boat', 'lake', 'luxury', 'millionaire', 'summer', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a4.png',
  },
  {
    emoji: '🛳',
    name: 'passenger_ship',
    shortcodes: ['cruise_ship', 'passenger_ship'],
    tags: ['passenger', 'ship'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f3-fe0f.png',
  },
  {
    emoji: '⛴',
    name: 'ferry',
    shortcodes: ['ferry'],
    tags: ['boat', 'passenger'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f4-fe0f.png',
  },
  {
    emoji: '🛥',
    name: 'motor_boat',
    shortcodes: ['motorboat'],
    tags: ['boat', 'motor', 'motorboat'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e5-fe0f.png',
  },
  {
    emoji: '🚢',
    name: 'ship',
    shortcodes: ['ship'],
    tags: ['boat', 'passenger', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a2.png',
  },
  {
    emoji: '✈',
    name: 'airplane',
    shortcodes: ['airplane'],
    tags: ['aeroplane', 'fly', 'flying', 'jet', 'plane', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2708-fe0f.png',
  },
  {
    emoji: '🛩',
    name: 'small_airplane',
    shortcodes: ['small_airplane'],
    tags: ['aeroplane', 'airplane', 'plane', 'small'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e9-fe0f.png',
  },
  {
    emoji: '🛫',
    name: 'flight_departure',
    shortcodes: ['airplane_departure'],
    tags: ['aeroplane', 'airplane', 'check-in', 'departure', 'departures', 'plane'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6eb.png',
  },
  {
    emoji: '🛬',
    name: 'flight_arrival',
    shortcodes: ['airplane_arriving'],
    tags: ['aeroplane', 'airplane', 'arrival', 'arrivals', 'arriving', 'landing', 'plane'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ec.png',
  },
  {
    emoji: '🪂',
    name: 'parachute',
    shortcodes: ['parachute'],
    tags: ['hang-glide', 'parasail', 'skydive'],
    group: 'travel & places',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa82.png',
  },
  {
    emoji: '💺',
    name: 'seat',
    shortcodes: ['seat'],
    tags: ['chair'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ba.png',
  },
  {
    emoji: '🚁',
    name: 'helicopter',
    shortcodes: ['helicopter'],
    tags: ['copter', 'roflcopter', 'travel', 'vehicle'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f681.png',
  },
  {
    emoji: '🚟',
    name: 'suspension_railway',
    shortcodes: ['suspension_railway'],
    tags: ['railway', 'suspension'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f69f.png',
  },
  {
    emoji: '🚠',
    name: 'mountain_cableway',
    shortcodes: ['mountain_cableway'],
    tags: ['cable', 'cableway', 'gondola', 'lift', 'mountain', 'ski'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a0.png',
  },
  {
    emoji: '🚡',
    name: 'aerial_tramway',
    shortcodes: ['aerial_tramway'],
    tags: ['aerial', 'cable', 'car', 'gondola', 'ropeway', 'tramway'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a1.png',
  },
  {
    emoji: '🛰',
    name: 'artificial_satellite',
    shortcodes: ['satellite'],
    tags: ['space'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f0-fe0f.png',
  },
  {
    emoji: '🚀',
    name: 'rocket',
    shortcodes: ['rocket'],
    tags: ['launch', 'rockets', 'space', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f680.png',
  },
  {
    emoji: '🛸',
    name: 'flying_saucer',
    shortcodes: ['flying_saucer'],
    tags: ['aliens', 'extra', 'flying', 'saucer', 'terrestrial', 'ufo'],
    group: 'travel & places',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f8.png',
  },
  {
    emoji: '🛎',
    name: 'bellhop_bell',
    shortcodes: ['bellhop'],
    tags: ['bell', 'bellhop', 'hotel'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ce-fe0f.png',
  },
  {
    emoji: '🧳',
    name: 'luggage',
    shortcodes: ['luggage'],
    tags: ['bag', 'packing', 'roller', 'suitcase', 'travel'],
    group: 'travel & places',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f3.png',
  },
  {
    emoji: '⌛',
    name: 'hourglass',
    shortcodes: ['hourglass'],
    tags: ['done', 'hourglass', 'sand', 'time', 'timer'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/231b.png',
  },
  {
    emoji: '⏳',
    name: 'hourglass_flowing_sand',
    shortcodes: ['hourglass_flowing_sand'],
    tags: ['done', 'flowing', 'hourglass', 'hours', 'not', 'sand', 'timer', 'waiting', 'yolo'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f3.png',
  },
  {
    emoji: '⌚',
    name: 'watch',
    shortcodes: ['watch'],
    tags: ['clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/231a.png',
  },
  {
    emoji: '⏰',
    name: 'alarm_clock',
    shortcodes: ['alarm_clock'],
    tags: ['alarm', 'clock', 'hours', 'hrs', 'late', 'time', 'waiting'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f0.png',
  },
  {
    emoji: '⏱',
    name: 'stopwatch',
    shortcodes: ['stopwatch'],
    tags: ['clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f1-fe0f.png',
  },
  {
    emoji: '⏲',
    name: 'timer_clock',
    shortcodes: ['timer_clock'],
    tags: ['clock', 'timer'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f2-fe0f.png',
  },
  {
    emoji: '🕰',
    name: 'mantelpiece_clock',
    shortcodes: ['clock'],
    tags: ['clock', 'mantelpiece', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f570-fe0f.png',
  },
  {
    emoji: '🕛',
    name: 'clock12',
    shortcodes: ['clock12'],
    tags: ['12', '12:00', 'clock', 'o’clock', 'time', 'twelve'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55b.png',
  },
  {
    emoji: '🕧',
    name: 'clock1230',
    shortcodes: ['clock1230'],
    tags: ['12', '12:30', '30', 'clock', 'thirty', 'time', 'twelve'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f567.png',
  },
  {
    emoji: '🕐',
    name: 'clock1',
    shortcodes: ['clock1'],
    tags: ['1', '1:00', 'clock', 'one', 'o’clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f550.png',
  },
  {
    emoji: '🕜',
    name: 'clock130',
    shortcodes: ['clock130'],
    tags: ['1', '1:30', '30', 'clock', 'one', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55c.png',
  },
  {
    emoji: '🕑',
    name: 'clock2',
    shortcodes: ['clock2'],
    tags: ['2', '2:00', 'clock', 'o’clock', 'time', 'two'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f551.png',
  },
  {
    emoji: '🕝',
    name: 'clock230',
    shortcodes: ['clock230'],
    tags: ['2', '2:30', '30', 'clock', 'thirty', 'time', 'two'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55d.png',
  },
  {
    emoji: '🕒',
    name: 'clock3',
    shortcodes: ['clock3'],
    tags: ['3', '3:00', 'clock', 'o’clock', 'three', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f552.png',
  },
  {
    emoji: '🕞',
    name: 'clock330',
    shortcodes: ['clock330'],
    tags: ['3', '30', '3:30', 'clock', 'thirty', 'three', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55e.png',
  },
  {
    emoji: '🕓',
    name: 'clock4',
    shortcodes: ['clock4'],
    tags: ['4', '4:00', 'clock', 'four', 'o’clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f553.png',
  },
  {
    emoji: '🕟',
    name: 'clock430',
    shortcodes: ['clock430'],
    tags: ['30', '4', '4:30', 'clock', 'four', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55f.png',
  },
  {
    emoji: '🕔',
    name: 'clock5',
    shortcodes: ['clock5'],
    tags: ['5', '5:00', 'clock', 'five', 'o’clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f554.png',
  },
  {
    emoji: '🕠',
    name: 'clock530',
    shortcodes: ['clock530'],
    tags: ['30', '5', '5:30', 'clock', 'five', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f560.png',
  },
  {
    emoji: '🕕',
    name: 'clock6',
    shortcodes: ['clock6'],
    tags: ['6', '6:00', 'clock', 'o’clock', 'six', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f555.png',
  },
  {
    emoji: '🕡',
    name: 'clock630',
    shortcodes: ['clock630'],
    tags: ['30', '6', '6:30', 'clock', 'six', 'thirty'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f561.png',
  },
  {
    emoji: '🕖',
    name: 'clock7',
    shortcodes: ['clock7'],
    tags: ['0', '7', '7:00', 'clock', 'o’clock', 'seven'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f556.png',
  },
  {
    emoji: '🕢',
    name: 'clock730',
    shortcodes: ['clock730'],
    tags: ['30', '7', '7:30', 'clock', 'seven', 'thirty'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f562.png',
  },
  {
    emoji: '🕗',
    name: 'clock8',
    shortcodes: ['clock8'],
    tags: ['8', '8:00', 'clock', 'eight', 'o’clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f557.png',
  },
  {
    emoji: '🕣',
    name: 'clock830',
    shortcodes: ['clock830'],
    tags: ['30', '8', '8:30', 'clock', 'eight', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f563.png',
  },
  {
    emoji: '🕘',
    name: 'clock9',
    shortcodes: ['clock9'],
    tags: ['9', '9:00', 'clock', 'nine', 'o’clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f558.png',
  },
  {
    emoji: '🕤',
    name: 'clock930',
    shortcodes: ['clock930'],
    tags: ['30', '9', '9:30', 'clock', 'nine', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f564.png',
  },
  {
    emoji: '🕙',
    name: 'clock10',
    shortcodes: ['clock10'],
    tags: ['0', '10', '10:00', 'clock', 'o’clock', 'ten'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f559.png',
  },
  {
    emoji: '🕥',
    name: 'clock1030',
    shortcodes: ['clock1030'],
    tags: ['10', '10:30', '30', 'clock', 'ten', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f565.png',
  },
  {
    emoji: '🕚',
    name: 'clock11',
    shortcodes: ['clock11'],
    tags: ['11', '11:00', 'clock', 'eleven', 'o’clock', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f55a.png',
  },
  {
    emoji: '🕦',
    name: 'clock1130',
    shortcodes: ['clock1130'],
    tags: ['11', '11:30', '30', 'clock', 'eleven', 'thirty', 'time'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f566.png',
  },
  {
    emoji: '🌑',
    name: 'new_moon',
    shortcodes: ['new_moon'],
    tags: ['dark', 'moon', 'new', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f311.png',
  },
  {
    emoji: '🌒',
    name: 'waxing_crescent_moon',
    shortcodes: ['waxing_crescent_moon'],
    tags: ['crescent', 'dreams', 'moon', 'space', 'waxing'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f312.png',
  },
  {
    emoji: '🌓',
    name: 'first_quarter_moon',
    shortcodes: ['first_quarter_moon'],
    tags: ['first', 'moon', 'quarter', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f313.png',
  },
  {
    emoji: '🌔',
    name: 'moon',
    shortcodes: ['waxing_gibbous_moon'],
    tags: ['gibbous', 'moon', 'space', 'waxing'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f314.png',
  },
  {
    emoji: '🌕',
    name: 'full_moon',
    shortcodes: ['full_moon'],
    tags: ['full', 'moon', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f315.png',
  },
  {
    emoji: '🌖',
    name: 'waning_gibbous_moon',
    shortcodes: ['waning_gibbous_moon'],
    tags: ['gibbous', 'moon', 'space', 'waning'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f316.png',
  },
  {
    emoji: '🌗',
    name: 'last_quarter_moon',
    shortcodes: ['last_quarter_moon'],
    tags: ['last', 'moon', 'quarter', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f317.png',
  },
  {
    emoji: '🌘',
    name: 'waning_crescent_moon',
    shortcodes: ['waning_crescent_moon'],
    tags: ['crescent', 'moon', 'space', 'waning'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f318.png',
  },
  {
    emoji: '🌙',
    name: 'crescent_moon',
    shortcodes: ['crescent_moon'],
    tags: ['crescent', 'moon', 'ramadan', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f319.png',
  },
  {
    emoji: '🌚',
    name: 'new_moon_with_face',
    shortcodes: ['new_moon_with_face'],
    tags: ['face', 'moon', 'new', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31a.png',
  },
  {
    emoji: '🌛',
    name: 'first_quarter_moon_with_face',
    shortcodes: ['first_quarter_moon_with_face'],
    tags: ['face', 'first', 'moon', 'quarter', 'space'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31b.png',
  },
  {
    emoji: '🌜',
    name: 'last_quarter_moon_with_face',
    shortcodes: ['last_quarter_moon_with_face'],
    tags: ['dreams', 'face', 'last', 'moon', 'quarter'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31c.png',
  },
  {
    emoji: '🌡',
    name: 'thermometer',
    shortcodes: ['thermometer'],
    tags: ['weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f321-fe0f.png',
  },
  {
    emoji: '☀',
    name: 'sunny',
    shortcodes: ['sun'],
    tags: ['bright', 'rays', 'space', 'sunny', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2600-fe0f.png',
  },
  {
    emoji: '🌝',
    name: 'full_moon_with_face',
    shortcodes: ['full_moon_with_face'],
    tags: ['bright', 'face', 'full', 'moon'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31d.png',
  },
  {
    emoji: '🌞',
    name: 'sun_with_face',
    shortcodes: ['sun_with_face'],
    tags: [
      'beach',
      'bright',
      'day',
      'face',
      'heat',
      'shine',
      'sun',
      'sunny',
      'sunshine',
      'weather',
    ],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31e.png',
  },
  {
    emoji: '🪐',
    name: 'ringed_planet',
    shortcodes: ['ringed_planet', 'saturn'],
    tags: ['planet', 'ringed', 'saturn', 'saturnine'],
    group: 'travel & places',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa90.png',
  },
  {
    emoji: '⭐',
    name: 'star',
    shortcodes: ['star'],
    tags: ['astronomy', 'medium', 'stars', 'white'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b50.png',
  },
  {
    emoji: '🌟',
    name: 'star2',
    shortcodes: ['glowing_star', 'star2'],
    tags: ['glittery', 'glow', 'glowing', 'night', 'shining', 'sparkle', 'star', 'win'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f31f.png',
  },
  {
    emoji: '🌠',
    name: 'stars',
    shortcodes: ['shooting_star', 'stars'],
    tags: ['falling', 'night', 'shooting', 'space', 'star'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f320.png',
  },
  {
    emoji: '🌌',
    name: 'milky_way',
    shortcodes: ['milky_way'],
    tags: ['milky', 'space', 'way'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30c.png',
  },
  {
    emoji: '☁',
    name: 'cloud',
    shortcodes: ['cloud'],
    tags: ['weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2601-fe0f.png',
  },
  {
    emoji: '⛅',
    name: 'partly_sunny',
    shortcodes: ['partly_sunny', 'sun_behind_cloud'],
    tags: ['behind', 'cloud', 'cloudy', 'sun', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26c5.png',
  },
  {
    emoji: '⛈',
    name: 'cloud_with_lightning_and_rain',
    shortcodes: ['stormy', 'thunder_cloud_and_rain'],
    tags: ['cloud', 'lightning', 'rain', 'thunder', 'thunderstorm'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26c8-fe0f.png',
  },
  {
    emoji: '🌤',
    name: 'sun_behind_small_cloud',
    shortcodes: ['sun_behind_small_cloud', 'sunny'],
    tags: ['behind', 'cloud', 'sun', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f324-fe0f.png',
  },
  {
    emoji: '🌥',
    name: 'sun_behind_large_cloud',
    shortcodes: ['cloudy', 'sun_behind_large_cloud'],
    tags: ['behind', 'cloud', 'sun', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f325-fe0f.png',
  },
  {
    emoji: '🌦',
    name: 'sun_behind_rain_cloud',
    shortcodes: ['sun_and_rain', 'sun_behind_rain_cloud'],
    tags: ['behind', 'cloud', 'rain', 'sun', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f326-fe0f.png',
  },
  {
    emoji: '🌧',
    name: 'cloud_with_rain',
    shortcodes: ['cloud_with_rain', 'rainy'],
    tags: ['cloud', 'rain', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f327-fe0f.png',
  },
  {
    emoji: '🌨',
    name: 'cloud_with_snow',
    shortcodes: ['cloud_with_snow', 'snowy'],
    tags: ['cloud', 'cold', 'snow', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f328-fe0f.png',
  },
  {
    emoji: '🌩',
    name: 'cloud_with_lightning',
    shortcodes: ['cloud_with_lightning', 'lightning'],
    tags: ['cloud', 'lightning', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f329-fe0f.png',
  },
  {
    emoji: '🌪',
    name: 'tornado',
    shortcodes: ['tornado'],
    tags: ['cloud', 'weather', 'whirlwind'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32a-fe0f.png',
  },
  {
    emoji: '🌫',
    name: 'fog',
    shortcodes: ['fog'],
    tags: ['cloud', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32b-fe0f.png',
  },
  {
    emoji: '🌬',
    name: 'wind_face',
    shortcodes: ['wind_blowing_face'],
    tags: ['blow', 'cloud', 'face', 'wind'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f32c-fe0f.png',
  },
  {
    emoji: '🌀',
    name: 'cyclone',
    shortcodes: ['cyclone'],
    tags: ['dizzy', 'hurricane', 'twister', 'typhoon', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f300.png',
  },
  {
    emoji: '🌈',
    name: 'rainbow',
    shortcodes: ['rainbow'],
    tags: [
      'gay',
      'genderqueer',
      'glbt',
      'glbtq',
      'lesbian',
      'lgbt',
      'lgbtq',
      'lgbtqia',
      'nature',
      'pride',
      'queer',
      'rain',
      'trans',
      'transgender',
      'weather',
    ],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f308.png',
  },
  {
    emoji: '🌂',
    name: 'closed_umbrella',
    shortcodes: ['closed_umbrella'],
    tags: ['closed', 'clothing', 'rain', 'umbrella'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f302.png',
  },
  {
    emoji: '☂',
    name: 'open_umbrella',
    shortcodes: ['umbrella'],
    tags: ['clothing', 'rain'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2602-fe0f.png',
  },
  {
    emoji: '☔',
    name: 'umbrella',
    shortcodes: ['umbrella_with_rain'],
    tags: ['clothing', 'drop', 'drops', 'rain', 'umbrella', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2614.png',
  },
  {
    emoji: '⛱',
    name: 'parasol_on_ground',
    shortcodes: ['beach_umbrella', 'umbrella_on_ground'],
    tags: ['ground', 'rain', 'sun', 'umbrella'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f1-fe0f.png',
  },
  {
    emoji: '⚡',
    name: 'zap',
    shortcodes: ['high_voltage', 'zap'],
    tags: [
      'danger',
      'electric',
      'electricity',
      'high',
      'lightning',
      'nature',
      'thunder',
      'thunderbolt',
      'voltage',
      'zap',
    ],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26a1.png',
  },
  {
    emoji: '❄',
    name: 'snowflake',
    shortcodes: ['snowflake'],
    tags: ['cold', 'snow', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2744-fe0f.png',
  },
  {
    emoji: '☃',
    name: 'snowman_with_snow',
    shortcodes: ['snowman2'],
    tags: ['cold', 'man', 'snow'],
    group: 'travel & places',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2603-fe0f.png',
  },
  {
    emoji: '⛄',
    name: 'snowman',
    shortcodes: ['snowman'],
    tags: ['cold', 'man', 'snow', 'snowman'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26c4.png',
  },
  {
    emoji: '☄',
    name: 'comet',
    shortcodes: ['comet'],
    tags: ['space'],
    group: 'travel & places',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2604-fe0f.png',
  },
  {
    emoji: '🔥',
    name: 'fire',
    shortcodes: ['fire'],
    tags: ['af', 'burn', 'flame', 'hot', 'lit', 'litaf', 'tool'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f525.png',
  },
  {
    emoji: '💧',
    name: 'droplet',
    shortcodes: ['droplet'],
    tags: ['cold', 'comic', 'drop', 'nature', 'sad', 'sweat', 'tear', 'water', 'weather'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a7.png',
  },
  {
    emoji: '🌊',
    name: 'ocean',
    shortcodes: ['ocean', 'water_wave'],
    tags: ['nature', 'ocean', 'surf', 'surfer', 'surfing', 'water', 'wave'],
    group: 'travel & places',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f30a.png',
  },
  {
    emoji: '🎃',
    name: 'jack_o_lantern',
    shortcodes: ['jack_o_lantern'],
    tags: ['celebration', 'halloween', 'jack', 'lantern', 'pumpkin'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f383.png',
  },
  {
    emoji: '🎄',
    name: 'christmas_tree',
    shortcodes: ['christmas_tree'],
    tags: ['celebration', 'christmas', 'tree'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f384.png',
  },
  {
    emoji: '🎆',
    name: 'fireworks',
    shortcodes: ['fireworks'],
    tags: ['boom', 'celebration', 'entertainment', 'yolo'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f386.png',
  },
  {
    emoji: '🎇',
    name: 'sparkler',
    shortcodes: ['sparkler'],
    tags: ['boom', 'celebration', 'fireworks', 'sparkle'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f387.png',
  },
  {
    emoji: '🧨',
    name: 'firecracker',
    shortcodes: ['firecracker'],
    tags: ['dynamite', 'explosive', 'fire', 'fireworks', 'light', 'pop', 'popping', 'spark'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e8.png',
  },
  {
    emoji: '✨',
    name: 'sparkles',
    shortcodes: ['sparkles'],
    tags: ['*', 'magic', 'sparkle', 'star'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2728.png',
  },
  {
    emoji: '🎈',
    name: 'balloon',
    shortcodes: ['balloon'],
    tags: ['birthday', 'celebrate', 'celebration'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f388.png',
  },
  {
    emoji: '🎉',
    name: 'tada',
    shortcodes: ['party', 'party_popper', 'tada'],
    tags: [
      'awesome',
      'birthday',
      'celebrate',
      'celebration',
      'excited',
      'hooray',
      'party',
      'popper',
      'tada',
      'woohoo',
    ],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f389.png',
  },
  {
    emoji: '🎊',
    name: 'confetti_ball',
    shortcodes: ['confetti_ball'],
    tags: ['ball', 'celebrate', 'celebration', 'confetti', 'party', 'woohoo'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38a.png',
  },
  {
    emoji: '🎋',
    name: 'tanabata_tree',
    shortcodes: ['tanabata_tree'],
    tags: ['banner', 'celebration', 'japanese', 'tanabata', 'tree'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38b.png',
  },
  {
    emoji: '🎍',
    name: 'bamboo',
    shortcodes: ['bamboo'],
    tags: ['bamboo', 'celebration', 'decoration', 'japanese', 'pine', 'plant'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38d.png',
  },
  {
    emoji: '🎎',
    name: 'dolls',
    shortcodes: ['dolls'],
    tags: ['celebration', 'doll', 'dolls', 'festival', 'japanese'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38e.png',
  },
  {
    emoji: '🎏',
    name: 'flags',
    shortcodes: ['carp_streamer', 'flags'],
    tags: ['carp', 'celebration', 'streamer'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38f.png',
  },
  {
    emoji: '🎐',
    name: 'wind_chime',
    shortcodes: ['wind_chime'],
    tags: ['bell', 'celebration', 'chime', 'wind'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f390.png',
  },
  {
    emoji: '🎑',
    name: 'rice_scene',
    shortcodes: ['moon_ceremony', 'rice_scene'],
    tags: ['celebration', 'ceremony', 'moon', 'viewing'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f391.png',
  },
  {
    emoji: '🧧',
    name: 'red_envelope',
    shortcodes: ['red_envelope'],
    tags: ['envelope', 'gift', 'good', 'hóngbāo', 'lai', 'luck', 'money', 'red', 'see'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e7.png',
  },
  {
    emoji: '🎀',
    name: 'ribbon',
    shortcodes: ['ribbon'],
    tags: ['celebration'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f380.png',
  },
  {
    emoji: '🎁',
    name: 'gift',
    shortcodes: ['gift'],
    tags: [
      'birthday',
      'bow',
      'box',
      'celebration',
      'christmas',
      'gift',
      'present',
      'surprise',
      'wrapped',
    ],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f381.png',
  },
  {
    emoji: '🎗',
    name: 'reminder_ribbon',
    shortcodes: ['reminder_ribbon'],
    tags: ['celebration', 'reminder', 'ribbon'],
    group: 'activities',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f397-fe0f.png',
  },
  {
    emoji: '🎟',
    name: 'tickets',
    shortcodes: ['admission_tickets', 'tickets'],
    tags: ['admission', 'ticket', 'tickets'],
    group: 'activities',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39f-fe0f.png',
  },
  {
    emoji: '🎫',
    name: 'ticket',
    shortcodes: ['ticket'],
    tags: ['admission', 'stub'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ab.png',
  },
  {
    emoji: '🎖',
    name: 'medal_military',
    shortcodes: ['military_medal'],
    tags: ['award', 'celebration', 'medal', 'military'],
    group: 'activities',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f396-fe0f.png',
  },
  {
    emoji: '🏆',
    name: 'trophy',
    shortcodes: ['trophy'],
    tags: ['champion', 'champs', 'prize', 'slay', 'sport', 'victory', 'win', 'winning'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c6.png',
  },
  {
    emoji: '🏅',
    name: 'medal_sports',
    shortcodes: ['sports_medal'],
    tags: ['award', 'gold', 'medal', 'sports', 'winner'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c5.png',
  },
  {
    emoji: '🥇',
    name: '1st_place_medal',
    shortcodes: ['1st', 'first_place_medal'],
    tags: ['1st', 'first', 'gold', 'medal', 'place'],
    group: 'activities',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f947.png',
  },
  {
    emoji: '🥈',
    name: '2nd_place_medal',
    shortcodes: ['2nd', 'second_place_medal'],
    tags: ['2nd', 'medal', 'place', 'second', 'silver'],
    group: 'activities',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f948.png',
  },
  {
    emoji: '🥉',
    name: '3rd_place_medal',
    shortcodes: ['3rd', 'third_place_medal'],
    tags: ['3rd', 'bronze', 'medal', 'place', 'third'],
    group: 'activities',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f949.png',
  },
  {
    emoji: '⚽',
    name: 'soccer',
    shortcodes: ['soccer'],
    tags: ['ball', 'football', 'futbol', 'soccer', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26bd.png',
  },
  {
    emoji: '⚾',
    name: 'baseball',
    shortcodes: ['baseball'],
    tags: ['ball', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26be.png',
  },
  {
    emoji: '🥎',
    name: 'softball',
    shortcodes: ['softball'],
    tags: ['ball', 'glove', 'sports', 'underarm'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94e.png',
  },
  {
    emoji: '🏀',
    name: 'basketball',
    shortcodes: ['basketball'],
    tags: ['ball', 'hoop', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c0.png',
  },
  {
    emoji: '🏐',
    name: 'volleyball',
    shortcodes: ['volleyball'],
    tags: ['ball', 'game'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d0.png',
  },
  {
    emoji: '🏈',
    name: 'football',
    shortcodes: ['football'],
    tags: ['american', 'ball', 'bowl', 'football', 'sport', 'super'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c8.png',
  },
  {
    emoji: '🏉',
    name: 'rugby_football',
    shortcodes: ['rugby_football'],
    tags: ['ball', 'football', 'rugby', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c9.png',
  },
  {
    emoji: '🎾',
    name: 'tennis',
    shortcodes: ['tennis'],
    tags: ['ball', 'racquet', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3be.png',
  },
  {
    emoji: '🥏',
    name: 'flying_disc',
    shortcodes: ['flying_disc'],
    tags: ['disc', 'flying', 'ultimate'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94f.png',
  },
  {
    emoji: '🎳',
    name: 'bowling',
    shortcodes: ['bowling'],
    tags: ['ball', 'game', 'sport', 'strike'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b3.png',
  },
  {
    emoji: '🏏',
    name: 'cricket_game',
    shortcodes: ['cricket_game'],
    tags: ['ball', 'bat', 'cricket', 'game'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3cf.png',
  },
  {
    emoji: '🏑',
    name: 'field_hockey',
    shortcodes: ['field_hockey'],
    tags: ['ball', 'field', 'game', 'hockey', 'stick'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d1.png',
  },
  {
    emoji: '🏒',
    name: 'ice_hockey',
    shortcodes: ['hockey'],
    tags: ['game', 'hockey', 'ice', 'puck', 'stick'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d2.png',
  },
  {
    emoji: '🥍',
    name: 'lacrosse',
    shortcodes: ['lacrosse'],
    tags: ['ball', 'goal', 'sports', 'stick'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94d.png',
  },
  {
    emoji: '🏓',
    name: 'ping_pong',
    shortcodes: ['ping_pong'],
    tags: ['ball', 'bat', 'game', 'paddle', 'ping', 'pingpong', 'pong', 'table', 'tennis'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3d3.png',
  },
  {
    emoji: '🏸',
    name: 'badminton',
    shortcodes: ['badminton'],
    tags: ['birdie', 'game', 'racquet', 'shuttlecock'],
    group: 'activities',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f8.png',
  },
  {
    emoji: '🥊',
    name: 'boxing_glove',
    shortcodes: ['boxing_glove'],
    tags: ['boxing', 'glove'],
    group: 'activities',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94a.png',
  },
  {
    emoji: '🥋',
    name: 'martial_arts_uniform',
    shortcodes: ['martial_arts_uniform'],
    tags: ['arts', 'judo', 'karate', 'martial', 'taekwondo', 'uniform'],
    group: 'activities',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94b.png',
  },
  {
    emoji: '🥅',
    name: 'goal_net',
    shortcodes: ['goal_net'],
    tags: ['goal', 'net'],
    group: 'activities',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f945.png',
  },
  {
    emoji: '⛳',
    name: 'golf',
    shortcodes: ['golf'],
    tags: ['flag', 'golf', 'hole', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f3.png',
  },
  {
    emoji: '⛸',
    name: 'ice_skate',
    shortcodes: ['ice_skate'],
    tags: ['ice', 'skate', 'skating'],
    group: 'activities',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26f8-fe0f.png',
  },
  {
    emoji: '🎣',
    name: 'fishing_pole_and_fish',
    shortcodes: ['fishing_pole', 'fishing_pole_and_fish'],
    tags: ['entertainment', 'fish', 'fishing', 'pole', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a3.png',
  },
  {
    emoji: '🤿',
    name: 'diving_mask',
    shortcodes: ['diving_mask'],
    tags: ['diving', 'mask', 'scuba', 'snorkeling'],
    group: 'activities',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f93f.png',
  },
  {
    emoji: '🎽',
    name: 'running_shirt_with_sash',
    shortcodes: ['running_shirt', 'running_shirt_with_sash'],
    tags: ['athletics', 'running', 'sash', 'shirt'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bd.png',
  },
  {
    emoji: '🎿',
    name: 'ski',
    shortcodes: ['ski'],
    tags: ['ski', 'snow', 'sport'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bf.png',
  },
  {
    emoji: '🛷',
    name: 'sled',
    shortcodes: ['sled'],
    tags: ['luge', 'sledge', 'sleigh', 'snow', 'toboggan'],
    group: 'activities',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6f7.png',
  },
  {
    emoji: '🥌',
    name: 'curling_stone',
    shortcodes: ['curling_stone'],
    tags: ['curling', 'game', 'rock', 'stone'],
    group: 'activities',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f94c.png',
  },
  {
    emoji: '🎯',
    name: 'dart',
    shortcodes: ['bullseye', 'dart', 'direct_hit'],
    tags: ['bull', 'dart', 'direct', 'entertainment', 'game', 'hit', 'target'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3af.png',
  },
  {
    emoji: '🪀',
    name: 'yo_yo',
    shortcodes: ['yo_yo'],
    tags: ['fluctuate', 'toy'],
    group: 'activities',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa80.png',
  },
  {
    emoji: '🪁',
    name: 'kite',
    shortcodes: ['kite'],
    tags: ['fly', 'soar'],
    group: 'activities',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa81.png',
  },
  {
    emoji: '🔫',
    name: 'gun',
    shortcodes: ['gun', 'pistol'],
    tags: ['gun', 'handgun', 'pistol', 'revolver', 'tool', 'water', 'weapon'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52b.png',
  },
  {
    emoji: '🎱',
    name: '8ball',
    shortcodes: ['8ball', 'billiards'],
    tags: ['8', '8ball', 'ball', 'billiard', 'eight', 'game', 'pool'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b1.png',
  },
  {
    emoji: '🔮',
    name: 'crystal_ball',
    shortcodes: ['crystal_ball'],
    tags: [
      'ball',
      'crystal',
      'fairy',
      'fairytale',
      'fantasy',
      'fortune',
      'future',
      'magic',
      'tale',
      'tool',
    ],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52e.png',
  },
  {
    emoji: '🪄',
    name: 'magic_wand',
    shortcodes: ['magic_wand'],
    tags: ['magic', 'magician', 'wand', 'witch', 'wizard'],
    group: 'activities',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa84.png',
  },
  {
    emoji: '🎮',
    name: 'video_game',
    shortcodes: ['controller', 'video_game'],
    tags: ['controller', 'entertainment', 'game', 'video'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ae.png',
  },
  {
    emoji: '🕹',
    name: 'joystick',
    shortcodes: ['joystick'],
    tags: ['game', 'video', 'videogame'],
    group: 'activities',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f579-fe0f.png',
  },
  {
    emoji: '🎰',
    name: 'slot_machine',
    shortcodes: ['slot_machine'],
    tags: ['casino', 'gamble', 'gambling', 'game', 'machine', 'slot', 'slots'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b0.png',
  },
  {
    emoji: '🎲',
    name: 'game_die',
    shortcodes: ['game_die'],
    tags: ['dice', 'die', 'entertainment', 'game'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b2.png',
  },
  {
    emoji: '🧩',
    name: 'jigsaw',
    shortcodes: ['jigsaw', 'puzzle_piece'],
    tags: ['clue', 'interlocking', 'jigsaw', 'piece', 'puzzle'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e9.png',
  },
  {
    emoji: '🧸',
    name: 'teddy_bear',
    shortcodes: ['teddy_bear'],
    tags: ['bear', 'plaything', 'plush', 'stuffed', 'teddy', 'toy'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f8.png',
  },
  {
    emoji: '🪅',
    name: 'pinata',
    shortcodes: ['pinata'],
    tags: [
      'candy',
      'celebrate',
      'celebration',
      'cinco',
      'de',
      'festive',
      'mayo',
      'party',
      'pinada',
      'pinata',
    ],
    group: 'activities',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa85.png',
  },
  {
    emoji: '🪩',
    name: 'mirror_ball',
    shortcodes: ['disco', 'disco_ball', 'mirror_ball'],
    tags: ['ball', 'dance', 'disco', 'glitter', 'mirror', 'party'],
    group: 'activities',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa9.png',
  },
  {
    emoji: '🪆',
    name: 'nesting_dolls',
    shortcodes: ['nesting_dolls'],
    tags: [
      'babooshka',
      'baboushka',
      'babushka',
      'doll',
      'dolls',
      'matryoshka',
      'nesting',
      'russia',
    ],
    group: 'activities',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa86.png',
  },
  {
    emoji: '♠',
    name: 'spades',
    shortcodes: ['spades'],
    tags: ['card', 'game', 'spade', 'suit'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2660-fe0f.png',
  },
  {
    emoji: '♥',
    name: 'hearts',
    shortcodes: ['hearts'],
    tags: ['card', 'emotion', 'game', 'heart', 'hearts', 'suit'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2665-fe0f.png',
  },
  {
    emoji: '♦',
    name: 'diamonds',
    shortcodes: ['diamonds'],
    tags: ['card', 'diamond', 'game', 'suit'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2666-fe0f.png',
  },
  {
    emoji: '♣',
    name: 'clubs',
    shortcodes: ['clubs'],
    tags: ['card', 'club', 'clubs', 'game', 'suit'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2663-fe0f.png',
  },
  {
    emoji: '♟',
    name: 'chess_pawn',
    shortcodes: ['chess_pawn'],
    tags: ['chess', 'dupe', 'expendable', 'pawn'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/265f-fe0f.png',
  },
  {
    emoji: '🃏',
    name: 'black_joker',
    shortcodes: ['black_joker'],
    tags: ['card', 'game', 'wildcard'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f0cf.png',
  },
  {
    emoji: '🀄',
    name: 'mahjong',
    shortcodes: ['mahjong'],
    tags: ['dragon', 'game', 'mahjong', 'red'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f004.png',
  },
  {
    emoji: '🎴',
    name: 'flower_playing_cards',
    shortcodes: ['flower_playing_cards'],
    tags: ['card', 'cards', 'flower', 'game', 'japanese', 'playing'],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b4.png',
  },
  {
    emoji: '🎭',
    name: 'performing_arts',
    shortcodes: ['performing_arts'],
    tags: [
      'actor',
      'actress',
      'art',
      'arts',
      'entertainment',
      'mask',
      'performing',
      'theater',
      'theatre',
      'thespian',
    ],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ad.png',
  },
  {
    emoji: '🖼',
    name: 'framed_picture',
    shortcodes: ['frame_with_picture', 'framed_picture'],
    tags: ['art', 'frame', 'framed', 'museum', 'painting', 'picture'],
    group: 'activities',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5bc-fe0f.png',
  },
  {
    emoji: '🎨',
    name: 'art',
    shortcodes: ['art', 'palette'],
    tags: [
      'art',
      'artist',
      'artsy',
      'arty',
      'colorful',
      'creative',
      'entertainment',
      'museum',
      'painter',
      'painting',
      'palette',
    ],
    group: 'activities',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a8.png',
  },
  {
    emoji: '🧵',
    name: 'thread',
    shortcodes: ['thread'],
    tags: ['needle', 'sewing', 'spool', 'string'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f5.png',
  },
  {
    emoji: '🪡',
    name: 'sewing_needle',
    shortcodes: ['sewing_needle'],
    tags: ['embroidery', 'needle', 'sew', 'sewing', 'stitches', 'sutures', 'tailoring', 'thread'],
    group: 'activities',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa1.png',
  },
  {
    emoji: '🧶',
    name: 'yarn',
    shortcodes: ['yarn'],
    tags: ['ball', 'crochet', 'knit'],
    group: 'activities',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f6.png',
  },
  {
    emoji: '🪢',
    name: 'knot',
    shortcodes: ['knot'],
    tags: ['cord', 'rope', 'tangled', 'tie', 'twine', 'twist'],
    group: 'activities',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa2.png',
  },
  {
    emoji: '👓',
    name: 'eyeglasses',
    shortcodes: ['eyeglasses', 'glasses'],
    tags: ['clothing', 'eye', 'eyeglasses', 'eyewear'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f453.png',
  },
  {
    emoji: '🕶',
    name: 'dark_sunglasses',
    shortcodes: ['sunglasses'],
    tags: ['dark', 'eye', 'eyewear', 'glasses'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f576-fe0f.png',
  },
  {
    emoji: '🥽',
    name: 'goggles',
    shortcodes: ['goggles'],
    tags: ['dive', 'eye', 'protection', 'scuba', 'swimming', 'welding'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97d.png',
  },
  {
    emoji: '🥼',
    name: 'lab_coat',
    shortcodes: ['lab_coat'],
    tags: ['clothes', 'coat', 'doctor', 'dr', 'experiment', 'jacket', 'lab', 'scientist', 'white'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97c.png',
  },
  {
    emoji: '🦺',
    name: 'safety_vest',
    shortcodes: ['safety_vest'],
    tags: ['emergency', 'safety', 'vest'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ba.png',
  },
  {
    emoji: '👔',
    name: 'necktie',
    shortcodes: ['necktie'],
    tags: ['clothing', 'employed', 'serious', 'shirt', 'tie'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f454.png',
  },
  {
    emoji: '👕',
    name: 'shirt',
    shortcodes: ['shirt'],
    tags: [
      'blue',
      'casual',
      'clothes',
      'clothing',
      'collar',
      'dressed',
      'shirt',
      'shopping',
      'tshirt',
      'weekend',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f455.png',
  },
  {
    emoji: '👖',
    name: 'jeans',
    shortcodes: ['jeans'],
    tags: [
      'blue',
      'casual',
      'clothes',
      'clothing',
      'denim',
      'dressed',
      'pants',
      'shopping',
      'trousers',
      'weekend',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f456.png',
  },
  {
    emoji: '🧣',
    name: 'scarf',
    shortcodes: ['scarf'],
    tags: ['bundle', 'cold', 'neck', 'up'],
    group: 'objects',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e3.png',
  },
  {
    emoji: '🧤',
    name: 'gloves',
    shortcodes: ['gloves'],
    tags: ['hand'],
    group: 'objects',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e4.png',
  },
  {
    emoji: '🧥',
    name: 'coat',
    shortcodes: ['coat'],
    tags: ['brr', 'bundle', 'cold', 'jacket', 'up'],
    group: 'objects',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e5.png',
  },
  {
    emoji: '🧦',
    name: 'socks',
    shortcodes: ['socks'],
    tags: ['stocking'],
    group: 'objects',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e6.png',
  },
  {
    emoji: '👗',
    name: 'dress',
    shortcodes: ['dress'],
    tags: ['clothes', 'clothing', 'dressed', 'fancy', 'shopping'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f457.png',
  },
  {
    emoji: '👘',
    name: 'kimono',
    shortcodes: ['kimono'],
    tags: ['clothing', 'comfortable'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f458.png',
  },
  {
    emoji: '🥻',
    name: 'sari',
    shortcodes: ['sari'],
    tags: ['clothing', 'dress'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97b.png',
  },
  {
    emoji: '🩱',
    name: 'one_piece_swimsuit',
    shortcodes: ['one_piece_swimsuit'],
    tags: ['bathing', 'one-piece', 'suit', 'swimsuit'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa71.png',
  },
  {
    emoji: '🩲',
    name: 'swim_brief',
    shortcodes: ['briefs'],
    tags: ['bathing', 'one-piece', 'suit', 'swimsuit', 'underwear'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa72.png',
  },
  {
    emoji: '🩳',
    name: 'shorts',
    shortcodes: ['shorts'],
    tags: ['bathing', 'pants', 'suit', 'swimsuit', 'underwear'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa73.png',
  },
  {
    emoji: '👙',
    name: 'bikini',
    shortcodes: ['bikini'],
    tags: ['bathing', 'beach', 'clothing', 'pool', 'suit', 'swim'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f459.png',
  },
  {
    emoji: '👚',
    name: 'womans_clothes',
    shortcodes: ['womans_clothes'],
    tags: [
      'blouse',
      'clothes',
      'clothing',
      'collar',
      'dress',
      'dressed',
      'lady',
      'shirt',
      'shopping',
      'woman',
      'woman’s',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45a.png',
  },
  {
    emoji: '🪭',
    name: 'folding_hand_fan',
    shortcodes: ['folding_fan'],
    tags: [
      'clack',
      'clap',
      'cool',
      'cooling',
      'dance',
      'fan',
      'flirt',
      'flutter',
      'folding',
      'hand',
      'hot',
      'shy',
    ],
    group: 'objects',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faad.png',
  },
  {
    emoji: '👛',
    name: 'purse',
    shortcodes: ['purse'],
    tags: ['clothes', 'clothing', 'coin', 'dress', 'fancy', 'handbag', 'shopping'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45b.png',
  },
  {
    emoji: '👜',
    name: 'handbag',
    shortcodes: ['handbag'],
    tags: ['bag', 'clothes', 'clothing', 'dress', 'lady', 'purse', 'shopping'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45c.png',
  },
  {
    emoji: '👝',
    name: 'pouch',
    shortcodes: ['clutch_bag', 'pouch'],
    tags: ['bag', 'clothes', 'clothing', 'clutch', 'dress', 'handbag', 'pouch', 'purse'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45d.png',
  },
  {
    emoji: '🛍',
    name: 'shopping',
    shortcodes: ['shopping_bags'],
    tags: ['bag', 'bags', 'hotel', 'shopping'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cd-fe0f.png',
  },
  {
    emoji: '🎒',
    name: 'school_satchel',
    shortcodes: ['backpack', 'school_satchel'],
    tags: ['backpacking', 'bag', 'bookbag', 'education', 'rucksack', 'satchel', 'school'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f392.png',
  },
  {
    emoji: '🩴',
    name: 'thong_sandal',
    shortcodes: ['thong_sandal'],
    tags: ['beach', 'flip', 'flop', 'sandal', 'sandals', 'shoe', 'thong', 'thongs', 'zōri'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa74.png',
  },
  {
    emoji: '👞',
    name: 'mans_shoe',
    shortcodes: ['mans_shoe'],
    tags: [
      'brown',
      'clothes',
      'clothing',
      'feet',
      'foot',
      'kick',
      'man',
      'man’s',
      'shoe',
      'shoes',
      'shopping',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45e.png',
  },
  {
    emoji: '👟',
    name: 'athletic_shoe',
    shortcodes: ['athletic_shoe', 'sneaker'],
    tags: [
      'athletic',
      'clothes',
      'clothing',
      'fast',
      'kick',
      'running',
      'shoe',
      'shoes',
      'shopping',
      'sneaker',
      'tennis',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f45f.png',
  },
  {
    emoji: '🥾',
    name: 'hiking_boot',
    shortcodes: ['hiking_boot'],
    tags: ['backpacking', 'boot', 'brown', 'camping', 'hiking', 'outdoors', 'shoe'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97e.png',
  },
  {
    emoji: '🥿',
    name: 'flat_shoe',
    shortcodes: ['flat_shoe', 'womans_flat_shoe'],
    tags: ['ballet', 'comfy', 'flat', 'flats', 'shoe', 'slip-on', 'slipper'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f97f.png',
  },
  {
    emoji: '👠',
    name: 'high_heel',
    shortcodes: ['high_heel'],
    tags: [
      'clothes',
      'clothing',
      'dress',
      'fashion',
      'heel',
      'heels',
      'high-heeled',
      'shoe',
      'shoes',
      'shopping',
      'stiletto',
      'woman',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f460.png',
  },
  {
    emoji: '👡',
    name: 'sandal',
    shortcodes: ['sandal'],
    tags: ['clothing', 'sandal', 'shoe', 'woman', 'woman’s'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f461.png',
  },
  {
    emoji: '🩰',
    name: 'ballet_shoes',
    shortcodes: ['ballet_shoes'],
    tags: ['ballet', 'dance', 'shoes'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa70.png',
  },
  {
    emoji: '👢',
    name: 'boot',
    shortcodes: ['boot'],
    tags: ['boot', 'clothes', 'clothing', 'dress', 'shoe', 'shoes', 'shopping', 'woman', 'woman’s'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f462.png',
  },
  {
    emoji: '🪮',
    name: 'hair_pick',
    shortcodes: ['hair_pick'],
    tags: ['afro', 'comb', 'groom', 'hair', 'pick'],
    group: 'objects',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faae.png',
  },
  {
    emoji: '👑',
    name: 'crown',
    shortcodes: ['crown'],
    tags: ['clothing', 'family', 'king', 'medieval', 'queen', 'royal', 'royalty', 'win'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f451.png',
  },
  {
    emoji: '👒',
    name: 'womans_hat',
    shortcodes: ['womans_hat'],
    tags: ['clothes', 'clothing', 'garden', 'hat', 'hats', 'party', 'woman', 'woman’s'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f452.png',
  },
  {
    emoji: '🎩',
    name: 'tophat',
    shortcodes: ['top_hat', 'tophat'],
    tags: ['clothes', 'clothing', 'fancy', 'formal', 'hat', 'magic', 'top', 'tophat'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a9.png',
  },
  {
    emoji: '🎓',
    name: 'mortar_board',
    shortcodes: ['graduation_cap', 'mortar_board'],
    tags: ['cap', 'celebration', 'clothing', 'education', 'graduation', 'hat', 'scholar'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f393.png',
  },
  {
    emoji: '🧢',
    name: 'billed_cap',
    shortcodes: ['billed_cap'],
    tags: ['baseball', 'bent', 'billed', 'cap', 'dad', 'hat'],
    group: 'objects',
    emoticons: [],
    version: 5,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9e2.png',
  },
  {
    emoji: '🪖',
    name: 'military_helmet',
    shortcodes: ['military_helmet'],
    tags: ['army', 'helmet', 'military', 'soldier', 'war', 'warrior'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa96.png',
  },
  {
    emoji: '⛑',
    name: 'rescue_worker_helmet',
    shortcodes: ['helmet_with_cross', 'rescue_worker_helmet'],
    tags: ['aid', 'cross', 'face', 'hat', 'helmet', 'rescue', 'worker’s'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d1-fe0f.png',
  },
  {
    emoji: '📿',
    name: 'prayer_beads',
    shortcodes: ['prayer_beads'],
    tags: ['beads', 'clothing', 'necklace', 'prayer', 'religion'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ff.png',
  },
  {
    emoji: '💄',
    name: 'lipstick',
    shortcodes: ['lipstick'],
    tags: ['cosmetics', 'date', 'makeup'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f484.png',
  },
  {
    emoji: '💍',
    name: 'ring',
    shortcodes: ['ring'],
    tags: [
      'diamond',
      'engaged',
      'engagement',
      'married',
      'romance',
      'shiny',
      'sparkling',
      'wedding',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48d.png',
  },
  {
    emoji: '💎',
    name: 'gem',
    shortcodes: ['gem'],
    tags: ['diamond', 'engagement', 'gem', 'jewel', 'money', 'romance', 'stone', 'wedding'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48e.png',
  },
  {
    emoji: '🔇',
    name: 'mute',
    shortcodes: ['mute', 'no_sound'],
    tags: ['mute', 'muted', 'quiet', 'silent', 'sound', 'speaker'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f507.png',
  },
  {
    emoji: '🔈',
    name: 'speaker',
    shortcodes: ['low_volume', 'quiet_sound', 'speaker'],
    tags: ['low', 'soft', 'sound', 'speaker', 'volume'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f508.png',
  },
  {
    emoji: '🔉',
    name: 'sound',
    shortcodes: ['medium_volumne', 'sound'],
    tags: ['medium', 'sound', 'speaker', 'volume'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f509.png',
  },
  {
    emoji: '🔊',
    name: 'loud_sound',
    shortcodes: ['high_volume', 'loud_sound'],
    tags: ['high', 'loud', 'music', 'sound', 'speaker', 'volume'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50a.png',
  },
  {
    emoji: '📢',
    name: 'loudspeaker',
    shortcodes: ['loudspeaker'],
    tags: ['address', 'communication', 'loud', 'public', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e2.png',
  },
  {
    emoji: '📣',
    name: 'mega',
    shortcodes: ['mega', 'megaphone'],
    tags: ['cheering', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e3.png',
  },
  {
    emoji: '📯',
    name: 'postal_horn',
    shortcodes: ['postal_horn'],
    tags: ['horn', 'post', 'postal'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ef.png',
  },
  {
    emoji: '🔔',
    name: 'bell',
    shortcodes: ['bell'],
    tags: ['break', 'church', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f514.png',
  },
  {
    emoji: '🔕',
    name: 'no_bell',
    shortcodes: ['no_bell'],
    tags: [
      'bell',
      'forbidden',
      'mute',
      'no',
      'not',
      'prohibited',
      'quiet',
      'silent',
      'slash',
      'sound',
    ],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f515.png',
  },
  {
    emoji: '🎼',
    name: 'musical_score',
    shortcodes: ['musical_score'],
    tags: ['music', 'musical', 'note', 'score'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bc.png',
  },
  {
    emoji: '🎵',
    name: 'musical_note',
    shortcodes: ['musical_note'],
    tags: ['music', 'musical', 'note', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b5.png',
  },
  {
    emoji: '🎶',
    name: 'notes',
    shortcodes: ['musical_notes', 'notes'],
    tags: ['music', 'musical', 'note', 'notes', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b6.png',
  },
  {
    emoji: '🎙',
    name: 'studio_microphone',
    shortcodes: ['studio_microphone'],
    tags: ['mic', 'microphone', 'music', 'studio'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f399-fe0f.png',
  },
  {
    emoji: '🎚',
    name: 'level_slider',
    shortcodes: ['level_slider'],
    tags: ['level', 'music', 'slider'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39a-fe0f.png',
  },
  {
    emoji: '🎛',
    name: 'control_knobs',
    shortcodes: ['control_knobs'],
    tags: ['control', 'knobs', 'music'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39b-fe0f.png',
  },
  {
    emoji: '🎤',
    name: 'microphone',
    shortcodes: ['microphone'],
    tags: ['karaoke', 'mic', 'music', 'sing', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a4.png',
  },
  {
    emoji: '🎧',
    name: 'headphones',
    shortcodes: ['headphones'],
    tags: ['earbud', 'sound'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a7.png',
  },
  {
    emoji: '📻',
    name: 'radio',
    shortcodes: ['radio'],
    tags: ['entertainment', 'tbt', 'video'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fb.png',
  },
  {
    emoji: '🎷',
    name: 'saxophone',
    shortcodes: ['saxophone'],
    tags: ['instrument', 'music', 'sax'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b7.png',
  },
  {
    emoji: '🎺',
    name: 'trumpet',
    shortcodes: ['trumpet'],
    tags: ['instrument', 'music'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ba.png',
  },
  {
    emoji: '🪊',
    name: 'trombone',
    shortcodes: ['trombone'],
    tags: ['brass', 'instrument', 'jazz', 'music', 'sad', 'slide'],
    group: 'objects',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '🪗',
    name: 'accordion',
    shortcodes: ['accordion'],
    tags: ['box', 'concertina', 'instrument', 'music', 'squeeze', 'squeezebox'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa97.png',
  },
  {
    emoji: '🎸',
    name: 'guitar',
    shortcodes: ['guitar'],
    tags: ['instrument', 'music', 'strat'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b8.png',
  },
  {
    emoji: '🎹',
    name: 'musical_keyboard',
    shortcodes: ['musical_keyboard'],
    tags: ['instrument', 'keyboard', 'music', 'musical', 'piano'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3b9.png',
  },
  {
    emoji: '🎻',
    name: 'violin',
    shortcodes: ['violin'],
    tags: ['instrument', 'music'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3bb.png',
  },
  {
    emoji: '🪕',
    name: 'banjo',
    shortcodes: ['banjo'],
    tags: ['music', 'stringed'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa95.png',
  },
  {
    emoji: '🥁',
    name: 'drum',
    shortcodes: ['drum'],
    tags: ['drumsticks', 'music'],
    group: 'objects',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f941.png',
  },
  {
    emoji: '🪘',
    name: 'long_drum',
    shortcodes: ['long_drum'],
    tags: ['beat', 'conga', 'drum', 'instrument', 'long', 'rhythm'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa98.png',
  },
  {
    emoji: '🪇',
    name: 'maracas',
    shortcodes: ['maracas'],
    tags: [
      'cha',
      'dance',
      'instrument',
      'music',
      'party',
      'percussion',
      'rattle',
      'shake',
      'shaker',
    ],
    group: 'objects',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa87.png',
  },
  {
    emoji: '🪈',
    name: 'flute',
    shortcodes: ['flute'],
    tags: [
      'band',
      'fife',
      'flautist',
      'instrument',
      'marching',
      'music',
      'orchestra',
      'piccolo',
      'pipe',
      'recorder',
      'woodwind',
    ],
    group: 'objects',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa88.png',
  },
  {
    emoji: '🪉',
    name: 'harp',
    shortcodes: ['harp'],
    tags: ['cupid', 'instrument', 'love', 'music', 'orchestra'],
    group: 'objects',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa89.png',
  },
  {
    emoji: '📱',
    name: 'iphone',
    shortcodes: ['android', 'iphone', 'mobile_phone'],
    tags: ['cell', 'communication', 'mobile', 'phone', 'telephone'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f1.png',
  },
  {
    emoji: '📲',
    name: 'calling',
    shortcodes: ['calling', 'mobile_phone_arrow'],
    tags: [
      'arrow',
      'build',
      'call',
      'cell',
      'communication',
      'mobile',
      'phone',
      'receive',
      'telephone',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f2.png',
  },
  {
    emoji: '☎',
    name: 'phone',
    shortcodes: ['telephone'],
    tags: ['phone'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/260e-fe0f.png',
  },
  {
    emoji: '📞',
    name: 'telephone_receiver',
    shortcodes: ['telephone_receiver'],
    tags: ['communication', 'phone', 'receiver', 'telephone', 'voip'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4de.png',
  },
  {
    emoji: '📟',
    name: 'pager',
    shortcodes: ['pager'],
    tags: ['communication'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4df.png',
  },
  {
    emoji: '📠',
    name: 'fax',
    shortcodes: ['fax', 'fax_machine'],
    tags: ['communication', 'fax', 'machine'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e0.png',
  },
  {
    emoji: '🔋',
    name: 'battery',
    shortcodes: ['battery'],
    tags: ['battery'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50b.png',
  },
  {
    emoji: '🪫',
    name: 'low_battery',
    shortcodes: ['low_battery'],
    tags: ['battery', 'drained', 'electronic', 'energy', 'low', 'power'],
    group: 'objects',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faab.png',
  },
  {
    emoji: '🔌',
    name: 'electric_plug',
    shortcodes: ['electric_plug'],
    tags: ['electric', 'electricity', 'plug'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50c.png',
  },
  {
    emoji: '💻',
    name: 'computer',
    shortcodes: ['laptop'],
    tags: ['computer', 'office', 'pc', 'personal'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bb.png',
  },
  {
    emoji: '🖥',
    name: 'desktop_computer',
    shortcodes: ['computer', 'desktop_computer'],
    tags: ['computer', 'desktop', 'monitor'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5a5-fe0f.png',
  },
  {
    emoji: '🖨',
    name: 'printer',
    shortcodes: ['printer'],
    tags: ['computer'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5a8-fe0f.png',
  },
  {
    emoji: '⌨',
    name: 'keyboard',
    shortcodes: ['keyboard'],
    tags: ['computer'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2328-fe0f.png',
  },
  {
    emoji: '🖱',
    name: 'computer_mouse',
    shortcodes: ['computer_mouse'],
    tags: ['computer', 'mouse'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5b1-fe0f.png',
  },
  {
    emoji: '🖲',
    name: 'trackball',
    shortcodes: ['trackball'],
    tags: ['computer'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5b2-fe0f.png',
  },
  {
    emoji: '💽',
    name: 'minidisc',
    shortcodes: ['computer_disk', 'minidisc'],
    tags: ['computer', 'disk', 'minidisk', 'optical'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bd.png',
  },
  {
    emoji: '💾',
    name: 'floppy_disk',
    shortcodes: ['floppy_disk'],
    tags: ['computer', 'disk', 'floppy'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4be.png',
  },
  {
    emoji: '💿',
    name: 'cd',
    shortcodes: ['cd', 'optical_disk'],
    tags: ['blu-ray', 'cd', 'computer', 'disk', 'dvd', 'optical'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bf.png',
  },
  {
    emoji: '📀',
    name: 'dvd',
    shortcodes: ['dvd'],
    tags: ['blu-ray', 'cd', 'computer', 'disk', 'optical'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c0.png',
  },
  {
    emoji: '🧮',
    name: 'abacus',
    shortcodes: ['abacus'],
    tags: ['calculation', 'calculator'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ee.png',
  },
  {
    emoji: '🎥',
    name: 'movie_camera',
    shortcodes: ['movie_camera'],
    tags: ['bollywood', 'camera', 'cinema', 'film', 'hollywood', 'movie', 'record'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a5.png',
  },
  {
    emoji: '🎞',
    name: 'film_strip',
    shortcodes: ['film_frames'],
    tags: ['cinema', 'film', 'frames', 'movie'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f39e-fe0f.png',
  },
  {
    emoji: '📽',
    name: 'film_projector',
    shortcodes: ['film_projector'],
    tags: ['cinema', 'film', 'movie', 'projector', 'video'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fd-fe0f.png',
  },
  {
    emoji: '🎬',
    name: 'clapper',
    shortcodes: ['clapper'],
    tags: ['action', 'board', 'clapper', 'movie'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ac.png',
  },
  {
    emoji: '📺',
    name: 'tv',
    shortcodes: ['tv'],
    tags: ['tv', 'video'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fa.png',
  },
  {
    emoji: '📷',
    name: 'camera',
    shortcodes: ['camera'],
    tags: ['photo', 'selfie', 'snap', 'tbt', 'trip', 'video'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f7.png',
  },
  {
    emoji: '📸',
    name: 'camera_flash',
    shortcodes: ['camera_with_flash'],
    tags: ['camera', 'flash', 'video'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f8.png',
  },
  {
    emoji: '📹',
    name: 'video_camera',
    shortcodes: ['video_camera'],
    tags: ['camcorder', 'camera', 'tbt', 'video'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f9.png',
  },
  {
    emoji: '📼',
    name: 'vhs',
    shortcodes: ['vhs', 'videocassette'],
    tags: ['old', 'school', 'tape', 'vcr', 'vhs', 'video'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4fc.png',
  },
  {
    emoji: '🔍',
    name: 'mag',
    shortcodes: ['mag'],
    tags: [
      'glass',
      'lab',
      'left',
      'left-pointing',
      'magnifying',
      'science',
      'search',
      'tilted',
      'tool',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50d.png',
  },
  {
    emoji: '🔎',
    name: 'mag_right',
    shortcodes: ['mag_right'],
    tags: [
      'contact',
      'glass',
      'lab',
      'magnifying',
      'right',
      'right-pointing',
      'science',
      'search',
      'tilted',
      'tool',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50e.png',
  },
  {
    emoji: '🕯',
    name: 'candle',
    shortcodes: ['candle'],
    tags: ['light'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f56f-fe0f.png',
  },
  {
    emoji: '💡',
    name: 'bulb',
    shortcodes: ['bulb', 'light_bulb'],
    tags: ['bulb', 'comic', 'electric', 'idea', 'light'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a1.png',
  },
  {
    emoji: '🔦',
    name: 'flashlight',
    shortcodes: ['flashlight'],
    tags: ['electric', 'light', 'tool', 'torch'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f526.png',
  },
  {
    emoji: '🏮',
    name: 'izakaya_lantern',
    shortcodes: ['izakaya_lantern', 'red_paper_lantern'],
    tags: ['bar', 'lantern', 'light', 'paper', 'red', 'restaurant'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3ee.png',
  },
  {
    emoji: '🪔',
    name: 'diya_lamp',
    shortcodes: ['diya_lamp'],
    tags: ['diya', 'lamp', 'light', 'oil'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa94.png',
  },
  {
    emoji: '📔',
    name: 'notebook_with_decorative_cover',
    shortcodes: ['notebook_with_decorative_cover'],
    tags: [
      'book',
      'cover',
      'decorated',
      'decorative',
      'education',
      'notebook',
      'school',
      'writing',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d4.png',
  },
  {
    emoji: '📕',
    name: 'closed_book',
    shortcodes: ['closed_book'],
    tags: ['book', 'closed', 'education'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d5.png',
  },
  {
    emoji: '📖',
    name: 'book',
    shortcodes: ['book', 'open_book'],
    tags: ['book', 'education', 'fantasy', 'knowledge', 'library', 'novels', 'open', 'reading'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d6.png',
  },
  {
    emoji: '📗',
    name: 'green_book',
    shortcodes: ['green_book'],
    tags: ['book', 'education', 'fantasy', 'green', 'library', 'reading'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d7.png',
  },
  {
    emoji: '📘',
    name: 'blue_book',
    shortcodes: ['blue_book'],
    tags: ['blue', 'book', 'education', 'fantasy', 'library', 'reading'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d8.png',
  },
  {
    emoji: '📙',
    name: 'orange_book',
    shortcodes: ['orange_book'],
    tags: ['book', 'education', 'fantasy', 'library', 'orange', 'reading'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d9.png',
  },
  {
    emoji: '📚',
    name: 'books',
    shortcodes: ['books'],
    tags: [
      'book',
      'education',
      'fantasy',
      'knowledge',
      'library',
      'novels',
      'reading',
      'school',
      'study',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4da.png',
  },
  {
    emoji: '📓',
    name: 'notebook',
    shortcodes: ['notebook'],
    tags: ['notebook'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d3.png',
  },
  {
    emoji: '📒',
    name: 'ledger',
    shortcodes: ['ledger'],
    tags: ['notebook'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d2.png',
  },
  {
    emoji: '📃',
    name: 'page_with_curl',
    shortcodes: ['page_with_curl'],
    tags: ['curl', 'document', 'page', 'paper'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c3.png',
  },
  {
    emoji: '📜',
    name: 'scroll',
    shortcodes: ['scroll'],
    tags: ['paper'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4dc.png',
  },
  {
    emoji: '📄',
    name: 'page_facing_up',
    shortcodes: ['page_facing_up'],
    tags: ['document', 'facing', 'page', 'paper', 'up'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c4.png',
  },
  {
    emoji: '📰',
    name: 'newspaper',
    shortcodes: ['newspaper'],
    tags: ['communication', 'news', 'paper'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f0.png',
  },
  {
    emoji: '🗞',
    name: 'newspaper_roll',
    shortcodes: ['rolled_up_newspaper'],
    tags: ['news', 'newspaper', 'paper', 'rolled', 'rolled-up'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5de-fe0f.png',
  },
  {
    emoji: '📑',
    name: 'bookmark_tabs',
    shortcodes: ['bookmark_tabs'],
    tags: ['bookmark', 'mark', 'marker', 'tabs'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d1.png',
  },
  {
    emoji: '🔖',
    name: 'bookmark',
    shortcodes: ['bookmark'],
    tags: ['mark'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f516.png',
  },
  {
    emoji: '🏷',
    name: 'label',
    shortcodes: ['label'],
    tags: ['tag'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f7-fe0f.png',
  },
  {
    emoji: '🪙',
    name: 'coin',
    shortcodes: ['coin'],
    tags: ['dollar', 'euro', 'gold', 'metal', 'money', 'rich', 'silver', 'treasure'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa99.png',
  },
  {
    emoji: '💰',
    name: 'moneybag',
    shortcodes: ['moneybag'],
    tags: [
      'bag',
      'bank',
      'bet',
      'billion',
      'cash',
      'cost',
      'dollar',
      'gold',
      'million',
      'money',
      'moneybag',
      'paid',
      'paying',
      'pot',
      'rich',
      'win',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b0.png',
  },
  {
    emoji: '🪎',
    name: 'treasure_chest',
    shortcodes: ['treasure_chest'],
    tags: ['gem', 'gold', 'jewels', 'loot', 'money', 'prize', 'silver', 'valuables', 'wealth'],
    group: 'objects',
    emoticons: [],
    version: 17,
  },
  {
    emoji: '💴',
    name: 'yen',
    shortcodes: ['yen'],
    tags: ['bank', 'banknote', 'bill', 'currency', 'money', 'note', 'yen'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b4.png',
  },
  {
    emoji: '💵',
    name: 'dollar',
    shortcodes: ['dollar'],
    tags: ['bank', 'banknote', 'bill', 'currency', 'dollar', 'money', 'note'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b5.png',
  },
  {
    emoji: '💶',
    name: 'euro',
    shortcodes: ['euro'],
    tags: ['100', 'bank', 'banknote', 'bill', 'currency', 'euro', 'money', 'note', 'rich'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b6.png',
  },
  {
    emoji: '💷',
    name: 'pound',
    shortcodes: ['pound'],
    tags: [
      'bank',
      'banknote',
      'bill',
      'billion',
      'cash',
      'currency',
      'money',
      'note',
      'pound',
      'pounds',
    ],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b7.png',
  },
  {
    emoji: '💸',
    name: 'money_with_wings',
    shortcodes: ['money_with_wings'],
    tags: [
      'bank',
      'banknote',
      'bill',
      'billion',
      'cash',
      'dollar',
      'fly',
      'million',
      'money',
      'note',
      'pay',
      'wings',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b8.png',
  },
  {
    emoji: '💳',
    name: 'credit_card',
    shortcodes: ['credit_card'],
    tags: ['bank', 'card', 'cash', 'charge', 'credit', 'money', 'pay'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b3.png',
  },
  {
    emoji: '🧾',
    name: 'receipt',
    shortcodes: ['receipt'],
    tags: ['accounting', 'bookkeeping', 'evidence', 'invoice', 'proof'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fe.png',
  },
  {
    emoji: '💹',
    name: 'chart',
    shortcodes: ['chart'],
    tags: [
      'bank',
      'chart',
      'currency',
      'graph',
      'growth',
      'increasing',
      'market',
      'money',
      'rise',
      'trend',
      'upward',
      'yen',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b9.png',
  },
  {
    emoji: '✉',
    name: 'envelope',
    shortcodes: ['envelope'],
    tags: ['e-mail', 'email', 'letter'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2709-fe0f.png',
  },
  {
    emoji: '📧',
    name: 'e-mail',
    shortcodes: ['e-mail', 'email'],
    tags: ['email', 'letter', 'mail'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e7.png',
  },
  {
    emoji: '📨',
    name: 'incoming_envelope',
    shortcodes: ['incoming_envelope'],
    tags: [
      'delivering',
      'e-mail',
      'email',
      'envelope',
      'incoming',
      'letter',
      'mail',
      'receive',
      'sent',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e8.png',
  },
  {
    emoji: '📩',
    name: 'envelope_with_arrow',
    shortcodes: ['envelope_with_arrow'],
    tags: [
      'arrow',
      'communication',
      'down',
      'e-mail',
      'email',
      'envelope',
      'letter',
      'mail',
      'outgoing',
      'send',
      'sent',
    ],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e9.png',
  },
  {
    emoji: '📤',
    name: 'outbox_tray',
    shortcodes: ['outbox_tray'],
    tags: ['box', 'email', 'letter', 'mail', 'outbox', 'sent', 'tray'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e4.png',
  },
  {
    emoji: '📥',
    name: 'inbox_tray',
    shortcodes: ['inbox_tray'],
    tags: ['box', 'email', 'inbox', 'letter', 'mail', 'receive', 'tray', 'zero'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e5.png',
  },
  {
    emoji: '📦',
    name: 'package',
    shortcodes: ['package'],
    tags: ['box', 'communication', 'delivery', 'parcel', 'shipping'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e6.png',
  },
  {
    emoji: '📫',
    name: 'mailbox',
    shortcodes: ['mailbox'],
    tags: ['closed', 'communication', 'flag', 'mail', 'mailbox', 'postbox', 'raised'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4eb.png',
  },
  {
    emoji: '📪',
    name: 'mailbox_closed',
    shortcodes: ['mailbox_closed'],
    tags: ['closed', 'flag', 'lowered', 'mail', 'mailbox', 'postbox'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ea.png',
  },
  {
    emoji: '📬',
    name: 'mailbox_with_mail',
    shortcodes: ['mailbox_with_mail'],
    tags: ['flag', 'mail', 'mailbox', 'open', 'postbox', 'raised'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ec.png',
  },
  {
    emoji: '📭',
    name: 'mailbox_with_no_mail',
    shortcodes: ['mailbox_with_no_mail'],
    tags: ['flag', 'lowered', 'mail', 'mailbox', 'open', 'postbox'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ed.png',
  },
  {
    emoji: '📮',
    name: 'postbox',
    shortcodes: ['postbox'],
    tags: ['mail', 'mailbox'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ee.png',
  },
  {
    emoji: '🗳',
    name: 'ballot_box',
    shortcodes: ['ballot_box'],
    tags: ['ballot', 'box'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5f3-fe0f.png',
  },
  {
    emoji: '✏',
    name: 'pencil2',
    shortcodes: ['pencil'],
    tags: ['pencil'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/270f-fe0f.png',
  },
  {
    emoji: '✒',
    name: 'black_nib',
    shortcodes: ['black_nib'],
    tags: ['black', 'nib', 'pen'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2712-fe0f.png',
  },
  {
    emoji: '🖋',
    name: 'fountain_pen',
    shortcodes: ['fountain_pen'],
    tags: ['fountain', 'pen'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58b-fe0f.png',
  },
  {
    emoji: '🖊',
    name: 'pen',
    shortcodes: ['pen'],
    tags: ['ballpoint'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58a-fe0f.png',
  },
  {
    emoji: '🖌',
    name: 'paintbrush',
    shortcodes: ['paintbrush'],
    tags: ['painting'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58c-fe0f.png',
  },
  {
    emoji: '🖍',
    name: 'crayon',
    shortcodes: ['crayon'],
    tags: ['crayon'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f58d-fe0f.png',
  },
  {
    emoji: '📝',
    name: 'memo',
    shortcodes: ['memo'],
    tags: ['communication', 'media', 'notes', 'pencil'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4dd.png',
  },
  {
    emoji: '💼',
    name: 'briefcase',
    shortcodes: ['briefcase'],
    tags: ['office'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4bc.png',
  },
  {
    emoji: '📁',
    name: 'file_folder',
    shortcodes: ['file_folder'],
    tags: ['file', 'folder'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c1.png',
  },
  {
    emoji: '📂',
    name: 'open_file_folder',
    shortcodes: ['open_file_folder'],
    tags: ['file', 'folder', 'open'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c2.png',
  },
  {
    emoji: '🗂',
    name: 'card_index_dividers',
    shortcodes: ['card_index_dividers'],
    tags: ['card', 'dividers', 'index'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5c2-fe0f.png',
  },
  {
    emoji: '📅',
    name: 'date',
    shortcodes: ['date'],
    tags: ['date'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c5.png',
  },
  {
    emoji: '📆',
    name: 'calendar',
    shortcodes: ['calendar'],
    tags: ['calendar', 'tear-off'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c6.png',
  },
  {
    emoji: '🗒',
    name: 'spiral_notepad',
    shortcodes: ['notepad_spiral'],
    tags: ['note', 'notepad', 'pad', 'spiral'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5d2-fe0f.png',
  },
  {
    emoji: '🗓',
    name: 'spiral_calendar',
    shortcodes: ['calendar_spiral'],
    tags: ['calendar', 'pad', 'spiral'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5d3-fe0f.png',
  },
  {
    emoji: '📇',
    name: 'card_index',
    shortcodes: ['card_index'],
    tags: ['card', 'index', 'old', 'rolodex', 'school'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c7.png',
  },
  {
    emoji: '📈',
    name: 'chart_with_upwards_trend',
    shortcodes: ['chart_increasing', 'chart_with_upwards_trend'],
    tags: ['chart', 'data', 'graph', 'growth', 'increasing', 'right', 'trend', 'up', 'upward'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c8.png',
  },
  {
    emoji: '📉',
    name: 'chart_with_downwards_trend',
    shortcodes: ['chart_decreasing', 'chart_with_downwards_trend'],
    tags: ['chart', 'data', 'decreasing', 'down', 'downward', 'graph', 'negative', 'trend'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4c9.png',
  },
  {
    emoji: '📊',
    name: 'bar_chart',
    shortcodes: ['bar_chart'],
    tags: ['bar', 'chart', 'data', 'graph'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ca.png',
  },
  {
    emoji: '📋',
    name: 'clipboard',
    shortcodes: ['clipboard'],
    tags: ['do', 'list', 'notes'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cb.png',
  },
  {
    emoji: '📌',
    name: 'pushpin',
    shortcodes: ['pushpin'],
    tags: ['collage', 'pin'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cc.png',
  },
  {
    emoji: '📍',
    name: 'round_pushpin',
    shortcodes: ['round_pushpin'],
    tags: ['location', 'map', 'pin', 'pushpin', 'round'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cd.png',
  },
  {
    emoji: '📎',
    name: 'paperclip',
    shortcodes: ['paperclip'],
    tags: ['paperclip'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4ce.png',
  },
  {
    emoji: '🖇',
    name: 'paperclips',
    shortcodes: ['paperclips'],
    tags: ['link', 'linked', 'paperclip', 'paperclips'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f587-fe0f.png',
  },
  {
    emoji: '📏',
    name: 'straight_ruler',
    shortcodes: ['straight_ruler'],
    tags: ['angle', 'edge', 'math', 'ruler', 'straight', 'straightedge'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4cf.png',
  },
  {
    emoji: '📐',
    name: 'triangular_ruler',
    shortcodes: ['triangular_ruler'],
    tags: ['angle', 'math', 'rule', 'ruler', 'set', 'slide', 'triangle', 'triangular'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4d0.png',
  },
  {
    emoji: '✂',
    name: 'scissors',
    shortcodes: ['scissors'],
    tags: ['cut', 'cutting', 'paper', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2702-fe0f.png',
  },
  {
    emoji: '🗃',
    name: 'card_file_box',
    shortcodes: ['card_file_box'],
    tags: ['box', 'card', 'file'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5c3-fe0f.png',
  },
  {
    emoji: '🗄',
    name: 'file_cabinet',
    shortcodes: ['file_cabinet'],
    tags: ['cabinet', 'file', 'filing', 'paper'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5c4-fe0f.png',
  },
  {
    emoji: '🗑',
    name: 'wastebasket',
    shortcodes: ['trashcan', 'wastebasket'],
    tags: ['can', 'garbage', 'trash', 'waste'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5d1-fe0f.png',
  },
  {
    emoji: '🔒',
    name: 'lock',
    shortcodes: ['lock', 'locked'],
    tags: ['closed', 'lock', 'private'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f512.png',
  },
  {
    emoji: '🔓',
    name: 'unlock',
    shortcodes: ['unlock', 'unlocked'],
    tags: ['cracked', 'lock', 'open', 'unlock'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f513.png',
  },
  {
    emoji: '🔏',
    name: 'lock_with_ink_pen',
    shortcodes: ['lock_with_ink_pen', 'locked_with_pen'],
    tags: ['ink', 'lock', 'locked', 'nib', 'pen', 'privacy'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f50f.png',
  },
  {
    emoji: '🔐',
    name: 'closed_lock_with_key',
    shortcodes: ['closed_lock_with_key', 'locked_with_key'],
    tags: ['bike', 'closed', 'key', 'lock', 'locked', 'secure'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f510.png',
  },
  {
    emoji: '🔑',
    name: 'key',
    shortcodes: ['key'],
    tags: ['keys', 'lock', 'major', 'password', 'unlock'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f511.png',
  },
  {
    emoji: '🗝',
    name: 'old_key',
    shortcodes: ['old_key'],
    tags: ['clue', 'key', 'lock', 'old'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5dd-fe0f.png',
  },
  {
    emoji: '🔨',
    name: 'hammer',
    shortcodes: ['hammer'],
    tags: ['home', 'improvement', 'repairs', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f528.png',
  },
  {
    emoji: '🪓',
    name: 'axe',
    shortcodes: ['axe'],
    tags: ['ax', 'chop', 'hatchet', 'split', 'wood'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa93.png',
  },
  {
    emoji: '⛏',
    name: 'pick',
    shortcodes: ['pick'],
    tags: ['hammer', 'mining', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26cf-fe0f.png',
  },
  {
    emoji: '⚒',
    name: 'hammer_and_pick',
    shortcodes: ['hammer_and_pick'],
    tags: ['hammer', 'pick', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2692-fe0f.png',
  },
  {
    emoji: '🛠',
    name: 'hammer_and_wrench',
    shortcodes: ['hammer_and_wrench'],
    tags: ['hammer', 'spanner', 'tool', 'wrench'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e0-fe0f.png',
  },
  {
    emoji: '🗡',
    name: 'dagger',
    shortcodes: ['dagger'],
    tags: ['knife', 'weapon'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5e1-fe0f.png',
  },
  {
    emoji: '⚔',
    name: 'crossed_swords',
    shortcodes: ['crossed_swords'],
    tags: ['crossed', 'swords', 'weapon'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2694-fe0f.png',
  },
  {
    emoji: '💣',
    name: 'bomb',
    shortcodes: ['bomb'],
    tags: ['boom', 'comic', 'dangerous', 'explosion', 'hot'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a3.png',
  },
  {
    emoji: '🪃',
    name: 'boomerang',
    shortcodes: ['boomerang'],
    tags: ['rebound', 'repercussion', 'weapon'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa83.png',
  },
  {
    emoji: '🏹',
    name: 'bow_and_arrow',
    shortcodes: ['bow_and_arrow'],
    tags: ['archer', 'archery', 'arrow', 'bow', 'sagittarius', 'tool', 'weapon', 'zodiac'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f9.png',
  },
  {
    emoji: '🛡',
    name: 'shield',
    shortcodes: ['shield'],
    tags: ['weapon'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6e1-fe0f.png',
  },
  {
    emoji: '🪚',
    name: 'carpentry_saw',
    shortcodes: ['carpentry_saw'],
    tags: ['carpenter', 'carpentry', 'cut', 'lumber', 'saw', 'tool', 'trim'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9a.png',
  },
  {
    emoji: '🔧',
    name: 'wrench',
    shortcodes: ['wrench'],
    tags: ['home', 'improvement', 'spanner', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f527.png',
  },
  {
    emoji: '🪛',
    name: 'screwdriver',
    shortcodes: ['screwdriver'],
    tags: ['flathead', 'handy', 'screw', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9b.png',
  },
  {
    emoji: '🔩',
    name: 'nut_and_bolt',
    shortcodes: ['nut_and_bolt'],
    tags: ['bolt', 'home', 'improvement', 'nut', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f529.png',
  },
  {
    emoji: '⚙',
    name: 'gear',
    shortcodes: ['gear'],
    tags: ['cog', 'cogwheel', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2699-fe0f.png',
  },
  {
    emoji: '🗜',
    name: 'clamp',
    shortcodes: ['clamp', 'compression'],
    tags: ['compress', 'tool', 'vice'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5dc-fe0f.png',
  },
  {
    emoji: '⚖',
    name: 'balance_scale',
    shortcodes: ['scales'],
    tags: ['balance', 'justice', 'libra', 'scale', 'scales', 'tool', 'weight', 'zodiac'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2696-fe0f.png',
  },
  {
    emoji: '🦯',
    name: 'probing_cane',
    shortcodes: ['probing_cane', 'white_cane'],
    tags: ['accessibility', 'blind', 'cane', 'probing', 'white'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9af.png',
  },
  {
    emoji: '🔗',
    name: 'link',
    shortcodes: ['link'],
    tags: ['links'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f517.png',
  },
  {
    emoji: '⛓‍💥',
    name: 'broken_chain',
    shortcodes: ['broken_chain'],
    tags: ['break', 'breaking', 'broken', 'chain', 'cuffs', 'freedom'],
    group: 'objects',
    emoticons: [],
    version: 15.1,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d3-fe0f-200d-1f4a5.png',
  },
  {
    emoji: '⛓',
    name: 'chains',
    shortcodes: ['chains'],
    tags: ['chain'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d3-fe0f.png',
  },
  {
    emoji: '🪝',
    name: 'hook',
    shortcodes: ['hook'],
    tags: ['catch', 'crook', 'curve', 'ensnare', 'point', 'selling'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9d.png',
  },
  {
    emoji: '🧰',
    name: 'toolbox',
    shortcodes: ['toolbox'],
    tags: ['box', 'chest', 'mechanic', 'red', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f0.png',
  },
  {
    emoji: '🧲',
    name: 'magnet',
    shortcodes: ['magnet'],
    tags: ['attraction', 'horseshoe', 'magnetic', 'negative', 'positive', 'shape', 'u'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f2.png',
  },
  {
    emoji: '🪜',
    name: 'ladder',
    shortcodes: ['ladder'],
    tags: ['climb', 'rung', 'step'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9c.png',
  },
  {
    emoji: '🪏',
    name: 'shovel',
    shortcodes: ['shovel'],
    tags: ['bury', 'dig', 'garden', 'hole', 'plant', 'scoop', 'snow', 'spade'],
    group: 'objects',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa8f.png',
  },
  {
    emoji: '⚗',
    name: 'alembic',
    shortcodes: ['alembic'],
    tags: ['chemistry', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2697-fe0f.png',
  },
  {
    emoji: '🧪',
    name: 'test_tube',
    shortcodes: ['test_tube'],
    tags: ['chemist', 'chemistry', 'experiment', 'lab', 'science', 'test', 'tube'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ea.png',
  },
  {
    emoji: '🧫',
    name: 'petri_dish',
    shortcodes: ['petri_dish'],
    tags: ['bacteria', 'biologist', 'biology', 'culture', 'dish', 'lab', 'petri'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9eb.png',
  },
  {
    emoji: '🧬',
    name: 'dna',
    shortcodes: ['dna', 'double_helix'],
    tags: ['biologist', 'evolution', 'gene', 'genetics', 'life'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ec.png',
  },
  {
    emoji: '🔬',
    name: 'microscope',
    shortcodes: ['microscope'],
    tags: ['experiment', 'lab', 'science', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52c.png',
  },
  {
    emoji: '🔭',
    name: 'telescope',
    shortcodes: ['telescope'],
    tags: ['contact', 'extraterrestrial', 'science', 'tool'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52d.png',
  },
  {
    emoji: '📡',
    name: 'satellite',
    shortcodes: ['satellite_antenna'],
    tags: ['aliens', 'antenna', 'contact', 'dish', 'satellite', 'science'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4e1.png',
  },
  {
    emoji: '💉',
    name: 'syringe',
    shortcodes: ['syringe'],
    tags: ['doctor', 'flu', 'medicine', 'needle', 'shot', 'sick', 'tool', 'vaccination'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f489.png',
  },
  {
    emoji: '🩸',
    name: 'drop_of_blood',
    shortcodes: ['drop_of_blood'],
    tags: ['bleed', 'blood', 'donation', 'drop', 'injury', 'medicine', 'menstruation'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa78.png',
  },
  {
    emoji: '💊',
    name: 'pill',
    shortcodes: ['pill'],
    tags: ['doctor', 'drugs', 'medicated', 'medicine', 'pills', 'sick', 'vitamin'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f48a.png',
  },
  {
    emoji: '🩹',
    name: 'adhesive_bandage',
    shortcodes: ['adhesive_bandage', 'bandaid'],
    tags: ['adhesive', 'bandage'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa79.png',
  },
  {
    emoji: '🩼',
    name: 'crutch',
    shortcodes: ['crutch'],
    tags: ['aid', 'cane', 'disability', 'help', 'hurt', 'injured', 'mobility', 'stick'],
    group: 'objects',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa7c.png',
  },
  {
    emoji: '🩺',
    name: 'stethoscope',
    shortcodes: ['stethoscope'],
    tags: ['doctor', 'heart', 'medicine'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa7a.png',
  },
  {
    emoji: '🩻',
    name: 'x_ray',
    shortcodes: ['x-ray', 'xray'],
    tags: ['bones', 'doctor', 'medical', 'skeleton', 'skull', 'xray'],
    group: 'objects',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa7b.png',
  },
  {
    emoji: '🚪',
    name: 'door',
    shortcodes: ['door'],
    tags: ['back', 'closet', 'front'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6aa.png',
  },
  {
    emoji: '🛗',
    name: 'elevator',
    shortcodes: ['elevator'],
    tags: ['accessibility', 'hoist', 'lift'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d7.png',
  },
  {
    emoji: '🪞',
    name: 'mirror',
    shortcodes: ['mirror'],
    tags: ['makeup', 'reflection', 'reflector', 'speculum'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9e.png',
  },
  {
    emoji: '🪟',
    name: 'window',
    shortcodes: ['window'],
    tags: ['air', 'frame', 'fresh', 'opening', 'transparent', 'view'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa9f.png',
  },
  {
    emoji: '🛏',
    name: 'bed',
    shortcodes: ['bed'],
    tags: ['hotel', 'sleep'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cf-fe0f.png',
  },
  {
    emoji: '🛋',
    name: 'couch_and_lamp',
    shortcodes: ['couch_and_lamp'],
    tags: ['couch', 'hotel', 'lamp'],
    group: 'objects',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6cb-fe0f.png',
  },
  {
    emoji: '🪑',
    name: 'chair',
    shortcodes: ['chair'],
    tags: ['seat', 'sit'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa91.png',
  },
  {
    emoji: '🚽',
    name: 'toilet',
    shortcodes: ['toilet'],
    tags: ['bathroom'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bd.png',
  },
  {
    emoji: '🪠',
    name: 'plunger',
    shortcodes: ['plunger'],
    tags: ['cup', 'force', 'plumber', 'poop', 'suction', 'toilet'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa0.png',
  },
  {
    emoji: '🚿',
    name: 'shower',
    shortcodes: ['shower'],
    tags: ['water'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bf.png',
  },
  {
    emoji: '🛁',
    name: 'bathtub',
    shortcodes: ['bathtub'],
    tags: ['bath'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c1.png',
  },
  {
    emoji: '🪤',
    name: 'mouse_trap',
    shortcodes: ['mouse_trap'],
    tags: ['bait', 'cheese', 'lure', 'mouse', 'mousetrap', 'snare', 'trap'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa4.png',
  },
  {
    emoji: '🪒',
    name: 'razor',
    shortcodes: ['razor'],
    tags: ['sharp', 'shave'],
    group: 'objects',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fa92.png',
  },
  {
    emoji: '🧴',
    name: 'lotion_bottle',
    shortcodes: ['lotion_bottle'],
    tags: ['bottle', 'lotion', 'moisturizer', 'shampoo', 'sunscreen'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f4.png',
  },
  {
    emoji: '🧷',
    name: 'safety_pin',
    shortcodes: ['safety_pin'],
    tags: ['diaper', 'pin', 'punk', 'rock', 'safety'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f7.png',
  },
  {
    emoji: '🧹',
    name: 'broom',
    shortcodes: ['broom'],
    tags: ['cleaning', 'sweeping', 'witch'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9f9.png',
  },
  {
    emoji: '🧺',
    name: 'basket',
    shortcodes: ['basket'],
    tags: ['farming', 'laundry', 'picnic'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fa.png',
  },
  {
    emoji: '🧻',
    name: 'roll_of_paper',
    shortcodes: ['roll_of_paper', 'toilet_paper'],
    tags: ['paper', 'roll', 'toilet', 'towels'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fb.png',
  },
  {
    emoji: '🪣',
    name: 'bucket',
    shortcodes: ['bucket'],
    tags: ['cask', 'pail', 'vat'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa3.png',
  },
  {
    emoji: '🧼',
    name: 'soap',
    shortcodes: ['soap'],
    tags: ['bar', 'bathing', 'clean', 'cleaning', 'lather', 'soapdish'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fc.png',
  },
  {
    emoji: '🫧',
    name: 'bubbles',
    shortcodes: ['bubbles'],
    tags: ['bubble', 'burp', 'clean', 'floating', 'pearl', 'soap', 'underwater'],
    group: 'objects',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae7.png',
  },
  {
    emoji: '🪥',
    name: 'toothbrush',
    shortcodes: ['toothbrush'],
    tags: ['bathroom', 'brush', 'clean', 'dental', 'hygiene', 'teeth', 'toiletry'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa5.png',
  },
  {
    emoji: '🧽',
    name: 'sponge',
    shortcodes: ['sponge'],
    tags: ['absorbing', 'cleaning', 'porous', 'soak'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9fd.png',
  },
  {
    emoji: '🧯',
    name: 'fire_extinguisher',
    shortcodes: ['fire_extinguisher'],
    tags: ['extinguish', 'extinguisher', 'fire', 'quench'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ef.png',
  },
  {
    emoji: '🛒',
    name: 'shopping_cart',
    shortcodes: ['shopping_cart'],
    tags: ['cart', 'shopping', 'trolley'],
    group: 'objects',
    emoticons: [],
    version: 3,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d2.png',
  },
  {
    emoji: '🚬',
    name: 'smoking',
    shortcodes: ['cigarette', 'smoking'],
    tags: ['smoking'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ac.png',
  },
  {
    emoji: '⚰',
    name: 'coffin',
    shortcodes: ['coffin'],
    tags: ['dead', 'death', 'vampire'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26b0-fe0f.png',
  },
  {
    emoji: '🪦',
    name: 'headstone',
    shortcodes: ['headstone'],
    tags: ['cemetery', 'dead', 'grave', 'graveyard', 'memorial', 'rip', 'tomb', 'tombstone'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa6.png',
  },
  {
    emoji: '⚱',
    name: 'funeral_urn',
    shortcodes: ['funeral_urn'],
    tags: ['ashes', 'death', 'funeral', 'urn'],
    group: 'objects',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26b1-fe0f.png',
  },
  {
    emoji: '🧿',
    name: 'nazar_amulet',
    shortcodes: ['nazar_amulet'],
    tags: ['amulet', 'bead', 'blue', 'charm', 'evil-eye', 'nazar', 'talisman'],
    group: 'objects',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9ff.png',
  },
  {
    emoji: '🪬',
    name: 'hamsa',
    shortcodes: ['hamsa'],
    tags: [
      'amulet',
      'fatima',
      'fortune',
      'guide',
      'hand',
      'mary',
      'miriam',
      'palm',
      'protect',
      'protection',
    ],
    group: 'objects',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faac.png',
  },
  {
    emoji: '🗿',
    name: 'moyai',
    shortcodes: ['moai', 'moyai'],
    tags: ['face', 'moyai', 'statue', 'stoneface', 'travel'],
    group: 'objects',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f5ff.png',
  },
  {
    emoji: '🪧',
    name: 'placard',
    shortcodes: ['placard'],
    tags: ['card', 'demonstration', 'notice', 'picket', 'plaque', 'protest', 'sign'],
    group: 'objects',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faa7.png',
  },
  {
    emoji: '🪪',
    name: 'identification_card',
    shortcodes: ['id_card'],
    tags: ['card', 'credentials', 'document', 'id', 'identification', 'license', 'security'],
    group: 'objects',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faaa.png',
  },
  {
    emoji: '🏧',
    name: 'atm',
    shortcodes: ['atm'],
    tags: ['atm', 'automated', 'bank', 'cash', 'money', 'sign', 'teller'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3e7.png',
  },
  {
    emoji: '🚮',
    name: 'put_litter_in_its_place',
    shortcodes: ['litter_bin', 'put_litter_in_its_place'],
    tags: ['bin', 'litter', 'litterbin', 'sign'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ae.png',
  },
  {
    emoji: '🚰',
    name: 'potable_water',
    shortcodes: ['potable_water'],
    tags: ['drinking', 'potable', 'water'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b0.png',
  },
  {
    emoji: '♿',
    name: 'wheelchair',
    shortcodes: ['handicapped', 'wheelchair'],
    tags: ['access', 'handicap', 'symbol', 'wheelchair'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/267f.png',
  },
  {
    emoji: '🚹',
    name: 'mens',
    shortcodes: ['mens'],
    tags: ['bathroom', 'lavatory', 'man', 'men’s', 'restroom', 'room', 'toilet', 'wc'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b9.png',
  },
  {
    emoji: '🚺',
    name: 'womens',
    shortcodes: ['womens'],
    tags: ['bathroom', 'lavatory', 'restroom', 'room', 'toilet', 'wc', 'woman', 'women’s'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ba.png',
  },
  {
    emoji: '🚻',
    name: 'restroom',
    shortcodes: ['bathroom', 'restroom'],
    tags: ['bathroom', 'lavatory', 'toilet', 'wc'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bb.png',
  },
  {
    emoji: '🚼',
    name: 'baby_symbol',
    shortcodes: ['baby_symbol'],
    tags: ['baby', 'changing', 'symbol'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6bc.png',
  },
  {
    emoji: '🚾',
    name: 'wc',
    shortcodes: ['water_closet', 'wc'],
    tags: ['bathroom', 'closet', 'lavatory', 'restroom', 'toilet', 'water', 'wc'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6be.png',
  },
  {
    emoji: '🛂',
    name: 'passport_control',
    shortcodes: ['passport_control'],
    tags: ['control', 'passport'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c2.png',
  },
  {
    emoji: '🛃',
    name: 'customs',
    shortcodes: ['customs'],
    tags: ['packing'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c3.png',
  },
  {
    emoji: '🛄',
    name: 'baggage_claim',
    shortcodes: ['baggage_claim'],
    tags: [
      'arrived',
      'baggage',
      'bags',
      'case',
      'checked',
      'claim',
      'journey',
      'packing',
      'plane',
      'ready',
      'travel',
      'trip',
    ],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c4.png',
  },
  {
    emoji: '🛅',
    name: 'left_luggage',
    shortcodes: ['left_luggage'],
    tags: ['baggage', 'case', 'left', 'locker', 'luggage'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6c5.png',
  },
  {
    emoji: '⚠',
    name: 'warning',
    shortcodes: ['warning'],
    tags: ['caution'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26a0-fe0f.png',
  },
  {
    emoji: '🚸',
    name: 'children_crossing',
    shortcodes: ['children_crossing'],
    tags: ['child', 'children', 'crossing', 'pedestrian', 'traffic'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b8.png',
  },
  {
    emoji: '⛔',
    name: 'no_entry',
    shortcodes: ['no_entry'],
    tags: ['do', 'entry', 'fail', 'forbidden', 'no', 'not', 'pass', 'prohibited', 'traffic'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26d4.png',
  },
  {
    emoji: '🚫',
    name: 'no_entry_sign',
    shortcodes: ['no_entry_sign'],
    tags: ['entry', 'forbidden', 'no', 'not', 'smoke'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ab.png',
  },
  {
    emoji: '🚳',
    name: 'no_bicycles',
    shortcodes: ['no_bicycles'],
    tags: ['bicycle', 'bicycles', 'bike', 'forbidden', 'no', 'not', 'prohibited'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b3.png',
  },
  {
    emoji: '🚭',
    name: 'no_smoking',
    shortcodes: ['no_smoking'],
    tags: ['forbidden', 'no', 'not', 'prohibited', 'smoke', 'smoking'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6ad.png',
  },
  {
    emoji: '🚯',
    name: 'do_not_litter',
    shortcodes: ['do_not_litter', 'no_littering'],
    tags: ['forbidden', 'litter', 'littering', 'no', 'not', 'prohibited'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6af.png',
  },
  {
    emoji: '🚱',
    name: 'non-potable_water',
    shortcodes: ['non-potable_water'],
    tags: ['dry', 'non-drinking', 'non-potable', 'prohibited', 'water'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b1.png',
  },
  {
    emoji: '🚷',
    name: 'no_pedestrians',
    shortcodes: ['no_pedestrians'],
    tags: ['forbidden', 'no', 'not', 'pedestrian', 'pedestrians', 'prohibited'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6b7.png',
  },
  {
    emoji: '📵',
    name: 'no_mobile_phones',
    shortcodes: ['no_mobile_phones'],
    tags: [
      'cell',
      'forbidden',
      'mobile',
      'no',
      'not',
      'phone',
      'phones',
      'prohibited',
      'telephone',
    ],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f5.png',
  },
  {
    emoji: '🔞',
    name: 'underage',
    shortcodes: ['no_one_under_18', 'underage'],
    tags: [
      '18',
      'age',
      'eighteen',
      'forbidden',
      'no',
      'not',
      'one',
      'prohibited',
      'restriction',
      'underage',
    ],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51e.png',
  },
  {
    emoji: '☢',
    name: 'radioactive',
    shortcodes: ['radioactive'],
    tags: ['sign'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2622-fe0f.png',
  },
  {
    emoji: '☣',
    name: 'biohazard',
    shortcodes: ['biohazard'],
    tags: ['sign'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2623-fe0f.png',
  },
  {
    emoji: '⬆',
    name: 'arrow_up',
    shortcodes: ['arrow_up'],
    tags: ['arrow', 'cardinal', 'direction', 'north', 'up'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b06-fe0f.png',
  },
  {
    emoji: '↗',
    name: 'arrow_upper_right',
    shortcodes: ['arrow_upper_right'],
    tags: ['arrow', 'direction', 'intercardinal', 'northeast', 'up-right'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2197-fe0f.png',
  },
  {
    emoji: '➡',
    name: 'arrow_right',
    shortcodes: ['arrow_right'],
    tags: ['arrow', 'cardinal', 'direction', 'east', 'right'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/27a1-fe0f.png',
  },
  {
    emoji: '↘',
    name: 'arrow_lower_right',
    shortcodes: ['arrow_lower_right'],
    tags: ['arrow', 'direction', 'down-right', 'intercardinal', 'southeast'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2198-fe0f.png',
  },
  {
    emoji: '⬇',
    name: 'arrow_down',
    shortcodes: ['arrow_down'],
    tags: ['arrow', 'cardinal', 'direction', 'down', 'south'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b07-fe0f.png',
  },
  {
    emoji: '↙',
    name: 'arrow_lower_left',
    shortcodes: ['arrow_lower_left'],
    tags: ['arrow', 'direction', 'down-left', 'intercardinal', 'southwest'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2199-fe0f.png',
  },
  {
    emoji: '⬅',
    name: 'arrow_left',
    shortcodes: ['arrow_left'],
    tags: ['arrow', 'cardinal', 'direction', 'left', 'west'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b05-fe0f.png',
  },
  {
    emoji: '↖',
    name: 'arrow_upper_left',
    shortcodes: ['arrow_upper_left'],
    tags: ['arrow', 'direction', 'intercardinal', 'northwest', 'up-left'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2196-fe0f.png',
  },
  {
    emoji: '↕',
    name: 'arrow_up_down',
    shortcodes: ['arrow_up_down'],
    tags: ['arrow', 'up-down'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2195-fe0f.png',
  },
  {
    emoji: '↔',
    name: 'left_right_arrow',
    shortcodes: ['left_right_arrow'],
    tags: ['arrow', 'left-right'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2194-fe0f.png',
  },
  {
    emoji: '↩',
    name: 'leftwards_arrow_with_hook',
    shortcodes: ['arrow_left_hook', 'leftwards_arrow_with_hook'],
    tags: ['arrow', 'curving', 'left', 'right'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/21a9-fe0f.png',
  },
  {
    emoji: '↪',
    name: 'arrow_right_hook',
    shortcodes: ['arrow_right_hook', 'rightwards_arrow_with_hook'],
    tags: ['arrow', 'curving', 'left', 'right'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/21aa-fe0f.png',
  },
  {
    emoji: '⤴',
    name: 'arrow_heading_up',
    shortcodes: ['arrow_heading_up'],
    tags: ['arrow', 'curving', 'right', 'up'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2934-fe0f.png',
  },
  {
    emoji: '⤵',
    name: 'arrow_heading_down',
    shortcodes: ['arrow_heading_down'],
    tags: ['arrow', 'curving', 'down', 'right'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2935-fe0f.png',
  },
  {
    emoji: '🔃',
    name: 'arrows_clockwise',
    shortcodes: ['arrows_clockwise', 'clockwise'],
    tags: ['arrow', 'arrows', 'clockwise', 'refresh', 'reload', 'vertical'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f503.png',
  },
  {
    emoji: '🔄',
    name: 'arrows_counterclockwise',
    shortcodes: ['arrows_counterclockwise', 'counterclockwise'],
    tags: [
      'again',
      'anticlockwise',
      'arrow',
      'arrows',
      'button',
      'counterclockwise',
      'deja',
      'refresh',
      'rewindershins',
      'vu',
    ],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f504.png',
  },
  {
    emoji: '🔙',
    name: 'back',
    shortcodes: ['back'],
    tags: ['arrow', 'back'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f519.png',
  },
  {
    emoji: '🔚',
    name: 'end',
    shortcodes: ['end'],
    tags: ['arrow', 'end'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51a.png',
  },
  {
    emoji: '🔛',
    name: 'on',
    shortcodes: ['on'],
    tags: ['arrow', 'mark', 'on!'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51b.png',
  },
  {
    emoji: '🔜',
    name: 'soon',
    shortcodes: ['soon'],
    tags: ['arrow', 'brb', 'omw', 'soon'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51c.png',
  },
  {
    emoji: '🔝',
    name: 'top',
    shortcodes: ['top'],
    tags: ['arrow', 'homie', 'top', 'up'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51d.png',
  },
  {
    emoji: '🛐',
    name: 'place_of_worship',
    shortcodes: ['place_of_worship'],
    tags: ['place', 'pray', 'religion', 'worship'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6d0.png',
  },
  {
    emoji: '⚛',
    name: 'atom_symbol',
    shortcodes: ['atom', 'atom_symbol'],
    tags: ['atheist', 'atom', 'symbol'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/269b-fe0f.png',
  },
  {
    emoji: '🕉',
    name: 'om',
    shortcodes: ['om'],
    tags: ['hindu', 'religion'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f549-fe0f.png',
  },
  {
    emoji: '✡',
    name: 'star_of_david',
    shortcodes: ['star_of_david'],
    tags: ['david', 'jew', 'jewish', 'judaism', 'religion', 'star'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2721-fe0f.png',
  },
  {
    emoji: '☸',
    name: 'wheel_of_dharma',
    shortcodes: ['wheel_of_dharma'],
    tags: ['buddhist', 'dharma', 'religion', 'wheel'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2638-fe0f.png',
  },
  {
    emoji: '☯',
    name: 'yin_yang',
    shortcodes: ['yin_yang'],
    tags: ['difficult', 'lives', 'religion', 'tao', 'taoist', 'total', 'yang', 'yin', 'yinyang'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/262f-fe0f.png',
  },
  {
    emoji: '✝',
    name: 'latin_cross',
    shortcodes: ['latin_cross'],
    tags: ['christ', 'christian', 'cross', 'latin', 'religion'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/271d-fe0f.png',
  },
  {
    emoji: '☦',
    name: 'orthodox_cross',
    shortcodes: ['orthodox_cross'],
    tags: ['christian', 'cross', 'orthodox', 'religion'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2626-fe0f.png',
  },
  {
    emoji: '☪',
    name: 'star_and_crescent',
    shortcodes: ['star_and_crescent'],
    tags: ['crescent', 'islam', 'muslim', 'ramadan', 'religion', 'star'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/262a-fe0f.png',
  },
  {
    emoji: '☮',
    name: 'peace_symbol',
    shortcodes: ['peace', 'peace_symbol'],
    tags: ['healing', 'peace', 'peaceful', 'symbol'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/262e-fe0f.png',
  },
  {
    emoji: '🕎',
    name: 'menorah',
    shortcodes: ['menorah'],
    tags: ['candelabrum', 'candlestick', 'hanukkah', 'jewish', 'judaism', 'religion'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f54e.png',
  },
  {
    emoji: '🔯',
    name: 'six_pointed_star',
    shortcodes: ['six_pointed_star'],
    tags: ['dotted', 'fortune', 'jewish', 'judaism', 'six-pointed', 'star'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f52f.png',
  },
  {
    emoji: '🪯',
    name: 'khanda',
    shortcodes: ['khanda'],
    tags: ['deg', 'fateh', 'khalsa', 'religion', 'sikh', 'sikhism', 'tegh'],
    group: 'symbols',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1faaf.png',
  },
  {
    emoji: '♈',
    name: 'aries',
    shortcodes: ['aries'],
    tags: ['aries', 'horoscope', 'ram', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2648.png',
  },
  {
    emoji: '♉',
    name: 'taurus',
    shortcodes: ['taurus'],
    tags: ['bull', 'horoscope', 'ox', 'taurus', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2649.png',
  },
  {
    emoji: '♊',
    name: 'gemini',
    shortcodes: ['gemini'],
    tags: ['gemini', 'horoscope', 'twins', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264a.png',
  },
  {
    emoji: '♋',
    name: 'cancer',
    shortcodes: ['cancer'],
    tags: ['cancer', 'crab', 'horoscope', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264b.png',
  },
  {
    emoji: '♌',
    name: 'leo',
    shortcodes: ['leo'],
    tags: ['horoscope', 'leo', 'lion', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264c.png',
  },
  {
    emoji: '♍',
    name: 'virgo',
    shortcodes: ['virgo'],
    tags: ['horoscope', 'virgo', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264d.png',
  },
  {
    emoji: '♎',
    name: 'libra',
    shortcodes: ['libra'],
    tags: ['balance', 'horoscope', 'justice', 'libra', 'scales', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264e.png',
  },
  {
    emoji: '♏',
    name: 'scorpius',
    shortcodes: ['scorpius'],
    tags: ['horoscope', 'scorpio', 'scorpion', 'scorpius', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/264f.png',
  },
  {
    emoji: '♐',
    name: 'sagittarius',
    shortcodes: ['sagittarius'],
    tags: ['archer', 'horoscope', 'sagittarius', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2650.png',
  },
  {
    emoji: '♑',
    name: 'capricorn',
    shortcodes: ['capricorn'],
    tags: ['capricorn', 'goat', 'horoscope', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2651.png',
  },
  {
    emoji: '♒',
    name: 'aquarius',
    shortcodes: ['aquarius'],
    tags: ['aquarius', 'bearer', 'horoscope', 'water', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2652.png',
  },
  {
    emoji: '♓',
    name: 'pisces',
    shortcodes: ['pisces'],
    tags: ['fish', 'horoscope', 'pisces', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2653.png',
  },
  {
    emoji: '⛎',
    name: 'ophiuchus',
    shortcodes: ['ophiuchus'],
    tags: ['bearer', 'ophiuchus', 'serpent', 'snake', 'zodiac'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26ce.png',
  },
  {
    emoji: '🔀',
    name: 'twisted_rightwards_arrows',
    shortcodes: ['shuffle', 'twisted_rightwards_arrows'],
    tags: ['arrow', 'button', 'crossed', 'shuffle', 'tracks'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f500.png',
  },
  {
    emoji: '🔁',
    name: 'repeat',
    shortcodes: ['repeat'],
    tags: ['arrow', 'button', 'clockwise', 'repeat'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f501.png',
  },
  {
    emoji: '🔂',
    name: 'repeat_one',
    shortcodes: ['repeat_one'],
    tags: ['arrow', 'button', 'clockwise', 'once', 'repeat', 'single'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f502.png',
  },
  {
    emoji: '▶',
    name: 'arrow_forward',
    shortcodes: ['arrow_forward', 'play'],
    tags: ['arrow', 'button', 'play', 'right', 'triangle'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25b6-fe0f.png',
  },
  {
    emoji: '⏩',
    name: 'fast_forward',
    shortcodes: ['fast_forward'],
    tags: ['arrow', 'button', 'double', 'fast', 'fast-forward', 'forward'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23e9.png',
  },
  {
    emoji: '⏭',
    name: 'next_track_button',
    shortcodes: ['next_track'],
    tags: ['arrow', 'button', 'next', 'scene', 'track', 'triangle'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ed-fe0f.png',
  },
  {
    emoji: '⏯',
    name: 'play_or_pause_button',
    shortcodes: ['play_pause'],
    tags: ['arrow', 'button', 'pause', 'play', 'right', 'triangle'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ef-fe0f.png',
  },
  {
    emoji: '◀',
    name: 'arrow_backward',
    shortcodes: ['arrow_backward', 'reverse'],
    tags: ['arrow', 'button', 'left', 'reverse', 'triangle'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25c0-fe0f.png',
  },
  {
    emoji: '⏪',
    name: 'rewind',
    shortcodes: ['fast_reverse', 'rewind'],
    tags: ['arrow', 'button', 'double', 'fast', 'reverse', 'rewind'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ea.png',
  },
  {
    emoji: '⏮',
    name: 'previous_track_button',
    shortcodes: ['previous_track'],
    tags: ['arrow', 'button', 'last', 'previous', 'scene', 'track', 'triangle'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ee-fe0f.png',
  },
  {
    emoji: '🔼',
    name: 'arrow_up_small',
    shortcodes: ['arrow_up_small', 'up'],
    tags: ['arrow', 'button', 'red', 'up', 'upwards'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53c.png',
  },
  {
    emoji: '⏫',
    name: 'arrow_double_up',
    shortcodes: ['arrow_double_up', 'fast_up'],
    tags: ['arrow', 'button', 'double', 'fast', 'up'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23eb.png',
  },
  {
    emoji: '🔽',
    name: 'arrow_down_small',
    shortcodes: ['arrow_down_small', 'down'],
    tags: ['arrow', 'button', 'down', 'downwards', 'red'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53d.png',
  },
  {
    emoji: '⏬',
    name: 'arrow_double_down',
    shortcodes: ['arrow_double_down', 'fast_down'],
    tags: ['arrow', 'button', 'double', 'down', 'fast'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23ec.png',
  },
  {
    emoji: '⏸',
    name: 'pause_button',
    shortcodes: ['pause'],
    tags: ['bar', 'button', 'double', 'pause', 'vertical'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f8-fe0f.png',
  },
  {
    emoji: '⏹',
    name: 'stop_button',
    shortcodes: ['stop'],
    tags: ['button', 'square', 'stop'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23f9-fe0f.png',
  },
  {
    emoji: '⏺',
    name: 'record_button',
    shortcodes: ['record'],
    tags: ['button', 'circle', 'record'],
    group: 'symbols',
    emoticons: [],
    version: 0.7,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23fa-fe0f.png',
  },
  {
    emoji: '⏏',
    name: 'eject_button',
    shortcodes: ['eject'],
    tags: ['button', 'eject'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/23cf-fe0f.png',
  },
  {
    emoji: '🎦',
    name: 'cinema',
    shortcodes: ['cinema'],
    tags: ['camera', 'film', 'movie'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3a6.png',
  },
  {
    emoji: '🔅',
    name: 'low_brightness',
    shortcodes: ['dim_button', 'low_brightness'],
    tags: ['brightness', 'button', 'dim', 'low'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f505.png',
  },
  {
    emoji: '🔆',
    name: 'high_brightness',
    shortcodes: ['bright_button', 'high_brightness'],
    tags: ['bright', 'brightness', 'button', 'light'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f506.png',
  },
  {
    emoji: '📶',
    name: 'signal_strength',
    shortcodes: ['antenna_bars', 'signal_strength'],
    tags: [
      'antenna',
      'bar',
      'bars',
      'cell',
      'communication',
      'mobile',
      'phone',
      'signal',
      'telephone',
    ],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f6.png',
  },
  {
    emoji: '🛜',
    name: 'wireless',
    shortcodes: ['wireless'],
    tags: [
      'broadband',
      'computer',
      'connectivity',
      'hotspot',
      'internet',
      'network',
      'router',
      'smartphone',
      'wi-fi',
      'wifi',
      'wlan',
    ],
    group: 'symbols',
    emoticons: [],
    version: 15,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6dc.png',
  },
  {
    emoji: '📳',
    name: 'vibration_mode',
    shortcodes: ['vibration_mode'],
    tags: ['cell', 'communication', 'mobile', 'mode', 'phone', 'telephone', 'vibration'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f3.png',
  },
  {
    emoji: '📴',
    name: 'mobile_phone_off',
    shortcodes: ['mobile_phone_off'],
    tags: ['cell', 'mobile', 'off', 'phone', 'telephone'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4f4.png',
  },
  {
    emoji: '♀',
    name: 'female_sign',
    shortcodes: ['female', 'female_sign'],
    tags: ['female', 'sign', 'woman'],
    group: 'symbols',
    emoticons: [],
    version: 4,
  },
  {
    emoji: '♂',
    name: 'male_sign',
    shortcodes: ['male', 'male_sign'],
    tags: ['male', 'man', 'sign'],
    group: 'symbols',
    emoticons: [],
    version: 4,
  },
  {
    emoji: '⚧',
    name: 'transgender_symbol',
    shortcodes: ['transgender_symbol'],
    tags: ['symbol', 'transgender'],
    group: 'symbols',
    emoticons: [],
    version: 13,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26a7-fe0f.png',
  },
  {
    emoji: '✖',
    name: 'heavy_multiplication_x',
    shortcodes: ['multiplication', 'multiply'],
    tags: ['cancel', 'multiplication', 'sign', 'x', '×'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2716-fe0f.png',
  },
  {
    emoji: '➕',
    name: 'heavy_plus_sign',
    shortcodes: ['plus'],
    tags: ['+'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2795.png',
  },
  {
    emoji: '➖',
    name: 'heavy_minus_sign',
    shortcodes: ['minus'],
    tags: ['-', 'heavy', 'math', 'sign', '−'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2796.png',
  },
  {
    emoji: '➗',
    name: 'heavy_division_sign',
    shortcodes: ['divide', 'division'],
    tags: ['division', 'heavy', 'math', 'sign', '÷'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2797.png',
  },
  {
    emoji: '🟰',
    name: 'heavy_equals_sign',
    shortcodes: ['heavy_equals_sign'],
    tags: ['answer', 'equal', 'equality', 'equals', 'heavy', 'math', 'sign'],
    group: 'symbols',
    emoticons: [],
    version: 14,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7f0.png',
  },
  {
    emoji: '♾',
    name: 'infinity',
    shortcodes: ['infinity'],
    tags: ['forever', 'unbounded', 'universal'],
    group: 'symbols',
    emoticons: [],
    version: 11,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/267e-fe0f.png',
  },
  {
    emoji: '‼',
    name: 'bangbang',
    shortcodes: ['bangbang', 'double_exclamation'],
    tags: ['!', '!!', 'bangbang', 'double', 'exclamation', 'mark', 'punctuation'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/203c-fe0f.png',
  },
  {
    emoji: '⁉',
    name: 'interrobang',
    shortcodes: ['exclamation_question', 'interrobang'],
    tags: ['!', '!?', '?', 'exclamation', 'interrobang', 'mark', 'punctuation', 'question'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2049-fe0f.png',
  },
  {
    emoji: '❓',
    name: 'question',
    shortcodes: ['question'],
    tags: ['?', 'mark', 'punctuation', 'question', 'red'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2753.png',
  },
  {
    emoji: '❔',
    name: 'grey_question',
    shortcodes: ['white_question'],
    tags: ['?', 'mark', 'outlined', 'punctuation', 'question', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2754.png',
  },
  {
    emoji: '❕',
    name: 'grey_exclamation',
    shortcodes: ['white_exclamation'],
    tags: ['!', 'exclamation', 'mark', 'outlined', 'punctuation', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2755.png',
  },
  {
    emoji: '❗',
    name: 'exclamation',
    shortcodes: ['exclamation'],
    tags: ['!', 'exclamation', 'mark', 'punctuation', 'red'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2757.png',
  },
  {
    emoji: '〰',
    name: 'wavy_dash',
    shortcodes: ['wavy_dash'],
    tags: ['dash', 'punctuation', 'wavy'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/3030-fe0f.png',
  },
  {
    emoji: '💱',
    name: 'currency_exchange',
    shortcodes: ['currency_exchange'],
    tags: ['bank', 'currency', 'exchange', 'money'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b1.png',
  },
  {
    emoji: '💲',
    name: 'heavy_dollar_sign',
    shortcodes: ['heavy_dollar_sign'],
    tags: [
      'billion',
      'cash',
      'charge',
      'currency',
      'dollar',
      'heavy',
      'million',
      'money',
      'pay',
      'sign',
    ],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4b2.png',
  },
  {
    emoji: '⚕',
    name: 'medical_symbol',
    shortcodes: ['medical', 'medical_symbol'],
    tags: ['aesculapius', 'medical', 'medicine', 'staff', 'symbol'],
    group: 'symbols',
    emoticons: [],
    version: 4,
  },
  {
    emoji: '♻',
    name: 'recycle',
    shortcodes: ['recycle', 'recycling_symbol'],
    tags: ['recycle', 'recycling', 'symbol'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/267b-fe0f.png',
  },
  {
    emoji: '⚜',
    name: 'fleur_de_lis',
    shortcodes: ['fleur-de-lis'],
    tags: ['knights'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/269c-fe0f.png',
  },
  {
    emoji: '🔱',
    name: 'trident',
    shortcodes: ['trident'],
    tags: ['anchor', 'emblem', 'poseidon', 'ship', 'tool', 'trident'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f531.png',
  },
  {
    emoji: '📛',
    name: 'name_badge',
    shortcodes: ['name_badge'],
    tags: ['badge', 'name'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4db.png',
  },
  {
    emoji: '🔰',
    name: 'beginner',
    shortcodes: ['beginner'],
    tags: ['beginner', 'chevron', 'green', 'japanese', 'leaf', 'symbol', 'tool', 'yellow'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f530.png',
  },
  {
    emoji: '⭕',
    name: 'o',
    shortcodes: ['hollow_red_circle', 'red_o'],
    tags: ['circle', 'heavy', 'hollow', 'large', 'o', 'red'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b55.png',
  },
  {
    emoji: '✅',
    name: 'white_check_mark',
    shortcodes: ['check_mark_button', 'white_check_mark'],
    tags: [
      'button',
      'check',
      'checked',
      'checkmark',
      'complete',
      'completed',
      'done',
      'fixed',
      'mark',
      'tick',
      '✓',
    ],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2705.png',
  },
  {
    emoji: '☑',
    name: 'ballot_box_with_check',
    shortcodes: ['ballot_box_with_check'],
    tags: ['ballot', 'box', 'check', 'checked', 'done', 'off', 'tick', '✓'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2611-fe0f.png',
  },
  {
    emoji: '✔',
    name: 'heavy_check_mark',
    shortcodes: ['check_mark', 'heavy_check_mark'],
    tags: ['check', 'checked', 'checkmark', 'done', 'heavy', 'mark', 'tick', '✓'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2714-fe0f.png',
  },
  {
    emoji: '❌',
    name: 'x',
    shortcodes: ['cross_mark', 'x'],
    tags: ['cancel', 'cross', 'mark', 'multiplication', 'multiply', 'x', '×'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/274c.png',
  },
  {
    emoji: '❎',
    name: 'negative_squared_cross_mark',
    shortcodes: ['cross_mark_button', 'negative_squared_cross_mark'],
    tags: ['button', 'cross', 'mark', 'multiplication', 'multiply', 'square', 'x', '×'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/274e.png',
  },
  {
    emoji: '➰',
    name: 'curly_loop',
    shortcodes: ['curly_loop'],
    tags: ['curl', 'curly', 'loop'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/27b0.png',
  },
  {
    emoji: '➿',
    name: 'loop',
    shortcodes: ['double_curly_loop', 'loop'],
    tags: ['curl', 'curly', 'double', 'loop'],
    group: 'symbols',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/27bf.png',
  },
  {
    emoji: '〽',
    name: 'part_alternation_mark',
    shortcodes: ['part_alternation_mark'],
    tags: ['alternation', 'mark', 'part'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/303d-fe0f.png',
  },
  {
    emoji: '✳',
    name: 'eight_spoked_asterisk',
    shortcodes: ['eight_spoked_asterisk'],
    tags: ['*', 'asterisk', 'eight-spoked'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2733-fe0f.png',
  },
  {
    emoji: '✴',
    name: 'eight_pointed_black_star',
    shortcodes: ['eight_pointed_black_star'],
    tags: ['*', 'eight-pointed', 'star'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2734-fe0f.png',
  },
  {
    emoji: '❇',
    name: 'sparkle',
    shortcodes: ['sparkle'],
    tags: ['*'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2747-fe0f.png',
  },
  {
    emoji: '©',
    name: 'copyright',
    shortcodes: ['copyright'],
    tags: ['c'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/00a9-fe0f.png',
  },
  {
    emoji: '®',
    name: 'registered',
    shortcodes: ['registered'],
    tags: ['r'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/00ae-fe0f.png',
  },
  {
    emoji: '™',
    name: 'tm',
    shortcodes: ['tm', 'trade_mark'],
    tags: ['mark', 'tm', 'trade', 'trademark'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2122-fe0f.png',
  },
  {
    emoji: '🫟',
    name: 'splatter',
    shortcodes: ['splatter'],
    tags: ['drip', 'holi', 'ink', 'liquid', 'mess', 'paint', 'spill', 'stain'],
    group: 'symbols',
    emoticons: [],
    version: 16,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fadf.png',
  },
  {
    emoji: '#⃣',
    name: 'hash',
    shortcodes: ['hash', 'number_sign'],
    tags: ['keycap'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0023-fe0f-20e3.png',
  },
  {
    emoji: '*⃣',
    name: 'asterisk',
    shortcodes: ['asterisk'],
    tags: ['keycap'],
    group: 'symbols',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/002a-fe0f-20e3.png',
  },
  {
    emoji: '0⃣',
    name: 'zero',
    shortcodes: ['zero'],
    tags: ['0', 'keycap', 'zero'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0030-fe0f-20e3.png',
  },
  {
    emoji: '1⃣',
    name: 'one',
    shortcodes: ['one'],
    tags: ['1', 'keycap', 'one'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0031-fe0f-20e3.png',
  },
  {
    emoji: '2⃣',
    name: 'two',
    shortcodes: ['two'],
    tags: ['2', 'keycap', 'two'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0032-fe0f-20e3.png',
  },
  {
    emoji: '3⃣',
    name: 'three',
    shortcodes: ['three'],
    tags: ['3', 'keycap', 'three'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0033-fe0f-20e3.png',
  },
  {
    emoji: '4⃣',
    name: 'four',
    shortcodes: ['four'],
    tags: ['4', 'four', 'keycap'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0034-fe0f-20e3.png',
  },
  {
    emoji: '5⃣',
    name: 'five',
    shortcodes: ['five'],
    tags: ['5', 'five', 'keycap'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0035-fe0f-20e3.png',
  },
  {
    emoji: '6⃣',
    name: 'six',
    shortcodes: ['six'],
    tags: ['6', 'keycap', 'six'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0036-fe0f-20e3.png',
  },
  {
    emoji: '7⃣',
    name: 'seven',
    shortcodes: ['seven'],
    tags: ['7', 'keycap', 'seven'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0037-fe0f-20e3.png',
  },
  {
    emoji: '8⃣',
    name: 'eight',
    shortcodes: ['eight'],
    tags: ['8', 'eight', 'keycap'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0038-fe0f-20e3.png',
  },
  {
    emoji: '9⃣',
    name: 'nine',
    shortcodes: ['nine'],
    tags: ['9', 'keycap', 'nine'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/0039-fe0f-20e3.png',
  },
  {
    emoji: '🔟',
    name: 'keycap_ten',
    shortcodes: ['ten'],
    tags: ['keycap'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f51f.png',
  },
  {
    emoji: '🔠',
    name: 'capital_abcd',
    shortcodes: ['capital_abcd'],
    tags: ['abcd', 'input', 'latin', 'letters', 'uppercase'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f520.png',
  },
  {
    emoji: '🔡',
    name: 'abcd',
    shortcodes: ['abcd'],
    tags: ['abcd', 'input', 'latin', 'letters', 'lowercase'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f521.png',
  },
  {
    emoji: '🔢',
    name: '1234',
    shortcodes: ['1234'],
    tags: ['1234', 'input', 'numbers'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f522.png',
  },
  {
    emoji: '🔣',
    name: 'symbols',
    shortcodes: ['symbols'],
    tags: ['%', '&', 'input', 'symbols', '♪', '〒'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f523.png',
  },
  {
    emoji: '🔤',
    name: 'abc',
    shortcodes: ['abc'],
    tags: ['abc', 'alphabet', 'input', 'latin', 'letters'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f524.png',
  },
  {
    emoji: '🅰',
    name: 'a',
    shortcodes: ['a', 'a_blood'],
    tags: ['blood', 'button', 'type'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f170-fe0f.png',
  },
  {
    emoji: '🆎',
    name: 'ab',
    shortcodes: ['ab', 'ab_blood'],
    tags: ['ab', 'blood', 'button', 'type'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f18e.png',
  },
  {
    emoji: '🅱',
    name: 'b',
    shortcodes: ['b', 'b_blood'],
    tags: ['b', 'blood', 'button', 'type'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f171-fe0f.png',
  },
  {
    emoji: '🆑',
    name: 'cl',
    shortcodes: ['cl'],
    tags: ['button', 'cl'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f191.png',
  },
  {
    emoji: '🆒',
    name: 'cool',
    shortcodes: ['cool'],
    tags: ['button', 'cool'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f192.png',
  },
  {
    emoji: '🆓',
    name: 'free',
    shortcodes: ['free'],
    tags: ['button', 'free'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f193.png',
  },
  {
    emoji: 'ℹ',
    name: 'information_source',
    shortcodes: ['info', 'information_source'],
    tags: ['i'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2139-fe0f.png',
  },
  {
    emoji: '🆔',
    name: 'id',
    shortcodes: ['id'],
    tags: ['button', 'id', 'identity'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f194.png',
  },
  {
    emoji: 'Ⓜ',
    name: 'm',
    shortcodes: ['m'],
    tags: ['circle', 'circled', 'm'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/24c2-fe0f.png',
  },
  {
    emoji: '🆕',
    name: 'new',
    shortcodes: ['new'],
    tags: ['button', 'new'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f195.png',
  },
  {
    emoji: '🆖',
    name: 'ng',
    shortcodes: ['ng'],
    tags: ['button', 'ng'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f196.png',
  },
  {
    emoji: '🅾',
    name: 'o2',
    shortcodes: ['o', 'o_blood'],
    tags: ['blood', 'button', 'o', 'type'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f17e-fe0f.png',
  },
  {
    emoji: '🆗',
    name: 'ok',
    shortcodes: ['ok'],
    tags: ['button', 'ok', 'okay'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f197.png',
  },
  {
    emoji: '🅿',
    name: 'parking',
    shortcodes: ['parking'],
    tags: ['button', 'p', 'parking'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f17f-fe0f.png',
  },
  {
    emoji: '🆘',
    name: 'sos',
    shortcodes: ['sos'],
    tags: ['button', 'help', 'sos'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f198.png',
  },
  {
    emoji: '🆙',
    name: 'up',
    shortcodes: ['up2'],
    tags: ['button', 'mark', 'up', 'up!'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f199.png',
  },
  {
    emoji: '🆚',
    name: 'vs',
    shortcodes: ['vs'],
    tags: ['button', 'versus', 'vs'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f19a.png',
  },
  {
    emoji: '🈁',
    name: 'koko',
    shortcodes: ['ja_here', 'koko'],
    tags: ['button', 'here', 'japanese', 'katakana'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f201.png',
  },
  {
    emoji: '🈂',
    name: 'sa',
    shortcodes: ['ja_service_charge'],
    tags: ['button', 'charge', 'japanese', 'katakana', 'service'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f202-fe0f.png',
  },
  {
    emoji: '🈷',
    name: 'u6708',
    shortcodes: ['ja_monthly_amount'],
    tags: ['amount', 'button', 'ideograph', 'japanese', 'monthly'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f237-fe0f.png',
  },
  {
    emoji: '🈶',
    name: 'u6709',
    shortcodes: ['ja_not_free_of_carge'],
    tags: ['button', 'charge', 'free', 'ideograph', 'japanese', 'not'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f236.png',
  },
  {
    emoji: '🈯',
    name: 'u6307',
    shortcodes: ['ja_reserved'],
    tags: ['button', 'ideograph', 'japanese', 'reserved'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f22f.png',
  },
  {
    emoji: '🉐',
    name: 'ideograph_advantage',
    shortcodes: ['ideograph_advantage', 'ja_bargain'],
    tags: ['bargain', 'button', 'ideograph', 'japanese'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f250.png',
  },
  {
    emoji: '🈹',
    name: 'u5272',
    shortcodes: ['ja_discount'],
    tags: ['button', 'discount', 'ideograph', 'japanese'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f239.png',
  },
  {
    emoji: '🈚',
    name: 'u7121',
    shortcodes: ['ja_free_of_charge'],
    tags: ['button', 'charge', 'free', 'ideograph', 'japanese'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f21a.png',
  },
  {
    emoji: '🈲',
    name: 'u7981',
    shortcodes: ['ja_prohibited'],
    tags: ['button', 'ideograph', 'japanese', 'prohibited'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f232.png',
  },
  {
    emoji: '🉑',
    name: 'accept',
    shortcodes: ['accept', 'ja_acceptable'],
    tags: ['acceptable', 'button', 'ideograph', 'japanese'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f251.png',
  },
  {
    emoji: '🈸',
    name: 'u7533',
    shortcodes: ['ja_application'],
    tags: ['application', 'button', 'ideograph', 'japanese'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f238.png',
  },
  {
    emoji: '🈴',
    name: 'u5408',
    shortcodes: ['ja_passing_grade'],
    tags: ['button', 'grade', 'ideograph', 'japanese', 'passing'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f234.png',
  },
  {
    emoji: '🈳',
    name: 'u7a7a',
    shortcodes: ['ja_vacancy'],
    tags: ['button', 'ideograph', 'japanese', 'vacancy'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f233.png',
  },
  {
    emoji: '㊗',
    name: 'congratulations',
    shortcodes: ['congratulations', 'ja_congratulations'],
    tags: ['button', 'congratulations', 'ideograph', 'japanese'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/3297-fe0f.png',
  },
  {
    emoji: '㊙',
    name: 'secret',
    shortcodes: ['ja_secret', 'secret'],
    tags: ['button', 'ideograph', 'japanese', 'secret'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/3299-fe0f.png',
  },
  {
    emoji: '🈺',
    name: 'u55b6',
    shortcodes: ['ja_open_for_business'],
    tags: ['business', 'button', 'ideograph', 'japanese', 'open'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f23a.png',
  },
  {
    emoji: '🈵',
    name: 'u6e80',
    shortcodes: ['ja_no_vacancy'],
    tags: ['button', 'ideograph', 'japanese', 'no', 'vacancy'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f235.png',
  },
  {
    emoji: '🔴',
    name: 'red_circle',
    shortcodes: ['red_circle'],
    tags: ['circle', 'geometric', 'red'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f534.png',
  },
  {
    emoji: '🟠',
    name: 'orange_circle',
    shortcodes: ['orange_circle'],
    tags: ['circle', 'orange'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e0.png',
  },
  {
    emoji: '🟡',
    name: 'yellow_circle',
    shortcodes: ['yellow_circle'],
    tags: ['circle', 'yellow'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e1.png',
  },
  {
    emoji: '🟢',
    name: 'green_circle',
    shortcodes: ['green_circle'],
    tags: ['circle', 'green'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e2.png',
  },
  {
    emoji: '🔵',
    name: 'large_blue_circle',
    shortcodes: ['blue_circle'],
    tags: ['blue', 'circle', 'geometric'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f535.png',
  },
  {
    emoji: '🟣',
    name: 'purple_circle',
    shortcodes: ['purple_circle'],
    tags: ['circle', 'purple'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e3.png',
  },
  {
    emoji: '🟤',
    name: 'brown_circle',
    shortcodes: ['brown_circle'],
    tags: ['brown', 'circle'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e4.png',
  },
  {
    emoji: '⚫',
    name: 'black_circle',
    shortcodes: ['black_circle'],
    tags: ['black', 'circle', 'geometric'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26ab.png',
  },
  {
    emoji: '⚪',
    name: 'white_circle',
    shortcodes: ['white_circle'],
    tags: ['circle', 'geometric', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/26aa.png',
  },
  {
    emoji: '🟥',
    name: 'red_square',
    shortcodes: ['red_square'],
    tags: ['card', 'penalty', 'red', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e5.png',
  },
  {
    emoji: '🟧',
    name: 'orange_square',
    shortcodes: ['orange_square'],
    tags: ['orange', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e7.png',
  },
  {
    emoji: '🟨',
    name: 'yellow_square',
    shortcodes: ['yellow_square'],
    tags: ['card', 'penalty', 'square', 'yellow'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e8.png',
  },
  {
    emoji: '🟩',
    name: 'green_square',
    shortcodes: ['green_square'],
    tags: ['green', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e9.png',
  },
  {
    emoji: '🟦',
    name: 'blue_square',
    shortcodes: ['blue_square'],
    tags: ['blue', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7e6.png',
  },
  {
    emoji: '🟪',
    name: 'purple_square',
    shortcodes: ['purple_square'],
    tags: ['purple', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7ea.png',
  },
  {
    emoji: '🟫',
    name: 'brown_square',
    shortcodes: ['brown_square'],
    tags: ['brown', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 12,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f7eb.png',
  },
  {
    emoji: '⬛',
    name: 'black_large_square',
    shortcodes: ['black_large_square'],
    tags: ['black', 'geometric', 'large', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b1b.png',
  },
  {
    emoji: '⬜',
    name: 'white_large_square',
    shortcodes: ['white_large_square'],
    tags: ['geometric', 'large', 'square', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/2b1c.png',
  },
  {
    emoji: '◼',
    name: 'black_medium_square',
    shortcodes: ['black_medium_square'],
    tags: ['black', 'geometric', 'medium', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fc-fe0f.png',
  },
  {
    emoji: '◻',
    name: 'white_medium_square',
    shortcodes: ['white_medium_square'],
    tags: ['geometric', 'medium', 'square', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fb-fe0f.png',
  },
  {
    emoji: '◾',
    name: 'black_medium_small_square',
    shortcodes: ['black_medium_small_square'],
    tags: ['black', 'geometric', 'medium-small', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fe.png',
  },
  {
    emoji: '◽',
    name: 'white_medium_small_square',
    shortcodes: ['white_medium_small_square'],
    tags: ['geometric', 'medium-small', 'square', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25fd.png',
  },
  {
    emoji: '▪',
    name: 'black_small_square',
    shortcodes: ['black_small_square'],
    tags: ['black', 'geometric', 'small', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25aa-fe0f.png',
  },
  {
    emoji: '▫',
    name: 'white_small_square',
    shortcodes: ['white_small_square'],
    tags: ['geometric', 'small', 'square', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/25ab-fe0f.png',
  },
  {
    emoji: '🔶',
    name: 'large_orange_diamond',
    shortcodes: ['large_orange_diamond'],
    tags: ['diamond', 'geometric', 'large', 'orange'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f536.png',
  },
  {
    emoji: '🔷',
    name: 'large_blue_diamond',
    shortcodes: ['large_blue_diamond'],
    tags: ['blue', 'diamond', 'geometric', 'large'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f537.png',
  },
  {
    emoji: '🔸',
    name: 'small_orange_diamond',
    shortcodes: ['small_orange_diamond'],
    tags: ['diamond', 'geometric', 'orange', 'small'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f538.png',
  },
  {
    emoji: '🔹',
    name: 'small_blue_diamond',
    shortcodes: ['small_blue_diamond'],
    tags: ['blue', 'diamond', 'geometric', 'small'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f539.png',
  },
  {
    emoji: '🔺',
    name: 'small_red_triangle',
    shortcodes: ['small_red_triangle'],
    tags: ['geometric', 'pointed', 'red', 'triangle', 'up'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53a.png',
  },
  {
    emoji: '🔻',
    name: 'small_red_triangle_down',
    shortcodes: ['small_red_triangle_down'],
    tags: ['down', 'geometric', 'pointed', 'red', 'triangle'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f53b.png',
  },
  {
    emoji: '💠',
    name: 'diamond_shape_with_a_dot_inside',
    shortcodes: ['diamond_shape_with_a_dot_inside', 'diamond_with_a_dot'],
    tags: ['comic', 'diamond', 'dot', 'geometric'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a0.png',
  },
  {
    emoji: '🔘',
    name: 'radio_button',
    shortcodes: ['radio_button'],
    tags: ['button', 'geometric', 'radio'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f518.png',
  },
  {
    emoji: '🔳',
    name: 'white_square_button',
    shortcodes: ['white_square_button'],
    tags: ['button', 'geometric', 'outlined', 'square', 'white'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f533.png',
  },
  {
    emoji: '🔲',
    name: 'black_square_button',
    shortcodes: ['black_square_button'],
    tags: ['black', 'button', 'geometric', 'square'],
    group: 'symbols',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f532.png',
  },
  {
    emoji: '🏁',
    name: 'checkered_flag',
    shortcodes: ['checkered_flag'],
    tags: [
      'checkered',
      'chequered',
      'finish',
      'flag',
      'flags',
      'game',
      'race',
      'racing',
      'sport',
      'win',
    ],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3c1.png',
  },
  {
    emoji: '🚩',
    name: 'triangular_flag_on_post',
    shortcodes: ['triangular_flag', 'triangular_flag_on_post'],
    tags: ['construction', 'flag', 'golf', 'post', 'triangular'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f6a9.png',
  },
  {
    emoji: '🎌',
    name: 'crossed_flags',
    shortcodes: ['crossed_flags'],
    tags: ['celebration', 'cross', 'crossed', 'flags', 'japanese'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f38c.png',
  },
  {
    emoji: '🏴',
    name: 'black_flag',
    shortcodes: ['black_flag'],
    tags: ['black', 'flag', 'waving'],
    group: 'flags',
    emoticons: [],
    version: 1,
    fallbackImage: 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4.png',
  },
  {
    emoji: '🏳',
    name: 'white_flag',
    shortcodes: ['white_flag'],
    tags: ['flag', 'waving', 'white'],
    group: 'flags',
    emoticons: [],
    version: 0.7,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f3-fe0f.png',
  },
  {
    emoji: '🏳‍🌈',
    name: 'rainbow_flag',
    shortcodes: ['rainbow_flag'],
    tags: [
      'bisexual',
      'flag',
      'gay',
      'genderqueer',
      'glbt',
      'glbtq',
      'lesbian',
      'lgbt',
      'lgbtq',
      'lgbtqia',
      'pride',
      'queer',
      'rainbow',
      'trans',
      'transgender',
    ],
    group: 'flags',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f3-fe0f-200d-1f308.png',
  },
  {
    emoji: '🏳‍⚧️',
    name: 'transgender_flag',
    shortcodes: ['transgender_flag'],
    tags: ['blue', 'flag', 'light', 'pink', 'transgender', 'white'],
    group: 'flags',
    emoticons: [],
    version: 13,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f3-fe0f-200d-26a7-fe0f.png',
  },
  {
    emoji: '🏴‍☠',
    name: 'pirate_flag',
    shortcodes: ['jolly_roger', 'pirate_flag'],
    tags: ['flag', 'jolly', 'pirate', 'plunder', 'roger', 'treasure'],
    group: 'flags',
    emoticons: [],
    version: 11,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-200d-2620-fe0f.png',
  },
  {
    emoji: '🇦🇨',
    name: 'ascension_island',
    shortcodes: ['ascension_island', 'flag_ac'],
    tags: ['AC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1e8.png',
  },
  {
    emoji: '🇦🇩',
    name: 'andorra',
    shortcodes: ['andorra', 'flag_ad'],
    tags: ['AD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1e9.png',
  },
  {
    emoji: '🇦🇪',
    name: 'united_arab_emirates',
    shortcodes: ['flag_ae', 'united_arab_emirates'],
    tags: ['AE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ea.png',
  },
  {
    emoji: '🇦🇫',
    name: 'afghanistan',
    shortcodes: ['afghanistan', 'flag_af'],
    tags: ['AF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1eb.png',
  },
  {
    emoji: '🇦🇬',
    name: 'antigua_barbuda',
    shortcodes: ['antigua_barbuda', 'flag_ag'],
    tags: ['AG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ec.png',
  },
  {
    emoji: '🇦🇮',
    name: 'anguilla',
    shortcodes: ['anguilla', 'flag_ai'],
    tags: ['AI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ee.png',
  },
  {
    emoji: '🇦🇱',
    name: 'albania',
    shortcodes: ['albania', 'flag_al'],
    tags: ['AL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f1.png',
  },
  {
    emoji: '🇦🇲',
    name: 'armenia',
    shortcodes: ['armenia', 'flag_am'],
    tags: ['AM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f2.png',
  },
  {
    emoji: '🇦🇴',
    name: 'angola',
    shortcodes: ['angola', 'flag_ao'],
    tags: ['AO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f4.png',
  },
  {
    emoji: '🇦🇶',
    name: 'antarctica',
    shortcodes: ['antarctica', 'flag_aq'],
    tags: ['AQ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f6.png',
  },
  {
    emoji: '🇦🇷',
    name: 'argentina',
    shortcodes: ['argentina', 'flag_ar'],
    tags: ['AR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f7.png',
  },
  {
    emoji: '🇦🇸',
    name: 'american_samoa',
    shortcodes: ['american_samoa', 'flag_as'],
    tags: ['AS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f8.png',
  },
  {
    emoji: '🇦🇹',
    name: 'austria',
    shortcodes: ['austria', 'flag_at'],
    tags: ['AT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1f9.png',
  },
  {
    emoji: '🇦🇺',
    name: 'australia',
    shortcodes: ['australia', 'flag_au'],
    tags: ['AU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1fa.png',
  },
  {
    emoji: '🇦🇼',
    name: 'aruba',
    shortcodes: ['aruba', 'flag_aw'],
    tags: ['AW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1fc.png',
  },
  {
    emoji: '🇦🇽',
    name: 'aland_islands',
    shortcodes: ['aland_islands', 'flag_ax'],
    tags: ['AX', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1fd.png',
  },
  {
    emoji: '🇦🇿',
    name: 'azerbaijan',
    shortcodes: ['azerbaijan', 'flag_az'],
    tags: ['AZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e6-1f1ff.png',
  },
  {
    emoji: '🇧🇦',
    name: 'bosnia_herzegovina',
    shortcodes: ['bosnia_herzegovina', 'flag_ba'],
    tags: ['BA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1e6.png',
  },
  {
    emoji: '🇧🇧',
    name: 'barbados',
    shortcodes: ['barbados', 'flag_bb'],
    tags: ['BB', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1e7.png',
  },
  {
    emoji: '🇧🇩',
    name: 'bangladesh',
    shortcodes: ['bangladesh', 'flag_bd'],
    tags: ['BD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1e9.png',
  },
  {
    emoji: '🇧🇪',
    name: 'belgium',
    shortcodes: ['belgium', 'flag_be'],
    tags: ['BE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ea.png',
  },
  {
    emoji: '🇧🇫',
    name: 'burkina_faso',
    shortcodes: ['burkina_faso', 'flag_bf'],
    tags: ['BF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1eb.png',
  },
  {
    emoji: '🇧🇬',
    name: 'bulgaria',
    shortcodes: ['bulgaria', 'flag_bg'],
    tags: ['BG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ec.png',
  },
  {
    emoji: '🇧🇭',
    name: 'bahrain',
    shortcodes: ['bahrain', 'flag_bh'],
    tags: ['BH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ed.png',
  },
  {
    emoji: '🇧🇮',
    name: 'burundi',
    shortcodes: ['burundi', 'flag_bi'],
    tags: ['BI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ee.png',
  },
  {
    emoji: '🇧🇯',
    name: 'benin',
    shortcodes: ['benin', 'flag_bj'],
    tags: ['BJ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ef.png',
  },
  {
    emoji: '🇧🇱',
    name: 'st_barthelemy',
    shortcodes: ['flag_bl', 'st_barthelemy'],
    tags: ['BL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f1.png',
  },
  {
    emoji: '🇧🇲',
    name: 'bermuda',
    shortcodes: ['bermuda', 'flag_bm'],
    tags: ['BM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f2.png',
  },
  {
    emoji: '🇧🇳',
    name: 'brunei',
    shortcodes: ['brunei', 'flag_bn'],
    tags: ['BN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f3.png',
  },
  {
    emoji: '🇧🇴',
    name: 'bolivia',
    shortcodes: ['bolivia', 'flag_bo'],
    tags: ['BO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f4.png',
  },
  {
    emoji: '🇧🇶',
    name: 'caribbean_netherlands',
    shortcodes: ['caribbean_netherlands', 'flag_bq'],
    tags: ['BQ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f6.png',
  },
  {
    emoji: '🇧🇷',
    name: 'brazil',
    shortcodes: ['brazil', 'flag_br'],
    tags: ['BR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f7.png',
  },
  {
    emoji: '🇧🇸',
    name: 'bahamas',
    shortcodes: ['bahamas', 'flag_bs'],
    tags: ['BS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f8.png',
  },
  {
    emoji: '🇧🇹',
    name: 'bhutan',
    shortcodes: ['bhutan', 'flag_bt'],
    tags: ['BT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1f9.png',
  },
  {
    emoji: '🇧🇻',
    name: 'bouvet_island',
    shortcodes: ['bouvet_island', 'flag_bv'],
    tags: ['BV', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1fb.png',
  },
  {
    emoji: '🇧🇼',
    name: 'botswana',
    shortcodes: ['botswana', 'flag_bw'],
    tags: ['BW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1fc.png',
  },
  {
    emoji: '🇧🇾',
    name: 'belarus',
    shortcodes: ['belarus', 'flag_by'],
    tags: ['BY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1fe.png',
  },
  {
    emoji: '🇧🇿',
    name: 'belize',
    shortcodes: ['belize', 'flag_bz'],
    tags: ['BZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e7-1f1ff.png',
  },
  {
    emoji: '🇨🇦',
    name: 'canada',
    shortcodes: ['canada', 'flag_ca'],
    tags: ['CA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1e6.png',
  },
  {
    emoji: '🇨🇨',
    name: 'cocos_islands',
    shortcodes: ['cocos_islands', 'flag_cc'],
    tags: ['CC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1e8.png',
  },
  {
    emoji: '🇨🇩',
    name: 'congo_kinshasa',
    shortcodes: ['congo_kinshasa', 'flag_cd'],
    tags: ['CD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1e9.png',
  },
  {
    emoji: '🇨🇫',
    name: 'central_african_republic',
    shortcodes: ['central_african_republic', 'flag_cf'],
    tags: ['CF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1eb.png',
  },
  {
    emoji: '🇨🇬',
    name: 'congo_brazzaville',
    shortcodes: ['congo_brazzaville', 'flag_cg'],
    tags: ['CG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ec.png',
  },
  {
    emoji: '🇨🇭',
    name: 'switzerland',
    shortcodes: ['flag_ch', 'switzerland'],
    tags: ['CH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ed.png',
  },
  {
    emoji: '🇨🇮',
    name: 'cote_divoire',
    shortcodes: ['cote_divoire', 'flag_ci'],
    tags: ['CI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ee.png',
  },
  {
    emoji: '🇨🇰',
    name: 'cook_islands',
    shortcodes: ['cook_islands', 'flag_ck'],
    tags: ['CK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f0.png',
  },
  {
    emoji: '🇨🇱',
    name: 'chile',
    shortcodes: ['chile', 'flag_cl'],
    tags: ['CL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f1.png',
  },
  {
    emoji: '🇨🇲',
    name: 'cameroon',
    shortcodes: ['cameroon', 'flag_cm'],
    tags: ['CM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f2.png',
  },
  {
    emoji: '🇨🇳',
    name: 'cn',
    shortcodes: ['china', 'flag_cn'],
    tags: ['CN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f3.png',
  },
  {
    emoji: '🇨🇴',
    name: 'colombia',
    shortcodes: ['colombia', 'flag_co'],
    tags: ['CO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f4.png',
  },
  {
    emoji: '🇨🇵',
    name: 'clipperton_island',
    shortcodes: ['clipperton_island', 'flag_cp'],
    tags: ['CP', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f5.png',
  },
  {
    emoji: '🇨🇶',
    name: 'flag_cq',
    shortcodes: ['flag_cq', 'sark'],
    tags: ['CQ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 16,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f6.png',
  },
  {
    emoji: '🇨🇷',
    name: 'costa_rica',
    shortcodes: ['costa_rica', 'flag_cr'],
    tags: ['CR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1f7.png',
  },
  {
    emoji: '🇨🇺',
    name: 'cuba',
    shortcodes: ['cuba', 'flag_cu'],
    tags: ['CU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fa.png',
  },
  {
    emoji: '🇨🇻',
    name: 'cape_verde',
    shortcodes: ['cape_verde', 'flag_cv'],
    tags: ['CV', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fb.png',
  },
  {
    emoji: '🇨🇼',
    name: 'curacao',
    shortcodes: ['curacao', 'flag_cw'],
    tags: ['CW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fc.png',
  },
  {
    emoji: '🇨🇽',
    name: 'christmas_island',
    shortcodes: ['christmas_island', 'flag_cx'],
    tags: ['CX', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fd.png',
  },
  {
    emoji: '🇨🇾',
    name: 'cyprus',
    shortcodes: ['cyprus', 'flag_cy'],
    tags: ['CY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1fe.png',
  },
  {
    emoji: '🇨🇿',
    name: 'czech_republic',
    shortcodes: ['czech_republic', 'czechia', 'flag_cz'],
    tags: ['CZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e8-1f1ff.png',
  },
  {
    emoji: '🇩🇪',
    name: 'de',
    shortcodes: ['flag_de', 'germany'],
    tags: ['DE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ea.png',
  },
  {
    emoji: '🇩🇬',
    name: 'diego_garcia',
    shortcodes: ['diego_garcia', 'flag_dg'],
    tags: ['DG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ec.png',
  },
  {
    emoji: '🇩🇯',
    name: 'djibouti',
    shortcodes: ['djibouti', 'flag_dj'],
    tags: ['DJ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ef.png',
  },
  {
    emoji: '🇩🇰',
    name: 'denmark',
    shortcodes: ['denmark', 'flag_dk'],
    tags: ['DK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1f0.png',
  },
  {
    emoji: '🇩🇲',
    name: 'dominica',
    shortcodes: ['dominica', 'flag_dm'],
    tags: ['DM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1f2.png',
  },
  {
    emoji: '🇩🇴',
    name: 'dominican_republic',
    shortcodes: ['dominican_republic', 'flag_do'],
    tags: ['DO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1f4.png',
  },
  {
    emoji: '🇩🇿',
    name: 'algeria',
    shortcodes: ['algeria', 'flag_dz'],
    tags: ['DZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1e9-1f1ff.png',
  },
  {
    emoji: '🇪🇦',
    name: 'ceuta_melilla',
    shortcodes: ['ceuta_melilla', 'flag_ea'],
    tags: ['EA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1e6.png',
  },
  {
    emoji: '🇪🇨',
    name: 'ecuador',
    shortcodes: ['ecuador', 'flag_ec'],
    tags: ['EC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1e8.png',
  },
  {
    emoji: '🇪🇪',
    name: 'estonia',
    shortcodes: ['estonia', 'flag_ee'],
    tags: ['EE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1ea.png',
  },
  {
    emoji: '🇪🇬',
    name: 'egypt',
    shortcodes: ['egypt', 'flag_eg'],
    tags: ['EG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1ec.png',
  },
  {
    emoji: '🇪🇭',
    name: 'western_sahara',
    shortcodes: ['flag_eh', 'western_sahara'],
    tags: ['EH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1ed.png',
  },
  {
    emoji: '🇪🇷',
    name: 'eritrea',
    shortcodes: ['eritrea', 'flag_er'],
    tags: ['ER', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1f7.png',
  },
  {
    emoji: '🇪🇸',
    name: 'es',
    shortcodes: ['flag_es', 'spain'],
    tags: ['ES', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1f8.png',
  },
  {
    emoji: '🇪🇹',
    name: 'ethiopia',
    shortcodes: ['ethiopia', 'flag_et'],
    tags: ['ET', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1f9.png',
  },
  {
    emoji: '🇪🇺',
    name: 'eu',
    shortcodes: ['european_union', 'flag_eu'],
    tags: ['EU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ea-1f1fa.png',
  },
  {
    emoji: '🇫🇮',
    name: 'finland',
    shortcodes: ['finland', 'flag_fi'],
    tags: ['FI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1ee.png',
  },
  {
    emoji: '🇫🇯',
    name: 'fiji',
    shortcodes: ['fiji', 'flag_fj'],
    tags: ['FJ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1ef.png',
  },
  {
    emoji: '🇫🇰',
    name: 'falkland_islands',
    shortcodes: ['falkland_islands', 'flag_fk'],
    tags: ['FK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f0.png',
  },
  {
    emoji: '🇫🇲',
    name: 'micronesia',
    shortcodes: ['flag_fm', 'micronesia'],
    tags: ['FM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f2.png',
  },
  {
    emoji: '🇫🇴',
    name: 'faroe_islands',
    shortcodes: ['faroe_islands', 'flag_fo'],
    tags: ['FO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f4.png',
  },
  {
    emoji: '🇫🇷',
    name: 'fr',
    shortcodes: ['flag_fr', 'france'],
    tags: ['FR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1eb-1f1f7.png',
  },
  {
    emoji: '🇬🇦',
    name: 'gabon',
    shortcodes: ['flag_ga', 'gabon'],
    tags: ['GA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1e6.png',
  },
  {
    emoji: '🇬🇧',
    name: 'gb',
    shortcodes: ['flag_gb', 'uk', 'united_kingdom'],
    tags: ['GB', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1e7.png',
  },
  {
    emoji: '🇬🇩',
    name: 'grenada',
    shortcodes: ['flag_gd', 'grenada'],
    tags: ['GD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1e9.png',
  },
  {
    emoji: '🇬🇪',
    name: 'georgia',
    shortcodes: ['flag_ge', 'georgia'],
    tags: ['GE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ea.png',
  },
  {
    emoji: '🇬🇫',
    name: 'french_guiana',
    shortcodes: ['flag_gf', 'french_guiana'],
    tags: ['GF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1eb.png',
  },
  {
    emoji: '🇬🇬',
    name: 'guernsey',
    shortcodes: ['flag_gg', 'guernsey'],
    tags: ['GG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ec.png',
  },
  {
    emoji: '🇬🇭',
    name: 'ghana',
    shortcodes: ['flag_gh', 'ghana'],
    tags: ['GH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ed.png',
  },
  {
    emoji: '🇬🇮',
    name: 'gibraltar',
    shortcodes: ['flag_gi', 'gibraltar'],
    tags: ['GI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1ee.png',
  },
  {
    emoji: '🇬🇱',
    name: 'greenland',
    shortcodes: ['flag_gl', 'greenland'],
    tags: ['GL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f1.png',
  },
  {
    emoji: '🇬🇲',
    name: 'gambia',
    shortcodes: ['flag_gm', 'gambia'],
    tags: ['GM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f2.png',
  },
  {
    emoji: '🇬🇳',
    name: 'guinea',
    shortcodes: ['flag_gn', 'guinea'],
    tags: ['GN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f3.png',
  },
  {
    emoji: '🇬🇵',
    name: 'guadeloupe',
    shortcodes: ['flag_gp', 'guadeloupe'],
    tags: ['GP', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f5.png',
  },
  {
    emoji: '🇬🇶',
    name: 'equatorial_guinea',
    shortcodes: ['equatorial_guinea', 'flag_gq'],
    tags: ['GQ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f6.png',
  },
  {
    emoji: '🇬🇷',
    name: 'greece',
    shortcodes: ['flag_gr', 'greece'],
    tags: ['GR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f7.png',
  },
  {
    emoji: '🇬🇸',
    name: 'south_georgia_south_sandwich_islands',
    shortcodes: ['flag_gs', 'south_georgia_south_sandwich_islands'],
    tags: ['GS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f8.png',
  },
  {
    emoji: '🇬🇹',
    name: 'guatemala',
    shortcodes: ['flag_gt', 'guatemala'],
    tags: ['GT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1f9.png',
  },
  {
    emoji: '🇬🇺',
    name: 'guam',
    shortcodes: ['flag_gu', 'guam'],
    tags: ['GU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1fa.png',
  },
  {
    emoji: '🇬🇼',
    name: 'guinea_bissau',
    shortcodes: ['flag_gw', 'guinea_bissau'],
    tags: ['GW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1fc.png',
  },
  {
    emoji: '🇬🇾',
    name: 'guyana',
    shortcodes: ['flag_gy', 'guyana'],
    tags: ['GY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ec-1f1fe.png',
  },
  {
    emoji: '🇭🇰',
    name: 'hong_kong',
    shortcodes: ['flag_hk', 'hong_kong'],
    tags: ['HK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f0.png',
  },
  {
    emoji: '🇭🇲',
    name: 'heard_mcdonald_islands',
    shortcodes: ['flag_hm', 'heard_mcdonald_islands'],
    tags: ['HM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f2.png',
  },
  {
    emoji: '🇭🇳',
    name: 'honduras',
    shortcodes: ['flag_hn', 'honduras'],
    tags: ['HN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f3.png',
  },
  {
    emoji: '🇭🇷',
    name: 'croatia',
    shortcodes: ['croatia', 'flag_hr'],
    tags: ['HR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f7.png',
  },
  {
    emoji: '🇭🇹',
    name: 'haiti',
    shortcodes: ['flag_ht', 'haiti'],
    tags: ['HT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1f9.png',
  },
  {
    emoji: '🇭🇺',
    name: 'hungary',
    shortcodes: ['flag_hu', 'hungary'],
    tags: ['HU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ed-1f1fa.png',
  },
  {
    emoji: '🇮🇨',
    name: 'canary_islands',
    shortcodes: ['canary_islands', 'flag_ic'],
    tags: ['IC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1e8.png',
  },
  {
    emoji: '🇮🇩',
    name: 'indonesia',
    shortcodes: ['flag_id', 'indonesia'],
    tags: ['ID', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1e9.png',
  },
  {
    emoji: '🇮🇪',
    name: 'ireland',
    shortcodes: ['flag_ie', 'ireland'],
    tags: ['IE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1ea.png',
  },
  {
    emoji: '🇮🇱',
    name: 'israel',
    shortcodes: ['flag_il', 'israel'],
    tags: ['IL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f1.png',
  },
  {
    emoji: '🇮🇲',
    name: 'isle_of_man',
    shortcodes: ['flag_im', 'isle_of_man'],
    tags: ['IM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f2.png',
  },
  {
    emoji: '🇮🇳',
    name: 'india',
    shortcodes: ['flag_in', 'india'],
    tags: ['IN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f3.png',
  },
  {
    emoji: '🇮🇴',
    name: 'british_indian_ocean_territory',
    shortcodes: ['british_indian_ocean_territory', 'flag_io'],
    tags: ['IO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f4.png',
  },
  {
    emoji: '🇮🇶',
    name: 'iraq',
    shortcodes: ['flag_iq', 'iraq'],
    tags: ['IQ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f6.png',
  },
  {
    emoji: '🇮🇷',
    name: 'iran',
    shortcodes: ['flag_ir', 'iran'],
    tags: ['IR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f7.png',
  },
  {
    emoji: '🇮🇸',
    name: 'iceland',
    shortcodes: ['flag_is', 'iceland'],
    tags: ['IS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f8.png',
  },
  {
    emoji: '🇮🇹',
    name: 'it',
    shortcodes: ['flag_it', 'italy'],
    tags: ['IT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ee-1f1f9.png',
  },
  {
    emoji: '🇯🇪',
    name: 'jersey',
    shortcodes: ['flag_je', 'jersey'],
    tags: ['JE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1ea.png',
  },
  {
    emoji: '🇯🇲',
    name: 'jamaica',
    shortcodes: ['flag_jm', 'jamaica'],
    tags: ['JM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1f2.png',
  },
  {
    emoji: '🇯🇴',
    name: 'jordan',
    shortcodes: ['flag_jo', 'jordan'],
    tags: ['JO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1f4.png',
  },
  {
    emoji: '🇯🇵',
    name: 'jp',
    shortcodes: ['flag_jp', 'japan'],
    tags: ['JP', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ef-1f1f5.png',
  },
  {
    emoji: '🇰🇪',
    name: 'kenya',
    shortcodes: ['flag_ke', 'kenya'],
    tags: ['KE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ea.png',
  },
  {
    emoji: '🇰🇬',
    name: 'kyrgyzstan',
    shortcodes: ['flag_kg', 'kyrgyzstan'],
    tags: ['KG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ec.png',
  },
  {
    emoji: '🇰🇭',
    name: 'cambodia',
    shortcodes: ['cambodia', 'flag_kh'],
    tags: ['KH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ed.png',
  },
  {
    emoji: '🇰🇮',
    name: 'kiribati',
    shortcodes: ['flag_ki', 'kiribati'],
    tags: ['KI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ee.png',
  },
  {
    emoji: '🇰🇲',
    name: 'comoros',
    shortcodes: ['comoros', 'flag_km'],
    tags: ['KM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f2.png',
  },
  {
    emoji: '🇰🇳',
    name: 'st_kitts_nevis',
    shortcodes: ['flag_kn', 'st_kitts_nevis'],
    tags: ['KN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f3.png',
  },
  {
    emoji: '🇰🇵',
    name: 'north_korea',
    shortcodes: ['flag_kp', 'north_korea'],
    tags: ['KP', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f5.png',
  },
  {
    emoji: '🇰🇷',
    name: 'kr',
    shortcodes: ['flag_kr', 'south_korea'],
    tags: ['KR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1f7.png',
  },
  {
    emoji: '🇰🇼',
    name: 'kuwait',
    shortcodes: ['flag_kw', 'kuwait'],
    tags: ['KW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1fc.png',
  },
  {
    emoji: '🇰🇾',
    name: 'cayman_islands',
    shortcodes: ['cayman_islands', 'flag_ky'],
    tags: ['KY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1fe.png',
  },
  {
    emoji: '🇰🇿',
    name: 'kazakhstan',
    shortcodes: ['flag_kz', 'kazakhstan'],
    tags: ['KZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f0-1f1ff.png',
  },
  {
    emoji: '🇱🇦',
    name: 'laos',
    shortcodes: ['flag_la', 'laos'],
    tags: ['LA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1e6.png',
  },
  {
    emoji: '🇱🇧',
    name: 'lebanon',
    shortcodes: ['flag_lb', 'lebanon'],
    tags: ['LB', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1e7.png',
  },
  {
    emoji: '🇱🇨',
    name: 'st_lucia',
    shortcodes: ['flag_lc', 'st_lucia'],
    tags: ['LC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1e8.png',
  },
  {
    emoji: '🇱🇮',
    name: 'liechtenstein',
    shortcodes: ['flag_li', 'liechtenstein'],
    tags: ['LI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1ee.png',
  },
  {
    emoji: '🇱🇰',
    name: 'sri_lanka',
    shortcodes: ['flag_lk', 'sri_lanka'],
    tags: ['LK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f0.png',
  },
  {
    emoji: '🇱🇷',
    name: 'liberia',
    shortcodes: ['flag_lr', 'liberia'],
    tags: ['LR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f7.png',
  },
  {
    emoji: '🇱🇸',
    name: 'lesotho',
    shortcodes: ['flag_ls', 'lesotho'],
    tags: ['LS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f8.png',
  },
  {
    emoji: '🇱🇹',
    name: 'lithuania',
    shortcodes: ['flag_lt', 'lithuania'],
    tags: ['LT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1f9.png',
  },
  {
    emoji: '🇱🇺',
    name: 'luxembourg',
    shortcodes: ['flag_lu', 'luxembourg'],
    tags: ['LU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1fa.png',
  },
  {
    emoji: '🇱🇻',
    name: 'latvia',
    shortcodes: ['flag_lv', 'latvia'],
    tags: ['LV', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1fb.png',
  },
  {
    emoji: '🇱🇾',
    name: 'libya',
    shortcodes: ['flag_ly', 'libya'],
    tags: ['LY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f1-1f1fe.png',
  },
  {
    emoji: '🇲🇦',
    name: 'morocco',
    shortcodes: ['flag_ma', 'morocco'],
    tags: ['MA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1e6.png',
  },
  {
    emoji: '🇲🇨',
    name: 'monaco',
    shortcodes: ['flag_mc', 'monaco'],
    tags: ['MC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1e8.png',
  },
  {
    emoji: '🇲🇩',
    name: 'moldova',
    shortcodes: ['flag_md', 'moldova'],
    tags: ['MD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1e9.png',
  },
  {
    emoji: '🇲🇪',
    name: 'montenegro',
    shortcodes: ['flag_me', 'montenegro'],
    tags: ['ME', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ea.png',
  },
  {
    emoji: '🇲🇫',
    name: 'st_martin',
    shortcodes: ['flag_mf', 'st_martin'],
    tags: ['MF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1eb.png',
  },
  {
    emoji: '🇲🇬',
    name: 'madagascar',
    shortcodes: ['flag_mg', 'madagascar'],
    tags: ['MG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ec.png',
  },
  {
    emoji: '🇲🇭',
    name: 'marshall_islands',
    shortcodes: ['flag_mh', 'marshall_islands'],
    tags: ['MH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ed.png',
  },
  {
    emoji: '🇲🇰',
    name: 'macedonia',
    shortcodes: ['flag_mk', 'macedonia'],
    tags: ['MK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f0.png',
  },
  {
    emoji: '🇲🇱',
    name: 'mali',
    shortcodes: ['flag_ml', 'mali'],
    tags: ['ML', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f1.png',
  },
  {
    emoji: '🇲🇲',
    name: 'myanmar',
    shortcodes: ['burma', 'flag_mm', 'myanmar'],
    tags: ['MM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f2.png',
  },
  {
    emoji: '🇲🇳',
    name: 'mongolia',
    shortcodes: ['flag_mn', 'mongolia'],
    tags: ['MN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f3.png',
  },
  {
    emoji: '🇲🇴',
    name: 'macau',
    shortcodes: ['flag_mo', 'macao', 'macau'],
    tags: ['MO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f4.png',
  },
  {
    emoji: '🇲🇵',
    name: 'northern_mariana_islands',
    shortcodes: ['flag_mp', 'northern_mariana_islands'],
    tags: ['MP', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f5.png',
  },
  {
    emoji: '🇲🇶',
    name: 'martinique',
    shortcodes: ['flag_mq', 'martinique'],
    tags: ['MQ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f6.png',
  },
  {
    emoji: '🇲🇷',
    name: 'mauritania',
    shortcodes: ['flag_mr', 'mauritania'],
    tags: ['MR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f7.png',
  },
  {
    emoji: '🇲🇸',
    name: 'montserrat',
    shortcodes: ['flag_ms', 'montserrat'],
    tags: ['MS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f8.png',
  },
  {
    emoji: '🇲🇹',
    name: 'malta',
    shortcodes: ['flag_mt', 'malta'],
    tags: ['MT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1f9.png',
  },
  {
    emoji: '🇲🇺',
    name: 'mauritius',
    shortcodes: ['flag_mu', 'mauritius'],
    tags: ['MU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fa.png',
  },
  {
    emoji: '🇲🇻',
    name: 'maldives',
    shortcodes: ['flag_mv', 'maldives'],
    tags: ['MV', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fb.png',
  },
  {
    emoji: '🇲🇼',
    name: 'malawi',
    shortcodes: ['flag_mw', 'malawi'],
    tags: ['MW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fc.png',
  },
  {
    emoji: '🇲🇽',
    name: 'mexico',
    shortcodes: ['flag_mx', 'mexico'],
    tags: ['MX', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fd.png',
  },
  {
    emoji: '🇲🇾',
    name: 'malaysia',
    shortcodes: ['flag_my', 'malaysia'],
    tags: ['MY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1fe.png',
  },
  {
    emoji: '🇲🇿',
    name: 'mozambique',
    shortcodes: ['flag_mz', 'mozambique'],
    tags: ['MZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f2-1f1ff.png',
  },
  {
    emoji: '🇳🇦',
    name: 'namibia',
    shortcodes: ['flag_na', 'namibia'],
    tags: ['NA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1e6.png',
  },
  {
    emoji: '🇳🇨',
    name: 'new_caledonia',
    shortcodes: ['flag_nc', 'new_caledonia'],
    tags: ['NC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1e8.png',
  },
  {
    emoji: '🇳🇪',
    name: 'niger',
    shortcodes: ['flag_ne', 'niger'],
    tags: ['NE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ea.png',
  },
  {
    emoji: '🇳🇫',
    name: 'norfolk_island',
    shortcodes: ['flag_nf', 'norfolk_island'],
    tags: ['NF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1eb.png',
  },
  {
    emoji: '🇳🇬',
    name: 'nigeria',
    shortcodes: ['flag_ng', 'nigeria'],
    tags: ['NG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ec.png',
  },
  {
    emoji: '🇳🇮',
    name: 'nicaragua',
    shortcodes: ['flag_ni', 'nicaragua'],
    tags: ['NI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ee.png',
  },
  {
    emoji: '🇳🇱',
    name: 'netherlands',
    shortcodes: ['flag_nl', 'netherlands'],
    tags: ['NL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f1.png',
  },
  {
    emoji: '🇳🇴',
    name: 'norway',
    shortcodes: ['flag_no', 'norway'],
    tags: ['NO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f4.png',
  },
  {
    emoji: '🇳🇵',
    name: 'nepal',
    shortcodes: ['flag_np', 'nepal'],
    tags: ['NP', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f5.png',
  },
  {
    emoji: '🇳🇷',
    name: 'nauru',
    shortcodes: ['flag_nr', 'nauru'],
    tags: ['NR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1f7.png',
  },
  {
    emoji: '🇳🇺',
    name: 'niue',
    shortcodes: ['flag_nu', 'niue'],
    tags: ['NU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1fa.png',
  },
  {
    emoji: '🇳🇿',
    name: 'new_zealand',
    shortcodes: ['flag_nz', 'new_zealand'],
    tags: ['NZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f3-1f1ff.png',
  },
  {
    emoji: '🇴🇲',
    name: 'oman',
    shortcodes: ['flag_om', 'oman'],
    tags: ['OM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f4-1f1f2.png',
  },
  {
    emoji: '🇵🇦',
    name: 'panama',
    shortcodes: ['flag_pa', 'panama'],
    tags: ['PA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1e6.png',
  },
  {
    emoji: '🇵🇪',
    name: 'peru',
    shortcodes: ['flag_pe', 'peru'],
    tags: ['PE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1ea.png',
  },
  {
    emoji: '🇵🇫',
    name: 'french_polynesia',
    shortcodes: ['flag_pf', 'french_polynesia'],
    tags: ['PF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1eb.png',
  },
  {
    emoji: '🇵🇬',
    name: 'papua_new_guinea',
    shortcodes: ['flag_pg', 'papua_new_guinea'],
    tags: ['PG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1ec.png',
  },
  {
    emoji: '🇵🇭',
    name: 'philippines',
    shortcodes: ['flag_ph', 'philippines'],
    tags: ['PH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1ed.png',
  },
  {
    emoji: '🇵🇰',
    name: 'pakistan',
    shortcodes: ['flag_pk', 'pakistan'],
    tags: ['PK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f0.png',
  },
  {
    emoji: '🇵🇱',
    name: 'poland',
    shortcodes: ['flag_pl', 'poland'],
    tags: ['PL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f1.png',
  },
  {
    emoji: '🇵🇲',
    name: 'st_pierre_miquelon',
    shortcodes: ['flag_pm', 'st_pierre_miquelon'],
    tags: ['PM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f2.png',
  },
  {
    emoji: '🇵🇳',
    name: 'pitcairn_islands',
    shortcodes: ['flag_pn', 'pitcairn_islands'],
    tags: ['PN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f3.png',
  },
  {
    emoji: '🇵🇷',
    name: 'puerto_rico',
    shortcodes: ['flag_pr', 'puerto_rico'],
    tags: ['PR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f7.png',
  },
  {
    emoji: '🇵🇸',
    name: 'palestinian_territories',
    shortcodes: ['flag_ps', 'palestinian_territories'],
    tags: ['PS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f8.png',
  },
  {
    emoji: '🇵🇹',
    name: 'portugal',
    shortcodes: ['flag_pt', 'portugal'],
    tags: ['PT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1f9.png',
  },
  {
    emoji: '🇵🇼',
    name: 'palau',
    shortcodes: ['flag_pw', 'palau'],
    tags: ['PW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1fc.png',
  },
  {
    emoji: '🇵🇾',
    name: 'paraguay',
    shortcodes: ['flag_py', 'paraguay'],
    tags: ['PY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f5-1f1fe.png',
  },
  {
    emoji: '🇶🇦',
    name: 'qatar',
    shortcodes: ['flag_qa', 'qatar'],
    tags: ['QA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f6-1f1e6.png',
  },
  {
    emoji: '🇷🇪',
    name: 'reunion',
    shortcodes: ['flag_re', 'reunion'],
    tags: ['RE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1ea.png',
  },
  {
    emoji: '🇷🇴',
    name: 'romania',
    shortcodes: ['flag_ro', 'romania'],
    tags: ['RO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1f4.png',
  },
  {
    emoji: '🇷🇸',
    name: 'serbia',
    shortcodes: ['flag_rs', 'serbia'],
    tags: ['RS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1f8.png',
  },
  {
    emoji: '🇷🇺',
    name: 'ru',
    shortcodes: ['flag_ru', 'russia'],
    tags: ['RU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1fa.png',
  },
  {
    emoji: '🇷🇼',
    name: 'rwanda',
    shortcodes: ['flag_rw', 'rwanda'],
    tags: ['RW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f7-1f1fc.png',
  },
  {
    emoji: '🇸🇦',
    name: 'saudi_arabia',
    shortcodes: ['flag_sa', 'saudi_arabia'],
    tags: ['SA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e6.png',
  },
  {
    emoji: '🇸🇧',
    name: 'solomon_islands',
    shortcodes: ['flag_sb', 'solomon_islands'],
    tags: ['SB', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e7.png',
  },
  {
    emoji: '🇸🇨',
    name: 'seychelles',
    shortcodes: ['flag_sc', 'seychelles'],
    tags: ['SC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e8.png',
  },
  {
    emoji: '🇸🇩',
    name: 'sudan',
    shortcodes: ['flag_sd', 'sudan'],
    tags: ['SD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1e9.png',
  },
  {
    emoji: '🇸🇪',
    name: 'sweden',
    shortcodes: ['flag_se', 'sweden'],
    tags: ['SE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ea.png',
  },
  {
    emoji: '🇸🇬',
    name: 'singapore',
    shortcodes: ['flag_sg', 'singapore'],
    tags: ['SG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ec.png',
  },
  {
    emoji: '🇸🇭',
    name: 'st_helena',
    shortcodes: ['flag_sh', 'st_helena'],
    tags: ['SH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ed.png',
  },
  {
    emoji: '🇸🇮',
    name: 'slovenia',
    shortcodes: ['flag_si', 'slovenia'],
    tags: ['SI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ee.png',
  },
  {
    emoji: '🇸🇯',
    name: 'svalbard_jan_mayen',
    shortcodes: ['flag_sj', 'svalbard_jan_mayen'],
    tags: ['SJ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ef.png',
  },
  {
    emoji: '🇸🇰',
    name: 'slovakia',
    shortcodes: ['flag_sk', 'slovakia'],
    tags: ['SK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f0.png',
  },
  {
    emoji: '🇸🇱',
    name: 'sierra_leone',
    shortcodes: ['flag_sl', 'sierra_leone'],
    tags: ['SL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f1.png',
  },
  {
    emoji: '🇸🇲',
    name: 'san_marino',
    shortcodes: ['flag_sm', 'san_marino'],
    tags: ['SM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f2.png',
  },
  {
    emoji: '🇸🇳',
    name: 'senegal',
    shortcodes: ['flag_sn', 'senegal'],
    tags: ['SN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f3.png',
  },
  {
    emoji: '🇸🇴',
    name: 'somalia',
    shortcodes: ['flag_so', 'somalia'],
    tags: ['SO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f4.png',
  },
  {
    emoji: '🇸🇷',
    name: 'suriname',
    shortcodes: ['flag_sr', 'suriname'],
    tags: ['SR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f7.png',
  },
  {
    emoji: '🇸🇸',
    name: 'south_sudan',
    shortcodes: ['flag_ss', 'south_sudan'],
    tags: ['SS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f8.png',
  },
  {
    emoji: '🇸🇹',
    name: 'sao_tome_principe',
    shortcodes: ['flag_st', 'sao_tome_principe'],
    tags: ['ST', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1f9.png',
  },
  {
    emoji: '🇸🇻',
    name: 'el_salvador',
    shortcodes: ['el_salvador', 'flag_sv'],
    tags: ['SV', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1fb.png',
  },
  {
    emoji: '🇸🇽',
    name: 'sint_maarten',
    shortcodes: ['flag_sx', 'sint_maarten'],
    tags: ['SX', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1fd.png',
  },
  {
    emoji: '🇸🇾',
    name: 'syria',
    shortcodes: ['flag_sy', 'syria'],
    tags: ['SY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1fe.png',
  },
  {
    emoji: '🇸🇿',
    name: 'swaziland',
    shortcodes: ['eswatini', 'flag_sz', 'swaziland'],
    tags: ['SZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f8-1f1ff.png',
  },
  {
    emoji: '🇹🇦',
    name: 'tristan_da_cunha',
    shortcodes: ['flag_ta', 'tristan_da_cunha'],
    tags: ['TA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1e6.png',
  },
  {
    emoji: '🇹🇨',
    name: 'turks_caicos_islands',
    shortcodes: ['flag_tc', 'turks_caicos_islands'],
    tags: ['TC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1e8.png',
  },
  {
    emoji: '🇹🇩',
    name: 'chad',
    shortcodes: ['chad', 'flag_td'],
    tags: ['TD', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1e9.png',
  },
  {
    emoji: '🇹🇫',
    name: 'french_southern_territories',
    shortcodes: ['flag_tf', 'french_southern_territories'],
    tags: ['TF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1eb.png',
  },
  {
    emoji: '🇹🇬',
    name: 'togo',
    shortcodes: ['flag_tg', 'togo'],
    tags: ['TG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ec.png',
  },
  {
    emoji: '🇹🇭',
    name: 'thailand',
    shortcodes: ['flag_th', 'thailand'],
    tags: ['TH', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ed.png',
  },
  {
    emoji: '🇹🇯',
    name: 'tajikistan',
    shortcodes: ['flag_tj', 'tajikistan'],
    tags: ['TJ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ef.png',
  },
  {
    emoji: '🇹🇰',
    name: 'tokelau',
    shortcodes: ['flag_tk', 'tokelau'],
    tags: ['TK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f0.png',
  },
  {
    emoji: '🇹🇱',
    name: 'timor_leste',
    shortcodes: ['flag_tl', 'timor_leste'],
    tags: ['TL', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f1.png',
  },
  {
    emoji: '🇹🇲',
    name: 'turkmenistan',
    shortcodes: ['flag_tm', 'turkmenistan'],
    tags: ['TM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f2.png',
  },
  {
    emoji: '🇹🇳',
    name: 'tunisia',
    shortcodes: ['flag_tn', 'tunisia'],
    tags: ['TN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f3.png',
  },
  {
    emoji: '🇹🇴',
    name: 'tonga',
    shortcodes: ['flag_to', 'tonga'],
    tags: ['TO', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f4.png',
  },
  {
    emoji: '🇹🇷',
    name: 'tr',
    shortcodes: ['flag_tr', 'turkey_tr'],
    tags: ['TR', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f7.png',
  },
  {
    emoji: '🇹🇹',
    name: 'trinidad_tobago',
    shortcodes: ['flag_tt', 'trinidad_tobago'],
    tags: ['TT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1f9.png',
  },
  {
    emoji: '🇹🇻',
    name: 'tuvalu',
    shortcodes: ['flag_tv', 'tuvalu'],
    tags: ['TV', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1fb.png',
  },
  {
    emoji: '🇹🇼',
    name: 'taiwan',
    shortcodes: ['flag_tw', 'taiwan'],
    tags: ['TW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1fc.png',
  },
  {
    emoji: '🇹🇿',
    name: 'tanzania',
    shortcodes: ['flag_tz', 'tanzania'],
    tags: ['TZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1f9-1f1ff.png',
  },
  {
    emoji: '🇺🇦',
    name: 'ukraine',
    shortcodes: ['flag_ua', 'ukraine'],
    tags: ['UA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1e6.png',
  },
  {
    emoji: '🇺🇬',
    name: 'uganda',
    shortcodes: ['flag_ug', 'uganda'],
    tags: ['UG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1ec.png',
  },
  {
    emoji: '🇺🇲',
    name: 'us_outlying_islands',
    shortcodes: ['flag_um', 'us_outlying_islands'],
    tags: ['UM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1f2.png',
  },
  {
    emoji: '🇺🇳',
    name: 'united_nations',
    shortcodes: ['flag_un', 'un', 'united_nations'],
    tags: ['UN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 4,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1f3.png',
  },
  {
    emoji: '🇺🇸',
    name: 'us',
    shortcodes: ['flag_us', 'united_states', 'usa'],
    tags: ['US', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 0.6,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1f8.png',
  },
  {
    emoji: '🇺🇾',
    name: 'uruguay',
    shortcodes: ['flag_uy', 'uruguay'],
    tags: ['UY', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1fe.png',
  },
  {
    emoji: '🇺🇿',
    name: 'uzbekistan',
    shortcodes: ['flag_uz', 'uzbekistan'],
    tags: ['UZ', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fa-1f1ff.png',
  },
  {
    emoji: '🇻🇦',
    name: 'vatican_city',
    shortcodes: ['flag_va', 'vatican_city'],
    tags: ['VA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1e6.png',
  },
  {
    emoji: '🇻🇨',
    name: 'st_vincent_grenadines',
    shortcodes: ['flag_vc', 'st_vincent_grenadines'],
    tags: ['VC', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1e8.png',
  },
  {
    emoji: '🇻🇪',
    name: 'venezuela',
    shortcodes: ['flag_ve', 'venezuela'],
    tags: ['VE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1ea.png',
  },
  {
    emoji: '🇻🇬',
    name: 'british_virgin_islands',
    shortcodes: ['british_virgin_islands', 'flag_vg'],
    tags: ['VG', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1ec.png',
  },
  {
    emoji: '🇻🇮',
    name: 'us_virgin_islands',
    shortcodes: ['flag_vi', 'us_virgin_islands'],
    tags: ['VI', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1ee.png',
  },
  {
    emoji: '🇻🇳',
    name: 'vietnam',
    shortcodes: ['flag_vn', 'vietnam'],
    tags: ['VN', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1f3.png',
  },
  {
    emoji: '🇻🇺',
    name: 'vanuatu',
    shortcodes: ['flag_vu', 'vanuatu'],
    tags: ['VU', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fb-1f1fa.png',
  },
  {
    emoji: '🇼🇫',
    name: 'wallis_futuna',
    shortcodes: ['flag_wf', 'wallis_futuna'],
    tags: ['WF', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fc-1f1eb.png',
  },
  {
    emoji: '🇼🇸',
    name: 'samoa',
    shortcodes: ['flag_ws', 'samoa'],
    tags: ['WS', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fc-1f1f8.png',
  },
  {
    emoji: '🇽🇰',
    name: 'kosovo',
    shortcodes: ['flag_xk', 'kosovo'],
    tags: ['XK', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fd-1f1f0.png',
  },
  {
    emoji: '🇾🇪',
    name: 'yemen',
    shortcodes: ['flag_ye', 'yemen'],
    tags: ['YE', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fe-1f1ea.png',
  },
  {
    emoji: '🇾🇹',
    name: 'mayotte',
    shortcodes: ['flag_yt', 'mayotte'],
    tags: ['YT', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1fe-1f1f9.png',
  },
  {
    emoji: '🇿🇦',
    name: 'south_africa',
    shortcodes: ['flag_za', 'south_africa'],
    tags: ['ZA', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ff-1f1e6.png',
  },
  {
    emoji: '🇿🇲',
    name: 'zambia',
    shortcodes: ['flag_zm', 'zambia'],
    tags: ['ZM', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ff-1f1f2.png',
  },
  {
    emoji: '🇿🇼',
    name: 'zimbabwe',
    shortcodes: ['flag_zw', 'zimbabwe'],
    tags: ['ZW', 'flag'],
    group: 'flags',
    emoticons: [],
    version: 2,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f1ff-1f1fc.png',
  },
  {
    emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    name: 'england',
    shortcodes: ['england', 'flag_gbeng'],
    tags: ['flag', 'gbeng'],
    group: 'flags',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-e0067-e0062-e0065-e006e-e0067-e007f.png',
  },
  {
    emoji: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    name: 'scotland',
    shortcodes: ['flag_gbsct', 'scotland'],
    tags: ['flag', 'gbsct'],
    group: 'flags',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-e0067-e0062-e0073-e0063-e0074-e007f.png',
  },
  {
    emoji: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
    name: 'wales',
    shortcodes: ['flag_gbwls', 'wales'],
    tags: ['flag', 'gbwls'],
    group: 'flags',
    emoticons: [],
    version: 5,
    fallbackImage:
      'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f3f4-e0067-e0062-e0077-e006c-e0073-e007f.png',
  },
]

export const gitHubCustomEmojis: EmojiItem[] = [
  {
    name: 'atom',
    shortcodes: ['atom'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/atom.png',
  },
  {
    name: 'basecamp',
    shortcodes: ['basecamp'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/basecamp.png',
  },
  {
    name: 'basecampy',
    shortcodes: ['basecampy'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/basecampy.png',
  },
  {
    name: 'bowtie',
    shortcodes: ['bowtie'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/bowtie.png',
  },
  {
    name: 'electron',
    shortcodes: ['electron'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/electron.png',
  },
  {
    name: 'feelsgood',
    shortcodes: ['feelsgood'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/feelsgood.png',
  },
  {
    name: 'finnadie',
    shortcodes: ['finnadie'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/finnadie.png',
  },
  {
    name: 'goberserk',
    shortcodes: ['goberserk'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/goberserk.png',
  },
  {
    name: 'godmode',
    shortcodes: ['godmode'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/godmode.png',
  },
  {
    name: 'hurtrealbad',
    shortcodes: ['hurtrealbad'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/hurtrealbad.png',
  },
  {
    name: 'neckbeard',
    shortcodes: ['neckbeard'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/neckbeard.png',
  },
  {
    name: 'octocat',
    shortcodes: ['octocat'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/octocat.png',
  },
  {
    name: 'rage1',
    shortcodes: ['rage1'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage1.png',
  },
  {
    name: 'rage2',
    shortcodes: ['rage2'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage2.png',
  },
  {
    name: 'rage3',
    shortcodes: ['rage3'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage3.png',
  },
  {
    name: 'rage4',
    shortcodes: ['rage4'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/rage4.png',
  },
  {
    name: 'shipit',
    shortcodes: ['shipit'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/shipit.png',
  },
  {
    name: 'suspect',
    shortcodes: ['suspect'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/suspect.png',
  },
  {
    name: 'trollface',
    shortcodes: ['trollface'],
    tags: [],
    group: 'GitHub',
    fallbackImage: 'https://github.githubassets.com/images/icons/emoji/trollface.png',
  },
]

export const gitHubEmojis: EmojiItem[] = [...emojis, ...gitHubCustomEmojis]
